"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Inosio Payments API
 * The Inosio Payments API description
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@inosio.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkOrdersApi = exports.WorkOrdersApiFactory = exports.WorkOrdersApiFp = exports.WorkOrdersApiAxiosParamCreator = exports.WebhookApi = exports.WebhookApiFactory = exports.WebhookApiFp = exports.WebhookApiAxiosParamCreator = exports.VendorsApi = exports.VendorsApiFactory = exports.VendorsApiFp = exports.VendorsApiAxiosParamCreator = exports.ResidentsApi = exports.ResidentsApiFactory = exports.ResidentsApiFp = exports.ResidentsApiAxiosParamCreator = exports.PropertyGroupsApi = exports.PropertyGroupsApiFactory = exports.PropertyGroupsApiFp = exports.PropertyGroupsApiAxiosParamCreator = exports.PropertiesApi = exports.PropertiesApiFactory = exports.PropertiesApiFp = exports.PropertiesApiAxiosParamCreator = exports.PmsApi = exports.PmsApiFactory = exports.PmsApiFp = exports.PmsApiAxiosParamCreator = exports.PaymentsApi = exports.PaymentsApiFactory = exports.PaymentsApiFp = exports.PaymentsApiAxiosParamCreator = exports.PartnersApi = exports.PartnersApiFactory = exports.PartnersApiFp = exports.PartnersApiAxiosParamCreator = exports.OwnersApi = exports.OwnersApiFactory = exports.OwnersApiFp = exports.OwnersApiAxiosParamCreator = exports.MaintenanceApi = exports.MaintenanceApiFactory = exports.MaintenanceApiFp = exports.MaintenanceApiAxiosParamCreator = exports.LegalApi = exports.LegalApiFactory = exports.LegalApiFp = exports.LegalApiAxiosParamCreator = exports.LedgersApi = exports.LedgersApiFactory = exports.LedgersApiFp = exports.LedgersApiAxiosParamCreator = exports.HealthcheckApi = exports.HealthcheckApiFactory = exports.HealthcheckApiFp = exports.HealthcheckApiAxiosParamCreator = exports.DocumentsApi = exports.DocumentsApiFactory = exports.DocumentsApiFp = exports.DocumentsApiAxiosParamCreator = exports.CompaniesApi = exports.CompaniesApiFactory = exports.CompaniesApiFp = exports.CompaniesApiAxiosParamCreator = exports.BankCardsApi = exports.BankCardsApiFactory = exports.BankCardsApiFp = exports.BankCardsApiAxiosParamCreator = exports.BankAccountsApi = exports.BankAccountsApiFactory = exports.BankAccountsApiFp = exports.BankAccountsApiAxiosParamCreator = exports.AuthApi = exports.AuthApiFactory = exports.AuthApiFp = exports.AuthApiAxiosParamCreator = exports.ApplicationsV2Api = exports.ApplicationsV2ApiFactory = exports.ApplicationsV2ApiFp = exports.ApplicationsV2ApiAxiosParamCreator = exports.ApplicationsV1Api = exports.ApplicationsV1ApiFactory = exports.ApplicationsV1ApiFp = exports.ApplicationsV1ApiAxiosParamCreator = exports.AnnouncementsApi = exports.AnnouncementsApiFactory = exports.AnnouncementsApiFp = exports.AnnouncementsApiAxiosParamCreator = exports.AdminApi = exports.AdminApiFactory = exports.AdminApiFp = exports.AdminApiAxiosParamCreator = exports.WorkOrderTypes = exports.WorkOrderStatusEnum = exports.WorkOrderSortDirectionEnum = exports.WorkOrderSortColumnEnum = exports.WorkOrderPriorityEnum = exports.WorkOrderEntityWorkOrderCostApprovalEnum = exports.WorkOrderCostApprovalEnum = exports.WorkOrderAssigneeDtoTypeEnum = exports.VendorSearchField = exports.VendorSearchDTOSearchStatusEnum = exports.ValidTransactionStatusEnum = exports.ValidRequestMessages = exports.UserRegistrationResponseStatusEnum = exports.UpdateVendorDtoStatusEnum = exports.UpdateOwnerStatusEnum = exports.UpdateBankAccountDTOAccountTypeEnum = exports.UpdateApplicationVehicleDtoTypeEnum = exports.UpdateApplicationOccupantDtoGenderEnum = exports.UpdateApplicationOccupantDtoEmploymentStatusEnum = exports.UpdateApplicationOccupantDtoGovIdTypeEnum = exports.UpdateApplicationEmploymentDtoStatusEnum = exports.UpdateApplicantStatusEnum = exports.UpdateAnnouncementDtoStatusEnum = exports.TransactionTypeEnum = exports.TransSearchField = exports.TieredFeeTypeEnum = exports.SoftwareIntegrationCredentialTypeEnum = exports.SenderIdentityStatus = exports.SearchType = exports.ScreeningStatusLabelEnum = exports.ScheduledAutoPayDtoTypeEnum = exports.ScheduledAutoPayDtoStatusEnum = exports.ScheduledAutoPayDtoFrequencyEnum = exports.ScheduleDayOffset = exports.Role = exports.ResponseType = exports.ResidentSortDirectionEnum = exports.ResidentSortColumnEnum = exports.ResidentSearchResponseV2DtoRegistrationStatusEnum = exports.ResidentSearchResponseV2DtoLeaseStatusEnum = exports.ResidentSearchParamsDTORegistrationStatusEnum = exports.ResidentSearchParamsDTOLeaseStatusEnum = exports.ResidentBalanceParamComparatorEnum = exports.RefundStatusEnum = exports.PropertySearchField = exports.ProfileSearchType = exports.ProductTypeEnum = exports.ProductBillingTypeEnum = exports.PreferredContactMethodEnum = exports.PmSearchField = exports.PaymentTypeField = exports.PaymentTypeEnum = exports.PaymentTypeConfigDtoTypeEnum = exports.PaymentRequestStatusType = exports.PaymentRequestSearchField = exports.PaymentClassEnum = exports.PayerType = exports.PartnerTransactionDtoPaymentTypeEnum = exports.PaidByEnum = exports.OwnerSortDirectionEnum = exports.OwnerSortColumnEnum = exports.OwnerSearchResponseV2DtoStatusEnum = exports.OwnerSearchResponseV2DtoRegistrationStatusEnum = exports.OwnerSearchRequestDtoStatusEnum = exports.OwnerSearchRequestDtoRegistrationStatusEnum = exports.OnboardingStepType = exports.OnboardingStepStatus = exports.OnboardingApplicationStatus = exports.OccupantDtoGenderEnum = exports.MaintenanceSearchField = exports.LedgerUserTypeEnum = exports.LedgerTypes = exports.LedgerItemTypeEnum = exports.LeaseStatusEnum = exports.InvoiceFileType = exports.InvitedCoapplicantDtoStatusEnum = exports.IntersectionBankCardDTOBankAccountDTOFundingStatusEnum = exports.IntersectionBankCardDTOBankAccountDTOAccountTypeEnum = exports.IntersectionBankCardDTOBankAccountDTOProcessAsCardTypeEnum = exports.IntersectionBankCardDTOBankAccountDTOCardTypeEnum = exports.FeeTypeEnum = exports.EntityTypeDescriptionEnum = exports.EmploymentStatusEnum = exports.DocumentTypes = exports.DocumentOwnerType = exports.DisbursementSearchParamsDTODisburseTypeEnum = exports.DisburseSearchField = exports.DepositSearchField = exports.DepositDetailItemDTOPaymentTypeEnum = exports.CustomQuestionTypeEnum = exports.CustomQuestionResponseTypeEnum = exports.CreateBankAccountV2DtoAccountTypeEnum = exports.CreateBankAccountDTOAccountTypeEnum = exports.CreateApplicationVehicleDtoTypeEnum = exports.CreateApplicationOccupantDtoGenderEnum = exports.CreateApplicationOccupantDtoEmploymentStatusEnum = exports.CreateApplicationOccupantDtoGovIdTypeEnum = exports.CreateApplicationEmploymentDtoStatusEnum = exports.CreateAnnouncementDtoStatusEnum = exports.CompanyType = exports.ChangeApplicationStatusEnum = exports.BankCardType = exports.BankCardDTOProcessAsCardTypeEnum = exports.BankCardDTOCardTypeEnum = exports.BankAccountV2DtoFundingStatusEnum = exports.BankAccountV2DtoAccountTypeEnum = exports.BankAccountSearchField = exports.BankAccountDTOFundingStatusEnum = exports.BankAccountDTOAccountTypeEnum = exports.AutoPayType = exports.AutoPayFrequency = exports.AutoPayConfigDtoTypeEnum = exports.ApplicationsHoldDepoistPrTimeType = exports.ApplicationVehicleDtoTypeEnum = exports.ApplicationStatus = exports.ApplicationSearchField = exports.ApplicationOccupantSummaryDtoStatusEnum = exports.ApplicationOccupantDtoGenderEnum = exports.ApplicationOccupantDtoEmploymentStatusEnum = exports.ApplicationOccupantDtoGovIdTypeEnum = exports.ApplicationFileTypeEnum = exports.ApplicationEmploymentDtoStatusEnum = exports.ApplicationDtoStatusEnum = exports.ApplicationDesiredLeaseTerm = exports.ApplicationDecisionFileTypeEnum = exports.ApplicationAcceptanceTermV2DtoTypeEnum = exports.ApplicantV2DtoStatusEnum = exports.ApplicantTypeEnum = exports.AnnouncementsSortDtoDirectionEnum = exports.AnnouncementsSortDtoColumnEnum = exports.AnnouncementTemplateSummaryDtoStatusEnum = exports.AnnouncementTemplateStatusEnum = exports.AnnouncementRecipientAlgorithms = exports.AnnouncementPersonalizationFields = exports.AnnouncementMethods = exports.AnnouncementFrequencies = exports.AdminCompanySearchDtoAdminViewEnum = exports.AdminCompanyDocumentTypeEnum = exports.AdminCompanyDetailDtoPaymentProcessingStatusEnum = exports.AccountActivationSubjectDtoEntityTypeEnum = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
/**
    * @export
    * @enum {string}
    */
var AccountActivationSubjectDtoEntityTypeEnum;
(function (AccountActivationSubjectDtoEntityTypeEnum) {
    AccountActivationSubjectDtoEntityTypeEnum["InternalCompany"] = "InternalCompany";
    AccountActivationSubjectDtoEntityTypeEnum["Resident"] = "Resident";
    AccountActivationSubjectDtoEntityTypeEnum["Company"] = "Company";
    AccountActivationSubjectDtoEntityTypeEnum["Property"] = "Property";
    AccountActivationSubjectDtoEntityTypeEnum["InternalEmployee"] = "InternalEmployee";
    AccountActivationSubjectDtoEntityTypeEnum["CompanyStaff"] = "CompanyStaff";
    AccountActivationSubjectDtoEntityTypeEnum["Lease"] = "Lease";
    AccountActivationSubjectDtoEntityTypeEnum["User"] = "User";
    AccountActivationSubjectDtoEntityTypeEnum["Address"] = "Address";
    AccountActivationSubjectDtoEntityTypeEnum["BankAccount"] = "BankAccount";
    AccountActivationSubjectDtoEntityTypeEnum["BankCard"] = "BankCard";
    AccountActivationSubjectDtoEntityTypeEnum["KycOfficer"] = "KYCOfficer";
    AccountActivationSubjectDtoEntityTypeEnum["Applicant"] = "Applicant";
    AccountActivationSubjectDtoEntityTypeEnum["Owner"] = "Owner";
    AccountActivationSubjectDtoEntityTypeEnum["Partner"] = "Partner";
    AccountActivationSubjectDtoEntityTypeEnum["Pet"] = "Pet";
    AccountActivationSubjectDtoEntityTypeEnum["Application"] = "Application";
    AccountActivationSubjectDtoEntityTypeEnum["MaintenanceRequest"] = "MaintenanceRequest";
    AccountActivationSubjectDtoEntityTypeEnum["WorkOrder"] = "WorkOrder";
    AccountActivationSubjectDtoEntityTypeEnum["GenericPayer"] = "GenericPayer";
    AccountActivationSubjectDtoEntityTypeEnum["Vendor"] = "Vendor";
    AccountActivationSubjectDtoEntityTypeEnum["Vehicle"] = "Vehicle";
    AccountActivationSubjectDtoEntityTypeEnum["Employment"] = "Employment";
    AccountActivationSubjectDtoEntityTypeEnum["RentalHistory"] = "RentalHistory";
    AccountActivationSubjectDtoEntityTypeEnum["VendorUser"] = "VendorUser";
    AccountActivationSubjectDtoEntityTypeEnum["PropertyGroup"] = "PropertyGroup";
    AccountActivationSubjectDtoEntityTypeEnum["InosioStaff"] = "InosioStaff";
})(AccountActivationSubjectDtoEntityTypeEnum = exports.AccountActivationSubjectDtoEntityTypeEnum || (exports.AccountActivationSubjectDtoEntityTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AdminCompanyDetailDtoPaymentProcessingStatusEnum;
(function (AdminCompanyDetailDtoPaymentProcessingStatusEnum) {
    AdminCompanyDetailDtoPaymentProcessingStatusEnum["Pending"] = "Pending";
    AdminCompanyDetailDtoPaymentProcessingStatusEnum["Submitted"] = "Submitted";
    AdminCompanyDetailDtoPaymentProcessingStatusEnum["AtProcessor"] = "At Processor";
    AdminCompanyDetailDtoPaymentProcessingStatusEnum["Approved"] = "Approved";
})(AdminCompanyDetailDtoPaymentProcessingStatusEnum = exports.AdminCompanyDetailDtoPaymentProcessingStatusEnum || (exports.AdminCompanyDetailDtoPaymentProcessingStatusEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var AdminCompanyDocumentTypeEnum;
(function (AdminCompanyDocumentTypeEnum) {
    AdminCompanyDocumentTypeEnum["Pci"] = "Pci";
})(AdminCompanyDocumentTypeEnum = exports.AdminCompanyDocumentTypeEnum || (exports.AdminCompanyDocumentTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AdminCompanySearchDtoAdminViewEnum;
(function (AdminCompanySearchDtoAdminViewEnum) {
    AdminCompanySearchDtoAdminViewEnum["Sales"] = "Sales";
    AdminCompanySearchDtoAdminViewEnum["Implementation"] = "Implementation";
})(AdminCompanySearchDtoAdminViewEnum = exports.AdminCompanySearchDtoAdminViewEnum || (exports.AdminCompanySearchDtoAdminViewEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var AnnouncementFrequencies;
(function (AnnouncementFrequencies) {
    AnnouncementFrequencies["OneTime"] = "ONE_TIME";
    AnnouncementFrequencies["Daily"] = "DAILY";
    AnnouncementFrequencies["Monthly"] = "MONTHLY";
    AnnouncementFrequencies["Quarterly"] = "QUARTERLY";
})(AnnouncementFrequencies = exports.AnnouncementFrequencies || (exports.AnnouncementFrequencies = {}));
/**
 *
 * @export
 * @enum {string}
 */
var AnnouncementMethods;
(function (AnnouncementMethods) {
    AnnouncementMethods["Email"] = "EMAIL";
    AnnouncementMethods["Sms"] = "SMS";
})(AnnouncementMethods = exports.AnnouncementMethods || (exports.AnnouncementMethods = {}));
/**
 *
 * @export
 * @enum {string}
 */
var AnnouncementPersonalizationFields;
(function (AnnouncementPersonalizationFields) {
    AnnouncementPersonalizationFields["CompanyDbaName"] = "{{company_dba_name}}";
    AnnouncementPersonalizationFields["CompanyLegalName"] = "{{company_legal_name}}";
    AnnouncementPersonalizationFields["CompanyMailingAddress"] = "{{company_mailing_address}}";
    AnnouncementPersonalizationFields["CompanyPhysicalAddress"] = "{{company_physical_address}}";
    AnnouncementPersonalizationFields["PropertyName"] = "{{property_name}}";
    AnnouncementPersonalizationFields["PropertyFullAddress"] = "{{property_full_address}}";
    AnnouncementPersonalizationFields["RecipientFirstName"] = "{{recipient_first_name}}";
    AnnouncementPersonalizationFields["RecipientFullname"] = "{{recipient_fullname}}";
})(AnnouncementPersonalizationFields = exports.AnnouncementPersonalizationFields || (exports.AnnouncementPersonalizationFields = {}));
/**
 *
 * @export
 * @enum {string}
 */
var AnnouncementRecipientAlgorithms;
(function (AnnouncementRecipientAlgorithms) {
    AnnouncementRecipientAlgorithms["Tenants"] = "ALL_ACTIVE_TENANTS";
    AnnouncementRecipientAlgorithms["Owners"] = "ALL_ACTIVE_OWNERS";
})(AnnouncementRecipientAlgorithms = exports.AnnouncementRecipientAlgorithms || (exports.AnnouncementRecipientAlgorithms = {}));
/**
 *
 * @export
 * @enum {string}
 */
var AnnouncementTemplateStatusEnum;
(function (AnnouncementTemplateStatusEnum) {
    AnnouncementTemplateStatusEnum["Draft"] = "DRAFT";
    AnnouncementTemplateStatusEnum["Scheduled"] = "SCHEDULED";
})(AnnouncementTemplateStatusEnum = exports.AnnouncementTemplateStatusEnum || (exports.AnnouncementTemplateStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AnnouncementTemplateSummaryDtoStatusEnum;
(function (AnnouncementTemplateSummaryDtoStatusEnum) {
    AnnouncementTemplateSummaryDtoStatusEnum["Draft"] = "DRAFT";
    AnnouncementTemplateSummaryDtoStatusEnum["Scheduled"] = "SCHEDULED";
})(AnnouncementTemplateSummaryDtoStatusEnum = exports.AnnouncementTemplateSummaryDtoStatusEnum || (exports.AnnouncementTemplateSummaryDtoStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AnnouncementsSortDtoColumnEnum;
(function (AnnouncementsSortDtoColumnEnum) {
    AnnouncementsSortDtoColumnEnum["Description"] = "Description";
    AnnouncementsSortDtoColumnEnum["Type"] = "Type";
    AnnouncementsSortDtoColumnEnum["LastSent"] = "LastSent";
    AnnouncementsSortDtoColumnEnum["NextSend"] = "NextSend";
})(AnnouncementsSortDtoColumnEnum = exports.AnnouncementsSortDtoColumnEnum || (exports.AnnouncementsSortDtoColumnEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AnnouncementsSortDtoDirectionEnum;
(function (AnnouncementsSortDtoDirectionEnum) {
    AnnouncementsSortDtoDirectionEnum["Asc"] = "ASC";
    AnnouncementsSortDtoDirectionEnum["Desc"] = "DESC";
})(AnnouncementsSortDtoDirectionEnum = exports.AnnouncementsSortDtoDirectionEnum || (exports.AnnouncementsSortDtoDirectionEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ApplicantTypeEnum;
(function (ApplicantTypeEnum) {
    ApplicantTypeEnum["Occupant"] = "Occupant";
    ApplicantTypeEnum["Cosigner"] = "Cosigner";
})(ApplicantTypeEnum = exports.ApplicantTypeEnum || (exports.ApplicantTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApplicantV2DtoStatusEnum;
(function (ApplicantV2DtoStatusEnum) {
    ApplicantV2DtoStatusEnum["Registered"] = "REGISTERED";
    ApplicantV2DtoStatusEnum["Invited"] = "INVITED";
    ApplicantV2DtoStatusEnum["Completed"] = "COMPLETED";
})(ApplicantV2DtoStatusEnum = exports.ApplicantV2DtoStatusEnum || (exports.ApplicantV2DtoStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApplicationAcceptanceTermV2DtoTypeEnum;
(function (ApplicationAcceptanceTermV2DtoTypeEnum) {
    ApplicationAcceptanceTermV2DtoTypeEnum["Date"] = "DATE";
    ApplicationAcceptanceTermV2DtoTypeEnum["String"] = "STRING";
    ApplicationAcceptanceTermV2DtoTypeEnum["Usd"] = "USD";
    ApplicationAcceptanceTermV2DtoTypeEnum["Integer"] = "INTEGER";
})(ApplicationAcceptanceTermV2DtoTypeEnum = exports.ApplicationAcceptanceTermV2DtoTypeEnum || (exports.ApplicationAcceptanceTermV2DtoTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ApplicationDecisionFileTypeEnum;
(function (ApplicationDecisionFileTypeEnum) {
    ApplicationDecisionFileTypeEnum["DenialLetter"] = "DenialLetter";
})(ApplicationDecisionFileTypeEnum = exports.ApplicationDecisionFileTypeEnum || (exports.ApplicationDecisionFileTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ApplicationDesiredLeaseTerm;
(function (ApplicationDesiredLeaseTerm) {
    ApplicationDesiredLeaseTerm["LessThan1Year"] = "Less than 1 year";
    ApplicationDesiredLeaseTerm["_1Year"] = "1 year";
    ApplicationDesiredLeaseTerm["MoreThan1Year"] = "More than 1 year";
})(ApplicationDesiredLeaseTerm = exports.ApplicationDesiredLeaseTerm || (exports.ApplicationDesiredLeaseTerm = {}));
/**
    * @export
    * @enum {string}
    */
var ApplicationDtoStatusEnum;
(function (ApplicationDtoStatusEnum) {
    ApplicationDtoStatusEnum["Incomplete"] = "INCOMPLETE";
    ApplicationDtoStatusEnum["Submitted"] = "SUBMITTED";
    ApplicationDtoStatusEnum["Approved"] = "APPROVED";
    ApplicationDtoStatusEnum["Rejected"] = "REJECTED";
    ApplicationDtoStatusEnum["Returned"] = "RETURNED";
})(ApplicationDtoStatusEnum = exports.ApplicationDtoStatusEnum || (exports.ApplicationDtoStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApplicationEmploymentDtoStatusEnum;
(function (ApplicationEmploymentDtoStatusEnum) {
    ApplicationEmploymentDtoStatusEnum["Employed"] = "Employed";
    ApplicationEmploymentDtoStatusEnum["NotEmployed"] = "Not Employed";
    ApplicationEmploymentDtoStatusEnum["SelfEmployed"] = "Self Employed";
})(ApplicationEmploymentDtoStatusEnum = exports.ApplicationEmploymentDtoStatusEnum || (exports.ApplicationEmploymentDtoStatusEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ApplicationFileTypeEnum;
(function (ApplicationFileTypeEnum) {
    ApplicationFileTypeEnum["ApplicationDataZip"] = "ApplicationDataZip";
    ApplicationFileTypeEnum["ApplicationDetailsPdf"] = "ApplicationDetailsPdf";
    ApplicationFileTypeEnum["RentalHistoryRelease"] = "RentalHistoryRelease";
    ApplicationFileTypeEnum["EmploymentHistoryRelease"] = "EmploymentHistoryRelease";
})(ApplicationFileTypeEnum = exports.ApplicationFileTypeEnum || (exports.ApplicationFileTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApplicationOccupantDtoGovIdTypeEnum;
(function (ApplicationOccupantDtoGovIdTypeEnum) {
    ApplicationOccupantDtoGovIdTypeEnum["Passport"] = "Passport";
    ApplicationOccupantDtoGovIdTypeEnum["Id"] = "ID";
    ApplicationOccupantDtoGovIdTypeEnum["DriversLicense"] = "Drivers License";
})(ApplicationOccupantDtoGovIdTypeEnum = exports.ApplicationOccupantDtoGovIdTypeEnum || (exports.ApplicationOccupantDtoGovIdTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApplicationOccupantDtoEmploymentStatusEnum;
(function (ApplicationOccupantDtoEmploymentStatusEnum) {
    ApplicationOccupantDtoEmploymentStatusEnum["Employed"] = "Employed";
    ApplicationOccupantDtoEmploymentStatusEnum["NotEmployed"] = "Not Employed";
    ApplicationOccupantDtoEmploymentStatusEnum["SelfEmployed"] = "Self Employed";
})(ApplicationOccupantDtoEmploymentStatusEnum = exports.ApplicationOccupantDtoEmploymentStatusEnum || (exports.ApplicationOccupantDtoEmploymentStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApplicationOccupantDtoGenderEnum;
(function (ApplicationOccupantDtoGenderEnum) {
    ApplicationOccupantDtoGenderEnum["Male"] = "MALE";
    ApplicationOccupantDtoGenderEnum["Female"] = "FEMALE";
    ApplicationOccupantDtoGenderEnum["NonBinary"] = "NON-BINARY";
    ApplicationOccupantDtoGenderEnum["Other"] = "OTHER";
})(ApplicationOccupantDtoGenderEnum = exports.ApplicationOccupantDtoGenderEnum || (exports.ApplicationOccupantDtoGenderEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApplicationOccupantSummaryDtoStatusEnum;
(function (ApplicationOccupantSummaryDtoStatusEnum) {
    ApplicationOccupantSummaryDtoStatusEnum["Registered"] = "REGISTERED";
    ApplicationOccupantSummaryDtoStatusEnum["Invited"] = "INVITED";
    ApplicationOccupantSummaryDtoStatusEnum["Completed"] = "COMPLETED";
    ApplicationOccupantSummaryDtoStatusEnum["Returned"] = "RETURNED";
})(ApplicationOccupantSummaryDtoStatusEnum = exports.ApplicationOccupantSummaryDtoStatusEnum || (exports.ApplicationOccupantSummaryDtoStatusEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ApplicationSearchField;
(function (ApplicationSearchField) {
    ApplicationSearchField["ApplicantName"] = "ApplicantName";
    ApplicationSearchField["PropertyAddress"] = "PropertyAddress";
    ApplicationSearchField["Status"] = "Status";
})(ApplicationSearchField = exports.ApplicationSearchField || (exports.ApplicationSearchField = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ApplicationStatus;
(function (ApplicationStatus) {
    ApplicationStatus["Incomplete"] = "INCOMPLETE";
    ApplicationStatus["Submitted"] = "SUBMITTED";
    ApplicationStatus["Approved"] = "APPROVED";
    ApplicationStatus["Rejected"] = "REJECTED";
    ApplicationStatus["Returned"] = "RETURNED";
})(ApplicationStatus = exports.ApplicationStatus || (exports.ApplicationStatus = {}));
/**
    * @export
    * @enum {string}
    */
var ApplicationVehicleDtoTypeEnum;
(function (ApplicationVehicleDtoTypeEnum) {
    ApplicationVehicleDtoTypeEnum["Car"] = "Car";
    ApplicationVehicleDtoTypeEnum["Truck"] = "Truck";
    ApplicationVehicleDtoTypeEnum["Suv"] = "SUV";
    ApplicationVehicleDtoTypeEnum["Boat"] = "Boat";
    ApplicationVehicleDtoTypeEnum["Rv"] = "RV";
    ApplicationVehicleDtoTypeEnum["Trailer"] = "Trailer";
    ApplicationVehicleDtoTypeEnum["Other"] = "Other";
})(ApplicationVehicleDtoTypeEnum = exports.ApplicationVehicleDtoTypeEnum || (exports.ApplicationVehicleDtoTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ApplicationsHoldDepoistPrTimeType;
(function (ApplicationsHoldDepoistPrTimeType) {
    ApplicationsHoldDepoistPrTimeType["Approval"] = "Approval";
    ApplicationsHoldDepoistPrTimeType["Submission"] = "Submission";
})(ApplicationsHoldDepoistPrTimeType = exports.ApplicationsHoldDepoistPrTimeType || (exports.ApplicationsHoldDepoistPrTimeType = {}));
/**
    * @export
    * @enum {string}
    */
var AutoPayConfigDtoTypeEnum;
(function (AutoPayConfigDtoTypeEnum) {
    AutoPayConfigDtoTypeEnum["Otp"] = "OTP";
    AutoPayConfigDtoTypeEnum["Fap"] = "FAP";
    AutoPayConfigDtoTypeEnum["Vap"] = "VAP";
})(AutoPayConfigDtoTypeEnum = exports.AutoPayConfigDtoTypeEnum || (exports.AutoPayConfigDtoTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var AutoPayFrequency;
(function (AutoPayFrequency) {
    AutoPayFrequency["M"] = "M";
    AutoPayFrequency["W"] = "W";
    AutoPayFrequency["Q"] = "Q";
    AutoPayFrequency["S"] = "S";
    AutoPayFrequency["A"] = "A";
    AutoPayFrequency["OneTime"] = "One-Time";
    AutoPayFrequency["BiWeekly"] = "Bi-Weekly";
})(AutoPayFrequency = exports.AutoPayFrequency || (exports.AutoPayFrequency = {}));
/**
 *
 * @export
 * @enum {string}
 */
var AutoPayType;
(function (AutoPayType) {
    AutoPayType["Fixed"] = "Fixed";
    AutoPayType["Variable"] = "Variable";
})(AutoPayType = exports.AutoPayType || (exports.AutoPayType = {}));
/**
    * @export
    * @enum {string}
    */
var BankAccountDTOAccountTypeEnum;
(function (BankAccountDTOAccountTypeEnum) {
    BankAccountDTOAccountTypeEnum["C"] = "C";
    BankAccountDTOAccountTypeEnum["S"] = "S";
})(BankAccountDTOAccountTypeEnum = exports.BankAccountDTOAccountTypeEnum || (exports.BankAccountDTOAccountTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var BankAccountDTOFundingStatusEnum;
(function (BankAccountDTOFundingStatusEnum) {
    BankAccountDTOFundingStatusEnum["Submitted"] = "Submitted";
    BankAccountDTOFundingStatusEnum["Approved"] = "Approved";
    BankAccountDTOFundingStatusEnum["AdditionalInfoRequired"] = "Additional Info Required";
})(BankAccountDTOFundingStatusEnum = exports.BankAccountDTOFundingStatusEnum || (exports.BankAccountDTOFundingStatusEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var BankAccountSearchField;
(function (BankAccountSearchField) {
    BankAccountSearchField["NickName"] = "NickName";
    BankAccountSearchField["AccountLastFour"] = "AccountLastFour";
    BankAccountSearchField["FundingStatus"] = "FundingStatus";
})(BankAccountSearchField = exports.BankAccountSearchField || (exports.BankAccountSearchField = {}));
/**
    * @export
    * @enum {string}
    */
var BankAccountV2DtoAccountTypeEnum;
(function (BankAccountV2DtoAccountTypeEnum) {
    BankAccountV2DtoAccountTypeEnum["C"] = "C";
    BankAccountV2DtoAccountTypeEnum["S"] = "S";
})(BankAccountV2DtoAccountTypeEnum = exports.BankAccountV2DtoAccountTypeEnum || (exports.BankAccountV2DtoAccountTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var BankAccountV2DtoFundingStatusEnum;
(function (BankAccountV2DtoFundingStatusEnum) {
    BankAccountV2DtoFundingStatusEnum["Submitted"] = "Submitted";
    BankAccountV2DtoFundingStatusEnum["Approved"] = "Approved";
    BankAccountV2DtoFundingStatusEnum["AdditionalInfoRequired"] = "Additional Info Required";
})(BankAccountV2DtoFundingStatusEnum = exports.BankAccountV2DtoFundingStatusEnum || (exports.BankAccountV2DtoFundingStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var BankCardDTOCardTypeEnum;
(function (BankCardDTOCardTypeEnum) {
    BankCardDTOCardTypeEnum["Cc"] = "CC";
    BankCardDTOCardTypeEnum["Db"] = "DB";
})(BankCardDTOCardTypeEnum = exports.BankCardDTOCardTypeEnum || (exports.BankCardDTOCardTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var BankCardDTOProcessAsCardTypeEnum;
(function (BankCardDTOProcessAsCardTypeEnum) {
    BankCardDTOProcessAsCardTypeEnum["Cc"] = "CC";
    BankCardDTOProcessAsCardTypeEnum["Db"] = "DB";
})(BankCardDTOProcessAsCardTypeEnum = exports.BankCardDTOProcessAsCardTypeEnum || (exports.BankCardDTOProcessAsCardTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var BankCardType;
(function (BankCardType) {
    BankCardType["Cc"] = "CC";
    BankCardType["Db"] = "DB";
})(BankCardType = exports.BankCardType || (exports.BankCardType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ChangeApplicationStatusEnum;
(function (ChangeApplicationStatusEnum) {
    ChangeApplicationStatusEnum["Approve"] = "Approve";
    ChangeApplicationStatusEnum["Deny"] = "Deny";
    ChangeApplicationStatusEnum["Return"] = "Return";
    ChangeApplicationStatusEnum["Submit"] = "Submit";
})(ChangeApplicationStatusEnum = exports.ChangeApplicationStatusEnum || (exports.ChangeApplicationStatusEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var CompanyType;
(function (CompanyType) {
    CompanyType["SoleProprietorship"] = "SoleProprietorship";
    CompanyType["Corporation"] = "Corporation";
    CompanyType["Llc"] = "LLC";
    CompanyType["Partnership"] = "Partnership";
    CompanyType["Nonprofit"] = "Nonprofit";
})(CompanyType = exports.CompanyType || (exports.CompanyType = {}));
/**
    * @export
    * @enum {string}
    */
var CreateAnnouncementDtoStatusEnum;
(function (CreateAnnouncementDtoStatusEnum) {
    CreateAnnouncementDtoStatusEnum["Draft"] = "DRAFT";
    CreateAnnouncementDtoStatusEnum["Scheduled"] = "SCHEDULED";
})(CreateAnnouncementDtoStatusEnum = exports.CreateAnnouncementDtoStatusEnum || (exports.CreateAnnouncementDtoStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CreateApplicationEmploymentDtoStatusEnum;
(function (CreateApplicationEmploymentDtoStatusEnum) {
    CreateApplicationEmploymentDtoStatusEnum["Employed"] = "Employed";
    CreateApplicationEmploymentDtoStatusEnum["NotEmployed"] = "Not Employed";
    CreateApplicationEmploymentDtoStatusEnum["SelfEmployed"] = "Self Employed";
})(CreateApplicationEmploymentDtoStatusEnum = exports.CreateApplicationEmploymentDtoStatusEnum || (exports.CreateApplicationEmploymentDtoStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CreateApplicationOccupantDtoGovIdTypeEnum;
(function (CreateApplicationOccupantDtoGovIdTypeEnum) {
    CreateApplicationOccupantDtoGovIdTypeEnum["Passport"] = "Passport";
    CreateApplicationOccupantDtoGovIdTypeEnum["Id"] = "ID";
    CreateApplicationOccupantDtoGovIdTypeEnum["DriversLicense"] = "Drivers License";
})(CreateApplicationOccupantDtoGovIdTypeEnum = exports.CreateApplicationOccupantDtoGovIdTypeEnum || (exports.CreateApplicationOccupantDtoGovIdTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CreateApplicationOccupantDtoEmploymentStatusEnum;
(function (CreateApplicationOccupantDtoEmploymentStatusEnum) {
    CreateApplicationOccupantDtoEmploymentStatusEnum["Employed"] = "Employed";
    CreateApplicationOccupantDtoEmploymentStatusEnum["NotEmployed"] = "Not Employed";
    CreateApplicationOccupantDtoEmploymentStatusEnum["SelfEmployed"] = "Self Employed";
})(CreateApplicationOccupantDtoEmploymentStatusEnum = exports.CreateApplicationOccupantDtoEmploymentStatusEnum || (exports.CreateApplicationOccupantDtoEmploymentStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CreateApplicationOccupantDtoGenderEnum;
(function (CreateApplicationOccupantDtoGenderEnum) {
    CreateApplicationOccupantDtoGenderEnum["Male"] = "MALE";
    CreateApplicationOccupantDtoGenderEnum["Female"] = "FEMALE";
    CreateApplicationOccupantDtoGenderEnum["NonBinary"] = "NON-BINARY";
    CreateApplicationOccupantDtoGenderEnum["Other"] = "OTHER";
})(CreateApplicationOccupantDtoGenderEnum = exports.CreateApplicationOccupantDtoGenderEnum || (exports.CreateApplicationOccupantDtoGenderEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CreateApplicationVehicleDtoTypeEnum;
(function (CreateApplicationVehicleDtoTypeEnum) {
    CreateApplicationVehicleDtoTypeEnum["Car"] = "Car";
    CreateApplicationVehicleDtoTypeEnum["Truck"] = "Truck";
    CreateApplicationVehicleDtoTypeEnum["Suv"] = "SUV";
    CreateApplicationVehicleDtoTypeEnum["Boat"] = "Boat";
    CreateApplicationVehicleDtoTypeEnum["Rv"] = "RV";
    CreateApplicationVehicleDtoTypeEnum["Trailer"] = "Trailer";
    CreateApplicationVehicleDtoTypeEnum["Other"] = "Other";
})(CreateApplicationVehicleDtoTypeEnum = exports.CreateApplicationVehicleDtoTypeEnum || (exports.CreateApplicationVehicleDtoTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CreateBankAccountDTOAccountTypeEnum;
(function (CreateBankAccountDTOAccountTypeEnum) {
    CreateBankAccountDTOAccountTypeEnum["C"] = "C";
    CreateBankAccountDTOAccountTypeEnum["S"] = "S";
})(CreateBankAccountDTOAccountTypeEnum = exports.CreateBankAccountDTOAccountTypeEnum || (exports.CreateBankAccountDTOAccountTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CreateBankAccountV2DtoAccountTypeEnum;
(function (CreateBankAccountV2DtoAccountTypeEnum) {
    CreateBankAccountV2DtoAccountTypeEnum["C"] = "C";
    CreateBankAccountV2DtoAccountTypeEnum["S"] = "S";
})(CreateBankAccountV2DtoAccountTypeEnum = exports.CreateBankAccountV2DtoAccountTypeEnum || (exports.CreateBankAccountV2DtoAccountTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var CustomQuestionResponseTypeEnum;
(function (CustomQuestionResponseTypeEnum) {
    CustomQuestionResponseTypeEnum["Boolean"] = "Boolean";
    CustomQuestionResponseTypeEnum["FreeText"] = "FreeText";
})(CustomQuestionResponseTypeEnum = exports.CustomQuestionResponseTypeEnum || (exports.CustomQuestionResponseTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var CustomQuestionTypeEnum;
(function (CustomQuestionTypeEnum) {
    CustomQuestionTypeEnum["PersonalV1"] = "PersonalV1";
    CustomQuestionTypeEnum["EmployeeV1"] = "EmployeeV1";
    CustomQuestionTypeEnum["PetV1"] = "PetV1";
    CustomQuestionTypeEnum["AdditionalOccupantV1"] = "AdditionalOccupantV1";
    CustomQuestionTypeEnum["VehicleV1"] = "VehicleV1";
    CustomQuestionTypeEnum["CustomV1"] = "CustomV1";
    CustomQuestionTypeEnum["RentalHistoryV1"] = "RentalHistoryV1";
})(CustomQuestionTypeEnum = exports.CustomQuestionTypeEnum || (exports.CustomQuestionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DepositDetailItemDTOPaymentTypeEnum;
(function (DepositDetailItemDTOPaymentTypeEnum) {
    DepositDetailItemDTOPaymentTypeEnum["Ach"] = "ACH";
    DepositDetailItemDTOPaymentTypeEnum["Chk21"] = "CHK21";
    DepositDetailItemDTOPaymentTypeEnum["Cc"] = "CC";
    DepositDetailItemDTOPaymentTypeEnum["Db"] = "DB";
    DepositDetailItemDTOPaymentTypeEnum["Pp"] = "PP";
    DepositDetailItemDTOPaymentTypeEnum["Ca"] = "CA";
})(DepositDetailItemDTOPaymentTypeEnum = exports.DepositDetailItemDTOPaymentTypeEnum || (exports.DepositDetailItemDTOPaymentTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var DepositSearchField;
(function (DepositSearchField) {
    DepositSearchField["DepositId"] = "DepositID";
    DepositSearchField["Amount"] = "Amount";
    DepositSearchField["Type"] = "Type";
    DepositSearchField["PaymentId"] = "PaymentID";
    DepositSearchField["DepositDate"] = "DepositDate";
    DepositSearchField["BankAccount"] = "BankAccount";
    DepositSearchField["DailyPaymentSummary"] = "DailyPaymentSummary";
})(DepositSearchField = exports.DepositSearchField || (exports.DepositSearchField = {}));
/**
 *
 * @export
 * @enum {string}
 */
var DisburseSearchField;
(function (DisburseSearchField) {
    DisburseSearchField["PaymentId"] = "PaymentId";
    DisburseSearchField["PayeeName"] = "PayeeName";
    DisburseSearchField["Amount"] = "Amount";
    DisburseSearchField["Status"] = "Status";
    DisburseSearchField["Threshold"] = "Threshold";
})(DisburseSearchField = exports.DisburseSearchField || (exports.DisburseSearchField = {}));
/**
    * @export
    * @enum {string}
    */
var DisbursementSearchParamsDTODisburseTypeEnum;
(function (DisbursementSearchParamsDTODisburseTypeEnum) {
    DisbursementSearchParamsDTODisburseTypeEnum["OwnerDistribution"] = "OwnerDistribution";
})(DisbursementSearchParamsDTODisburseTypeEnum = exports.DisbursementSearchParamsDTODisburseTypeEnum || (exports.DisbursementSearchParamsDTODisburseTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var DocumentOwnerType;
(function (DocumentOwnerType) {
    DocumentOwnerType["Owner"] = "Owner";
    DocumentOwnerType["Property"] = "Property";
    DocumentOwnerType["Resident"] = "Resident";
})(DocumentOwnerType = exports.DocumentOwnerType || (exports.DocumentOwnerType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var DocumentTypes;
(function (DocumentTypes) {
    DocumentTypes["BankAccountFile"] = "BankAccountFile";
    DocumentTypes["Companylegalese"] = "Companylegalese";
    DocumentTypes["WorkOrderFile"] = "WorkOrderFile";
    DocumentTypes["GovIssuedId"] = "GovIssuedID";
    DocumentTypes["ProofOfIncome"] = "ProofOfIncome";
    DocumentTypes["PetPhoto"] = "PetPhoto";
    DocumentTypes["Ftp"] = "FTP";
    DocumentTypes["AcknowledgementFile"] = "AcknowledgementFile";
    DocumentTypes["OwnerStatement"] = "OwnerStatement";
    DocumentTypes["VendorInvoice"] = "VendorInvoice";
    DocumentTypes["VendorEstimate"] = "VendorEstimate";
    DocumentTypes["OwnerDocumentOther"] = "OwnerDocumentOther";
    DocumentTypes["PropertyManagementAgreement"] = "PropertyManagementAgreement";
    DocumentTypes["Lease"] = "Lease";
    DocumentTypes["LeaseAddendum"] = "LeaseAddendum";
    DocumentTypes["UtilityBill"] = "UtilityBill";
    DocumentTypes["OtherManagementDocuments"] = "OtherManagementDocuments";
    DocumentTypes["CompletedApplicationPdf"] = "CompletedApplicationPdf";
})(DocumentTypes = exports.DocumentTypes || (exports.DocumentTypes = {}));
/**
 *
 * @export
 * @enum {string}
 */
var EmploymentStatusEnum;
(function (EmploymentStatusEnum) {
    EmploymentStatusEnum["Employed"] = "Employed";
    EmploymentStatusEnum["NotEmployed"] = "Not Employed";
    EmploymentStatusEnum["SelfEmployed"] = "Self Employed";
})(EmploymentStatusEnum = exports.EmploymentStatusEnum || (exports.EmploymentStatusEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var EntityTypeDescriptionEnum;
(function (EntityTypeDescriptionEnum) {
    EntityTypeDescriptionEnum["InternalCompany"] = "InternalCompany";
    EntityTypeDescriptionEnum["Resident"] = "Resident";
    EntityTypeDescriptionEnum["Company"] = "Company";
    EntityTypeDescriptionEnum["Property"] = "Property";
    EntityTypeDescriptionEnum["InternalEmployee"] = "InternalEmployee";
    EntityTypeDescriptionEnum["CompanyStaff"] = "CompanyStaff";
    EntityTypeDescriptionEnum["Lease"] = "Lease";
    EntityTypeDescriptionEnum["User"] = "User";
    EntityTypeDescriptionEnum["Address"] = "Address";
    EntityTypeDescriptionEnum["BankAccount"] = "BankAccount";
    EntityTypeDescriptionEnum["BankCard"] = "BankCard";
    EntityTypeDescriptionEnum["KycOfficer"] = "KYCOfficer";
    EntityTypeDescriptionEnum["Applicant"] = "Applicant";
    EntityTypeDescriptionEnum["Owner"] = "Owner";
    EntityTypeDescriptionEnum["Partner"] = "Partner";
    EntityTypeDescriptionEnum["Pet"] = "Pet";
    EntityTypeDescriptionEnum["Application"] = "Application";
    EntityTypeDescriptionEnum["MaintenanceRequest"] = "MaintenanceRequest";
    EntityTypeDescriptionEnum["WorkOrder"] = "WorkOrder";
    EntityTypeDescriptionEnum["GenericPayer"] = "GenericPayer";
    EntityTypeDescriptionEnum["Vendor"] = "Vendor";
    EntityTypeDescriptionEnum["Vehicle"] = "Vehicle";
    EntityTypeDescriptionEnum["Employment"] = "Employment";
    EntityTypeDescriptionEnum["RentalHistory"] = "RentalHistory";
    EntityTypeDescriptionEnum["VendorUser"] = "VendorUser";
    EntityTypeDescriptionEnum["PropertyGroup"] = "PropertyGroup";
    EntityTypeDescriptionEnum["InosioStaff"] = "InosioStaff";
})(EntityTypeDescriptionEnum = exports.EntityTypeDescriptionEnum || (exports.EntityTypeDescriptionEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var FeeTypeEnum;
(function (FeeTypeEnum) {
    FeeTypeEnum["F"] = "F";
    FeeTypeEnum["P"] = "P";
    FeeTypeEnum["T"] = "T";
})(FeeTypeEnum = exports.FeeTypeEnum || (exports.FeeTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var IntersectionBankCardDTOBankAccountDTOCardTypeEnum;
(function (IntersectionBankCardDTOBankAccountDTOCardTypeEnum) {
    IntersectionBankCardDTOBankAccountDTOCardTypeEnum["Cc"] = "CC";
    IntersectionBankCardDTOBankAccountDTOCardTypeEnum["Db"] = "DB";
})(IntersectionBankCardDTOBankAccountDTOCardTypeEnum = exports.IntersectionBankCardDTOBankAccountDTOCardTypeEnum || (exports.IntersectionBankCardDTOBankAccountDTOCardTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var IntersectionBankCardDTOBankAccountDTOProcessAsCardTypeEnum;
(function (IntersectionBankCardDTOBankAccountDTOProcessAsCardTypeEnum) {
    IntersectionBankCardDTOBankAccountDTOProcessAsCardTypeEnum["Cc"] = "CC";
    IntersectionBankCardDTOBankAccountDTOProcessAsCardTypeEnum["Db"] = "DB";
})(IntersectionBankCardDTOBankAccountDTOProcessAsCardTypeEnum = exports.IntersectionBankCardDTOBankAccountDTOProcessAsCardTypeEnum || (exports.IntersectionBankCardDTOBankAccountDTOProcessAsCardTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var IntersectionBankCardDTOBankAccountDTOAccountTypeEnum;
(function (IntersectionBankCardDTOBankAccountDTOAccountTypeEnum) {
    IntersectionBankCardDTOBankAccountDTOAccountTypeEnum["C"] = "C";
    IntersectionBankCardDTOBankAccountDTOAccountTypeEnum["S"] = "S";
})(IntersectionBankCardDTOBankAccountDTOAccountTypeEnum = exports.IntersectionBankCardDTOBankAccountDTOAccountTypeEnum || (exports.IntersectionBankCardDTOBankAccountDTOAccountTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var IntersectionBankCardDTOBankAccountDTOFundingStatusEnum;
(function (IntersectionBankCardDTOBankAccountDTOFundingStatusEnum) {
    IntersectionBankCardDTOBankAccountDTOFundingStatusEnum["Submitted"] = "Submitted";
    IntersectionBankCardDTOBankAccountDTOFundingStatusEnum["Approved"] = "Approved";
    IntersectionBankCardDTOBankAccountDTOFundingStatusEnum["AdditionalInfoRequired"] = "Additional Info Required";
})(IntersectionBankCardDTOBankAccountDTOFundingStatusEnum = exports.IntersectionBankCardDTOBankAccountDTOFundingStatusEnum || (exports.IntersectionBankCardDTOBankAccountDTOFundingStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var InvitedCoapplicantDtoStatusEnum;
(function (InvitedCoapplicantDtoStatusEnum) {
    InvitedCoapplicantDtoStatusEnum["Invited"] = "Invited";
    InvitedCoapplicantDtoStatusEnum["Registered"] = "Registered";
    InvitedCoapplicantDtoStatusEnum["Submitted"] = "Submitted";
})(InvitedCoapplicantDtoStatusEnum = exports.InvitedCoapplicantDtoStatusEnum || (exports.InvitedCoapplicantDtoStatusEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var InvoiceFileType;
(function (InvoiceFileType) {
    InvoiceFileType["SummaryPdf"] = "SummaryPDF";
    InvoiceFileType["DetailCsv"] = "DetailCSV";
})(InvoiceFileType = exports.InvoiceFileType || (exports.InvoiceFileType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var LeaseStatusEnum;
(function (LeaseStatusEnum) {
    LeaseStatusEnum["Current"] = "Current";
    LeaseStatusEnum["Past"] = "Past";
    LeaseStatusEnum["Future"] = "Future";
    LeaseStatusEnum["Other"] = "Other";
})(LeaseStatusEnum = exports.LeaseStatusEnum || (exports.LeaseStatusEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var LedgerItemTypeEnum;
(function (LedgerItemTypeEnum) {
    LedgerItemTypeEnum["Credit"] = "Credit";
    LedgerItemTypeEnum["Debit"] = "Debit";
})(LedgerItemTypeEnum = exports.LedgerItemTypeEnum || (exports.LedgerItemTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var LedgerTypes;
(function (LedgerTypes) {
    LedgerTypes["Ledger"] = "Ledger";
    LedgerTypes["Tenant"] = "Tenant";
    LedgerTypes["Security"] = "Security";
    LedgerTypes["Vendor"] = "Vendor";
})(LedgerTypes = exports.LedgerTypes || (exports.LedgerTypes = {}));
/**
 *
 * @export
 * @enum {string}
 */
var LedgerUserTypeEnum;
(function (LedgerUserTypeEnum) {
    LedgerUserTypeEnum["Owner"] = "Owner";
    LedgerUserTypeEnum["Resident"] = "Resident";
})(LedgerUserTypeEnum = exports.LedgerUserTypeEnum || (exports.LedgerUserTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var MaintenanceSearchField;
(function (MaintenanceSearchField) {
    MaintenanceSearchField["Status"] = "Status";
})(MaintenanceSearchField = exports.MaintenanceSearchField || (exports.MaintenanceSearchField = {}));
/**
    * @export
    * @enum {string}
    */
var OccupantDtoGenderEnum;
(function (OccupantDtoGenderEnum) {
    OccupantDtoGenderEnum["Male"] = "MALE";
    OccupantDtoGenderEnum["Female"] = "FEMALE";
    OccupantDtoGenderEnum["NonBinary"] = "NON-BINARY";
    OccupantDtoGenderEnum["Other"] = "OTHER";
})(OccupantDtoGenderEnum = exports.OccupantDtoGenderEnum || (exports.OccupantDtoGenderEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var OnboardingApplicationStatus;
(function (OnboardingApplicationStatus) {
    OnboardingApplicationStatus["Incomplete"] = "APPLICATION_INCOMPLETE";
    OnboardingApplicationStatus["Submitted"] = "APPLICATION_SUBMITTED";
    OnboardingApplicationStatus["Rejected"] = "APPLICATION_REJECTED";
    OnboardingApplicationStatus["Approved"] = "APPLICATION_APPROVED";
})(OnboardingApplicationStatus = exports.OnboardingApplicationStatus || (exports.OnboardingApplicationStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
var OnboardingStepStatus;
(function (OnboardingStepStatus) {
    OnboardingStepStatus["Completed"] = "Completed";
    OnboardingStepStatus["Incomplete"] = "Incomplete";
})(OnboardingStepStatus = exports.OnboardingStepStatus || (exports.OnboardingStepStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
var OnboardingStepType;
(function (OnboardingStepType) {
    OnboardingStepType["PaymentsProcessingApplication"] = "PAYMENTS_PROCESSING_APPLICATION";
    OnboardingStepType["AddIntegration"] = "ADD_INTEGRATION";
    OnboardingStepType["AddOtherUsers"] = "ADD_OTHER_USERS";
    OnboardingStepType["ImplementationCall"] = "IMPLEMENTATION_CALL";
    OnboardingStepType["PaymentOnboardingComplete"] = "PAYMENT_ONBOARDING_COMPLETE";
    OnboardingStepType["ApplicationOnboardingComplete"] = "APPLICATION_ONBOARDING_COMPLETE";
    OnboardingStepType["MaintenanceOnboardingComplete"] = "MAINTENANCE_ONBOARDING_COMPLETE";
})(OnboardingStepType = exports.OnboardingStepType || (exports.OnboardingStepType = {}));
/**
    * @export
    * @enum {string}
    */
var OwnerSearchRequestDtoRegistrationStatusEnum;
(function (OwnerSearchRequestDtoRegistrationStatusEnum) {
    OwnerSearchRequestDtoRegistrationStatusEnum["Registered"] = "REGISTERED";
    OwnerSearchRequestDtoRegistrationStatusEnum["Unregistered"] = "UNREGISTERED";
})(OwnerSearchRequestDtoRegistrationStatusEnum = exports.OwnerSearchRequestDtoRegistrationStatusEnum || (exports.OwnerSearchRequestDtoRegistrationStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var OwnerSearchRequestDtoStatusEnum;
(function (OwnerSearchRequestDtoStatusEnum) {
    OwnerSearchRequestDtoStatusEnum["Active"] = "ACTIVE";
    OwnerSearchRequestDtoStatusEnum["Inactive"] = "INACTIVE";
})(OwnerSearchRequestDtoStatusEnum = exports.OwnerSearchRequestDtoStatusEnum || (exports.OwnerSearchRequestDtoStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var OwnerSearchResponseV2DtoRegistrationStatusEnum;
(function (OwnerSearchResponseV2DtoRegistrationStatusEnum) {
    OwnerSearchResponseV2DtoRegistrationStatusEnum["Registered"] = "REGISTERED";
    OwnerSearchResponseV2DtoRegistrationStatusEnum["Unregistered"] = "UNREGISTERED";
})(OwnerSearchResponseV2DtoRegistrationStatusEnum = exports.OwnerSearchResponseV2DtoRegistrationStatusEnum || (exports.OwnerSearchResponseV2DtoRegistrationStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var OwnerSearchResponseV2DtoStatusEnum;
(function (OwnerSearchResponseV2DtoStatusEnum) {
    OwnerSearchResponseV2DtoStatusEnum["Active"] = "ACTIVE";
    OwnerSearchResponseV2DtoStatusEnum["Inactive"] = "INACTIVE";
})(OwnerSearchResponseV2DtoStatusEnum = exports.OwnerSearchResponseV2DtoStatusEnum || (exports.OwnerSearchResponseV2DtoStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var OwnerSortColumnEnum;
(function (OwnerSortColumnEnum) {
    OwnerSortColumnEnum["Name"] = "Name";
    OwnerSortColumnEnum["OwnerId"] = "OwnerId";
    OwnerSortColumnEnum["Property"] = "Property";
})(OwnerSortColumnEnum = exports.OwnerSortColumnEnum || (exports.OwnerSortColumnEnum = {}));
/**
    * @export
    * @enum {string}
    */
var OwnerSortDirectionEnum;
(function (OwnerSortDirectionEnum) {
    OwnerSortDirectionEnum["Asc"] = "ASC";
    OwnerSortDirectionEnum["Desc"] = "DESC";
})(OwnerSortDirectionEnum = exports.OwnerSortDirectionEnum || (exports.OwnerSortDirectionEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var PaidByEnum;
(function (PaidByEnum) {
    PaidByEnum["Payer"] = "Payer";
    PaidByEnum["Pm"] = "PM";
})(PaidByEnum = exports.PaidByEnum || (exports.PaidByEnum = {}));
/**
    * @export
    * @enum {string}
    */
var PartnerTransactionDtoPaymentTypeEnum;
(function (PartnerTransactionDtoPaymentTypeEnum) {
    PartnerTransactionDtoPaymentTypeEnum["Ach"] = "ACH";
    PartnerTransactionDtoPaymentTypeEnum["Chk21"] = "CHK21";
    PartnerTransactionDtoPaymentTypeEnum["Cc"] = "CC";
    PartnerTransactionDtoPaymentTypeEnum["Db"] = "DB";
    PartnerTransactionDtoPaymentTypeEnum["Pp"] = "PP";
    PartnerTransactionDtoPaymentTypeEnum["Ca"] = "CA";
})(PartnerTransactionDtoPaymentTypeEnum = exports.PartnerTransactionDtoPaymentTypeEnum || (exports.PartnerTransactionDtoPaymentTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var PayerType;
(function (PayerType) {
    PayerType["Applicant"] = "Applicant";
    PayerType["Owner"] = "Owner";
    PayerType["Resident"] = "Resident";
    PayerType["All"] = "All";
})(PayerType = exports.PayerType || (exports.PayerType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var PaymentClassEnum;
(function (PaymentClassEnum) {
    PaymentClassEnum["Otp"] = "OTP";
    PaymentClassEnum["Fap"] = "FAP";
    PaymentClassEnum["Vap"] = "VAP";
})(PaymentClassEnum = exports.PaymentClassEnum || (exports.PaymentClassEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var PaymentRequestSearchField;
(function (PaymentRequestSearchField) {
    PaymentRequestSearchField["Id"] = "Id";
    PaymentRequestSearchField["Type"] = "Type";
    PaymentRequestSearchField["Amount"] = "Amount";
    PaymentRequestSearchField["Status"] = "Status";
})(PaymentRequestSearchField = exports.PaymentRequestSearchField || (exports.PaymentRequestSearchField = {}));
/**
 *
 * @export
 * @enum {string}
 */
var PaymentRequestStatusType;
(function (PaymentRequestStatusType) {
    PaymentRequestStatusType["Pending"] = "Pending";
    PaymentRequestStatusType["Completed"] = "Completed";
    PaymentRequestStatusType["Cancelled"] = "Cancelled";
    PaymentRequestStatusType["Returned"] = "Returned";
    PaymentRequestStatusType["Refunded"] = "Refunded";
    PaymentRequestStatusType["Chargedback"] = "Chargedback";
})(PaymentRequestStatusType = exports.PaymentRequestStatusType || (exports.PaymentRequestStatusType = {}));
/**
    * @export
    * @enum {string}
    */
var PaymentTypeConfigDtoTypeEnum;
(function (PaymentTypeConfigDtoTypeEnum) {
    PaymentTypeConfigDtoTypeEnum["Ach"] = "ACH";
    PaymentTypeConfigDtoTypeEnum["Chk21"] = "CHK21";
    PaymentTypeConfigDtoTypeEnum["Cc"] = "CC";
    PaymentTypeConfigDtoTypeEnum["Db"] = "DB";
    PaymentTypeConfigDtoTypeEnum["Pp"] = "PP";
    PaymentTypeConfigDtoTypeEnum["Ca"] = "CA";
})(PaymentTypeConfigDtoTypeEnum = exports.PaymentTypeConfigDtoTypeEnum || (exports.PaymentTypeConfigDtoTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var PaymentTypeEnum;
(function (PaymentTypeEnum) {
    PaymentTypeEnum["Ach"] = "ACH";
    PaymentTypeEnum["Chk21"] = "CHK21";
    PaymentTypeEnum["Cc"] = "CC";
    PaymentTypeEnum["Db"] = "DB";
    PaymentTypeEnum["Pp"] = "PP";
    PaymentTypeEnum["Ca"] = "CA";
})(PaymentTypeEnum = exports.PaymentTypeEnum || (exports.PaymentTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var PaymentTypeField;
(function (PaymentTypeField) {
    PaymentTypeField["Ach"] = "Ach";
    PaymentTypeField["Card"] = "Card";
    PaymentTypeField["LeasePartialPayment"] = "LeasePartialPayment";
})(PaymentTypeField = exports.PaymentTypeField || (exports.PaymentTypeField = {}));
/**
 *
 * @export
 * @enum {string}
 */
var PmSearchField;
(function (PmSearchField) {
    PmSearchField["Name"] = "Name";
    PmSearchField["Role"] = "Role";
})(PmSearchField = exports.PmSearchField || (exports.PmSearchField = {}));
/**
 *
 * @export
 * @enum {string}
 */
var PreferredContactMethodEnum;
(function (PreferredContactMethodEnum) {
    PreferredContactMethodEnum["Call"] = "CALL";
    PreferredContactMethodEnum["Email"] = "EMAIL";
    PreferredContactMethodEnum["Text"] = "TEXT";
})(PreferredContactMethodEnum = exports.PreferredContactMethodEnum || (exports.PreferredContactMethodEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ProductBillingTypeEnum;
(function (ProductBillingTypeEnum) {
    ProductBillingTypeEnum["PerConsumption"] = "PerConsumption";
    ProductBillingTypeEnum["FlatMonthlyFee"] = "FlatMonthlyFee";
})(ProductBillingTypeEnum = exports.ProductBillingTypeEnum || (exports.ProductBillingTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ProductTypeEnum;
(function (ProductTypeEnum) {
    ProductTypeEnum["Payments"] = "PAYMENTS";
    ProductTypeEnum["Applications"] = "APPLICATIONS";
    ProductTypeEnum["Maintenance"] = "MAINTENANCE";
    ProductTypeEnum["Screening"] = "SCREENING";
    ProductTypeEnum["OwnerPortal"] = "OWNER_PORTAL";
    ProductTypeEnum["TenantPortal"] = "TENANT_PORTAL";
    ProductTypeEnum["Platform"] = "PLATFORM";
})(ProductTypeEnum = exports.ProductTypeEnum || (exports.ProductTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ProfileSearchType;
(function (ProfileSearchType) {
    ProfileSearchType["Resident"] = "Resident";
    ProfileSearchType["CompanyStaff"] = "CompanyStaff";
    ProfileSearchType["Applicant"] = "Applicant";
    ProfileSearchType["Owner"] = "Owner";
})(ProfileSearchType = exports.ProfileSearchType || (exports.ProfileSearchType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var PropertySearchField;
(function (PropertySearchField) {
    PropertySearchField["PropertyName"] = "PropertyName";
    PropertySearchField["PropertyId"] = "PropertyId";
    PropertySearchField["City"] = "City";
    PropertySearchField["State"] = "State";
    PropertySearchField["Zip"] = "Zip";
})(PropertySearchField = exports.PropertySearchField || (exports.PropertySearchField = {}));
/**
 *
 * @export
 * @enum {string}
 */
var RefundStatusEnum;
(function (RefundStatusEnum) {
    RefundStatusEnum["Requested"] = "Requested";
    RefundStatusEnum["Denied"] = "Denied";
    RefundStatusEnum["Approved"] = "Approved";
    RefundStatusEnum["Issued"] = "Issued";
})(RefundStatusEnum = exports.RefundStatusEnum || (exports.RefundStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ResidentBalanceParamComparatorEnum;
(function (ResidentBalanceParamComparatorEnum) {
    ResidentBalanceParamComparatorEnum["Gte"] = "GTE";
    ResidentBalanceParamComparatorEnum["Lte"] = "LTE";
    ResidentBalanceParamComparatorEnum["Eq"] = "EQ";
})(ResidentBalanceParamComparatorEnum = exports.ResidentBalanceParamComparatorEnum || (exports.ResidentBalanceParamComparatorEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ResidentSearchParamsDTOLeaseStatusEnum;
(function (ResidentSearchParamsDTOLeaseStatusEnum) {
    ResidentSearchParamsDTOLeaseStatusEnum["Future"] = "FUTURE";
    ResidentSearchParamsDTOLeaseStatusEnum["Current"] = "CURRENT";
    ResidentSearchParamsDTOLeaseStatusEnum["Past"] = "PAST";
    ResidentSearchParamsDTOLeaseStatusEnum["Other"] = "OTHER";
})(ResidentSearchParamsDTOLeaseStatusEnum = exports.ResidentSearchParamsDTOLeaseStatusEnum || (exports.ResidentSearchParamsDTOLeaseStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ResidentSearchParamsDTORegistrationStatusEnum;
(function (ResidentSearchParamsDTORegistrationStatusEnum) {
    ResidentSearchParamsDTORegistrationStatusEnum["Registered"] = "REGISTERED";
    ResidentSearchParamsDTORegistrationStatusEnum["Unregistered"] = "UNREGISTERED";
})(ResidentSearchParamsDTORegistrationStatusEnum = exports.ResidentSearchParamsDTORegistrationStatusEnum || (exports.ResidentSearchParamsDTORegistrationStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ResidentSearchResponseV2DtoLeaseStatusEnum;
(function (ResidentSearchResponseV2DtoLeaseStatusEnum) {
    ResidentSearchResponseV2DtoLeaseStatusEnum["Future"] = "FUTURE";
    ResidentSearchResponseV2DtoLeaseStatusEnum["Current"] = "CURRENT";
    ResidentSearchResponseV2DtoLeaseStatusEnum["Past"] = "PAST";
    ResidentSearchResponseV2DtoLeaseStatusEnum["Other"] = "OTHER";
})(ResidentSearchResponseV2DtoLeaseStatusEnum = exports.ResidentSearchResponseV2DtoLeaseStatusEnum || (exports.ResidentSearchResponseV2DtoLeaseStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ResidentSearchResponseV2DtoRegistrationStatusEnum;
(function (ResidentSearchResponseV2DtoRegistrationStatusEnum) {
    ResidentSearchResponseV2DtoRegistrationStatusEnum["Registered"] = "REGISTERED";
    ResidentSearchResponseV2DtoRegistrationStatusEnum["Unregistered"] = "UNREGISTERED";
})(ResidentSearchResponseV2DtoRegistrationStatusEnum = exports.ResidentSearchResponseV2DtoRegistrationStatusEnum || (exports.ResidentSearchResponseV2DtoRegistrationStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ResidentSortColumnEnum;
(function (ResidentSortColumnEnum) {
    ResidentSortColumnEnum["Name"] = "Name";
    ResidentSortColumnEnum["ResidentId"] = "ResidentId";
    ResidentSortColumnEnum["Property"] = "Property";
    ResidentSortColumnEnum["Balance"] = "Balance";
})(ResidentSortColumnEnum = exports.ResidentSortColumnEnum || (exports.ResidentSortColumnEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ResidentSortDirectionEnum;
(function (ResidentSortDirectionEnum) {
    ResidentSortDirectionEnum["Asc"] = "ASC";
    ResidentSortDirectionEnum["Desc"] = "DESC";
})(ResidentSortDirectionEnum = exports.ResidentSortDirectionEnum || (exports.ResidentSortDirectionEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ResponseType;
(function (ResponseType) {
    ResponseType["Email"] = "email";
    ResponseType["Name"] = "name";
})(ResponseType = exports.ResponseType || (exports.ResponseType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var Role;
(function (Role) {
    Role["Resident"] = "Resident";
    Role["PropertyManager"] = "PropertyManager";
    Role["PropertyManagerAdmin"] = "PropertyManagerAdmin";
    Role["MaintenanceCoordinator"] = "MaintenanceCoordinator";
    Role["MaintenanceStaff"] = "MaintenanceStaff";
    Role["PartnerService"] = "PartnerService";
    Role["InosioAdmin"] = "InosioAdmin";
    Role["InosioStaff"] = "InosioStaff";
    Role["AnyAuthenticated"] = "AnyAuthenticated";
    Role["Applicant"] = "Applicant";
    Role["Vendor"] = "Vendor";
    Role["Owner"] = "Owner";
    Role["Mfa"] = "Mfa";
})(Role = exports.Role || (exports.Role = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ScheduleDayOffset;
(function (ScheduleDayOffset) {
    ScheduleDayOffset["OnThisDay"] = "OnThisDay";
    ScheduleDayOffset["FirstBusinessDayOfTheMonth"] = "FirstBusinessDayOfTheMonth";
    ScheduleDayOffset["LastBusinessDayOfTheMonth"] = "LastBusinessDayOfTheMonth";
    ScheduleDayOffset["FirstBusinessDayOnOrAfterCalendarDate"] = "FirstBusinessDayOnOrAfterCalendarDate";
    ScheduleDayOffset["FirstBusinessDayOnOrBeforeCalendarDate"] = "FirstBusinessDayOnOrBeforeCalendarDate";
})(ScheduleDayOffset = exports.ScheduleDayOffset || (exports.ScheduleDayOffset = {}));
/**
    * @export
    * @enum {string}
    */
var ScheduledAutoPayDtoFrequencyEnum;
(function (ScheduledAutoPayDtoFrequencyEnum) {
    ScheduledAutoPayDtoFrequencyEnum["M"] = "M";
    ScheduledAutoPayDtoFrequencyEnum["W"] = "W";
    ScheduledAutoPayDtoFrequencyEnum["Q"] = "Q";
    ScheduledAutoPayDtoFrequencyEnum["S"] = "S";
    ScheduledAutoPayDtoFrequencyEnum["A"] = "A";
    ScheduledAutoPayDtoFrequencyEnum["OneTime"] = "One-Time";
    ScheduledAutoPayDtoFrequencyEnum["BiWeekly"] = "Bi-Weekly";
})(ScheduledAutoPayDtoFrequencyEnum = exports.ScheduledAutoPayDtoFrequencyEnum || (exports.ScheduledAutoPayDtoFrequencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ScheduledAutoPayDtoStatusEnum;
(function (ScheduledAutoPayDtoStatusEnum) {
    ScheduledAutoPayDtoStatusEnum["Active"] = "Active";
    ScheduledAutoPayDtoStatusEnum["Cancelled"] = "Cancelled";
    ScheduledAutoPayDtoStatusEnum["Skipped"] = "Skipped";
})(ScheduledAutoPayDtoStatusEnum = exports.ScheduledAutoPayDtoStatusEnum || (exports.ScheduledAutoPayDtoStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ScheduledAutoPayDtoTypeEnum;
(function (ScheduledAutoPayDtoTypeEnum) {
    ScheduledAutoPayDtoTypeEnum["Fixed"] = "Fixed";
    ScheduledAutoPayDtoTypeEnum["Variable"] = "Variable";
})(ScheduledAutoPayDtoTypeEnum = exports.ScheduledAutoPayDtoTypeEnum || (exports.ScheduledAutoPayDtoTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ScreeningStatusLabelEnum;
(function (ScreeningStatusLabelEnum) {
    ScreeningStatusLabelEnum["Pending"] = "Pending";
    ScreeningStatusLabelEnum["Completed"] = "Completed";
    ScreeningStatusLabelEnum["Cancelled"] = "Cancelled";
})(ScreeningStatusLabelEnum = exports.ScreeningStatusLabelEnum || (exports.ScreeningStatusLabelEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var SearchType;
(function (SearchType) {
    SearchType["Email"] = "email";
    SearchType["Name"] = "name";
})(SearchType = exports.SearchType || (exports.SearchType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var SenderIdentityStatus;
(function (SenderIdentityStatus) {
    SenderIdentityStatus["Enabled"] = "ENABLED";
    SenderIdentityStatus["Disabled"] = "DISABLED";
    SenderIdentityStatus["Pending"] = "PENDING";
})(SenderIdentityStatus = exports.SenderIdentityStatus || (exports.SenderIdentityStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
var SoftwareIntegrationCredentialTypeEnum;
(function (SoftwareIntegrationCredentialTypeEnum) {
    SoftwareIntegrationCredentialTypeEnum["Inosio"] = "INOSIO";
    SoftwareIntegrationCredentialTypeEnum["Promas"] = "PROMAS";
    SoftwareIntegrationCredentialTypeEnum["TenantReports"] = "TENANT_REPORTS";
})(SoftwareIntegrationCredentialTypeEnum = exports.SoftwareIntegrationCredentialTypeEnum || (exports.SoftwareIntegrationCredentialTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var TieredFeeTypeEnum;
(function (TieredFeeTypeEnum) {
    TieredFeeTypeEnum["F"] = "F";
    TieredFeeTypeEnum["P"] = "P";
})(TieredFeeTypeEnum = exports.TieredFeeTypeEnum || (exports.TieredFeeTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var TransSearchField;
(function (TransSearchField) {
    TransSearchField["PaymentId"] = "PaymentId";
    TransSearchField["PayerName"] = "PayerName";
    TransSearchField["PropertyName"] = "PropertyName";
    TransSearchField["Amount"] = "Amount";
    TransSearchField["Status"] = "Status";
    TransSearchField["BatchCloseDate"] = "BatchCloseDate";
})(TransSearchField = exports.TransSearchField || (exports.TransSearchField = {}));
/**
 *
 * @export
 * @enum {string}
 */
var TransactionTypeEnum;
(function (TransactionTypeEnum) {
    TransactionTypeEnum["ResidentPayment"] = "ResidentPayment";
    TransactionTypeEnum["PmPayout"] = "PmPayout";
    TransactionTypeEnum["PmInvoicePayment"] = "PMInvoicePayment";
    TransactionTypeEnum["Return"] = "Return";
    TransactionTypeEnum["Refund"] = "Refund";
    TransactionTypeEnum["PaymentRequest"] = "PaymentRequest";
    TransactionTypeEnum["OwnerPayment"] = "OwnerPayment";
    TransactionTypeEnum["NsfFee"] = "NsfFee";
    TransactionTypeEnum["Chargeback"] = "Chargeback";
    TransactionTypeEnum["OwnerDistribution"] = "OwnerDistribution";
    TransactionTypeEnum["ApplicationFee"] = "ApplicationFee";
    TransactionTypeEnum["QuickPay"] = "QuickPay";
})(TransactionTypeEnum = exports.TransactionTypeEnum || (exports.TransactionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UpdateAnnouncementDtoStatusEnum;
(function (UpdateAnnouncementDtoStatusEnum) {
    UpdateAnnouncementDtoStatusEnum["Draft"] = "DRAFT";
    UpdateAnnouncementDtoStatusEnum["Scheduled"] = "SCHEDULED";
})(UpdateAnnouncementDtoStatusEnum = exports.UpdateAnnouncementDtoStatusEnum || (exports.UpdateAnnouncementDtoStatusEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var UpdateApplicantStatusEnum;
(function (UpdateApplicantStatusEnum) {
    UpdateApplicantStatusEnum["Completed"] = "Completed";
    UpdateApplicantStatusEnum["Incomplete"] = "Incomplete";
})(UpdateApplicantStatusEnum = exports.UpdateApplicantStatusEnum || (exports.UpdateApplicantStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UpdateApplicationEmploymentDtoStatusEnum;
(function (UpdateApplicationEmploymentDtoStatusEnum) {
    UpdateApplicationEmploymentDtoStatusEnum["Employed"] = "Employed";
    UpdateApplicationEmploymentDtoStatusEnum["NotEmployed"] = "Not Employed";
    UpdateApplicationEmploymentDtoStatusEnum["SelfEmployed"] = "Self Employed";
})(UpdateApplicationEmploymentDtoStatusEnum = exports.UpdateApplicationEmploymentDtoStatusEnum || (exports.UpdateApplicationEmploymentDtoStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UpdateApplicationOccupantDtoGovIdTypeEnum;
(function (UpdateApplicationOccupantDtoGovIdTypeEnum) {
    UpdateApplicationOccupantDtoGovIdTypeEnum["Passport"] = "Passport";
    UpdateApplicationOccupantDtoGovIdTypeEnum["Id"] = "ID";
    UpdateApplicationOccupantDtoGovIdTypeEnum["DriversLicense"] = "Drivers License";
})(UpdateApplicationOccupantDtoGovIdTypeEnum = exports.UpdateApplicationOccupantDtoGovIdTypeEnum || (exports.UpdateApplicationOccupantDtoGovIdTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UpdateApplicationOccupantDtoEmploymentStatusEnum;
(function (UpdateApplicationOccupantDtoEmploymentStatusEnum) {
    UpdateApplicationOccupantDtoEmploymentStatusEnum["Employed"] = "Employed";
    UpdateApplicationOccupantDtoEmploymentStatusEnum["NotEmployed"] = "Not Employed";
    UpdateApplicationOccupantDtoEmploymentStatusEnum["SelfEmployed"] = "Self Employed";
})(UpdateApplicationOccupantDtoEmploymentStatusEnum = exports.UpdateApplicationOccupantDtoEmploymentStatusEnum || (exports.UpdateApplicationOccupantDtoEmploymentStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UpdateApplicationOccupantDtoGenderEnum;
(function (UpdateApplicationOccupantDtoGenderEnum) {
    UpdateApplicationOccupantDtoGenderEnum["Male"] = "MALE";
    UpdateApplicationOccupantDtoGenderEnum["Female"] = "FEMALE";
    UpdateApplicationOccupantDtoGenderEnum["NonBinary"] = "NON-BINARY";
    UpdateApplicationOccupantDtoGenderEnum["Other"] = "OTHER";
})(UpdateApplicationOccupantDtoGenderEnum = exports.UpdateApplicationOccupantDtoGenderEnum || (exports.UpdateApplicationOccupantDtoGenderEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UpdateApplicationVehicleDtoTypeEnum;
(function (UpdateApplicationVehicleDtoTypeEnum) {
    UpdateApplicationVehicleDtoTypeEnum["Car"] = "Car";
    UpdateApplicationVehicleDtoTypeEnum["Truck"] = "Truck";
    UpdateApplicationVehicleDtoTypeEnum["Suv"] = "SUV";
    UpdateApplicationVehicleDtoTypeEnum["Boat"] = "Boat";
    UpdateApplicationVehicleDtoTypeEnum["Rv"] = "RV";
    UpdateApplicationVehicleDtoTypeEnum["Trailer"] = "Trailer";
    UpdateApplicationVehicleDtoTypeEnum["Other"] = "Other";
})(UpdateApplicationVehicleDtoTypeEnum = exports.UpdateApplicationVehicleDtoTypeEnum || (exports.UpdateApplicationVehicleDtoTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UpdateBankAccountDTOAccountTypeEnum;
(function (UpdateBankAccountDTOAccountTypeEnum) {
    UpdateBankAccountDTOAccountTypeEnum["C"] = "C";
    UpdateBankAccountDTOAccountTypeEnum["S"] = "S";
})(UpdateBankAccountDTOAccountTypeEnum = exports.UpdateBankAccountDTOAccountTypeEnum || (exports.UpdateBankAccountDTOAccountTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var UpdateOwnerStatusEnum;
(function (UpdateOwnerStatusEnum) {
    UpdateOwnerStatusEnum["Reactivate"] = "Reactivate";
    UpdateOwnerStatusEnum["Deactivate"] = "Deactivate";
})(UpdateOwnerStatusEnum = exports.UpdateOwnerStatusEnum || (exports.UpdateOwnerStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UpdateVendorDtoStatusEnum;
(function (UpdateVendorDtoStatusEnum) {
    UpdateVendorDtoStatusEnum["Active"] = "Active";
    UpdateVendorDtoStatusEnum["Inactive"] = "Inactive";
})(UpdateVendorDtoStatusEnum = exports.UpdateVendorDtoStatusEnum || (exports.UpdateVendorDtoStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UserRegistrationResponseStatusEnum;
(function (UserRegistrationResponseStatusEnum) {
    UserRegistrationResponseStatusEnum["Success"] = "Success";
    UserRegistrationResponseStatusEnum["Failure"] = "Failure";
})(UserRegistrationResponseStatusEnum = exports.UserRegistrationResponseStatusEnum || (exports.UserRegistrationResponseStatusEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ValidRequestMessages;
(function (ValidRequestMessages) {
    ValidRequestMessages["Approved"] = "APPROVED";
    ValidRequestMessages["Denied"] = "DENIED";
    ValidRequestMessages["Adhoc"] = "ADHOC";
    ValidRequestMessages["Refund"] = "REFUND";
    ValidRequestMessages["Cancel"] = "CANCEL";
    ValidRequestMessages["Acceptchargeback"] = "ACCEPTCHARGEBACK";
    ValidRequestMessages["Disputechargeback"] = "DISPUTECHARGEBACK";
})(ValidRequestMessages = exports.ValidRequestMessages || (exports.ValidRequestMessages = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ValidTransactionStatusEnum;
(function (ValidTransactionStatusEnum) {
    ValidTransactionStatusEnum["Pending"] = "Pending";
    ValidTransactionStatusEnum["Completed"] = "Completed";
    ValidTransactionStatusEnum["Cancelled"] = "Cancelled";
    ValidTransactionStatusEnum["Returned"] = "Returned";
    ValidTransactionStatusEnum["Refunded"] = "Refunded";
    ValidTransactionStatusEnum["Chargedback"] = "Chargedback";
})(ValidTransactionStatusEnum = exports.ValidTransactionStatusEnum || (exports.ValidTransactionStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var VendorSearchDTOSearchStatusEnum;
(function (VendorSearchDTOSearchStatusEnum) {
    VendorSearchDTOSearchStatusEnum["Active"] = "Active";
    VendorSearchDTOSearchStatusEnum["Inactive"] = "Inactive";
})(VendorSearchDTOSearchStatusEnum = exports.VendorSearchDTOSearchStatusEnum || (exports.VendorSearchDTOSearchStatusEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var VendorSearchField;
(function (VendorSearchField) {
    VendorSearchField["Name"] = "Name";
    VendorSearchField["ContactName"] = "ContactName";
})(VendorSearchField = exports.VendorSearchField || (exports.VendorSearchField = {}));
/**
    * @export
    * @enum {string}
    */
var WorkOrderAssigneeDtoTypeEnum;
(function (WorkOrderAssigneeDtoTypeEnum) {
    WorkOrderAssigneeDtoTypeEnum["Vendor"] = "vendor";
    WorkOrderAssigneeDtoTypeEnum["Staff"] = "staff";
})(WorkOrderAssigneeDtoTypeEnum = exports.WorkOrderAssigneeDtoTypeEnum || (exports.WorkOrderAssigneeDtoTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var WorkOrderCostApprovalEnum;
(function (WorkOrderCostApprovalEnum) {
    WorkOrderCostApprovalEnum["Always"] = "ALWAYS";
    WorkOrderCostApprovalEnum["Never"] = "NEVER";
    WorkOrderCostApprovalEnum["AboveLimit"] = "ABOVE_LIMIT";
})(WorkOrderCostApprovalEnum = exports.WorkOrderCostApprovalEnum || (exports.WorkOrderCostApprovalEnum = {}));
/**
    * @export
    * @enum {string}
    */
var WorkOrderEntityWorkOrderCostApprovalEnum;
(function (WorkOrderEntityWorkOrderCostApprovalEnum) {
    WorkOrderEntityWorkOrderCostApprovalEnum["Always"] = "ALWAYS";
    WorkOrderEntityWorkOrderCostApprovalEnum["Never"] = "NEVER";
    WorkOrderEntityWorkOrderCostApprovalEnum["AboveLimit"] = "ABOVE_LIMIT";
})(WorkOrderEntityWorkOrderCostApprovalEnum = exports.WorkOrderEntityWorkOrderCostApprovalEnum || (exports.WorkOrderEntityWorkOrderCostApprovalEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var WorkOrderPriorityEnum;
(function (WorkOrderPriorityEnum) {
    WorkOrderPriorityEnum["Standard"] = "Standard";
    WorkOrderPriorityEnum["Low"] = "Low";
    WorkOrderPriorityEnum["High"] = "High";
    WorkOrderPriorityEnum["Urgent"] = "Urgent";
})(WorkOrderPriorityEnum = exports.WorkOrderPriorityEnum || (exports.WorkOrderPriorityEnum = {}));
/**
    * @export
    * @enum {string}
    */
var WorkOrderSortColumnEnum;
(function (WorkOrderSortColumnEnum) {
    WorkOrderSortColumnEnum["Id"] = "Id";
    WorkOrderSortColumnEnum["Title"] = "Title";
    WorkOrderSortColumnEnum["StatusId"] = "StatusId";
    WorkOrderSortColumnEnum["PriorityId"] = "PriorityId";
    WorkOrderSortColumnEnum["TypeId"] = "TypeId";
    WorkOrderSortColumnEnum["CreatedDate"] = "CreatedDate";
    WorkOrderSortColumnEnum["PropertyName"] = "PropertyName";
    WorkOrderSortColumnEnum["AssignedTo"] = "AssignedTo";
})(WorkOrderSortColumnEnum = exports.WorkOrderSortColumnEnum || (exports.WorkOrderSortColumnEnum = {}));
/**
    * @export
    * @enum {string}
    */
var WorkOrderSortDirectionEnum;
(function (WorkOrderSortDirectionEnum) {
    WorkOrderSortDirectionEnum["Asc"] = "ASC";
    WorkOrderSortDirectionEnum["Desc"] = "DESC";
})(WorkOrderSortDirectionEnum = exports.WorkOrderSortDirectionEnum || (exports.WorkOrderSortDirectionEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var WorkOrderStatusEnum;
(function (WorkOrderStatusEnum) {
    WorkOrderStatusEnum["NeedsReview"] = "NeedsReview";
    WorkOrderStatusEnum["OwnerDiscussion"] = "OwnerDiscussion";
    WorkOrderStatusEnum["VendorDiscussion"] = "VendorDiscussion";
    WorkOrderStatusEnum["SentToVendor"] = "SentToVendor";
    WorkOrderStatusEnum["WorkInProgress"] = "WorkInProgress";
    WorkOrderStatusEnum["ObtainingQuotes"] = "ObtainingQuotes";
    WorkOrderStatusEnum["Completed"] = "Completed";
    WorkOrderStatusEnum["InvoiceReceived"] = "InvoiceReceived";
    WorkOrderStatusEnum["Closed"] = "Closed";
})(WorkOrderStatusEnum = exports.WorkOrderStatusEnum || (exports.WorkOrderStatusEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var WorkOrderTypes;
(function (WorkOrderTypes) {
    WorkOrderTypes["MaintenanceRequest"] = "Maintenance Request";
})(WorkOrderTypes = exports.WorkOrderTypes || (exports.WorkOrderTypes = {}));
/**
 * AdminApi - axios parameter creator
 * @export
 */
exports.AdminApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *    Clones configs from one property group to another. Let it be known to the world that this first ends/disables all existing configs (if any) on the destination property group.   This is a deep copy. Once copied, all settings are therefore separate between the two entities. The configs take effect immediately.   In Scope:    - All AssignedConfigs    - Terms and Conditions (and the rich text associated)    - Fee Configs    - Quick Pays    - Application Custom Questions    - Maintenance Criteria
         * @summary Clones the property group configs from the source (in the body) to the destination (in URL).
         * @param {string} uuid
         * @param {string} propertyGroupUuid
         * @param {ClonePropertyGroupConfigsDto} clonePropertyGroupConfigsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneAndReplacePropertyGroupConfigs: (uuid, propertyGroupUuid, clonePropertyGroupConfigsDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('cloneAndReplacePropertyGroupConfigs', 'uuid', uuid);
            // verify required parameter 'propertyGroupUuid' is not null or undefined
            common_1.assertParamExists('cloneAndReplacePropertyGroupConfigs', 'propertyGroupUuid', propertyGroupUuid);
            // verify required parameter 'clonePropertyGroupConfigsDto' is not null or undefined
            common_1.assertParamExists('cloneAndReplacePropertyGroupConfigs', 'clonePropertyGroupConfigsDto', clonePropertyGroupConfigsDto);
            const localVarPath = `/api/v1/admin/companies/{uuid}/propertygroups/{property_group_uuid}/configs`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"property_group_uuid"}}`, encodeURIComponent(String(propertyGroupUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(clonePropertyGroupConfigsDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Downloads the latest PCI attestation for a company.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadLatestPciAttestation: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('downloadLatestPciAttestation', 'uuid', uuid);
            const localVarPath = `/api/v1/admin/companies/{uuid}/docs/pci_attestation`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Export attachments of a bank account
         * @param {string} uuid
         * @param {string} bankUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportBankAccountFiles: (uuid, bankUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('exportBankAccountFiles', 'uuid', uuid);
            // verify required parameter 'bankUuid' is not null or undefined
            common_1.assertParamExists('exportBankAccountFiles', 'bankUuid', bankUuid);
            const localVarPath = `/api/v1/admin/companies/{uuid}/bankaccounts/{bank_uuid}/export`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"bank_uuid"}}`, encodeURIComponent(String(bankUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets all the admin metadata about a transaciton.
         * @param {string} transacitonUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminTransactionMetadata: (transacitonUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'transacitonUuid' is not null or undefined
            common_1.assertParamExists('getAdminTransactionMetadata', 'transacitonUuid', transacitonUuid);
            const localVarPath = `/api/v1/admin/transactions/{transacitonUuid}`
                .replace(`{${"transacitonUuid"}}`, encodeURIComponent(String(transacitonUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get Company Details for the admin purpose
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyDetail: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getCompanyDetail', 'uuid', uuid);
            const localVarPath = `/api/v1/admin/companies/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets Product Config Validations.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyProductConfigValidations: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getCompanyProductConfigValidations', 'uuid', uuid);
            const localVarPath = `/api/v1/admin/companies/{uuid}/config_validations`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates ACH debits for the open PM invoice remaining amounts against the bank account on file.
         * @summary Pays unpaid PM invoices
         * @param {PayInvoicesDto} payInvoicesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payPmInvoices: (payInvoicesDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'payInvoicesDto' is not null or undefined
            common_1.assertParamExists('payPmInvoices', 'payInvoicesDto', payInvoicesDto);
            const localVarPath = `/api/v1/admin/invoices/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(payInvoicesDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Search Companies for the admin purpose
         * @param {AdminCompanySearchDto} adminCompanySearchDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCompanies: (adminCompanySearchDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'adminCompanySearchDto' is not null or undefined
            common_1.assertParamExists('searchCompanies', 'adminCompanySearchDto', adminCompanySearchDto);
            const localVarPath = `/api/v1/admin/companies/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(adminCompanySearchDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Search profiles(for now residents and pms)
         * @param {ProfileSearchDto} profileSearchDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProfiles: (profileSearchDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'profileSearchDto' is not null or undefined
            common_1.assertParamExists('searchProfiles', 'profileSearchDto', profileSearchDto);
            const localVarPath = `/api/v1/admin/profiles/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(profileSearchDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Invites all unregistered owners that meet a specific criteria.
         * @summary Sends email invitations to owners.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOwnerEmailInvitations: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('sendOwnerEmailInvitations', 'uuid', uuid);
            const localVarPath = `/api/v1/admin/companies/{uuid}/sendownerinvitations`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Invites all unregistered residents that meet a specific criteria.
         * @summary Sends email invitations to residents.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendResidentEmailInvitations: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('sendResidentEmailInvitations', 'uuid', uuid);
            const localVarPath = `/api/v1/admin/companies/{uuid}/sendresidentinvitations`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Submit an onboarding application to the processor service.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitOnboardingApp: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('submitOnboardingApp', 'uuid', uuid);
            const localVarPath = `/api/v1/admin/companies/{uuid}/onboarding`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update company product configs(for now master flags only).
         * @param {string} uuid
         * @param {AdminCompanyProductConfigsDto} adminCompanyProductConfigsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyProductConfigs: (uuid, adminCompanyProductConfigsDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateCompanyProductConfigs', 'uuid', uuid);
            // verify required parameter 'adminCompanyProductConfigsDto' is not null or undefined
            common_1.assertParamExists('updateCompanyProductConfigs', 'adminCompanyProductConfigsDto', adminCompanyProductConfigsDto);
            const localVarPath = `/api/v1/admin/companies/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(adminCompanyProductConfigsDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminApi - functional programming interface
 * @export
 */
exports.AdminApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AdminApiAxiosParamCreator(configuration);
    return {
        /**
         *    Clones configs from one property group to another. Let it be known to the world that this first ends/disables all existing configs (if any) on the destination property group.   This is a deep copy. Once copied, all settings are therefore separate between the two entities. The configs take effect immediately.   In Scope:    - All AssignedConfigs    - Terms and Conditions (and the rich text associated)    - Fee Configs    - Quick Pays    - Application Custom Questions    - Maintenance Criteria
         * @summary Clones the property group configs from the source (in the body) to the destination (in URL).
         * @param {string} uuid
         * @param {string} propertyGroupUuid
         * @param {ClonePropertyGroupConfigsDto} clonePropertyGroupConfigsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneAndReplacePropertyGroupConfigs(uuid, propertyGroupUuid, clonePropertyGroupConfigsDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cloneAndReplacePropertyGroupConfigs(uuid, propertyGroupUuid, clonePropertyGroupConfigsDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Downloads the latest PCI attestation for a company.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadLatestPciAttestation(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadLatestPciAttestation(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Export attachments of a bank account
         * @param {string} uuid
         * @param {string} bankUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportBankAccountFiles(uuid, bankUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.exportBankAccountFiles(uuid, bankUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets all the admin metadata about a transaciton.
         * @param {string} transacitonUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminTransactionMetadata(transacitonUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAdminTransactionMetadata(transacitonUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get Company Details for the admin purpose
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyDetail(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompanyDetail(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets Product Config Validations.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyProductConfigValidations(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompanyProductConfigValidations(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Creates ACH debits for the open PM invoice remaining amounts against the bank account on file.
         * @summary Pays unpaid PM invoices
         * @param {PayInvoicesDto} payInvoicesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payPmInvoices(payInvoicesDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.payPmInvoices(payInvoicesDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Search Companies for the admin purpose
         * @param {AdminCompanySearchDto} adminCompanySearchDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCompanies(adminCompanySearchDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchCompanies(adminCompanySearchDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Search profiles(for now residents and pms)
         * @param {ProfileSearchDto} profileSearchDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProfiles(profileSearchDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchProfiles(profileSearchDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Invites all unregistered owners that meet a specific criteria.
         * @summary Sends email invitations to owners.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOwnerEmailInvitations(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendOwnerEmailInvitations(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Invites all unregistered residents that meet a specific criteria.
         * @summary Sends email invitations to residents.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendResidentEmailInvitations(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendResidentEmailInvitations(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Submit an onboarding application to the processor service.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitOnboardingApp(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.submitOnboardingApp(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update company product configs(for now master flags only).
         * @param {string} uuid
         * @param {AdminCompanyProductConfigsDto} adminCompanyProductConfigsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyProductConfigs(uuid, adminCompanyProductConfigsDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCompanyProductConfigs(uuid, adminCompanyProductConfigsDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminApi - factory interface
 * @export
 */
exports.AdminApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AdminApiFp(configuration);
    return {
        /**
         *    Clones configs from one property group to another. Let it be known to the world that this first ends/disables all existing configs (if any) on the destination property group.   This is a deep copy. Once copied, all settings are therefore separate between the two entities. The configs take effect immediately.   In Scope:    - All AssignedConfigs    - Terms and Conditions (and the rich text associated)    - Fee Configs    - Quick Pays    - Application Custom Questions    - Maintenance Criteria
         * @summary Clones the property group configs from the source (in the body) to the destination (in URL).
         * @param {string} uuid
         * @param {string} propertyGroupUuid
         * @param {ClonePropertyGroupConfigsDto} clonePropertyGroupConfigsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneAndReplacePropertyGroupConfigs(uuid, propertyGroupUuid, clonePropertyGroupConfigsDto, options) {
            return localVarFp.cloneAndReplacePropertyGroupConfigs(uuid, propertyGroupUuid, clonePropertyGroupConfigsDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Downloads the latest PCI attestation for a company.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadLatestPciAttestation(uuid, options) {
            return localVarFp.downloadLatestPciAttestation(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Export attachments of a bank account
         * @param {string} uuid
         * @param {string} bankUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportBankAccountFiles(uuid, bankUuid, options) {
            return localVarFp.exportBankAccountFiles(uuid, bankUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets all the admin metadata about a transaciton.
         * @param {string} transacitonUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminTransactionMetadata(transacitonUuid, options) {
            return localVarFp.getAdminTransactionMetadata(transacitonUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Company Details for the admin purpose
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyDetail(uuid, options) {
            return localVarFp.getCompanyDetail(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets Product Config Validations.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyProductConfigValidations(uuid, options) {
            return localVarFp.getCompanyProductConfigValidations(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates ACH debits for the open PM invoice remaining amounts against the bank account on file.
         * @summary Pays unpaid PM invoices
         * @param {PayInvoicesDto} payInvoicesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payPmInvoices(payInvoicesDto, options) {
            return localVarFp.payPmInvoices(payInvoicesDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search Companies for the admin purpose
         * @param {AdminCompanySearchDto} adminCompanySearchDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCompanies(adminCompanySearchDto, options) {
            return localVarFp.searchCompanies(adminCompanySearchDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search profiles(for now residents and pms)
         * @param {ProfileSearchDto} profileSearchDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProfiles(profileSearchDto, options) {
            return localVarFp.searchProfiles(profileSearchDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Invites all unregistered owners that meet a specific criteria.
         * @summary Sends email invitations to owners.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOwnerEmailInvitations(uuid, options) {
            return localVarFp.sendOwnerEmailInvitations(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Invites all unregistered residents that meet a specific criteria.
         * @summary Sends email invitations to residents.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendResidentEmailInvitations(uuid, options) {
            return localVarFp.sendResidentEmailInvitations(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Submit an onboarding application to the processor service.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitOnboardingApp(uuid, options) {
            return localVarFp.submitOnboardingApp(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update company product configs(for now master flags only).
         * @param {string} uuid
         * @param {AdminCompanyProductConfigsDto} adminCompanyProductConfigsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyProductConfigs(uuid, adminCompanyProductConfigsDto, options) {
            return localVarFp.updateCompanyProductConfigs(uuid, adminCompanyProductConfigsDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
class AdminApi extends base_1.BaseAPI {
    /**
     *    Clones configs from one property group to another. Let it be known to the world that this first ends/disables all existing configs (if any) on the destination property group.   This is a deep copy. Once copied, all settings are therefore separate between the two entities. The configs take effect immediately.   In Scope:    - All AssignedConfigs    - Terms and Conditions (and the rich text associated)    - Fee Configs    - Quick Pays    - Application Custom Questions    - Maintenance Criteria
     * @summary Clones the property group configs from the source (in the body) to the destination (in URL).
     * @param {string} uuid
     * @param {string} propertyGroupUuid
     * @param {ClonePropertyGroupConfigsDto} clonePropertyGroupConfigsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    cloneAndReplacePropertyGroupConfigs(uuid, propertyGroupUuid, clonePropertyGroupConfigsDto, options) {
        return exports.AdminApiFp(this.configuration).cloneAndReplacePropertyGroupConfigs(uuid, propertyGroupUuid, clonePropertyGroupConfigsDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Downloads the latest PCI attestation for a company.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    downloadLatestPciAttestation(uuid, options) {
        return exports.AdminApiFp(this.configuration).downloadLatestPciAttestation(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Export attachments of a bank account
     * @param {string} uuid
     * @param {string} bankUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    exportBankAccountFiles(uuid, bankUuid, options) {
        return exports.AdminApiFp(this.configuration).exportBankAccountFiles(uuid, bankUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets all the admin metadata about a transaciton.
     * @param {string} transacitonUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    getAdminTransactionMetadata(transacitonUuid, options) {
        return exports.AdminApiFp(this.configuration).getAdminTransactionMetadata(transacitonUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Company Details for the admin purpose
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    getCompanyDetail(uuid, options) {
        return exports.AdminApiFp(this.configuration).getCompanyDetail(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets Product Config Validations.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    getCompanyProductConfigValidations(uuid, options) {
        return exports.AdminApiFp(this.configuration).getCompanyProductConfigValidations(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates ACH debits for the open PM invoice remaining amounts against the bank account on file.
     * @summary Pays unpaid PM invoices
     * @param {PayInvoicesDto} payInvoicesDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    payPmInvoices(payInvoicesDto, options) {
        return exports.AdminApiFp(this.configuration).payPmInvoices(payInvoicesDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Search Companies for the admin purpose
     * @param {AdminCompanySearchDto} adminCompanySearchDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    searchCompanies(adminCompanySearchDto, options) {
        return exports.AdminApiFp(this.configuration).searchCompanies(adminCompanySearchDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Search profiles(for now residents and pms)
     * @param {ProfileSearchDto} profileSearchDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    searchProfiles(profileSearchDto, options) {
        return exports.AdminApiFp(this.configuration).searchProfiles(profileSearchDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Invites all unregistered owners that meet a specific criteria.
     * @summary Sends email invitations to owners.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    sendOwnerEmailInvitations(uuid, options) {
        return exports.AdminApiFp(this.configuration).sendOwnerEmailInvitations(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Invites all unregistered residents that meet a specific criteria.
     * @summary Sends email invitations to residents.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    sendResidentEmailInvitations(uuid, options) {
        return exports.AdminApiFp(this.configuration).sendResidentEmailInvitations(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Submit an onboarding application to the processor service.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    submitOnboardingApp(uuid, options) {
        return exports.AdminApiFp(this.configuration).submitOnboardingApp(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update company product configs(for now master flags only).
     * @param {string} uuid
     * @param {AdminCompanyProductConfigsDto} adminCompanyProductConfigsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    updateCompanyProductConfigs(uuid, adminCompanyProductConfigsDto, options) {
        return exports.AdminApiFp(this.configuration).updateCompanyProductConfigs(uuid, adminCompanyProductConfigsDto, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AdminApi = AdminApi;
/**
 * AnnouncementsApi - axios parameter creator
 * @export
 */
exports.AnnouncementsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create a new announcement
         * @summary Create a new announcement
         * @param {CreateAnnouncementDto} createAnnouncementDto
         * @param {string} [cloneFrom] Supply the existing &lt;announcement template&gt; id to clone a completely new announcement based on the source data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnnouncementTemplate: (createAnnouncementDto, cloneFrom, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createAnnouncementDto' is not null or undefined
            common_1.assertParamExists('createAnnouncementTemplate', 'createAnnouncementDto', createAnnouncementDto);
            const localVarPath = `/api/v1/announcements/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (cloneFrom !== undefined) {
                localVarQueryParameter['cloneFrom'] = cloneFrom;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createAnnouncementDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * delete an announcement
         * @summary delete an announcement
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnnouncementTemplate: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('deleteAnnouncementTemplate', 'uuid', uuid);
            const localVarPath = `/api/v1/announcements/templates/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * get details of a sent announcement
         * @summary get details of a sent announcement
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnouncementEvent: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getAnnouncementEvent', 'uuid', uuid);
            const localVarPath = `/api/v1/announcements/events/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * get one announcement
         * @summary get one announcement
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnouncementTemplate: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getAnnouncementTemplate', 'uuid', uuid);
            const localVarPath = `/api/v1/announcements/templates/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Search for announcement templates
         * @summary Search for announcement templates
         * @param {SearchAnnouncementTemplatesParamsDto} searchAnnouncementTemplatesParamsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchForAnnouncementTemplates: (searchAnnouncementTemplatesParamsDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchAnnouncementTemplatesParamsDto' is not null or undefined
            common_1.assertParamExists('searchForAnnouncementTemplates', 'searchAnnouncementTemplatesParamsDto', searchAnnouncementTemplatesParamsDto);
            const localVarPath = `/api/v1/announcements/templates/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(searchAnnouncementTemplatesParamsDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Search for sent announcements
         * @summary Search for sent announcements
         * @param {SearchSentAnnouncementsDto} searchSentAnnouncementsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchForSentAnnouncements: (searchSentAnnouncementsDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchSentAnnouncementsDto' is not null or undefined
            common_1.assertParamExists('searchForSentAnnouncements', 'searchSentAnnouncementsDto', searchSentAnnouncementsDto);
            const localVarPath = `/api/v1/announcements/events/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(searchSentAnnouncementsDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates parts of an announcement
         * @summary Updates parts of an announcement
         * @param {string} uuid
         * @param {UpdateAnnouncementDto} updateAnnouncementDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnnouncementTemplate: (uuid, updateAnnouncementDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateAnnouncementTemplate', 'uuid', uuid);
            // verify required parameter 'updateAnnouncementDto' is not null or undefined
            common_1.assertParamExists('updateAnnouncementTemplate', 'updateAnnouncementDto', updateAnnouncementDto);
            const localVarPath = `/api/v1/announcements/templates/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateAnnouncementDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AnnouncementsApi - functional programming interface
 * @export
 */
exports.AnnouncementsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AnnouncementsApiAxiosParamCreator(configuration);
    return {
        /**
         * Create a new announcement
         * @summary Create a new announcement
         * @param {CreateAnnouncementDto} createAnnouncementDto
         * @param {string} [cloneFrom] Supply the existing &lt;announcement template&gt; id to clone a completely new announcement based on the source data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnnouncementTemplate(createAnnouncementDto, cloneFrom, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAnnouncementTemplate(createAnnouncementDto, cloneFrom, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * delete an announcement
         * @summary delete an announcement
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnnouncementTemplate(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteAnnouncementTemplate(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * get details of a sent announcement
         * @summary get details of a sent announcement
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnouncementEvent(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAnnouncementEvent(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * get one announcement
         * @summary get one announcement
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnouncementTemplate(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAnnouncementTemplate(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Search for announcement templates
         * @summary Search for announcement templates
         * @param {SearchAnnouncementTemplatesParamsDto} searchAnnouncementTemplatesParamsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchForAnnouncementTemplates(searchAnnouncementTemplatesParamsDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchForAnnouncementTemplates(searchAnnouncementTemplatesParamsDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Search for sent announcements
         * @summary Search for sent announcements
         * @param {SearchSentAnnouncementsDto} searchSentAnnouncementsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchForSentAnnouncements(searchSentAnnouncementsDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchForSentAnnouncements(searchSentAnnouncementsDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates parts of an announcement
         * @summary Updates parts of an announcement
         * @param {string} uuid
         * @param {UpdateAnnouncementDto} updateAnnouncementDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnnouncementTemplate(uuid, updateAnnouncementDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateAnnouncementTemplate(uuid, updateAnnouncementDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AnnouncementsApi - factory interface
 * @export
 */
exports.AnnouncementsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AnnouncementsApiFp(configuration);
    return {
        /**
         * Create a new announcement
         * @summary Create a new announcement
         * @param {CreateAnnouncementDto} createAnnouncementDto
         * @param {string} [cloneFrom] Supply the existing &lt;announcement template&gt; id to clone a completely new announcement based on the source data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnnouncementTemplate(createAnnouncementDto, cloneFrom, options) {
            return localVarFp.createAnnouncementTemplate(createAnnouncementDto, cloneFrom, options).then((request) => request(axios, basePath));
        },
        /**
         * delete an announcement
         * @summary delete an announcement
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnnouncementTemplate(uuid, options) {
            return localVarFp.deleteAnnouncementTemplate(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * get details of a sent announcement
         * @summary get details of a sent announcement
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnouncementEvent(uuid, options) {
            return localVarFp.getAnnouncementEvent(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * get one announcement
         * @summary get one announcement
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnouncementTemplate(uuid, options) {
            return localVarFp.getAnnouncementTemplate(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for announcement templates
         * @summary Search for announcement templates
         * @param {SearchAnnouncementTemplatesParamsDto} searchAnnouncementTemplatesParamsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchForAnnouncementTemplates(searchAnnouncementTemplatesParamsDto, options) {
            return localVarFp.searchForAnnouncementTemplates(searchAnnouncementTemplatesParamsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for sent announcements
         * @summary Search for sent announcements
         * @param {SearchSentAnnouncementsDto} searchSentAnnouncementsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchForSentAnnouncements(searchSentAnnouncementsDto, options) {
            return localVarFp.searchForSentAnnouncements(searchSentAnnouncementsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates parts of an announcement
         * @summary Updates parts of an announcement
         * @param {string} uuid
         * @param {UpdateAnnouncementDto} updateAnnouncementDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnnouncementTemplate(uuid, updateAnnouncementDto, options) {
            return localVarFp.updateAnnouncementTemplate(uuid, updateAnnouncementDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AnnouncementsApi - object-oriented interface
 * @export
 * @class AnnouncementsApi
 * @extends {BaseAPI}
 */
class AnnouncementsApi extends base_1.BaseAPI {
    /**
     * Create a new announcement
     * @summary Create a new announcement
     * @param {CreateAnnouncementDto} createAnnouncementDto
     * @param {string} [cloneFrom] Supply the existing &lt;announcement template&gt; id to clone a completely new announcement based on the source data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnouncementsApi
     */
    createAnnouncementTemplate(createAnnouncementDto, cloneFrom, options) {
        return exports.AnnouncementsApiFp(this.configuration).createAnnouncementTemplate(createAnnouncementDto, cloneFrom, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * delete an announcement
     * @summary delete an announcement
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnouncementsApi
     */
    deleteAnnouncementTemplate(uuid, options) {
        return exports.AnnouncementsApiFp(this.configuration).deleteAnnouncementTemplate(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * get details of a sent announcement
     * @summary get details of a sent announcement
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnouncementsApi
     */
    getAnnouncementEvent(uuid, options) {
        return exports.AnnouncementsApiFp(this.configuration).getAnnouncementEvent(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * get one announcement
     * @summary get one announcement
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnouncementsApi
     */
    getAnnouncementTemplate(uuid, options) {
        return exports.AnnouncementsApiFp(this.configuration).getAnnouncementTemplate(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search for announcement templates
     * @summary Search for announcement templates
     * @param {SearchAnnouncementTemplatesParamsDto} searchAnnouncementTemplatesParamsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnouncementsApi
     */
    searchForAnnouncementTemplates(searchAnnouncementTemplatesParamsDto, options) {
        return exports.AnnouncementsApiFp(this.configuration).searchForAnnouncementTemplates(searchAnnouncementTemplatesParamsDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search for sent announcements
     * @summary Search for sent announcements
     * @param {SearchSentAnnouncementsDto} searchSentAnnouncementsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnouncementsApi
     */
    searchForSentAnnouncements(searchSentAnnouncementsDto, options) {
        return exports.AnnouncementsApiFp(this.configuration).searchForSentAnnouncements(searchSentAnnouncementsDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates parts of an announcement
     * @summary Updates parts of an announcement
     * @param {string} uuid
     * @param {UpdateAnnouncementDto} updateAnnouncementDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnouncementsApi
     */
    updateAnnouncementTemplate(uuid, updateAnnouncementDto, options) {
        return exports.AnnouncementsApiFp(this.configuration).updateAnnouncementTemplate(uuid, updateAnnouncementDto, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AnnouncementsApi = AnnouncementsApi;
/**
 * ApplicationsV1Api - axios parameter creator
 * @export
 */
exports.ApplicationsV1ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Allows the user to add an applicant into our system
         * @param {CreateApplicationOccupantDto} createApplicationOccupantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApplicant: (createApplicationOccupantDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createApplicationOccupantDto' is not null or undefined
            common_1.assertParamExists('createApplicant', 'createApplicationOccupantDto', createApplicationOccupantDto);
            const localVarPath = `/api/v1/applications/applicant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createApplicationOccupantDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Allows the user to add an application employment into our system
         * @param {CreateApplicationEmploymentDto} createApplicationEmploymentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmployment: (createApplicationEmploymentDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createApplicationEmploymentDto' is not null or undefined
            common_1.assertParamExists('createEmployment', 'createApplicationEmploymentDto', createApplicationEmploymentDto);
            const localVarPath = `/api/v1/applications/employment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createApplicationEmploymentDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Allows the user to add a pet into our system
         * @param {CreateApplicationPetDto} createApplicationPetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPet: (createApplicationPetDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createApplicationPetDto' is not null or undefined
            common_1.assertParamExists('createPet', 'createApplicationPetDto', createApplicationPetDto);
            const localVarPath = `/api/v1/applications/pet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createApplicationPetDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Allows the user to add an application rental history into our system
         * @param {CreateApplicationRentalHistoryDto} createApplicationRentalHistoryDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRentalHistory: (createApplicationRentalHistoryDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createApplicationRentalHistoryDto' is not null or undefined
            common_1.assertParamExists('createRentalHistory', 'createApplicationRentalHistoryDto', createApplicationRentalHistoryDto);
            const localVarPath = `/api/v1/applications/rentalhisotry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createApplicationRentalHistoryDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Creates a new screening request for this applicant.
         * @param {CreateScreeningOrderDto} createScreeningOrderDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScreeningOrder: (createScreeningOrderDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createScreeningOrderDto' is not null or undefined
            common_1.assertParamExists('createScreeningOrder', 'createScreeningOrderDto', createScreeningOrderDto);
            const localVarPath = `/api/v1/applications/screening`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createScreeningOrderDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Allows the user to add a vehicle into our system
         * @param {CreateApplicationVehicleDto} createApplicationVehicleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVehicle: (createApplicationVehicleDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createApplicationVehicleDto' is not null or undefined
            common_1.assertParamExists('createVehicle', 'createApplicationVehicleDto', createApplicationVehicleDto);
            const localVarPath = `/api/v1/applications/vehicle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createApplicationVehicleDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete an applicant.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApplicant: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('deleteApplicant', 'uuid', uuid);
            const localVarPath = `/api/v1/applications/applicant/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete an employment.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmployment: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('deleteEmployment', 'uuid', uuid);
            const localVarPath = `/api/v1/applications/employment/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a pet.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePet: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('deletePet', 'uuid', uuid);
            const localVarPath = `/api/v1/applications/pet/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a rental history.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRentalHistory: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('deleteRentalHistory', 'uuid', uuid);
            const localVarPath = `/api/v1/applications/rentalhistory/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a vehicle.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVehicle: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('deleteVehicle', 'uuid', uuid);
            const localVarPath = `/api/v1/applications/vehicle/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get a specific applicant.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicant: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getApplicant', 'uuid', uuid);
            const localVarPath = `/api/v1/applications/applicant/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get application detail with company and coapplicant.
         * @param {string} application
         * @param {string} coapplicant
         * @param {string} hmac
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationDetail: (application, coapplicant, hmac, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'application' is not null or undefined
            common_1.assertParamExists('getApplicationDetail', 'application', application);
            // verify required parameter 'coapplicant' is not null or undefined
            common_1.assertParamExists('getApplicationDetail', 'coapplicant', coapplicant);
            // verify required parameter 'hmac' is not null or undefined
            common_1.assertParamExists('getApplicationDetail', 'hmac', hmac);
            const localVarPath = `/api/v1/applications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (application !== undefined) {
                localVarQueryParameter['application'] = application;
            }
            if (coapplicant !== undefined) {
                localVarQueryParameter['coapplicant'] = coapplicant;
            }
            if (hmac !== undefined) {
                localVarQueryParameter['hmac'] = hmac;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the latest company terms and conditions for applications.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationApplicationTerms: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getOrganizationApplicationTerms', 'uuid', uuid);
            const localVarPath = `/api/v1/applications/company/{uuid}/terms`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get Screening Order Info
         * @param {string} uuid Screening Order Uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScreeningOrderDetails: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getScreeningOrderDetails', 'uuid', uuid);
            const localVarPath = `/api/v1/applications/screening/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Send an invitation to co-applicant
         * @param {string} uuid
         * @param {InviteCoapplicantDto} inviteCoapplicantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteCoapplicant: (uuid, inviteCoapplicantDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('inviteCoapplicant', 'uuid', uuid);
            // verify required parameter 'inviteCoapplicantDto' is not null or undefined
            common_1.assertParamExists('inviteCoapplicant', 'inviteCoapplicantDto', inviteCoapplicantDto);
            const localVarPath = `/api/v1/applications/{uuid}/applicant/invite`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(inviteCoapplicantDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Searches for Application with pagination
         * @summary Find Applications by pm uuid.
         * @param {ApplicationSearchDto} applicationSearchDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchApplications: (applicationSearchDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'applicationSearchDto' is not null or undefined
            common_1.assertParamExists('searchApplications', 'applicationSearchDto', applicationSearchDto);
            const localVarPath = `/api/v1/applications/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(applicationSearchDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update an applicant.
         * @param {string} uuid
         * @param {UpdateApplicationOccupantDto} updateApplicationOccupantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplicant: (uuid, updateApplicationOccupantDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateApplicant', 'uuid', uuid);
            // verify required parameter 'updateApplicationOccupantDto' is not null or undefined
            common_1.assertParamExists('updateApplicant', 'updateApplicationOccupantDto', updateApplicationOccupantDto);
            const localVarPath = `/api/v1/applications/applicant/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateApplicationOccupantDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update an employment.
         * @param {string} uuid
         * @param {UpdateApplicationEmploymentDto} updateApplicationEmploymentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployment: (uuid, updateApplicationEmploymentDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateEmployment', 'uuid', uuid);
            // verify required parameter 'updateApplicationEmploymentDto' is not null or undefined
            common_1.assertParamExists('updateEmployment', 'updateApplicationEmploymentDto', updateApplicationEmploymentDto);
            const localVarPath = `/api/v1/applications/employment/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateApplicationEmploymentDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update an pet.
         * @param {string} uuid
         * @param {UpdateApplicationPetDto} updateApplicationPetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePet: (uuid, updateApplicationPetDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updatePet', 'uuid', uuid);
            // verify required parameter 'updateApplicationPetDto' is not null or undefined
            common_1.assertParamExists('updatePet', 'updateApplicationPetDto', updateApplicationPetDto);
            const localVarPath = `/api/v1/applications/pet/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateApplicationPetDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update a rental history.
         * @param {string} uuid
         * @param {UpdateApplicationRentalHistoryDto} updateApplicationRentalHistoryDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRentalHistory: (uuid, updateApplicationRentalHistoryDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateRentalHistory', 'uuid', uuid);
            // verify required parameter 'updateApplicationRentalHistoryDto' is not null or undefined
            common_1.assertParamExists('updateRentalHistory', 'updateApplicationRentalHistoryDto', updateApplicationRentalHistoryDto);
            const localVarPath = `/api/v1/applications/rentalhistory/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateApplicationRentalHistoryDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update a vehicle.
         * @param {string} uuid
         * @param {UpdateApplicationVehicleDto} updateApplicationVehicleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVehicle: (uuid, updateApplicationVehicleDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateVehicle', 'uuid', uuid);
            // verify required parameter 'updateApplicationVehicleDto' is not null or undefined
            common_1.assertParamExists('updateVehicle', 'updateApplicationVehicleDto', updateApplicationVehicleDto);
            const localVarPath = `/api/v1/applications/vehicle/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateApplicationVehicleDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ApplicationsV1Api - functional programming interface
 * @export
 */
exports.ApplicationsV1ApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.ApplicationsV1ApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Allows the user to add an applicant into our system
         * @param {CreateApplicationOccupantDto} createApplicationOccupantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApplicant(createApplicationOccupantDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createApplicant(createApplicationOccupantDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Allows the user to add an application employment into our system
         * @param {CreateApplicationEmploymentDto} createApplicationEmploymentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmployment(createApplicationEmploymentDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createEmployment(createApplicationEmploymentDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Allows the user to add a pet into our system
         * @param {CreateApplicationPetDto} createApplicationPetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPet(createApplicationPetDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createPet(createApplicationPetDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Allows the user to add an application rental history into our system
         * @param {CreateApplicationRentalHistoryDto} createApplicationRentalHistoryDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRentalHistory(createApplicationRentalHistoryDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createRentalHistory(createApplicationRentalHistoryDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Creates a new screening request for this applicant.
         * @param {CreateScreeningOrderDto} createScreeningOrderDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScreeningOrder(createScreeningOrderDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createScreeningOrder(createScreeningOrderDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Allows the user to add a vehicle into our system
         * @param {CreateApplicationVehicleDto} createApplicationVehicleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVehicle(createApplicationVehicleDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createVehicle(createApplicationVehicleDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete an applicant.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApplicant(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteApplicant(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete an employment.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmployment(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteEmployment(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete a pet.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePet(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deletePet(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete a rental history.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRentalHistory(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteRentalHistory(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete a vehicle.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVehicle(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteVehicle(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get a specific applicant.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicant(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getApplicant(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get application detail with company and coapplicant.
         * @param {string} application
         * @param {string} coapplicant
         * @param {string} hmac
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationDetail(application, coapplicant, hmac, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getApplicationDetail(application, coapplicant, hmac, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get the latest company terms and conditions for applications.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationApplicationTerms(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOrganizationApplicationTerms(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get Screening Order Info
         * @param {string} uuid Screening Order Uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScreeningOrderDetails(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getScreeningOrderDetails(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Send an invitation to co-applicant
         * @param {string} uuid
         * @param {InviteCoapplicantDto} inviteCoapplicantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteCoapplicant(uuid, inviteCoapplicantDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.inviteCoapplicant(uuid, inviteCoapplicantDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Searches for Application with pagination
         * @summary Find Applications by pm uuid.
         * @param {ApplicationSearchDto} applicationSearchDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchApplications(applicationSearchDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchApplications(applicationSearchDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update an applicant.
         * @param {string} uuid
         * @param {UpdateApplicationOccupantDto} updateApplicationOccupantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplicant(uuid, updateApplicationOccupantDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateApplicant(uuid, updateApplicationOccupantDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update an employment.
         * @param {string} uuid
         * @param {UpdateApplicationEmploymentDto} updateApplicationEmploymentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployment(uuid, updateApplicationEmploymentDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateEmployment(uuid, updateApplicationEmploymentDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update an pet.
         * @param {string} uuid
         * @param {UpdateApplicationPetDto} updateApplicationPetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePet(uuid, updateApplicationPetDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePet(uuid, updateApplicationPetDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update a rental history.
         * @param {string} uuid
         * @param {UpdateApplicationRentalHistoryDto} updateApplicationRentalHistoryDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRentalHistory(uuid, updateApplicationRentalHistoryDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateRentalHistory(uuid, updateApplicationRentalHistoryDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update a vehicle.
         * @param {string} uuid
         * @param {UpdateApplicationVehicleDto} updateApplicationVehicleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVehicle(uuid, updateApplicationVehicleDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateVehicle(uuid, updateApplicationVehicleDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ApplicationsV1Api - factory interface
 * @export
 */
exports.ApplicationsV1ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.ApplicationsV1ApiFp(configuration);
    return {
        /**
         *
         * @summary Allows the user to add an applicant into our system
         * @param {CreateApplicationOccupantDto} createApplicationOccupantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApplicant(createApplicationOccupantDto, options) {
            return localVarFp.createApplicant(createApplicationOccupantDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Allows the user to add an application employment into our system
         * @param {CreateApplicationEmploymentDto} createApplicationEmploymentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmployment(createApplicationEmploymentDto, options) {
            return localVarFp.createEmployment(createApplicationEmploymentDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Allows the user to add a pet into our system
         * @param {CreateApplicationPetDto} createApplicationPetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPet(createApplicationPetDto, options) {
            return localVarFp.createPet(createApplicationPetDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Allows the user to add an application rental history into our system
         * @param {CreateApplicationRentalHistoryDto} createApplicationRentalHistoryDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRentalHistory(createApplicationRentalHistoryDto, options) {
            return localVarFp.createRentalHistory(createApplicationRentalHistoryDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Creates a new screening request for this applicant.
         * @param {CreateScreeningOrderDto} createScreeningOrderDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScreeningOrder(createScreeningOrderDto, options) {
            return localVarFp.createScreeningOrder(createScreeningOrderDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Allows the user to add a vehicle into our system
         * @param {CreateApplicationVehicleDto} createApplicationVehicleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVehicle(createApplicationVehicleDto, options) {
            return localVarFp.createVehicle(createApplicationVehicleDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete an applicant.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApplicant(uuid, options) {
            return localVarFp.deleteApplicant(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete an employment.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmployment(uuid, options) {
            return localVarFp.deleteEmployment(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a pet.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePet(uuid, options) {
            return localVarFp.deletePet(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a rental history.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRentalHistory(uuid, options) {
            return localVarFp.deleteRentalHistory(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a vehicle.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVehicle(uuid, options) {
            return localVarFp.deleteVehicle(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a specific applicant.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicant(uuid, options) {
            return localVarFp.getApplicant(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get application detail with company and coapplicant.
         * @param {string} application
         * @param {string} coapplicant
         * @param {string} hmac
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationDetail(application, coapplicant, hmac, options) {
            return localVarFp.getApplicationDetail(application, coapplicant, hmac, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the latest company terms and conditions for applications.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationApplicationTerms(uuid, options) {
            return localVarFp.getOrganizationApplicationTerms(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Screening Order Info
         * @param {string} uuid Screening Order Uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScreeningOrderDetails(uuid, options) {
            return localVarFp.getScreeningOrderDetails(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Send an invitation to co-applicant
         * @param {string} uuid
         * @param {InviteCoapplicantDto} inviteCoapplicantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteCoapplicant(uuid, inviteCoapplicantDto, options) {
            return localVarFp.inviteCoapplicant(uuid, inviteCoapplicantDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Searches for Application with pagination
         * @summary Find Applications by pm uuid.
         * @param {ApplicationSearchDto} applicationSearchDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchApplications(applicationSearchDto, options) {
            return localVarFp.searchApplications(applicationSearchDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an applicant.
         * @param {string} uuid
         * @param {UpdateApplicationOccupantDto} updateApplicationOccupantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplicant(uuid, updateApplicationOccupantDto, options) {
            return localVarFp.updateApplicant(uuid, updateApplicationOccupantDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an employment.
         * @param {string} uuid
         * @param {UpdateApplicationEmploymentDto} updateApplicationEmploymentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployment(uuid, updateApplicationEmploymentDto, options) {
            return localVarFp.updateEmployment(uuid, updateApplicationEmploymentDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an pet.
         * @param {string} uuid
         * @param {UpdateApplicationPetDto} updateApplicationPetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePet(uuid, updateApplicationPetDto, options) {
            return localVarFp.updatePet(uuid, updateApplicationPetDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a rental history.
         * @param {string} uuid
         * @param {UpdateApplicationRentalHistoryDto} updateApplicationRentalHistoryDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRentalHistory(uuid, updateApplicationRentalHistoryDto, options) {
            return localVarFp.updateRentalHistory(uuid, updateApplicationRentalHistoryDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a vehicle.
         * @param {string} uuid
         * @param {UpdateApplicationVehicleDto} updateApplicationVehicleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVehicle(uuid, updateApplicationVehicleDto, options) {
            return localVarFp.updateVehicle(uuid, updateApplicationVehicleDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ApplicationsV1Api - object-oriented interface
 * @export
 * @class ApplicationsV1Api
 * @extends {BaseAPI}
 */
class ApplicationsV1Api extends base_1.BaseAPI {
    /**
     *
     * @summary Allows the user to add an applicant into our system
     * @param {CreateApplicationOccupantDto} createApplicationOccupantDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV1Api
     */
    createApplicant(createApplicationOccupantDto, options) {
        return exports.ApplicationsV1ApiFp(this.configuration).createApplicant(createApplicationOccupantDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Allows the user to add an application employment into our system
     * @param {CreateApplicationEmploymentDto} createApplicationEmploymentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV1Api
     */
    createEmployment(createApplicationEmploymentDto, options) {
        return exports.ApplicationsV1ApiFp(this.configuration).createEmployment(createApplicationEmploymentDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Allows the user to add a pet into our system
     * @param {CreateApplicationPetDto} createApplicationPetDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV1Api
     */
    createPet(createApplicationPetDto, options) {
        return exports.ApplicationsV1ApiFp(this.configuration).createPet(createApplicationPetDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Allows the user to add an application rental history into our system
     * @param {CreateApplicationRentalHistoryDto} createApplicationRentalHistoryDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV1Api
     */
    createRentalHistory(createApplicationRentalHistoryDto, options) {
        return exports.ApplicationsV1ApiFp(this.configuration).createRentalHistory(createApplicationRentalHistoryDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Creates a new screening request for this applicant.
     * @param {CreateScreeningOrderDto} createScreeningOrderDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV1Api
     */
    createScreeningOrder(createScreeningOrderDto, options) {
        return exports.ApplicationsV1ApiFp(this.configuration).createScreeningOrder(createScreeningOrderDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Allows the user to add a vehicle into our system
     * @param {CreateApplicationVehicleDto} createApplicationVehicleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV1Api
     */
    createVehicle(createApplicationVehicleDto, options) {
        return exports.ApplicationsV1ApiFp(this.configuration).createVehicle(createApplicationVehicleDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete an applicant.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV1Api
     */
    deleteApplicant(uuid, options) {
        return exports.ApplicationsV1ApiFp(this.configuration).deleteApplicant(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete an employment.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV1Api
     */
    deleteEmployment(uuid, options) {
        return exports.ApplicationsV1ApiFp(this.configuration).deleteEmployment(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a pet.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV1Api
     */
    deletePet(uuid, options) {
        return exports.ApplicationsV1ApiFp(this.configuration).deletePet(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a rental history.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV1Api
     */
    deleteRentalHistory(uuid, options) {
        return exports.ApplicationsV1ApiFp(this.configuration).deleteRentalHistory(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a vehicle.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV1Api
     */
    deleteVehicle(uuid, options) {
        return exports.ApplicationsV1ApiFp(this.configuration).deleteVehicle(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a specific applicant.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV1Api
     */
    getApplicant(uuid, options) {
        return exports.ApplicationsV1ApiFp(this.configuration).getApplicant(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get application detail with company and coapplicant.
     * @param {string} application
     * @param {string} coapplicant
     * @param {string} hmac
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV1Api
     */
    getApplicationDetail(application, coapplicant, hmac, options) {
        return exports.ApplicationsV1ApiFp(this.configuration).getApplicationDetail(application, coapplicant, hmac, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the latest company terms and conditions for applications.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV1Api
     */
    getOrganizationApplicationTerms(uuid, options) {
        return exports.ApplicationsV1ApiFp(this.configuration).getOrganizationApplicationTerms(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Screening Order Info
     * @param {string} uuid Screening Order Uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV1Api
     */
    getScreeningOrderDetails(uuid, options) {
        return exports.ApplicationsV1ApiFp(this.configuration).getScreeningOrderDetails(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Send an invitation to co-applicant
     * @param {string} uuid
     * @param {InviteCoapplicantDto} inviteCoapplicantDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV1Api
     */
    inviteCoapplicant(uuid, inviteCoapplicantDto, options) {
        return exports.ApplicationsV1ApiFp(this.configuration).inviteCoapplicant(uuid, inviteCoapplicantDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Searches for Application with pagination
     * @summary Find Applications by pm uuid.
     * @param {ApplicationSearchDto} applicationSearchDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV1Api
     */
    searchApplications(applicationSearchDto, options) {
        return exports.ApplicationsV1ApiFp(this.configuration).searchApplications(applicationSearchDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an applicant.
     * @param {string} uuid
     * @param {UpdateApplicationOccupantDto} updateApplicationOccupantDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV1Api
     */
    updateApplicant(uuid, updateApplicationOccupantDto, options) {
        return exports.ApplicationsV1ApiFp(this.configuration).updateApplicant(uuid, updateApplicationOccupantDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an employment.
     * @param {string} uuid
     * @param {UpdateApplicationEmploymentDto} updateApplicationEmploymentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV1Api
     */
    updateEmployment(uuid, updateApplicationEmploymentDto, options) {
        return exports.ApplicationsV1ApiFp(this.configuration).updateEmployment(uuid, updateApplicationEmploymentDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an pet.
     * @param {string} uuid
     * @param {UpdateApplicationPetDto} updateApplicationPetDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV1Api
     */
    updatePet(uuid, updateApplicationPetDto, options) {
        return exports.ApplicationsV1ApiFp(this.configuration).updatePet(uuid, updateApplicationPetDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a rental history.
     * @param {string} uuid
     * @param {UpdateApplicationRentalHistoryDto} updateApplicationRentalHistoryDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV1Api
     */
    updateRentalHistory(uuid, updateApplicationRentalHistoryDto, options) {
        return exports.ApplicationsV1ApiFp(this.configuration).updateRentalHistory(uuid, updateApplicationRentalHistoryDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a vehicle.
     * @param {string} uuid
     * @param {UpdateApplicationVehicleDto} updateApplicationVehicleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV1Api
     */
    updateVehicle(uuid, updateApplicationVehicleDto, options) {
        return exports.ApplicationsV1ApiFp(this.configuration).updateVehicle(uuid, updateApplicationVehicleDto, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ApplicationsV1Api = ApplicationsV1Api;
/**
 * ApplicationsV2Api - axios parameter creator
 * @export
 */
exports.ApplicationsV2ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Adds an accepted TsCs
         * @param {string} uuid
         * @param {ApplicationAcceptedTsCsAuditV2Dto} applicationAcceptedTsCsAuditV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAcceptedTsCs: (uuid, applicationAcceptedTsCsAuditV2Dto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('addAcceptedTsCs', 'uuid', uuid);
            // verify required parameter 'applicationAcceptedTsCsAuditV2Dto' is not null or undefined
            common_1.assertParamExists('addAcceptedTsCs', 'applicationAcceptedTsCsAuditV2Dto', applicationAcceptedTsCsAuditV2Dto);
            const localVarPath = `/api/v2/applications/{uuid}/termsconditions`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(applicationAcceptedTsCsAuditV2Dto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Adds/replaces a custom question answer
         * @param {string} uuid
         * @param {ApplicationQuestionResponseV2Dto} applicationQuestionResponseV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCustomQuestionAnswers: (uuid, applicationQuestionResponseV2Dto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('addCustomQuestionAnswers', 'uuid', uuid);
            // verify required parameter 'applicationQuestionResponseV2Dto' is not null or undefined
            common_1.assertParamExists('addCustomQuestionAnswers', 'applicationQuestionResponseV2Dto', applicationQuestionResponseV2Dto);
            const localVarPath = `/api/v2/applications/{uuid}/customquestions`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(applicationQuestionResponseV2Dto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Allows the PM/Applicant to change the status on an application
         * @param {string} uuid
         * @param {ChangeApplicationStatusDto} changeApplicationStatusDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeApplicationStatus: (uuid, changeApplicationStatusDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('changeApplicationStatus', 'uuid', uuid);
            // verify required parameter 'changeApplicationStatusDto' is not null or undefined
            common_1.assertParamExists('changeApplicationStatus', 'changeApplicationStatusDto', changeApplicationStatusDto);
            const localVarPath = `/api/v2/applications/{uuid}/status`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(changeApplicationStatusDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Adds an applicant into our system. If an applicant for this user alrady exists, it is returned instead.
         * @param {UpsertApplicantV2Dto} upsertApplicantV2Dto
         * @param {string} [inviteToApplicationUuid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApplicantV2: (upsertApplicantV2Dto, inviteToApplicationUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'upsertApplicantV2Dto' is not null or undefined
            common_1.assertParamExists('createApplicantV2', 'upsertApplicantV2Dto', upsertApplicantV2Dto);
            const localVarPath = `/api/v2/applications/applicants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (inviteToApplicationUuid !== undefined) {
                localVarQueryParameter['inviteToApplicationUuid'] = inviteToApplicationUuid;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(upsertApplicantV2Dto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Start a net new application
         * @summary Start a net new application
         * @param {CreateApplicationV2Dto} createApplicationV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApplicationV2: (createApplicationV2Dto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createApplicationV2Dto' is not null or undefined
            common_1.assertParamExists('createApplicationV2', 'createApplicationV2Dto', createApplicationV2Dto);
            const localVarPath = `/api/v2/applications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createApplicationV2Dto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Allows the user to add an employment into our system
         * @param {string} uuid
         * @param {UpsertApplicantEmploymentHistoryV2Dto} upsertApplicantEmploymentHistoryV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmploymentV2: (uuid, upsertApplicantEmploymentHistoryV2Dto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('createEmploymentV2', 'uuid', uuid);
            // verify required parameter 'upsertApplicantEmploymentHistoryV2Dto' is not null or undefined
            common_1.assertParamExists('createEmploymentV2', 'upsertApplicantEmploymentHistoryV2Dto', upsertApplicantEmploymentHistoryV2Dto);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/employments`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(upsertApplicantEmploymentHistoryV2Dto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Allows the user to add a minor into our system
         * @param {string} uuid
         * @param {UpsertApplicantMinorV2Dto} upsertApplicantMinorV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMinorV2: (uuid, upsertApplicantMinorV2Dto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('createMinorV2', 'uuid', uuid);
            // verify required parameter 'upsertApplicantMinorV2Dto' is not null or undefined
            common_1.assertParamExists('createMinorV2', 'upsertApplicantMinorV2Dto', upsertApplicantMinorV2Dto);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/minors`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(upsertApplicantMinorV2Dto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Creates a PM note on this application
         * @param {string} uuid
         * @param {CreateApplicationNoteDto} createApplicationNoteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNote: (uuid, createApplicationNoteDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('createNote', 'uuid', uuid);
            // verify required parameter 'createApplicationNoteDto' is not null or undefined
            common_1.assertParamExists('createNote', 'createApplicationNoteDto', createApplicationNoteDto);
            const localVarPath = `/api/v2/applications/{uuid}/notes`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createApplicationNoteDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Allows the user to add a pet into our system
         * @param {string} uuid
         * @param {UpsertApplicationPetV2Dto} upsertApplicationPetV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPetV2: (uuid, upsertApplicationPetV2Dto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('createPetV2', 'uuid', uuid);
            // verify required parameter 'upsertApplicationPetV2Dto' is not null or undefined
            common_1.assertParamExists('createPetV2', 'upsertApplicationPetV2Dto', upsertApplicationPetV2Dto);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/pets`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(upsertApplicationPetV2Dto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Allows the user to add a rental history into our system
         * @param {string} uuid
         * @param {UpsertApplicantRentalHistoryV2Dto} upsertApplicantRentalHistoryV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRentalHistoryV2: (uuid, upsertApplicantRentalHistoryV2Dto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('createRentalHistoryV2', 'uuid', uuid);
            // verify required parameter 'upsertApplicantRentalHistoryV2Dto' is not null or undefined
            common_1.assertParamExists('createRentalHistoryV2', 'upsertApplicantRentalHistoryV2Dto', upsertApplicantRentalHistoryV2Dto);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/rentalhistories`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(upsertApplicantRentalHistoryV2Dto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Allows the user to add a vehicle into our system
         * @param {string} uuid
         * @param {UpsertApplicantVehicleV2Dto} upsertApplicantVehicleV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVehicleV2: (uuid, upsertApplicantVehicleV2Dto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('createVehicleV2', 'uuid', uuid);
            // verify required parameter 'upsertApplicantVehicleV2Dto' is not null or undefined
            common_1.assertParamExists('createVehicleV2', 'upsertApplicantVehicleV2Dto', upsertApplicantVehicleV2Dto);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/vehicles`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(upsertApplicantVehicleV2Dto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Deletes an applicant.
         * @param {string} uuid
         * @param {string} applicationUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApplicantV2: (uuid, applicationUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('deleteApplicantV2', 'uuid', uuid);
            // verify required parameter 'applicationUuid' is not null or undefined
            common_1.assertParamExists('deleteApplicantV2', 'applicationUuid', applicationUuid);
            const localVarPath = `/api/v2/applications/applicants/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (applicationUuid !== undefined) {
                localVarQueryParameter['applicationUuid'] = applicationUuid;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Removes an employment.
         * @param {string} uuid
         * @param {string} employmentUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmploymentV2: (uuid, employmentUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('deleteEmploymentV2', 'uuid', uuid);
            // verify required parameter 'employmentUuid' is not null or undefined
            common_1.assertParamExists('deleteEmploymentV2', 'employmentUuid', employmentUuid);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/employments/{employment_uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"employment_uuid"}}`, encodeURIComponent(String(employmentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Removes a rental history.
         * @param {string} uuid
         * @param {string} minorUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMinorV2: (uuid, minorUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('deleteMinorV2', 'uuid', uuid);
            // verify required parameter 'minorUuid' is not null or undefined
            common_1.assertParamExists('deleteMinorV2', 'minorUuid', minorUuid);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/minors/{minor_uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"minor_uuid"}}`, encodeURIComponent(String(minorUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Deletes a PM note on this application
         * @param {string} uuid
         * @param {string} noteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNote: (uuid, noteId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('deleteNote', 'uuid', uuid);
            // verify required parameter 'noteId' is not null or undefined
            common_1.assertParamExists('deleteNote', 'noteId', noteId);
            const localVarPath = `/api/v2/applications/{uuid}/notes/{note_id}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"note_id"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a pet.
         * @param {string} uuid
         * @param {string} petUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePetV2: (uuid, petUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('deletePetV2', 'uuid', uuid);
            // verify required parameter 'petUuid' is not null or undefined
            common_1.assertParamExists('deletePetV2', 'petUuid', petUuid);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/pets/{pet_uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"pet_uuid"}}`, encodeURIComponent(String(petUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Removes a rental history.
         * @param {string} uuid
         * @param {string} rentalhistoryUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRentalHistoryV2: (uuid, rentalhistoryUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('deleteRentalHistoryV2', 'uuid', uuid);
            // verify required parameter 'rentalhistoryUuid' is not null or undefined
            common_1.assertParamExists('deleteRentalHistoryV2', 'rentalhistoryUuid', rentalhistoryUuid);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/rentalhistories/{rentalhistory_uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"rentalhistory_uuid"}}`, encodeURIComponent(String(rentalhistoryUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Removes a rental history.
         * @param {string} uuid
         * @param {string} vehicleUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVehicleV2: (uuid, vehicleUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('deleteVehicleV2', 'uuid', uuid);
            // verify required parameter 'vehicleUuid' is not null or undefined
            common_1.assertParamExists('deleteVehicleV2', 'vehicleUuid', vehicleUuid);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/vehicles/{vehicle_uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"vehicle_uuid"}}`, encodeURIComponent(String(vehicleUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary export files related to a decision on an application
         * @param {string} uuid
         * @param {ApplicationDecisionFileExportDto} applicationDecisionFileExportDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportApplicationDecisionFiles: (uuid, applicationDecisionFileExportDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('exportApplicationDecisionFiles', 'uuid', uuid);
            // verify required parameter 'applicationDecisionFileExportDto' is not null or undefined
            common_1.assertParamExists('exportApplicationDecisionFiles', 'applicationDecisionFileExportDto', applicationDecisionFileExportDto);
            const localVarPath = `/api/v2/applications/{uuid}/decision/export`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(applicationDecisionFileExportDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary export details of submitted application as pdf
         * @param {string} uuid
         * @param {ApplicationDesiredFileDto} applicationDesiredFileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportApplicationFiles: (uuid, applicationDesiredFileDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('exportApplicationFiles', 'uuid', uuid);
            // verify required parameter 'applicationDesiredFileDto' is not null or undefined
            common_1.assertParamExists('exportApplicationFiles', 'applicationDesiredFileDto', applicationDesiredFileDto);
            const localVarPath = `/api/v2/applications/{uuid}/export`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(applicationDesiredFileDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Adds an accepted TsCs
         * @param {string} uuid
         * @param {string} applicantUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAcceptedTsCs: (uuid, applicantUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getAcceptedTsCs', 'uuid', uuid);
            // verify required parameter 'applicantUuid' is not null or undefined
            common_1.assertParamExists('getAcceptedTsCs', 'applicantUuid', applicantUuid);
            const localVarPath = `/api/v2/applications/{uuid}/termsconditions`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (applicantUuid !== undefined) {
                localVarQueryParameter['applicantUuid'] = applicantUuid;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all PM notes on this application
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNotes: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getAllNotes', 'uuid', uuid);
            const localVarPath = `/api/v2/applications/{uuid}/notes`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets all pets.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPetsV2: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getAllPetsV2', 'uuid', uuid);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/pets`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets all rental histories for this applicant
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRentalHistoriesV2: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getAllRentalHistoriesV2', 'uuid', uuid);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/rentalhistories`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets an applicant\'s applications.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicantApplicationsV2: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getApplicantApplicationsV2', 'uuid', uuid);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/applications`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets an applicant\'s documents.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicantDocumentsV2: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getApplicantDocumentsV2', 'uuid', uuid);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/documents`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets an applicant.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicantV2: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getApplicantV2', 'uuid', uuid);
            const localVarPath = `/api/v2/applications/applicants/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets coapplicant invitation information.
         * @param {string} applicationUuid
         * @param {string} coapplicantUuid
         * @param {string} hmac
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationInvitationDetail: (applicationUuid, coapplicantUuid, hmac, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'applicationUuid' is not null or undefined
            common_1.assertParamExists('getApplicationInvitationDetail', 'applicationUuid', applicationUuid);
            // verify required parameter 'coapplicantUuid' is not null or undefined
            common_1.assertParamExists('getApplicationInvitationDetail', 'coapplicantUuid', coapplicantUuid);
            // verify required parameter 'hmac' is not null or undefined
            common_1.assertParamExists('getApplicationInvitationDetail', 'hmac', hmac);
            const localVarPath = `/api/v2/applications/invitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (applicationUuid !== undefined) {
                localVarQueryParameter['applicationUuid'] = applicationUuid;
            }
            if (coapplicantUuid !== undefined) {
                localVarQueryParameter['coapplicantUuid'] = coapplicantUuid;
            }
            if (hmac !== undefined) {
                localVarQueryParameter['hmac'] = hmac;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets Application Details
         * @summary Get Application Details.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationV2: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getApplicationV2', 'uuid', uuid);
            const localVarPath = `/api/v2/applications/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets custom questions answers
         * @param {string} uuid
         * @param {string} applicantUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomQuestionAnswers: (uuid, applicantUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getCustomQuestionAnswers', 'uuid', uuid);
            // verify required parameter 'applicantUuid' is not null or undefined
            common_1.assertParamExists('getCustomQuestionAnswers', 'applicantUuid', applicantUuid);
            const localVarPath = `/api/v2/applications/{uuid}/customquestions`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (applicantUuid !== undefined) {
                localVarQueryParameter['applicantUuid'] = applicantUuid;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets an employment.
         * @param {string} uuid
         * @param {string} employmentUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmploymentV2: (uuid, employmentUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getEmploymentV2', 'uuid', uuid);
            // verify required parameter 'employmentUuid' is not null or undefined
            common_1.assertParamExists('getEmploymentV2', 'employmentUuid', employmentUuid);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/employments/{employment_uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"employment_uuid"}}`, encodeURIComponent(String(employmentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets all employments for this applicant
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmploymentsV2: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getEmploymentsV2', 'uuid', uuid);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/employments`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets a minor.
         * @param {string} uuid
         * @param {string} minorUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMinorV2: (uuid, minorUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getMinorV2', 'uuid', uuid);
            // verify required parameter 'minorUuid' is not null or undefined
            common_1.assertParamExists('getMinorV2', 'minorUuid', minorUuid);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/minors/{minor_uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"minor_uuid"}}`, encodeURIComponent(String(minorUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets all minors for this applicant
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMinorsV2: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getMinorsV2', 'uuid', uuid);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/minors`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets a pet.
         * @param {string} uuid
         * @param {string} petUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPetV2: (uuid, petUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getPetV2', 'uuid', uuid);
            // verify required parameter 'petUuid' is not null or undefined
            common_1.assertParamExists('getPetV2', 'petUuid', petUuid);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/pets/{pet_uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"pet_uuid"}}`, encodeURIComponent(String(petUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets a rental history.
         * @param {string} uuid
         * @param {string} rentalhistoryUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRentalHistoryV2: (uuid, rentalhistoryUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getRentalHistoryV2', 'uuid', uuid);
            // verify required parameter 'rentalhistoryUuid' is not null or undefined
            common_1.assertParamExists('getRentalHistoryV2', 'rentalhistoryUuid', rentalhistoryUuid);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/rentalhistories/{rentalhistory_uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"rentalhistory_uuid"}}`, encodeURIComponent(String(rentalhistoryUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets a vehicle.
         * @param {string} uuid
         * @param {string} vehicleUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicle2: (uuid, vehicleUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getVehicle2', 'uuid', uuid);
            // verify required parameter 'vehicleUuid' is not null or undefined
            common_1.assertParamExists('getVehicle2', 'vehicleUuid', vehicleUuid);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/vehicles/{vehicle_uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"vehicle_uuid"}}`, encodeURIComponent(String(vehicleUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets all vehicles for this applicant
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclesV2: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getVehiclesV2', 'uuid', uuid);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/vehicles`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Searches for Application with pagination
         * @summary Find Applications
         * @param {ApplicationSearchDto} applicationSearchDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchApplicationsV2: (applicationSearchDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'applicationSearchDto' is not null or undefined
            common_1.assertParamExists('searchApplicationsV2', 'applicationSearchDto', applicationSearchDto);
            const localVarPath = `/api/v2/applications/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(applicationSearchDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Notifies applicant(s) about a decision on their application
         * @param {string} uuid
         * @param {SendApplicationStatusNotificationDto} sendApplicationStatusNotificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendApplicationStatusNotification: (uuid, sendApplicationStatusNotificationDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('sendApplicationStatusNotification', 'uuid', uuid);
            // verify required parameter 'sendApplicationStatusNotificationDto' is not null or undefined
            common_1.assertParamExists('sendApplicationStatusNotification', 'sendApplicationStatusNotificationDto', sendApplicationStatusNotificationDto);
            const localVarPath = `/api/v2/applications/{uuid}/status/notification`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(sendApplicationStatusNotificationDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates the status of an applicant on an application
         * @summary Updates the status of an applicant on an application
         * @param {string} uuid
         * @param {string} applicantUuid
         * @param {UpdateApplicantStatusDto} updateApplicantStatusDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplicantStatusV2: (uuid, applicantUuid, updateApplicantStatusDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateApplicantStatusV2', 'uuid', uuid);
            // verify required parameter 'applicantUuid' is not null or undefined
            common_1.assertParamExists('updateApplicantStatusV2', 'applicantUuid', applicantUuid);
            // verify required parameter 'updateApplicantStatusDto' is not null or undefined
            common_1.assertParamExists('updateApplicantStatusV2', 'updateApplicantStatusDto', updateApplicantStatusDto);
            const localVarPath = `/api/v2/applications/{uuid}/applicants/{applicant_uuid}/status`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"applicant_uuid"}}`, encodeURIComponent(String(applicantUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateApplicantStatusDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Updates an applicant.
         * @param {string} uuid
         * @param {UpsertApplicantV2Dto} upsertApplicantV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplicantV2: (uuid, upsertApplicantV2Dto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateApplicantV2', 'uuid', uuid);
            // verify required parameter 'upsertApplicantV2Dto' is not null or undefined
            common_1.assertParamExists('updateApplicantV2', 'upsertApplicantV2Dto', upsertApplicantV2Dto);
            const localVarPath = `/api/v2/applications/applicants/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(upsertApplicantV2Dto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Allows the PM to update the property on an application
         * @param {string} uuid
         * @param {UpdateApplicationPropertyDto} updateApplicationPropertyDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplicationProperty: (uuid, updateApplicationPropertyDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateApplicationProperty', 'uuid', uuid);
            // verify required parameter 'updateApplicationPropertyDto' is not null or undefined
            common_1.assertParamExists('updateApplicationProperty', 'updateApplicationPropertyDto', updateApplicationPropertyDto);
            const localVarPath = `/api/v2/applications/{uuid}/property`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateApplicationPropertyDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates parts of an app
         * @summary Updates parts of an app
         * @param {string} uuid
         * @param {UpdateApplicationV2Dto} updateApplicationV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplicationV2: (uuid, updateApplicationV2Dto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateApplicationV2', 'uuid', uuid);
            // verify required parameter 'updateApplicationV2Dto' is not null or undefined
            common_1.assertParamExists('updateApplicationV2', 'updateApplicationV2Dto', updateApplicationV2Dto);
            const localVarPath = `/api/v2/applications/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateApplicationV2Dto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update an employment.
         * @param {string} uuid
         * @param {string} employmentUuid
         * @param {UpsertApplicantEmploymentHistoryV2Dto} upsertApplicantEmploymentHistoryV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmploymentV2: (uuid, employmentUuid, upsertApplicantEmploymentHistoryV2Dto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateEmploymentV2', 'uuid', uuid);
            // verify required parameter 'employmentUuid' is not null or undefined
            common_1.assertParamExists('updateEmploymentV2', 'employmentUuid', employmentUuid);
            // verify required parameter 'upsertApplicantEmploymentHistoryV2Dto' is not null or undefined
            common_1.assertParamExists('updateEmploymentV2', 'upsertApplicantEmploymentHistoryV2Dto', upsertApplicantEmploymentHistoryV2Dto);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/employments/{employment_uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"employment_uuid"}}`, encodeURIComponent(String(employmentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(upsertApplicantEmploymentHistoryV2Dto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update a minor.
         * @param {string} uuid
         * @param {string} minorUuid
         * @param {UpsertApplicantMinorV2Dto} upsertApplicantMinorV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMinorV2: (uuid, minorUuid, upsertApplicantMinorV2Dto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateMinorV2', 'uuid', uuid);
            // verify required parameter 'minorUuid' is not null or undefined
            common_1.assertParamExists('updateMinorV2', 'minorUuid', minorUuid);
            // verify required parameter 'upsertApplicantMinorV2Dto' is not null or undefined
            common_1.assertParamExists('updateMinorV2', 'upsertApplicantMinorV2Dto', upsertApplicantMinorV2Dto);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/minors/{minor_uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"minor_uuid"}}`, encodeURIComponent(String(minorUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(upsertApplicantMinorV2Dto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update a pet.
         * @param {string} uuid
         * @param {string} petUuid
         * @param {UpsertApplicationPetV2Dto} upsertApplicationPetV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePetV2: (uuid, petUuid, upsertApplicationPetV2Dto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updatePetV2', 'uuid', uuid);
            // verify required parameter 'petUuid' is not null or undefined
            common_1.assertParamExists('updatePetV2', 'petUuid', petUuid);
            // verify required parameter 'upsertApplicationPetV2Dto' is not null or undefined
            common_1.assertParamExists('updatePetV2', 'upsertApplicationPetV2Dto', upsertApplicationPetV2Dto);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/pets/{pet_uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"pet_uuid"}}`, encodeURIComponent(String(petUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(upsertApplicationPetV2Dto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update a rental history.
         * @param {string} uuid
         * @param {string} rentalhistoryUuid
         * @param {UpsertApplicantRentalHistoryV2Dto} upsertApplicantRentalHistoryV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRentalHistoryV2: (uuid, rentalhistoryUuid, upsertApplicantRentalHistoryV2Dto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateRentalHistoryV2', 'uuid', uuid);
            // verify required parameter 'rentalhistoryUuid' is not null or undefined
            common_1.assertParamExists('updateRentalHistoryV2', 'rentalhistoryUuid', rentalhistoryUuid);
            // verify required parameter 'upsertApplicantRentalHistoryV2Dto' is not null or undefined
            common_1.assertParamExists('updateRentalHistoryV2', 'upsertApplicantRentalHistoryV2Dto', upsertApplicantRentalHistoryV2Dto);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/rentalhistories/{rentalhistory_uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"rentalhistory_uuid"}}`, encodeURIComponent(String(rentalhistoryUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(upsertApplicantRentalHistoryV2Dto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update a vehicle.
         * @param {string} uuid
         * @param {string} vehicleUuid
         * @param {UpsertApplicantVehicleV2Dto} upsertApplicantVehicleV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVehicleV2: (uuid, vehicleUuid, upsertApplicantVehicleV2Dto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateVehicleV2', 'uuid', uuid);
            // verify required parameter 'vehicleUuid' is not null or undefined
            common_1.assertParamExists('updateVehicleV2', 'vehicleUuid', vehicleUuid);
            // verify required parameter 'upsertApplicantVehicleV2Dto' is not null or undefined
            common_1.assertParamExists('updateVehicleV2', 'upsertApplicantVehicleV2Dto', upsertApplicantVehicleV2Dto);
            const localVarPath = `/api/v2/applications/applicants/{uuid}/vehicles/{vehicle_uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"vehicle_uuid"}}`, encodeURIComponent(String(vehicleUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(upsertApplicantVehicleV2Dto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ApplicationsV2Api - functional programming interface
 * @export
 */
exports.ApplicationsV2ApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.ApplicationsV2ApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Adds an accepted TsCs
         * @param {string} uuid
         * @param {ApplicationAcceptedTsCsAuditV2Dto} applicationAcceptedTsCsAuditV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAcceptedTsCs(uuid, applicationAcceptedTsCsAuditV2Dto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addAcceptedTsCs(uuid, applicationAcceptedTsCsAuditV2Dto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Adds/replaces a custom question answer
         * @param {string} uuid
         * @param {ApplicationQuestionResponseV2Dto} applicationQuestionResponseV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCustomQuestionAnswers(uuid, applicationQuestionResponseV2Dto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addCustomQuestionAnswers(uuid, applicationQuestionResponseV2Dto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Allows the PM/Applicant to change the status on an application
         * @param {string} uuid
         * @param {ChangeApplicationStatusDto} changeApplicationStatusDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeApplicationStatus(uuid, changeApplicationStatusDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.changeApplicationStatus(uuid, changeApplicationStatusDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Adds an applicant into our system. If an applicant for this user alrady exists, it is returned instead.
         * @param {UpsertApplicantV2Dto} upsertApplicantV2Dto
         * @param {string} [inviteToApplicationUuid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApplicantV2(upsertApplicantV2Dto, inviteToApplicationUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createApplicantV2(upsertApplicantV2Dto, inviteToApplicationUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Start a net new application
         * @summary Start a net new application
         * @param {CreateApplicationV2Dto} createApplicationV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApplicationV2(createApplicationV2Dto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createApplicationV2(createApplicationV2Dto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Allows the user to add an employment into our system
         * @param {string} uuid
         * @param {UpsertApplicantEmploymentHistoryV2Dto} upsertApplicantEmploymentHistoryV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmploymentV2(uuid, upsertApplicantEmploymentHistoryV2Dto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createEmploymentV2(uuid, upsertApplicantEmploymentHistoryV2Dto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Allows the user to add a minor into our system
         * @param {string} uuid
         * @param {UpsertApplicantMinorV2Dto} upsertApplicantMinorV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMinorV2(uuid, upsertApplicantMinorV2Dto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createMinorV2(uuid, upsertApplicantMinorV2Dto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Creates a PM note on this application
         * @param {string} uuid
         * @param {CreateApplicationNoteDto} createApplicationNoteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNote(uuid, createApplicationNoteDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createNote(uuid, createApplicationNoteDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Allows the user to add a pet into our system
         * @param {string} uuid
         * @param {UpsertApplicationPetV2Dto} upsertApplicationPetV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPetV2(uuid, upsertApplicationPetV2Dto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createPetV2(uuid, upsertApplicationPetV2Dto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Allows the user to add a rental history into our system
         * @param {string} uuid
         * @param {UpsertApplicantRentalHistoryV2Dto} upsertApplicantRentalHistoryV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRentalHistoryV2(uuid, upsertApplicantRentalHistoryV2Dto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createRentalHistoryV2(uuid, upsertApplicantRentalHistoryV2Dto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Allows the user to add a vehicle into our system
         * @param {string} uuid
         * @param {UpsertApplicantVehicleV2Dto} upsertApplicantVehicleV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVehicleV2(uuid, upsertApplicantVehicleV2Dto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createVehicleV2(uuid, upsertApplicantVehicleV2Dto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Deletes an applicant.
         * @param {string} uuid
         * @param {string} applicationUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApplicantV2(uuid, applicationUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteApplicantV2(uuid, applicationUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Removes an employment.
         * @param {string} uuid
         * @param {string} employmentUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmploymentV2(uuid, employmentUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteEmploymentV2(uuid, employmentUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Removes a rental history.
         * @param {string} uuid
         * @param {string} minorUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMinorV2(uuid, minorUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteMinorV2(uuid, minorUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Deletes a PM note on this application
         * @param {string} uuid
         * @param {string} noteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNote(uuid, noteId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteNote(uuid, noteId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete a pet.
         * @param {string} uuid
         * @param {string} petUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePetV2(uuid, petUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deletePetV2(uuid, petUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Removes a rental history.
         * @param {string} uuid
         * @param {string} rentalhistoryUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRentalHistoryV2(uuid, rentalhistoryUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteRentalHistoryV2(uuid, rentalhistoryUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Removes a rental history.
         * @param {string} uuid
         * @param {string} vehicleUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVehicleV2(uuid, vehicleUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteVehicleV2(uuid, vehicleUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary export files related to a decision on an application
         * @param {string} uuid
         * @param {ApplicationDecisionFileExportDto} applicationDecisionFileExportDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportApplicationDecisionFiles(uuid, applicationDecisionFileExportDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.exportApplicationDecisionFiles(uuid, applicationDecisionFileExportDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary export details of submitted application as pdf
         * @param {string} uuid
         * @param {ApplicationDesiredFileDto} applicationDesiredFileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportApplicationFiles(uuid, applicationDesiredFileDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.exportApplicationFiles(uuid, applicationDesiredFileDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Adds an accepted TsCs
         * @param {string} uuid
         * @param {string} applicantUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAcceptedTsCs(uuid, applicantUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAcceptedTsCs(uuid, applicantUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all PM notes on this application
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNotes(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllNotes(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets all pets.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPetsV2(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllPetsV2(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets all rental histories for this applicant
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRentalHistoriesV2(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllRentalHistoriesV2(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets an applicant\'s applications.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicantApplicationsV2(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getApplicantApplicationsV2(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets an applicant\'s documents.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicantDocumentsV2(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getApplicantDocumentsV2(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets an applicant.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicantV2(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getApplicantV2(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets coapplicant invitation information.
         * @param {string} applicationUuid
         * @param {string} coapplicantUuid
         * @param {string} hmac
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationInvitationDetail(applicationUuid, coapplicantUuid, hmac, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getApplicationInvitationDetail(applicationUuid, coapplicantUuid, hmac, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets Application Details
         * @summary Get Application Details.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationV2(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getApplicationV2(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets custom questions answers
         * @param {string} uuid
         * @param {string} applicantUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomQuestionAnswers(uuid, applicantUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCustomQuestionAnswers(uuid, applicantUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets an employment.
         * @param {string} uuid
         * @param {string} employmentUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmploymentV2(uuid, employmentUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEmploymentV2(uuid, employmentUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets all employments for this applicant
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmploymentsV2(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEmploymentsV2(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets a minor.
         * @param {string} uuid
         * @param {string} minorUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMinorV2(uuid, minorUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMinorV2(uuid, minorUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets all minors for this applicant
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMinorsV2(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMinorsV2(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets a pet.
         * @param {string} uuid
         * @param {string} petUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPetV2(uuid, petUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPetV2(uuid, petUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets a rental history.
         * @param {string} uuid
         * @param {string} rentalhistoryUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRentalHistoryV2(uuid, rentalhistoryUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRentalHistoryV2(uuid, rentalhistoryUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets a vehicle.
         * @param {string} uuid
         * @param {string} vehicleUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicle2(uuid, vehicleUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getVehicle2(uuid, vehicleUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets all vehicles for this applicant
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclesV2(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getVehiclesV2(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Searches for Application with pagination
         * @summary Find Applications
         * @param {ApplicationSearchDto} applicationSearchDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchApplicationsV2(applicationSearchDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchApplicationsV2(applicationSearchDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Notifies applicant(s) about a decision on their application
         * @param {string} uuid
         * @param {SendApplicationStatusNotificationDto} sendApplicationStatusNotificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendApplicationStatusNotification(uuid, sendApplicationStatusNotificationDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendApplicationStatusNotification(uuid, sendApplicationStatusNotificationDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates the status of an applicant on an application
         * @summary Updates the status of an applicant on an application
         * @param {string} uuid
         * @param {string} applicantUuid
         * @param {UpdateApplicantStatusDto} updateApplicantStatusDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplicantStatusV2(uuid, applicantUuid, updateApplicantStatusDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateApplicantStatusV2(uuid, applicantUuid, updateApplicantStatusDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Updates an applicant.
         * @param {string} uuid
         * @param {UpsertApplicantV2Dto} upsertApplicantV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplicantV2(uuid, upsertApplicantV2Dto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateApplicantV2(uuid, upsertApplicantV2Dto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Allows the PM to update the property on an application
         * @param {string} uuid
         * @param {UpdateApplicationPropertyDto} updateApplicationPropertyDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplicationProperty(uuid, updateApplicationPropertyDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateApplicationProperty(uuid, updateApplicationPropertyDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates parts of an app
         * @summary Updates parts of an app
         * @param {string} uuid
         * @param {UpdateApplicationV2Dto} updateApplicationV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplicationV2(uuid, updateApplicationV2Dto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateApplicationV2(uuid, updateApplicationV2Dto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update an employment.
         * @param {string} uuid
         * @param {string} employmentUuid
         * @param {UpsertApplicantEmploymentHistoryV2Dto} upsertApplicantEmploymentHistoryV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmploymentV2(uuid, employmentUuid, upsertApplicantEmploymentHistoryV2Dto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateEmploymentV2(uuid, employmentUuid, upsertApplicantEmploymentHistoryV2Dto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update a minor.
         * @param {string} uuid
         * @param {string} minorUuid
         * @param {UpsertApplicantMinorV2Dto} upsertApplicantMinorV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMinorV2(uuid, minorUuid, upsertApplicantMinorV2Dto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateMinorV2(uuid, minorUuid, upsertApplicantMinorV2Dto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update a pet.
         * @param {string} uuid
         * @param {string} petUuid
         * @param {UpsertApplicationPetV2Dto} upsertApplicationPetV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePetV2(uuid, petUuid, upsertApplicationPetV2Dto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePetV2(uuid, petUuid, upsertApplicationPetV2Dto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update a rental history.
         * @param {string} uuid
         * @param {string} rentalhistoryUuid
         * @param {UpsertApplicantRentalHistoryV2Dto} upsertApplicantRentalHistoryV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRentalHistoryV2(uuid, rentalhistoryUuid, upsertApplicantRentalHistoryV2Dto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateRentalHistoryV2(uuid, rentalhistoryUuid, upsertApplicantRentalHistoryV2Dto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update a vehicle.
         * @param {string} uuid
         * @param {string} vehicleUuid
         * @param {UpsertApplicantVehicleV2Dto} upsertApplicantVehicleV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVehicleV2(uuid, vehicleUuid, upsertApplicantVehicleV2Dto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateVehicleV2(uuid, vehicleUuid, upsertApplicantVehicleV2Dto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ApplicationsV2Api - factory interface
 * @export
 */
exports.ApplicationsV2ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.ApplicationsV2ApiFp(configuration);
    return {
        /**
         *
         * @summary Adds an accepted TsCs
         * @param {string} uuid
         * @param {ApplicationAcceptedTsCsAuditV2Dto} applicationAcceptedTsCsAuditV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAcceptedTsCs(uuid, applicationAcceptedTsCsAuditV2Dto, options) {
            return localVarFp.addAcceptedTsCs(uuid, applicationAcceptedTsCsAuditV2Dto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Adds/replaces a custom question answer
         * @param {string} uuid
         * @param {ApplicationQuestionResponseV2Dto} applicationQuestionResponseV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCustomQuestionAnswers(uuid, applicationQuestionResponseV2Dto, options) {
            return localVarFp.addCustomQuestionAnswers(uuid, applicationQuestionResponseV2Dto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Allows the PM/Applicant to change the status on an application
         * @param {string} uuid
         * @param {ChangeApplicationStatusDto} changeApplicationStatusDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeApplicationStatus(uuid, changeApplicationStatusDto, options) {
            return localVarFp.changeApplicationStatus(uuid, changeApplicationStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Adds an applicant into our system. If an applicant for this user alrady exists, it is returned instead.
         * @param {UpsertApplicantV2Dto} upsertApplicantV2Dto
         * @param {string} [inviteToApplicationUuid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApplicantV2(upsertApplicantV2Dto, inviteToApplicationUuid, options) {
            return localVarFp.createApplicantV2(upsertApplicantV2Dto, inviteToApplicationUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Start a net new application
         * @summary Start a net new application
         * @param {CreateApplicationV2Dto} createApplicationV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApplicationV2(createApplicationV2Dto, options) {
            return localVarFp.createApplicationV2(createApplicationV2Dto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Allows the user to add an employment into our system
         * @param {string} uuid
         * @param {UpsertApplicantEmploymentHistoryV2Dto} upsertApplicantEmploymentHistoryV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmploymentV2(uuid, upsertApplicantEmploymentHistoryV2Dto, options) {
            return localVarFp.createEmploymentV2(uuid, upsertApplicantEmploymentHistoryV2Dto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Allows the user to add a minor into our system
         * @param {string} uuid
         * @param {UpsertApplicantMinorV2Dto} upsertApplicantMinorV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMinorV2(uuid, upsertApplicantMinorV2Dto, options) {
            return localVarFp.createMinorV2(uuid, upsertApplicantMinorV2Dto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Creates a PM note on this application
         * @param {string} uuid
         * @param {CreateApplicationNoteDto} createApplicationNoteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNote(uuid, createApplicationNoteDto, options) {
            return localVarFp.createNote(uuid, createApplicationNoteDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Allows the user to add a pet into our system
         * @param {string} uuid
         * @param {UpsertApplicationPetV2Dto} upsertApplicationPetV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPetV2(uuid, upsertApplicationPetV2Dto, options) {
            return localVarFp.createPetV2(uuid, upsertApplicationPetV2Dto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Allows the user to add a rental history into our system
         * @param {string} uuid
         * @param {UpsertApplicantRentalHistoryV2Dto} upsertApplicantRentalHistoryV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRentalHistoryV2(uuid, upsertApplicantRentalHistoryV2Dto, options) {
            return localVarFp.createRentalHistoryV2(uuid, upsertApplicantRentalHistoryV2Dto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Allows the user to add a vehicle into our system
         * @param {string} uuid
         * @param {UpsertApplicantVehicleV2Dto} upsertApplicantVehicleV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVehicleV2(uuid, upsertApplicantVehicleV2Dto, options) {
            return localVarFp.createVehicleV2(uuid, upsertApplicantVehicleV2Dto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Deletes an applicant.
         * @param {string} uuid
         * @param {string} applicationUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApplicantV2(uuid, applicationUuid, options) {
            return localVarFp.deleteApplicantV2(uuid, applicationUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Removes an employment.
         * @param {string} uuid
         * @param {string} employmentUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmploymentV2(uuid, employmentUuid, options) {
            return localVarFp.deleteEmploymentV2(uuid, employmentUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Removes a rental history.
         * @param {string} uuid
         * @param {string} minorUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMinorV2(uuid, minorUuid, options) {
            return localVarFp.deleteMinorV2(uuid, minorUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Deletes a PM note on this application
         * @param {string} uuid
         * @param {string} noteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNote(uuid, noteId, options) {
            return localVarFp.deleteNote(uuid, noteId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a pet.
         * @param {string} uuid
         * @param {string} petUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePetV2(uuid, petUuid, options) {
            return localVarFp.deletePetV2(uuid, petUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Removes a rental history.
         * @param {string} uuid
         * @param {string} rentalhistoryUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRentalHistoryV2(uuid, rentalhistoryUuid, options) {
            return localVarFp.deleteRentalHistoryV2(uuid, rentalhistoryUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Removes a rental history.
         * @param {string} uuid
         * @param {string} vehicleUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVehicleV2(uuid, vehicleUuid, options) {
            return localVarFp.deleteVehicleV2(uuid, vehicleUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary export files related to a decision on an application
         * @param {string} uuid
         * @param {ApplicationDecisionFileExportDto} applicationDecisionFileExportDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportApplicationDecisionFiles(uuid, applicationDecisionFileExportDto, options) {
            return localVarFp.exportApplicationDecisionFiles(uuid, applicationDecisionFileExportDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary export details of submitted application as pdf
         * @param {string} uuid
         * @param {ApplicationDesiredFileDto} applicationDesiredFileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportApplicationFiles(uuid, applicationDesiredFileDto, options) {
            return localVarFp.exportApplicationFiles(uuid, applicationDesiredFileDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Adds an accepted TsCs
         * @param {string} uuid
         * @param {string} applicantUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAcceptedTsCs(uuid, applicantUuid, options) {
            return localVarFp.getAcceptedTsCs(uuid, applicantUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all PM notes on this application
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNotes(uuid, options) {
            return localVarFp.getAllNotes(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets all pets.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPetsV2(uuid, options) {
            return localVarFp.getAllPetsV2(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets all rental histories for this applicant
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRentalHistoriesV2(uuid, options) {
            return localVarFp.getAllRentalHistoriesV2(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets an applicant\'s applications.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicantApplicationsV2(uuid, options) {
            return localVarFp.getApplicantApplicationsV2(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets an applicant\'s documents.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicantDocumentsV2(uuid, options) {
            return localVarFp.getApplicantDocumentsV2(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets an applicant.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicantV2(uuid, options) {
            return localVarFp.getApplicantV2(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets coapplicant invitation information.
         * @param {string} applicationUuid
         * @param {string} coapplicantUuid
         * @param {string} hmac
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationInvitationDetail(applicationUuid, coapplicantUuid, hmac, options) {
            return localVarFp.getApplicationInvitationDetail(applicationUuid, coapplicantUuid, hmac, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets Application Details
         * @summary Get Application Details.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationV2(uuid, options) {
            return localVarFp.getApplicationV2(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets custom questions answers
         * @param {string} uuid
         * @param {string} applicantUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomQuestionAnswers(uuid, applicantUuid, options) {
            return localVarFp.getCustomQuestionAnswers(uuid, applicantUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets an employment.
         * @param {string} uuid
         * @param {string} employmentUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmploymentV2(uuid, employmentUuid, options) {
            return localVarFp.getEmploymentV2(uuid, employmentUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets all employments for this applicant
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmploymentsV2(uuid, options) {
            return localVarFp.getEmploymentsV2(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets a minor.
         * @param {string} uuid
         * @param {string} minorUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMinorV2(uuid, minorUuid, options) {
            return localVarFp.getMinorV2(uuid, minorUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets all minors for this applicant
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMinorsV2(uuid, options) {
            return localVarFp.getMinorsV2(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets a pet.
         * @param {string} uuid
         * @param {string} petUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPetV2(uuid, petUuid, options) {
            return localVarFp.getPetV2(uuid, petUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets a rental history.
         * @param {string} uuid
         * @param {string} rentalhistoryUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRentalHistoryV2(uuid, rentalhistoryUuid, options) {
            return localVarFp.getRentalHistoryV2(uuid, rentalhistoryUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets a vehicle.
         * @param {string} uuid
         * @param {string} vehicleUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicle2(uuid, vehicleUuid, options) {
            return localVarFp.getVehicle2(uuid, vehicleUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets all vehicles for this applicant
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclesV2(uuid, options) {
            return localVarFp.getVehiclesV2(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Searches for Application with pagination
         * @summary Find Applications
         * @param {ApplicationSearchDto} applicationSearchDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchApplicationsV2(applicationSearchDto, options) {
            return localVarFp.searchApplicationsV2(applicationSearchDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Notifies applicant(s) about a decision on their application
         * @param {string} uuid
         * @param {SendApplicationStatusNotificationDto} sendApplicationStatusNotificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendApplicationStatusNotification(uuid, sendApplicationStatusNotificationDto, options) {
            return localVarFp.sendApplicationStatusNotification(uuid, sendApplicationStatusNotificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the status of an applicant on an application
         * @summary Updates the status of an applicant on an application
         * @param {string} uuid
         * @param {string} applicantUuid
         * @param {UpdateApplicantStatusDto} updateApplicantStatusDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplicantStatusV2(uuid, applicantUuid, updateApplicantStatusDto, options) {
            return localVarFp.updateApplicantStatusV2(uuid, applicantUuid, updateApplicantStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Updates an applicant.
         * @param {string} uuid
         * @param {UpsertApplicantV2Dto} upsertApplicantV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplicantV2(uuid, upsertApplicantV2Dto, options) {
            return localVarFp.updateApplicantV2(uuid, upsertApplicantV2Dto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Allows the PM to update the property on an application
         * @param {string} uuid
         * @param {UpdateApplicationPropertyDto} updateApplicationPropertyDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplicationProperty(uuid, updateApplicationPropertyDto, options) {
            return localVarFp.updateApplicationProperty(uuid, updateApplicationPropertyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates parts of an app
         * @summary Updates parts of an app
         * @param {string} uuid
         * @param {UpdateApplicationV2Dto} updateApplicationV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplicationV2(uuid, updateApplicationV2Dto, options) {
            return localVarFp.updateApplicationV2(uuid, updateApplicationV2Dto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an employment.
         * @param {string} uuid
         * @param {string} employmentUuid
         * @param {UpsertApplicantEmploymentHistoryV2Dto} upsertApplicantEmploymentHistoryV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmploymentV2(uuid, employmentUuid, upsertApplicantEmploymentHistoryV2Dto, options) {
            return localVarFp.updateEmploymentV2(uuid, employmentUuid, upsertApplicantEmploymentHistoryV2Dto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a minor.
         * @param {string} uuid
         * @param {string} minorUuid
         * @param {UpsertApplicantMinorV2Dto} upsertApplicantMinorV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMinorV2(uuid, minorUuid, upsertApplicantMinorV2Dto, options) {
            return localVarFp.updateMinorV2(uuid, minorUuid, upsertApplicantMinorV2Dto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a pet.
         * @param {string} uuid
         * @param {string} petUuid
         * @param {UpsertApplicationPetV2Dto} upsertApplicationPetV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePetV2(uuid, petUuid, upsertApplicationPetV2Dto, options) {
            return localVarFp.updatePetV2(uuid, petUuid, upsertApplicationPetV2Dto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a rental history.
         * @param {string} uuid
         * @param {string} rentalhistoryUuid
         * @param {UpsertApplicantRentalHistoryV2Dto} upsertApplicantRentalHistoryV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRentalHistoryV2(uuid, rentalhistoryUuid, upsertApplicantRentalHistoryV2Dto, options) {
            return localVarFp.updateRentalHistoryV2(uuid, rentalhistoryUuid, upsertApplicantRentalHistoryV2Dto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a vehicle.
         * @param {string} uuid
         * @param {string} vehicleUuid
         * @param {UpsertApplicantVehicleV2Dto} upsertApplicantVehicleV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVehicleV2(uuid, vehicleUuid, upsertApplicantVehicleV2Dto, options) {
            return localVarFp.updateVehicleV2(uuid, vehicleUuid, upsertApplicantVehicleV2Dto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ApplicationsV2Api - object-oriented interface
 * @export
 * @class ApplicationsV2Api
 * @extends {BaseAPI}
 */
class ApplicationsV2Api extends base_1.BaseAPI {
    /**
     *
     * @summary Adds an accepted TsCs
     * @param {string} uuid
     * @param {ApplicationAcceptedTsCsAuditV2Dto} applicationAcceptedTsCsAuditV2Dto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    addAcceptedTsCs(uuid, applicationAcceptedTsCsAuditV2Dto, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).addAcceptedTsCs(uuid, applicationAcceptedTsCsAuditV2Dto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Adds/replaces a custom question answer
     * @param {string} uuid
     * @param {ApplicationQuestionResponseV2Dto} applicationQuestionResponseV2Dto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    addCustomQuestionAnswers(uuid, applicationQuestionResponseV2Dto, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).addCustomQuestionAnswers(uuid, applicationQuestionResponseV2Dto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Allows the PM/Applicant to change the status on an application
     * @param {string} uuid
     * @param {ChangeApplicationStatusDto} changeApplicationStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    changeApplicationStatus(uuid, changeApplicationStatusDto, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).changeApplicationStatus(uuid, changeApplicationStatusDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Adds an applicant into our system. If an applicant for this user alrady exists, it is returned instead.
     * @param {UpsertApplicantV2Dto} upsertApplicantV2Dto
     * @param {string} [inviteToApplicationUuid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    createApplicantV2(upsertApplicantV2Dto, inviteToApplicationUuid, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).createApplicantV2(upsertApplicantV2Dto, inviteToApplicationUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Start a net new application
     * @summary Start a net new application
     * @param {CreateApplicationV2Dto} createApplicationV2Dto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    createApplicationV2(createApplicationV2Dto, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).createApplicationV2(createApplicationV2Dto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Allows the user to add an employment into our system
     * @param {string} uuid
     * @param {UpsertApplicantEmploymentHistoryV2Dto} upsertApplicantEmploymentHistoryV2Dto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    createEmploymentV2(uuid, upsertApplicantEmploymentHistoryV2Dto, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).createEmploymentV2(uuid, upsertApplicantEmploymentHistoryV2Dto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Allows the user to add a minor into our system
     * @param {string} uuid
     * @param {UpsertApplicantMinorV2Dto} upsertApplicantMinorV2Dto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    createMinorV2(uuid, upsertApplicantMinorV2Dto, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).createMinorV2(uuid, upsertApplicantMinorV2Dto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Creates a PM note on this application
     * @param {string} uuid
     * @param {CreateApplicationNoteDto} createApplicationNoteDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    createNote(uuid, createApplicationNoteDto, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).createNote(uuid, createApplicationNoteDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Allows the user to add a pet into our system
     * @param {string} uuid
     * @param {UpsertApplicationPetV2Dto} upsertApplicationPetV2Dto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    createPetV2(uuid, upsertApplicationPetV2Dto, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).createPetV2(uuid, upsertApplicationPetV2Dto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Allows the user to add a rental history into our system
     * @param {string} uuid
     * @param {UpsertApplicantRentalHistoryV2Dto} upsertApplicantRentalHistoryV2Dto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    createRentalHistoryV2(uuid, upsertApplicantRentalHistoryV2Dto, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).createRentalHistoryV2(uuid, upsertApplicantRentalHistoryV2Dto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Allows the user to add a vehicle into our system
     * @param {string} uuid
     * @param {UpsertApplicantVehicleV2Dto} upsertApplicantVehicleV2Dto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    createVehicleV2(uuid, upsertApplicantVehicleV2Dto, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).createVehicleV2(uuid, upsertApplicantVehicleV2Dto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Deletes an applicant.
     * @param {string} uuid
     * @param {string} applicationUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    deleteApplicantV2(uuid, applicationUuid, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).deleteApplicantV2(uuid, applicationUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Removes an employment.
     * @param {string} uuid
     * @param {string} employmentUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    deleteEmploymentV2(uuid, employmentUuid, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).deleteEmploymentV2(uuid, employmentUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Removes a rental history.
     * @param {string} uuid
     * @param {string} minorUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    deleteMinorV2(uuid, minorUuid, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).deleteMinorV2(uuid, minorUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Deletes a PM note on this application
     * @param {string} uuid
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    deleteNote(uuid, noteId, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).deleteNote(uuid, noteId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a pet.
     * @param {string} uuid
     * @param {string} petUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    deletePetV2(uuid, petUuid, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).deletePetV2(uuid, petUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Removes a rental history.
     * @param {string} uuid
     * @param {string} rentalhistoryUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    deleteRentalHistoryV2(uuid, rentalhistoryUuid, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).deleteRentalHistoryV2(uuid, rentalhistoryUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Removes a rental history.
     * @param {string} uuid
     * @param {string} vehicleUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    deleteVehicleV2(uuid, vehicleUuid, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).deleteVehicleV2(uuid, vehicleUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary export files related to a decision on an application
     * @param {string} uuid
     * @param {ApplicationDecisionFileExportDto} applicationDecisionFileExportDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    exportApplicationDecisionFiles(uuid, applicationDecisionFileExportDto, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).exportApplicationDecisionFiles(uuid, applicationDecisionFileExportDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary export details of submitted application as pdf
     * @param {string} uuid
     * @param {ApplicationDesiredFileDto} applicationDesiredFileDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    exportApplicationFiles(uuid, applicationDesiredFileDto, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).exportApplicationFiles(uuid, applicationDesiredFileDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Adds an accepted TsCs
     * @param {string} uuid
     * @param {string} applicantUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    getAcceptedTsCs(uuid, applicantUuid, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).getAcceptedTsCs(uuid, applicantUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all PM notes on this application
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    getAllNotes(uuid, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).getAllNotes(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets all pets.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    getAllPetsV2(uuid, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).getAllPetsV2(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets all rental histories for this applicant
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    getAllRentalHistoriesV2(uuid, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).getAllRentalHistoriesV2(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets an applicant\'s applications.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    getApplicantApplicationsV2(uuid, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).getApplicantApplicationsV2(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets an applicant\'s documents.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    getApplicantDocumentsV2(uuid, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).getApplicantDocumentsV2(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets an applicant.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    getApplicantV2(uuid, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).getApplicantV2(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets coapplicant invitation information.
     * @param {string} applicationUuid
     * @param {string} coapplicantUuid
     * @param {string} hmac
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    getApplicationInvitationDetail(applicationUuid, coapplicantUuid, hmac, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).getApplicationInvitationDetail(applicationUuid, coapplicantUuid, hmac, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets Application Details
     * @summary Get Application Details.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    getApplicationV2(uuid, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).getApplicationV2(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets custom questions answers
     * @param {string} uuid
     * @param {string} applicantUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    getCustomQuestionAnswers(uuid, applicantUuid, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).getCustomQuestionAnswers(uuid, applicantUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets an employment.
     * @param {string} uuid
     * @param {string} employmentUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    getEmploymentV2(uuid, employmentUuid, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).getEmploymentV2(uuid, employmentUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets all employments for this applicant
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    getEmploymentsV2(uuid, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).getEmploymentsV2(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets a minor.
     * @param {string} uuid
     * @param {string} minorUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    getMinorV2(uuid, minorUuid, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).getMinorV2(uuid, minorUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets all minors for this applicant
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    getMinorsV2(uuid, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).getMinorsV2(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets a pet.
     * @param {string} uuid
     * @param {string} petUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    getPetV2(uuid, petUuid, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).getPetV2(uuid, petUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets a rental history.
     * @param {string} uuid
     * @param {string} rentalhistoryUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    getRentalHistoryV2(uuid, rentalhistoryUuid, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).getRentalHistoryV2(uuid, rentalhistoryUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets a vehicle.
     * @param {string} uuid
     * @param {string} vehicleUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    getVehicle2(uuid, vehicleUuid, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).getVehicle2(uuid, vehicleUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets all vehicles for this applicant
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    getVehiclesV2(uuid, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).getVehiclesV2(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Searches for Application with pagination
     * @summary Find Applications
     * @param {ApplicationSearchDto} applicationSearchDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    searchApplicationsV2(applicationSearchDto, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).searchApplicationsV2(applicationSearchDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Notifies applicant(s) about a decision on their application
     * @param {string} uuid
     * @param {SendApplicationStatusNotificationDto} sendApplicationStatusNotificationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    sendApplicationStatusNotification(uuid, sendApplicationStatusNotificationDto, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).sendApplicationStatusNotification(uuid, sendApplicationStatusNotificationDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates the status of an applicant on an application
     * @summary Updates the status of an applicant on an application
     * @param {string} uuid
     * @param {string} applicantUuid
     * @param {UpdateApplicantStatusDto} updateApplicantStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    updateApplicantStatusV2(uuid, applicantUuid, updateApplicantStatusDto, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).updateApplicantStatusV2(uuid, applicantUuid, updateApplicantStatusDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Updates an applicant.
     * @param {string} uuid
     * @param {UpsertApplicantV2Dto} upsertApplicantV2Dto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    updateApplicantV2(uuid, upsertApplicantV2Dto, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).updateApplicantV2(uuid, upsertApplicantV2Dto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Allows the PM to update the property on an application
     * @param {string} uuid
     * @param {UpdateApplicationPropertyDto} updateApplicationPropertyDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    updateApplicationProperty(uuid, updateApplicationPropertyDto, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).updateApplicationProperty(uuid, updateApplicationPropertyDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates parts of an app
     * @summary Updates parts of an app
     * @param {string} uuid
     * @param {UpdateApplicationV2Dto} updateApplicationV2Dto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    updateApplicationV2(uuid, updateApplicationV2Dto, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).updateApplicationV2(uuid, updateApplicationV2Dto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an employment.
     * @param {string} uuid
     * @param {string} employmentUuid
     * @param {UpsertApplicantEmploymentHistoryV2Dto} upsertApplicantEmploymentHistoryV2Dto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    updateEmploymentV2(uuid, employmentUuid, upsertApplicantEmploymentHistoryV2Dto, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).updateEmploymentV2(uuid, employmentUuid, upsertApplicantEmploymentHistoryV2Dto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a minor.
     * @param {string} uuid
     * @param {string} minorUuid
     * @param {UpsertApplicantMinorV2Dto} upsertApplicantMinorV2Dto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    updateMinorV2(uuid, minorUuid, upsertApplicantMinorV2Dto, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).updateMinorV2(uuid, minorUuid, upsertApplicantMinorV2Dto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a pet.
     * @param {string} uuid
     * @param {string} petUuid
     * @param {UpsertApplicationPetV2Dto} upsertApplicationPetV2Dto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    updatePetV2(uuid, petUuid, upsertApplicationPetV2Dto, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).updatePetV2(uuid, petUuid, upsertApplicationPetV2Dto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a rental history.
     * @param {string} uuid
     * @param {string} rentalhistoryUuid
     * @param {UpsertApplicantRentalHistoryV2Dto} upsertApplicantRentalHistoryV2Dto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    updateRentalHistoryV2(uuid, rentalhistoryUuid, upsertApplicantRentalHistoryV2Dto, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).updateRentalHistoryV2(uuid, rentalhistoryUuid, upsertApplicantRentalHistoryV2Dto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a vehicle.
     * @param {string} uuid
     * @param {string} vehicleUuid
     * @param {UpsertApplicantVehicleV2Dto} upsertApplicantVehicleV2Dto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsV2Api
     */
    updateVehicleV2(uuid, vehicleUuid, upsertApplicantVehicleV2Dto, options) {
        return exports.ApplicationsV2ApiFp(this.configuration).updateVehicleV2(uuid, vehicleUuid, upsertApplicantVehicleV2Dto, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ApplicationsV2Api = ApplicationsV2Api;
/**
 * AuthApi - axios parameter creator
 * @export
 */
exports.AuthApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get the date/time and ip address of the user which agreed to our terms
         * @summary Record the aggrement which the user agreed upon
         * @param {AcceptTermsandConditionsDto} acceptTermsandConditionsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptterms: (acceptTermsandConditionsDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'acceptTermsandConditionsDto' is not null or undefined
            common_1.assertParamExists('acceptterms', 'acceptTermsandConditionsDto', acceptTermsandConditionsDto);
            const localVarPath = `/api/v1/auth/acceptterms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(acceptTermsandConditionsDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Adds/activates a new profile (via an activation token) to an existing user.
         * @param {AddProfileDto} addProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProfile: (addProfileDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'addProfileDto' is not null or undefined
            common_1.assertParamExists('addProfile', 'addProfileDto', addProfileDto);
            const localVarPath = `/api/v1/auth/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(addProfileDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Generates an activation token for a profile that rolls up to the current user.
         * @param {RegistrationTokenRequestDto} registrationTokenRequestDto
         * @param {boolean} [sendEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivationToken: (registrationTokenRequestDto, sendEmail, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'registrationTokenRequestDto' is not null or undefined
            common_1.assertParamExists('createActivationToken', 'registrationTokenRequestDto', registrationTokenRequestDto);
            const localVarPath = `/api/v2/auth/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (sendEmail !== undefined) {
                localVarQueryParameter['sendEmail'] = sendEmail;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(registrationTokenRequestDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Endpoint for client credentials registration.
         * @param {CreateClientCredentialsDTO} createClientCredentialsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClientCredentials: (createClientCredentialsDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createClientCredentialsDTO' is not null or undefined
            common_1.assertParamExists('createClientCredentials', 'createClientCredentialsDTO', createClientCredentialsDTO);
            const localVarPath = `/api/v1/auth/client`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createClientCredentialsDTO, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create or Update a notification subscription
         * @param {UpsertNotificationSubscriptionDto} upsertNotificationSubscriptionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateNotificationSubscription: (upsertNotificationSubscriptionDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'upsertNotificationSubscriptionDto' is not null or undefined
            common_1.assertParamExists('createOrUpdateNotificationSubscription', 'upsertNotificationSubscriptionDto', upsertNotificationSubscriptionDto);
            const localVarPath = `/api/v1/auth/notificationsubscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(upsertNotificationSubscriptionDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a notification subscription
         * @param {string} notificationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationSubscription: (notificationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'notificationId' is not null or undefined
            common_1.assertParamExists('deleteNotificationSubscription', 'notificationId', notificationId);
            const localVarPath = `/api/v1/auth/notificationsubscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (notificationId !== undefined) {
                localVarQueryParameter['notificationId'] = notificationId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Fetch all supported notifications for this user regardless if they have a subscription or not
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSupportedNotifications: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v1/auth/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDetails: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v1/auth/userdetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Company staff can issue a temporary passord for a subject in their realm
         * @param {TempPasscodeRequestDto} tempPasscodeRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueTempPasscode: (tempPasscodeRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tempPasscodeRequestDto' is not null or undefined
            common_1.assertParamExists('issueTempPasscode', 'tempPasscodeRequestDto', tempPasscodeRequestDto);
            const localVarPath = `/api/v1/auth/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(tempPasscodeRequestDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {LoginAsDto} loginAsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAs: (loginAsDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'loginAsDto' is not null or undefined
            common_1.assertParamExists('loginAs', 'loginAsDto', loginAsDto);
            const localVarPath = `/api/v1/auth/impersonation_token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(loginAsDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Unauthenticated user can request a reset token be sent to the user\'s email which will allow them to reset their password.
         * @param {PasswordResetRequest} passwordResetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset: (passwordResetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'passwordResetRequest' is not null or undefined
            common_1.assertParamExists('requestPasswordReset', 'passwordResetRequest', passwordResetRequest);
            const localVarPath = `/api/v1/auth/passwordreset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(passwordResetRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Resets a user\'s password, given a valid reset token is supplied.
         * @param {string} token
         * @param {PasswordResetChange} passwordResetChange
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordWithToken: (token, passwordResetChange, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'token' is not null or undefined
            common_1.assertParamExists('resetPasswordWithToken', 'token', token);
            // verify required parameter 'passwordResetChange' is not null or undefined
            common_1.assertParamExists('resetPasswordWithToken', 'passwordResetChange', passwordResetChange);
            const localVarPath = `/api/v1/auth/passwordreset/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(passwordResetChange, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Allows the profile to invite themselves by sending an activation link to their integration email
         * @param {SelfInviteProfileDto} selfInviteProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfInviteProfile: (selfInviteProfileDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'selfInviteProfileDto' is not null or undefined
            common_1.assertParamExists('selfInviteProfile', 'selfInviteProfileDto', selfInviteProfileDto);
            const localVarPath = `/api/v2/auth/invite/self`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(selfInviteProfileDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Service login for partners and other microservices like PITA. Returns JWT.
         * @summary service login
         * @param {ClientAuthRequest} clientAuthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceLogin: (clientAuthRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clientAuthRequest' is not null or undefined
            common_1.assertParamExists('serviceLogin', 'clientAuthRequest', clientAuthRequest);
            const localVarPath = `/api/v1/auth/clientlogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(clientAuthRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Generates and returns a new access token with the supplied UUID set as the current principal. The new principal UUID must be in an option in the current token.
         * @param {SwitchProfileDto} switchProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrincipal: (switchProfileDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'switchProfileDto' is not null or undefined
            common_1.assertParamExists('setPrincipal', 'switchProfileDto', switchProfileDto);
            const localVarPath = `/api/v1/auth/setprincipal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(switchProfileDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Set up user 2FA
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUpUser2FA: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v1/auth/mfa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update user details.
         * @param {UpdateUserDetailsDto} updateUserDetailsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserDetails: (updateUserDetailsDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'updateUserDetailsDto' is not null or undefined
            common_1.assertParamExists('updateUserDetails', 'updateUserDetailsDto', updateUserDetailsDto);
            const localVarPath = `/api/v1/auth/userdetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateUserDetailsDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary user login with MFA
         * @param {MfaAuthRequest} mfaAuthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLoginMfa: (mfaAuthRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'mfaAuthRequest' is not null or undefined
            common_1.assertParamExists('userLoginMfa', 'mfaAuthRequest', mfaAuthRequest);
            const localVarPath = `/api/v1/auth/login/mfa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(mfaAuthRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary user login
         * @param {UserAuthRequest} userAuthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLoginPassword: (userAuthRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userAuthRequest' is not null or undefined
            common_1.assertParamExists('userLoginPassword', 'userAuthRequest', userAuthRequest);
            const localVarPath = `/api/v1/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(userAuthRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Endpoint for user registration.
         * @param {UserRegistrationV2Dto} userRegistrationV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegistrationV2: (userRegistrationV2Dto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userRegistrationV2Dto' is not null or undefined
            common_1.assertParamExists('userRegistrationV2', 'userRegistrationV2Dto', userRegistrationV2Dto);
            const localVarPath = `/api/v2/auth/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(userRegistrationV2Dto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Useful for a UI to show an error or allow a user to proceed.
         * @summary Validates a password reset token is still good and valid.
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePasswordResetToken: (token, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'token' is not null or undefined
            common_1.assertParamExists('validatePasswordResetToken', 'token', token);
            const localVarPath = `/api/v1/auth/passwordreset/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Validates an activation token is still good and valid and returns the associated profile details.
         * @param {string} activationToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateactivationtoken: (activationToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'activationToken' is not null or undefined
            common_1.assertParamExists('validateactivationtoken', 'activationToken', activationToken);
            const localVarPath = `/api/v1/auth/activationtoken/{activationToken}`
                .replace(`{${"activationToken"}}`, encodeURIComponent(String(activationToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AuthApi - functional programming interface
 * @export
 */
exports.AuthApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AuthApiAxiosParamCreator(configuration);
    return {
        /**
         * Get the date/time and ip address of the user which agreed to our terms
         * @summary Record the aggrement which the user agreed upon
         * @param {AcceptTermsandConditionsDto} acceptTermsandConditionsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptterms(acceptTermsandConditionsDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.acceptterms(acceptTermsandConditionsDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Adds/activates a new profile (via an activation token) to an existing user.
         * @param {AddProfileDto} addProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProfile(addProfileDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addProfile(addProfileDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Generates an activation token for a profile that rolls up to the current user.
         * @param {RegistrationTokenRequestDto} registrationTokenRequestDto
         * @param {boolean} [sendEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivationToken(registrationTokenRequestDto, sendEmail, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createActivationToken(registrationTokenRequestDto, sendEmail, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Endpoint for client credentials registration.
         * @param {CreateClientCredentialsDTO} createClientCredentialsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClientCredentials(createClientCredentialsDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createClientCredentials(createClientCredentialsDTO, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create or Update a notification subscription
         * @param {UpsertNotificationSubscriptionDto} upsertNotificationSubscriptionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateNotificationSubscription(upsertNotificationSubscriptionDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createOrUpdateNotificationSubscription(upsertNotificationSubscriptionDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete a notification subscription
         * @param {string} notificationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationSubscription(notificationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteNotificationSubscription(notificationId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Fetch all supported notifications for this user regardless if they have a subscription or not
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSupportedNotifications(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchSupportedNotifications(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDetails(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserDetails(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Company staff can issue a temporary passord for a subject in their realm
         * @param {TempPasscodeRequestDto} tempPasscodeRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueTempPasscode(tempPasscodeRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.issueTempPasscode(tempPasscodeRequestDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {LoginAsDto} loginAsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAs(loginAsDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.loginAs(loginAsDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Unauthenticated user can request a reset token be sent to the user\'s email which will allow them to reset their password.
         * @param {PasswordResetRequest} passwordResetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset(passwordResetRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.requestPasswordReset(passwordResetRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Resets a user\'s password, given a valid reset token is supplied.
         * @param {string} token
         * @param {PasswordResetChange} passwordResetChange
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordWithToken(token, passwordResetChange, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resetPasswordWithToken(token, passwordResetChange, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Allows the profile to invite themselves by sending an activation link to their integration email
         * @param {SelfInviteProfileDto} selfInviteProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfInviteProfile(selfInviteProfileDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.selfInviteProfile(selfInviteProfileDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Service login for partners and other microservices like PITA. Returns JWT.
         * @summary service login
         * @param {ClientAuthRequest} clientAuthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceLogin(clientAuthRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.serviceLogin(clientAuthRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Generates and returns a new access token with the supplied UUID set as the current principal. The new principal UUID must be in an option in the current token.
         * @param {SwitchProfileDto} switchProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrincipal(switchProfileDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setPrincipal(switchProfileDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Set up user 2FA
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUpUser2FA(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setUpUser2FA(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Update user details.
         * @param {UpdateUserDetailsDto} updateUserDetailsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserDetails(updateUserDetailsDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateUserDetails(updateUserDetailsDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary user login with MFA
         * @param {MfaAuthRequest} mfaAuthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLoginMfa(mfaAuthRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userLoginMfa(mfaAuthRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary user login
         * @param {UserAuthRequest} userAuthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLoginPassword(userAuthRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userLoginPassword(userAuthRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Endpoint for user registration.
         * @param {UserRegistrationV2Dto} userRegistrationV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegistrationV2(userRegistrationV2Dto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userRegistrationV2(userRegistrationV2Dto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Useful for a UI to show an error or allow a user to proceed.
         * @summary Validates a password reset token is still good and valid.
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePasswordResetToken(token, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.validatePasswordResetToken(token, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Validates an activation token is still good and valid and returns the associated profile details.
         * @param {string} activationToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateactivationtoken(activationToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.validateactivationtoken(activationToken, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AuthApi - factory interface
 * @export
 */
exports.AuthApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AuthApiFp(configuration);
    return {
        /**
         * Get the date/time and ip address of the user which agreed to our terms
         * @summary Record the aggrement which the user agreed upon
         * @param {AcceptTermsandConditionsDto} acceptTermsandConditionsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptterms(acceptTermsandConditionsDto, options) {
            return localVarFp.acceptterms(acceptTermsandConditionsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds/activates a new profile (via an activation token) to an existing user.
         * @param {AddProfileDto} addProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProfile(addProfileDto, options) {
            return localVarFp.addProfile(addProfileDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Generates an activation token for a profile that rolls up to the current user.
         * @param {RegistrationTokenRequestDto} registrationTokenRequestDto
         * @param {boolean} [sendEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivationToken(registrationTokenRequestDto, sendEmail, options) {
            return localVarFp.createActivationToken(registrationTokenRequestDto, sendEmail, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Endpoint for client credentials registration.
         * @param {CreateClientCredentialsDTO} createClientCredentialsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClientCredentials(createClientCredentialsDTO, options) {
            return localVarFp.createClientCredentials(createClientCredentialsDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create or Update a notification subscription
         * @param {UpsertNotificationSubscriptionDto} upsertNotificationSubscriptionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateNotificationSubscription(upsertNotificationSubscriptionDto, options) {
            return localVarFp.createOrUpdateNotificationSubscription(upsertNotificationSubscriptionDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a notification subscription
         * @param {string} notificationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationSubscription(notificationId, options) {
            return localVarFp.deleteNotificationSubscription(notificationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Fetch all supported notifications for this user regardless if they have a subscription or not
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSupportedNotifications(options) {
            return localVarFp.fetchSupportedNotifications(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDetails(options) {
            return localVarFp.getUserDetails(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Company staff can issue a temporary passord for a subject in their realm
         * @param {TempPasscodeRequestDto} tempPasscodeRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueTempPasscode(tempPasscodeRequestDto, options) {
            return localVarFp.issueTempPasscode(tempPasscodeRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {LoginAsDto} loginAsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAs(loginAsDto, options) {
            return localVarFp.loginAs(loginAsDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Unauthenticated user can request a reset token be sent to the user\'s email which will allow them to reset their password.
         * @param {PasswordResetRequest} passwordResetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset(passwordResetRequest, options) {
            return localVarFp.requestPasswordReset(passwordResetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Resets a user\'s password, given a valid reset token is supplied.
         * @param {string} token
         * @param {PasswordResetChange} passwordResetChange
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordWithToken(token, passwordResetChange, options) {
            return localVarFp.resetPasswordWithToken(token, passwordResetChange, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Allows the profile to invite themselves by sending an activation link to their integration email
         * @param {SelfInviteProfileDto} selfInviteProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfInviteProfile(selfInviteProfileDto, options) {
            return localVarFp.selfInviteProfile(selfInviteProfileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Service login for partners and other microservices like PITA. Returns JWT.
         * @summary service login
         * @param {ClientAuthRequest} clientAuthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceLogin(clientAuthRequest, options) {
            return localVarFp.serviceLogin(clientAuthRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates and returns a new access token with the supplied UUID set as the current principal. The new principal UUID must be in an option in the current token.
         * @param {SwitchProfileDto} switchProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrincipal(switchProfileDto, options) {
            return localVarFp.setPrincipal(switchProfileDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set up user 2FA
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUpUser2FA(options) {
            return localVarFp.setUpUser2FA(options).then((request) => request(axios, basePath));
        },
        /**
         * Update user details.
         * @param {UpdateUserDetailsDto} updateUserDetailsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserDetails(updateUserDetailsDto, options) {
            return localVarFp.updateUserDetails(updateUserDetailsDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary user login with MFA
         * @param {MfaAuthRequest} mfaAuthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLoginMfa(mfaAuthRequest, options) {
            return localVarFp.userLoginMfa(mfaAuthRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary user login
         * @param {UserAuthRequest} userAuthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLoginPassword(userAuthRequest, options) {
            return localVarFp.userLoginPassword(userAuthRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Endpoint for user registration.
         * @param {UserRegistrationV2Dto} userRegistrationV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegistrationV2(userRegistrationV2Dto, options) {
            return localVarFp.userRegistrationV2(userRegistrationV2Dto, options).then((request) => request(axios, basePath));
        },
        /**
         * Useful for a UI to show an error or allow a user to proceed.
         * @summary Validates a password reset token is still good and valid.
         * @param {string} token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePasswordResetToken(token, options) {
            return localVarFp.validatePasswordResetToken(token, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Validates an activation token is still good and valid and returns the associated profile details.
         * @param {string} activationToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateactivationtoken(activationToken, options) {
            return localVarFp.validateactivationtoken(activationToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
class AuthApi extends base_1.BaseAPI {
    /**
     * Get the date/time and ip address of the user which agreed to our terms
     * @summary Record the aggrement which the user agreed upon
     * @param {AcceptTermsandConditionsDto} acceptTermsandConditionsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    acceptterms(acceptTermsandConditionsDto, options) {
        return exports.AuthApiFp(this.configuration).acceptterms(acceptTermsandConditionsDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Adds/activates a new profile (via an activation token) to an existing user.
     * @param {AddProfileDto} addProfileDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    addProfile(addProfileDto, options) {
        return exports.AuthApiFp(this.configuration).addProfile(addProfileDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Generates an activation token for a profile that rolls up to the current user.
     * @param {RegistrationTokenRequestDto} registrationTokenRequestDto
     * @param {boolean} [sendEmail]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    createActivationToken(registrationTokenRequestDto, sendEmail, options) {
        return exports.AuthApiFp(this.configuration).createActivationToken(registrationTokenRequestDto, sendEmail, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Endpoint for client credentials registration.
     * @param {CreateClientCredentialsDTO} createClientCredentialsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    createClientCredentials(createClientCredentialsDTO, options) {
        return exports.AuthApiFp(this.configuration).createClientCredentials(createClientCredentialsDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create or Update a notification subscription
     * @param {UpsertNotificationSubscriptionDto} upsertNotificationSubscriptionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    createOrUpdateNotificationSubscription(upsertNotificationSubscriptionDto, options) {
        return exports.AuthApiFp(this.configuration).createOrUpdateNotificationSubscription(upsertNotificationSubscriptionDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a notification subscription
     * @param {string} notificationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    deleteNotificationSubscription(notificationId, options) {
        return exports.AuthApiFp(this.configuration).deleteNotificationSubscription(notificationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Fetch all supported notifications for this user regardless if they have a subscription or not
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    fetchSupportedNotifications(options) {
        return exports.AuthApiFp(this.configuration).fetchSupportedNotifications(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    getUserDetails(options) {
        return exports.AuthApiFp(this.configuration).getUserDetails(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Company staff can issue a temporary passord for a subject in their realm
     * @param {TempPasscodeRequestDto} tempPasscodeRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    issueTempPasscode(tempPasscodeRequestDto, options) {
        return exports.AuthApiFp(this.configuration).issueTempPasscode(tempPasscodeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LoginAsDto} loginAsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    loginAs(loginAsDto, options) {
        return exports.AuthApiFp(this.configuration).loginAs(loginAsDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Unauthenticated user can request a reset token be sent to the user\'s email which will allow them to reset their password.
     * @param {PasswordResetRequest} passwordResetRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    requestPasswordReset(passwordResetRequest, options) {
        return exports.AuthApiFp(this.configuration).requestPasswordReset(passwordResetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Resets a user\'s password, given a valid reset token is supplied.
     * @param {string} token
     * @param {PasswordResetChange} passwordResetChange
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    resetPasswordWithToken(token, passwordResetChange, options) {
        return exports.AuthApiFp(this.configuration).resetPasswordWithToken(token, passwordResetChange, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Allows the profile to invite themselves by sending an activation link to their integration email
     * @param {SelfInviteProfileDto} selfInviteProfileDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    selfInviteProfile(selfInviteProfileDto, options) {
        return exports.AuthApiFp(this.configuration).selfInviteProfile(selfInviteProfileDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Service login for partners and other microservices like PITA. Returns JWT.
     * @summary service login
     * @param {ClientAuthRequest} clientAuthRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    serviceLogin(clientAuthRequest, options) {
        return exports.AuthApiFp(this.configuration).serviceLogin(clientAuthRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Generates and returns a new access token with the supplied UUID set as the current principal. The new principal UUID must be in an option in the current token.
     * @param {SwitchProfileDto} switchProfileDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    setPrincipal(switchProfileDto, options) {
        return exports.AuthApiFp(this.configuration).setPrincipal(switchProfileDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Set up user 2FA
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    setUpUser2FA(options) {
        return exports.AuthApiFp(this.configuration).setUpUser2FA(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update user details.
     * @param {UpdateUserDetailsDto} updateUserDetailsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    updateUserDetails(updateUserDetailsDto, options) {
        return exports.AuthApiFp(this.configuration).updateUserDetails(updateUserDetailsDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary user login with MFA
     * @param {MfaAuthRequest} mfaAuthRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    userLoginMfa(mfaAuthRequest, options) {
        return exports.AuthApiFp(this.configuration).userLoginMfa(mfaAuthRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary user login
     * @param {UserAuthRequest} userAuthRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    userLoginPassword(userAuthRequest, options) {
        return exports.AuthApiFp(this.configuration).userLoginPassword(userAuthRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Endpoint for user registration.
     * @param {UserRegistrationV2Dto} userRegistrationV2Dto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    userRegistrationV2(userRegistrationV2Dto, options) {
        return exports.AuthApiFp(this.configuration).userRegistrationV2(userRegistrationV2Dto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Useful for a UI to show an error or allow a user to proceed.
     * @summary Validates a password reset token is still good and valid.
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    validatePasswordResetToken(token, options) {
        return exports.AuthApiFp(this.configuration).validatePasswordResetToken(token, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Validates an activation token is still good and valid and returns the associated profile details.
     * @param {string} activationToken
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    validateactivationtoken(activationToken, options) {
        return exports.AuthApiFp(this.configuration).validateactivationtoken(activationToken, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AuthApi = AuthApi;
/**
 * BankAccountsApi - axios parameter creator
 * @export
 */
exports.BankAccountsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new bank account record.
         * @param {CreateBankAccountDTO} createBankAccountDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankAccount: (createBankAccountDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createBankAccountDTO' is not null or undefined
            common_1.assertParamExists('createBankAccount', 'createBankAccountDTO', createBankAccountDTO);
            const localVarPath = `/api/v1/bankaccounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createBankAccountDTO, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Deletes a bank account.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBankAccount: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('deleteBankAccount', 'uuid', uuid);
            const localVarPath = `/api/v1/bankaccounts/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Searches for bankaccount with pagination
         * @summary Find bankaccounts by pm uuid.
         * @param {BankAccountSearchDTO} bankAccountSearchDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBankAccounts: (bankAccountSearchDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'bankAccountSearchDTO' is not null or undefined
            common_1.assertParamExists('searchBankAccounts', 'bankAccountSearchDTO', bankAccountSearchDTO);
            const localVarPath = `/api/v1/bankaccounts/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(bankAccountSearchDTO, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update a bank account record.
         * @param {string} uuid
         * @param {UpdateBankAccountDTO} updateBankAccountDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBankAccount: (uuid, updateBankAccountDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateBankAccount', 'uuid', uuid);
            // verify required parameter 'updateBankAccountDTO' is not null or undefined
            common_1.assertParamExists('updateBankAccount', 'updateBankAccountDTO', updateBankAccountDTO);
            const localVarPath = `/api/v1/bankaccounts/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateBankAccountDTO, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BankAccountsApi - functional programming interface
 * @export
 */
exports.BankAccountsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.BankAccountsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new bank account record.
         * @param {CreateBankAccountDTO} createBankAccountDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankAccount(createBankAccountDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createBankAccount(createBankAccountDTO, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Deletes a bank account.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBankAccount(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteBankAccount(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Searches for bankaccount with pagination
         * @summary Find bankaccounts by pm uuid.
         * @param {BankAccountSearchDTO} bankAccountSearchDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBankAccounts(bankAccountSearchDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchBankAccounts(bankAccountSearchDTO, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update a bank account record.
         * @param {string} uuid
         * @param {UpdateBankAccountDTO} updateBankAccountDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBankAccount(uuid, updateBankAccountDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateBankAccount(uuid, updateBankAccountDTO, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BankAccountsApi - factory interface
 * @export
 */
exports.BankAccountsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.BankAccountsApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new bank account record.
         * @param {CreateBankAccountDTO} createBankAccountDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankAccount(createBankAccountDTO, options) {
            return localVarFp.createBankAccount(createBankAccountDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Deletes a bank account.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBankAccount(uuid, options) {
            return localVarFp.deleteBankAccount(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Searches for bankaccount with pagination
         * @summary Find bankaccounts by pm uuid.
         * @param {BankAccountSearchDTO} bankAccountSearchDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBankAccounts(bankAccountSearchDTO, options) {
            return localVarFp.searchBankAccounts(bankAccountSearchDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a bank account record.
         * @param {string} uuid
         * @param {UpdateBankAccountDTO} updateBankAccountDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBankAccount(uuid, updateBankAccountDTO, options) {
            return localVarFp.updateBankAccount(uuid, updateBankAccountDTO, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BankAccountsApi - object-oriented interface
 * @export
 * @class BankAccountsApi
 * @extends {BaseAPI}
 */
class BankAccountsApi extends base_1.BaseAPI {
    /**
     *
     * @summary Create a new bank account record.
     * @param {CreateBankAccountDTO} createBankAccountDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountsApi
     */
    createBankAccount(createBankAccountDTO, options) {
        return exports.BankAccountsApiFp(this.configuration).createBankAccount(createBankAccountDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Deletes a bank account.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountsApi
     */
    deleteBankAccount(uuid, options) {
        return exports.BankAccountsApiFp(this.configuration).deleteBankAccount(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Searches for bankaccount with pagination
     * @summary Find bankaccounts by pm uuid.
     * @param {BankAccountSearchDTO} bankAccountSearchDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountsApi
     */
    searchBankAccounts(bankAccountSearchDTO, options) {
        return exports.BankAccountsApiFp(this.configuration).searchBankAccounts(bankAccountSearchDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a bank account record.
     * @param {string} uuid
     * @param {UpdateBankAccountDTO} updateBankAccountDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountsApi
     */
    updateBankAccount(uuid, updateBankAccountDTO, options) {
        return exports.BankAccountsApiFp(this.configuration).updateBankAccount(uuid, updateBankAccountDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BankAccountsApi = BankAccountsApi;
/**
 * BankCardsApi - axios parameter creator
 * @export
 */
exports.BankCardsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new bank card record.
         * @param {CreateBankCardDTO} createBankCardDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankCard: (createBankCardDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createBankCardDTO' is not null or undefined
            common_1.assertParamExists('createBankCard', 'createBankCardDTO', createBankCardDTO);
            const localVarPath = `/api/v1/bankcards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createBankCardDTO, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Deletes a bank card.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBankCard: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('deleteBankCard', 'uuid', uuid);
            const localVarPath = `/api/v1/bankcards/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns the card type and network. Requires at least the first six digits passed in .
         * @param {string} cardprefix
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankCardTypeByBIN: (cardprefix, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'cardprefix' is not null or undefined
            common_1.assertParamExists('getBankCardTypeByBIN', 'cardprefix', cardprefix);
            const localVarPath = `/api/v1/bankcards/binlookup/{cardprefix}`
                .replace(`{${"cardprefix"}}`, encodeURIComponent(String(cardprefix)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update a new bank card record.
         * @param {string} uuid
         * @param {UpdateBankCardDTO} updateBankCardDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBankCard: (uuid, updateBankCardDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateBankCard', 'uuid', uuid);
            // verify required parameter 'updateBankCardDTO' is not null or undefined
            common_1.assertParamExists('updateBankCard', 'updateBankCardDTO', updateBankCardDTO);
            const localVarPath = `/api/v1/bankcards/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateBankCardDTO, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BankCardsApi - functional programming interface
 * @export
 */
exports.BankCardsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.BankCardsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new bank card record.
         * @param {CreateBankCardDTO} createBankCardDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankCard(createBankCardDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createBankCard(createBankCardDTO, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Deletes a bank card.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBankCard(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteBankCard(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns the card type and network. Requires at least the first six digits passed in .
         * @param {string} cardprefix
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankCardTypeByBIN(cardprefix, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBankCardTypeByBIN(cardprefix, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update a new bank card record.
         * @param {string} uuid
         * @param {UpdateBankCardDTO} updateBankCardDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBankCard(uuid, updateBankCardDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateBankCard(uuid, updateBankCardDTO, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BankCardsApi - factory interface
 * @export
 */
exports.BankCardsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.BankCardsApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new bank card record.
         * @param {CreateBankCardDTO} createBankCardDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankCard(createBankCardDTO, options) {
            return localVarFp.createBankCard(createBankCardDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Deletes a bank card.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBankCard(uuid, options) {
            return localVarFp.deleteBankCard(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns the card type and network. Requires at least the first six digits passed in .
         * @param {string} cardprefix
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankCardTypeByBIN(cardprefix, options) {
            return localVarFp.getBankCardTypeByBIN(cardprefix, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a new bank card record.
         * @param {string} uuid
         * @param {UpdateBankCardDTO} updateBankCardDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBankCard(uuid, updateBankCardDTO, options) {
            return localVarFp.updateBankCard(uuid, updateBankCardDTO, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BankCardsApi - object-oriented interface
 * @export
 * @class BankCardsApi
 * @extends {BaseAPI}
 */
class BankCardsApi extends base_1.BaseAPI {
    /**
     *
     * @summary Create a new bank card record.
     * @param {CreateBankCardDTO} createBankCardDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankCardsApi
     */
    createBankCard(createBankCardDTO, options) {
        return exports.BankCardsApiFp(this.configuration).createBankCard(createBankCardDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Deletes a bank card.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankCardsApi
     */
    deleteBankCard(uuid, options) {
        return exports.BankCardsApiFp(this.configuration).deleteBankCard(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns the card type and network. Requires at least the first six digits passed in .
     * @param {string} cardprefix
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankCardsApi
     */
    getBankCardTypeByBIN(cardprefix, options) {
        return exports.BankCardsApiFp(this.configuration).getBankCardTypeByBIN(cardprefix, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a new bank card record.
     * @param {string} uuid
     * @param {UpdateBankCardDTO} updateBankCardDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankCardsApi
     */
    updateBankCard(uuid, updateBankCardDTO, options) {
        return exports.BankCardsApiFp(this.configuration).updateBankCard(uuid, updateBankCardDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BankCardsApi = BankCardsApi;
/**
 * CompaniesApi - axios parameter creator
 * @export
 */
exports.CompaniesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create/start an onboarding application for a property management company into our system.
         * @param {CreateCompanyOnboardingDTO} createCompanyOnboardingDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOnboardingApplication: (createCompanyOnboardingDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createCompanyOnboardingDTO' is not null or undefined
            common_1.assertParamExists('createOnboardingApplication', 'createCompanyOnboardingDTO', createCompanyOnboardingDTO);
            const localVarPath = `/api/v1/companies/onboarding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createCompanyOnboardingDTO, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get companies with onboard details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompaniesOnboardingDetails: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v1/companies/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get a specific company detail
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyDetail: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getCompanyDetail', 'uuid', uuid);
            const localVarPath = `/api/v1/companies/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update an onboarding application for a company into our system.
         * @param {string} uuid
         * @param {UpdateCompanyOnboardingDTO} updateCompanyOnboardingDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOnboardingApplication: (uuid, updateCompanyOnboardingDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateOnboardingApplication', 'uuid', uuid);
            // verify required parameter 'updateCompanyOnboardingDTO' is not null or undefined
            common_1.assertParamExists('updateOnboardingApplication', 'updateCompanyOnboardingDTO', updateCompanyOnboardingDTO);
            const localVarPath = `/api/v1/companies/onboarding/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateCompanyOnboardingDTO, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CompaniesApi - functional programming interface
 * @export
 */
exports.CompaniesApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.CompaniesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create/start an onboarding application for a property management company into our system.
         * @param {CreateCompanyOnboardingDTO} createCompanyOnboardingDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOnboardingApplication(createCompanyOnboardingDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createOnboardingApplication(createCompanyOnboardingDTO, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get companies with onboard details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompaniesOnboardingDetails(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompaniesOnboardingDetails(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get a specific company detail
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyDetail(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompanyDetail(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update an onboarding application for a company into our system.
         * @param {string} uuid
         * @param {UpdateCompanyOnboardingDTO} updateCompanyOnboardingDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOnboardingApplication(uuid, updateCompanyOnboardingDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateOnboardingApplication(uuid, updateCompanyOnboardingDTO, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CompaniesApi - factory interface
 * @export
 */
exports.CompaniesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.CompaniesApiFp(configuration);
    return {
        /**
         *
         * @summary Create/start an onboarding application for a property management company into our system.
         * @param {CreateCompanyOnboardingDTO} createCompanyOnboardingDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOnboardingApplication(createCompanyOnboardingDTO, options) {
            return localVarFp.createOnboardingApplication(createCompanyOnboardingDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get companies with onboard details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompaniesOnboardingDetails(options) {
            return localVarFp.getCompaniesOnboardingDetails(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a specific company detail
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyDetail(uuid, options) {
            return localVarFp.getCompanyDetail(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an onboarding application for a company into our system.
         * @param {string} uuid
         * @param {UpdateCompanyOnboardingDTO} updateCompanyOnboardingDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOnboardingApplication(uuid, updateCompanyOnboardingDTO, options) {
            return localVarFp.updateOnboardingApplication(uuid, updateCompanyOnboardingDTO, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CompaniesApi - object-oriented interface
 * @export
 * @class CompaniesApi
 * @extends {BaseAPI}
 */
class CompaniesApi extends base_1.BaseAPI {
    /**
     *
     * @summary Create/start an onboarding application for a property management company into our system.
     * @param {CreateCompanyOnboardingDTO} createCompanyOnboardingDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    createOnboardingApplication(createCompanyOnboardingDTO, options) {
        return exports.CompaniesApiFp(this.configuration).createOnboardingApplication(createCompanyOnboardingDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get companies with onboard details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    getCompaniesOnboardingDetails(options) {
        return exports.CompaniesApiFp(this.configuration).getCompaniesOnboardingDetails(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a specific company detail
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    getCompanyDetail(uuid, options) {
        return exports.CompaniesApiFp(this.configuration).getCompanyDetail(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an onboarding application for a company into our system.
     * @param {string} uuid
     * @param {UpdateCompanyOnboardingDTO} updateCompanyOnboardingDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    updateOnboardingApplication(uuid, updateCompanyOnboardingDTO, options) {
        return exports.CompaniesApiFp(this.configuration).updateOnboardingApplication(uuid, updateCompanyOnboardingDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CompaniesApi = CompaniesApi;
/**
 * DocumentsApi - axios parameter creator
 * @export
 */
exports.DocumentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary deletes the file.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('deleteFile', 'uuid', uuid);
            const localVarPath = `/api/v1/documents/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary downloads the file.
         * @param {string} uuid
         * @param {'Base64'} [format]
         * @param {boolean} [viewInBrowser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentFile: (uuid, format, viewInBrowser, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getDocumentFile', 'uuid', uuid);
            const localVarPath = `/api/v1/documents/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            if (viewInBrowser !== undefined) {
                localVarQueryParameter['view_in_browser'] = viewInBrowser;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets a short-lived temporary url of a file.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTempUrl: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getTempUrl', 'uuid', uuid);
            const localVarPath = `/api/v1/documents/{uuid}/url`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} belongsToEntityUuid
         * @param {string} documentType
         * @param {Array<any>} documents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile: (belongsToEntityUuid, documentType, documents, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'belongsToEntityUuid' is not null or undefined
            common_1.assertParamExists('uploadFile', 'belongsToEntityUuid', belongsToEntityUuid);
            // verify required parameter 'documentType' is not null or undefined
            common_1.assertParamExists('uploadFile', 'documentType', documentType);
            // verify required parameter 'documents' is not null or undefined
            common_1.assertParamExists('uploadFile', 'documents', documents);
            const localVarPath = `/api/v1/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (belongsToEntityUuid !== undefined) {
                localVarFormParams.append('belongsToEntityUuid', belongsToEntityUuid);
            }
            if (documentType !== undefined) {
                localVarFormParams.append('documentType', documentType);
            }
            if (documents) {
                documents.forEach((element) => {
                    localVarFormParams.append('documents', element);
                });
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DocumentsApi - functional programming interface
 * @export
 */
exports.DocumentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.DocumentsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary deletes the file.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteFile(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary downloads the file.
         * @param {string} uuid
         * @param {'Base64'} [format]
         * @param {boolean} [viewInBrowser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentFile(uuid, format, viewInBrowser, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDocumentFile(uuid, format, viewInBrowser, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets a short-lived temporary url of a file.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTempUrl(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTempUrl(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} belongsToEntityUuid
         * @param {string} documentType
         * @param {Array<any>} documents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile(belongsToEntityUuid, documentType, documents, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadFile(belongsToEntityUuid, documentType, documents, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * DocumentsApi - factory interface
 * @export
 */
exports.DocumentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.DocumentsApiFp(configuration);
    return {
        /**
         *
         * @summary deletes the file.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile(uuid, options) {
            return localVarFp.deleteFile(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary downloads the file.
         * @param {string} uuid
         * @param {'Base64'} [format]
         * @param {boolean} [viewInBrowser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentFile(uuid, format, viewInBrowser, options) {
            return localVarFp.getDocumentFile(uuid, format, viewInBrowser, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets a short-lived temporary url of a file.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTempUrl(uuid, options) {
            return localVarFp.getTempUrl(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} belongsToEntityUuid
         * @param {string} documentType
         * @param {Array<any>} documents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile(belongsToEntityUuid, documentType, documents, options) {
            return localVarFp.uploadFile(belongsToEntityUuid, documentType, documents, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DocumentsApi - object-oriented interface
 * @export
 * @class DocumentsApi
 * @extends {BaseAPI}
 */
class DocumentsApi extends base_1.BaseAPI {
    /**
     *
     * @summary deletes the file.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    deleteFile(uuid, options) {
        return exports.DocumentsApiFp(this.configuration).deleteFile(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary downloads the file.
     * @param {string} uuid
     * @param {'Base64'} [format]
     * @param {boolean} [viewInBrowser]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    getDocumentFile(uuid, format, viewInBrowser, options) {
        return exports.DocumentsApiFp(this.configuration).getDocumentFile(uuid, format, viewInBrowser, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets a short-lived temporary url of a file.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    getTempUrl(uuid, options) {
        return exports.DocumentsApiFp(this.configuration).getTempUrl(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} belongsToEntityUuid
     * @param {string} documentType
     * @param {Array<any>} documents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    uploadFile(belongsToEntityUuid, documentType, documents, options) {
        return exports.DocumentsApiFp(this.configuration).uploadFile(belongsToEntityUuid, documentType, documents, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DocumentsApi = DocumentsApi;
/**
 * HealthcheckApi - axios parameter creator
 * @export
 */
exports.HealthcheckApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthCheck: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v1/healthcheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * HealthcheckApi - functional programming interface
 * @export
 */
exports.HealthcheckApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.HealthcheckApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthCheck(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getHealthCheck(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * HealthcheckApi - factory interface
 * @export
 */
exports.HealthcheckApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.HealthcheckApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthCheck(options) {
            return localVarFp.getHealthCheck(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * HealthcheckApi - object-oriented interface
 * @export
 * @class HealthcheckApi
 * @extends {BaseAPI}
 */
class HealthcheckApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthcheckApi
     */
    getHealthCheck(options) {
        return exports.HealthcheckApiFp(this.configuration).getHealthCheck(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.HealthcheckApi = HealthcheckApi;
/**
 * LedgersApi - axios parameter creator
 * @export
 */
exports.LedgersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Gets all types of ledgers for this entity without line items
         * @param {string} entityUuid uuid of the entity that owns these ledgers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLedgers: (entityUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'entityUuid' is not null or undefined
            common_1.assertParamExists('getAllLedgers', 'entityUuid', entityUuid);
            const localVarPath = `/api/v1/ledgers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (entityUuid !== undefined) {
                localVarQueryParameter['entityUuid'] = entityUuid;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Given a ledger UUID, searches the ledger detail items for this entity
         * @param {string} uuid
         * @param {SearchLedgerDetailsParamsDto} searchLedgerDetailsParamsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLedgerDetails: (uuid, searchLedgerDetailsParamsDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('searchLedgerDetails', 'uuid', uuid);
            // verify required parameter 'searchLedgerDetailsParamsDto' is not null or undefined
            common_1.assertParamExists('searchLedgerDetails', 'searchLedgerDetailsParamsDto', searchLedgerDetailsParamsDto);
            const localVarPath = `/api/v1/ledgers/{uuid}/details/search`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(searchLedgerDetailsParamsDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * LedgersApi - functional programming interface
 * @export
 */
exports.LedgersApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.LedgersApiAxiosParamCreator(configuration);
    return {
        /**
         * Gets all types of ledgers for this entity without line items
         * @param {string} entityUuid uuid of the entity that owns these ledgers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLedgers(entityUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllLedgers(entityUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Given a ledger UUID, searches the ledger detail items for this entity
         * @param {string} uuid
         * @param {SearchLedgerDetailsParamsDto} searchLedgerDetailsParamsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLedgerDetails(uuid, searchLedgerDetailsParamsDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchLedgerDetails(uuid, searchLedgerDetailsParamsDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * LedgersApi - factory interface
 * @export
 */
exports.LedgersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.LedgersApiFp(configuration);
    return {
        /**
         * Gets all types of ledgers for this entity without line items
         * @param {string} entityUuid uuid of the entity that owns these ledgers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLedgers(entityUuid, options) {
            return localVarFp.getAllLedgers(entityUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Given a ledger UUID, searches the ledger detail items for this entity
         * @param {string} uuid
         * @param {SearchLedgerDetailsParamsDto} searchLedgerDetailsParamsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLedgerDetails(uuid, searchLedgerDetailsParamsDto, options) {
            return localVarFp.searchLedgerDetails(uuid, searchLedgerDetailsParamsDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LedgersApi - object-oriented interface
 * @export
 * @class LedgersApi
 * @extends {BaseAPI}
 */
class LedgersApi extends base_1.BaseAPI {
    /**
     * Gets all types of ledgers for this entity without line items
     * @param {string} entityUuid uuid of the entity that owns these ledgers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgersApi
     */
    getAllLedgers(entityUuid, options) {
        return exports.LedgersApiFp(this.configuration).getAllLedgers(entityUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Given a ledger UUID, searches the ledger detail items for this entity
     * @param {string} uuid
     * @param {SearchLedgerDetailsParamsDto} searchLedgerDetailsParamsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgersApi
     */
    searchLedgerDetails(uuid, searchLedgerDetailsParamsDto, options) {
        return exports.LedgersApiFp(this.configuration).searchLedgerDetails(uuid, searchLedgerDetailsParamsDto, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.LedgersApi = LedgersApi;
/**
 * LegalApi - axios parameter creator
 * @export
 */
exports.LegalApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Download outstanding acknowledgement docs
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOustandingAcknowledgementsDocs: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('checkOustandingAcknowledgementsDocs', 'uuid', uuid);
            const localVarPath = `/api/v1/legal/acknowledgements/{uuid}/docs`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Download a pdf for the pricing quote
         * @param {string} pricingQuoteUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPricingQuoteDoc: (pricingQuoteUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'pricingQuoteUuid' is not null or undefined
            common_1.assertParamExists('downloadPricingQuoteDoc', 'pricingQuoteUuid', pricingQuoteUuid);
            const localVarPath = `/api/v1/legal/inosio/pricingquote/{pricingQuoteUuid}/doc`
                .replace(`{${"pricingQuoteUuid"}}`, encodeURIComponent(String(pricingQuoteUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the latest Inosio terms and conditions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInosioPmTermsConditions: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v1/legal/inosio/terms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the latest Inosio privacy policy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInosioPrivacyPolicy: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v1/legal/inosio/privacypolicy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets outstanding acknowledgments for user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutstandingAcknowledgmentsV2: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v1/legal/acknowledgements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Fetches a pricing quote given a pricing quote uuid
         * @param {string} pricingQuoteUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricingQuote: (pricingQuoteUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'pricingQuoteUuid' is not null or undefined
            common_1.assertParamExists('getPricingQuote', 'pricingQuoteUuid', pricingQuoteUuid);
            const localVarPath = `/api/v1/legal/inosio/pricingquote/{pricingQuoteUuid}`
                .replace(`{${"pricingQuoteUuid"}}`, encodeURIComponent(String(pricingQuoteUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Take note of the \'Amount\' field. When FeeType is fixed, amount represents USD in terms of pennies. So you need to divide by 100.    For example, when the FeeType is \'FIXED\', and the amount is \'295\', then you divide by 295 by 100 and the result is \'$2.95\'.    When FeeType is \'PERCENT\', the amount represents 1/10000th of a percent. So \'2.99%\' should be returned as \'299\'. \'3.5%\' would be returned as \'350\' and so forth.
         * @summary Get product packages with their pricing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPackagesV2: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v2/legal/inosio/products/packages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get product listing.
         * @param {string} organizationUuid
         * @param {'PAYMENTS' | 'APPLICATIONS' | 'MAINTENANCE' | 'SCREENING' | 'OWNER_PORTAL' | 'TENANT_PORTAL' | 'PLATFORM'} [productType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts: (organizationUuid, productType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationUuid' is not null or undefined
            common_1.assertParamExists('getProducts', 'organizationUuid', organizationUuid);
            const localVarPath = `/api/v1/legal/inosio/{organizationUuid}/products`
                .replace(`{${"organizationUuid"}}`, encodeURIComponent(String(organizationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (productType !== undefined) {
                localVarQueryParameter['productType'] = productType;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Take note of the \'Amount\' field. When FeeType is fixed, amount represents USD in terms of pennies. So you need to divide by 100.    For example, when the FeeType is \'FIXED\', and the amount is \'295\', then you divide by 295 by 100 and the result is \'$2.95\'.    When FeeType is \'PERCENT\', the amount represents 1/10000th of a percent. So \'2.99%\' should be returned as \'299\'. \'3.5%\' would be returned as \'350\' and so forth.
         * @summary Get product packages with pricing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsPackages: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v1/legal/inosio/products/packages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Mark acks as viewed/delivered. Should not be used for terms and conditions.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAcknowledgementViewed: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('markAcknowledgementViewed', 'uuid', uuid);
            const localVarPath = `/api/v1/legal/acknowledgements/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Inserts a pricing quote in the db if the quote uuid is not provided. Updates the quote if it is provided.
         * @summary Upserts a pricing quote into the db and returns it
         * @param {UpsertPricingQuoteDto} upsertPricingQuoteDto
         * @param {string} [pricingQuoteUuid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertPricingQuote: (upsertPricingQuoteDto, pricingQuoteUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'upsertPricingQuoteDto' is not null or undefined
            common_1.assertParamExists('upsertPricingQuote', 'upsertPricingQuoteDto', upsertPricingQuoteDto);
            const localVarPath = `/api/v1/legal/inosio/pricingquote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (pricingQuoteUuid !== undefined) {
                localVarQueryParameter['pricingQuoteUuid'] = pricingQuoteUuid;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(upsertPricingQuoteDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * LegalApi - functional programming interface
 * @export
 */
exports.LegalApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.LegalApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Download outstanding acknowledgement docs
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOustandingAcknowledgementsDocs(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkOustandingAcknowledgementsDocs(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Download a pdf for the pricing quote
         * @param {string} pricingQuoteUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPricingQuoteDoc(pricingQuoteUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadPricingQuoteDoc(pricingQuoteUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get the latest Inosio terms and conditions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInosioPmTermsConditions(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getInosioPmTermsConditions(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get the latest Inosio privacy policy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInosioPrivacyPolicy(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getInosioPrivacyPolicy(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets outstanding acknowledgments for user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutstandingAcknowledgmentsV2(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOutstandingAcknowledgmentsV2(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Fetches a pricing quote given a pricing quote uuid
         * @param {string} pricingQuoteUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricingQuote(pricingQuoteUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPricingQuote(pricingQuoteUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Take note of the \'Amount\' field. When FeeType is fixed, amount represents USD in terms of pennies. So you need to divide by 100.    For example, when the FeeType is \'FIXED\', and the amount is \'295\', then you divide by 295 by 100 and the result is \'$2.95\'.    When FeeType is \'PERCENT\', the amount represents 1/10000th of a percent. So \'2.99%\' should be returned as \'299\'. \'3.5%\' would be returned as \'350\' and so forth.
         * @summary Get product packages with their pricing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPackagesV2(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductPackagesV2(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get product listing.
         * @param {string} organizationUuid
         * @param {'PAYMENTS' | 'APPLICATIONS' | 'MAINTENANCE' | 'SCREENING' | 'OWNER_PORTAL' | 'TENANT_PORTAL' | 'PLATFORM'} [productType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(organizationUuid, productType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProducts(organizationUuid, productType, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Take note of the \'Amount\' field. When FeeType is fixed, amount represents USD in terms of pennies. So you need to divide by 100.    For example, when the FeeType is \'FIXED\', and the amount is \'295\', then you divide by 295 by 100 and the result is \'$2.95\'.    When FeeType is \'PERCENT\', the amount represents 1/10000th of a percent. So \'2.99%\' should be returned as \'299\'. \'3.5%\' would be returned as \'350\' and so forth.
         * @summary Get product packages with pricing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsPackages(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductsPackages(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Mark acks as viewed/delivered. Should not be used for terms and conditions.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAcknowledgementViewed(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.markAcknowledgementViewed(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Inserts a pricing quote in the db if the quote uuid is not provided. Updates the quote if it is provided.
         * @summary Upserts a pricing quote into the db and returns it
         * @param {UpsertPricingQuoteDto} upsertPricingQuoteDto
         * @param {string} [pricingQuoteUuid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertPricingQuote(upsertPricingQuoteDto, pricingQuoteUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.upsertPricingQuote(upsertPricingQuoteDto, pricingQuoteUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * LegalApi - factory interface
 * @export
 */
exports.LegalApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.LegalApiFp(configuration);
    return {
        /**
         *
         * @summary Download outstanding acknowledgement docs
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOustandingAcknowledgementsDocs(uuid, options) {
            return localVarFp.checkOustandingAcknowledgementsDocs(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Download a pdf for the pricing quote
         * @param {string} pricingQuoteUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPricingQuoteDoc(pricingQuoteUuid, options) {
            return localVarFp.downloadPricingQuoteDoc(pricingQuoteUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the latest Inosio terms and conditions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInosioPmTermsConditions(options) {
            return localVarFp.getInosioPmTermsConditions(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the latest Inosio privacy policy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInosioPrivacyPolicy(options) {
            return localVarFp.getInosioPrivacyPolicy(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets outstanding acknowledgments for user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutstandingAcknowledgmentsV2(options) {
            return localVarFp.getOutstandingAcknowledgmentsV2(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Fetches a pricing quote given a pricing quote uuid
         * @param {string} pricingQuoteUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricingQuote(pricingQuoteUuid, options) {
            return localVarFp.getPricingQuote(pricingQuoteUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Take note of the \'Amount\' field. When FeeType is fixed, amount represents USD in terms of pennies. So you need to divide by 100.    For example, when the FeeType is \'FIXED\', and the amount is \'295\', then you divide by 295 by 100 and the result is \'$2.95\'.    When FeeType is \'PERCENT\', the amount represents 1/10000th of a percent. So \'2.99%\' should be returned as \'299\'. \'3.5%\' would be returned as \'350\' and so forth.
         * @summary Get product packages with their pricing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPackagesV2(options) {
            return localVarFp.getProductPackagesV2(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get product listing.
         * @param {string} organizationUuid
         * @param {'PAYMENTS' | 'APPLICATIONS' | 'MAINTENANCE' | 'SCREENING' | 'OWNER_PORTAL' | 'TENANT_PORTAL' | 'PLATFORM'} [productType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(organizationUuid, productType, options) {
            return localVarFp.getProducts(organizationUuid, productType, options).then((request) => request(axios, basePath));
        },
        /**
         * Take note of the \'Amount\' field. When FeeType is fixed, amount represents USD in terms of pennies. So you need to divide by 100.    For example, when the FeeType is \'FIXED\', and the amount is \'295\', then you divide by 295 by 100 and the result is \'$2.95\'.    When FeeType is \'PERCENT\', the amount represents 1/10000th of a percent. So \'2.99%\' should be returned as \'299\'. \'3.5%\' would be returned as \'350\' and so forth.
         * @summary Get product packages with pricing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsPackages(options) {
            return localVarFp.getProductsPackages(options).then((request) => request(axios, basePath));
        },
        /**
         * Mark acks as viewed/delivered. Should not be used for terms and conditions.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAcknowledgementViewed(uuid, options) {
            return localVarFp.markAcknowledgementViewed(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Inserts a pricing quote in the db if the quote uuid is not provided. Updates the quote if it is provided.
         * @summary Upserts a pricing quote into the db and returns it
         * @param {UpsertPricingQuoteDto} upsertPricingQuoteDto
         * @param {string} [pricingQuoteUuid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertPricingQuote(upsertPricingQuoteDto, pricingQuoteUuid, options) {
            return localVarFp.upsertPricingQuote(upsertPricingQuoteDto, pricingQuoteUuid, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LegalApi - object-oriented interface
 * @export
 * @class LegalApi
 * @extends {BaseAPI}
 */
class LegalApi extends base_1.BaseAPI {
    /**
     *
     * @summary Download outstanding acknowledgement docs
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalApi
     */
    checkOustandingAcknowledgementsDocs(uuid, options) {
        return exports.LegalApiFp(this.configuration).checkOustandingAcknowledgementsDocs(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Download a pdf for the pricing quote
     * @param {string} pricingQuoteUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalApi
     */
    downloadPricingQuoteDoc(pricingQuoteUuid, options) {
        return exports.LegalApiFp(this.configuration).downloadPricingQuoteDoc(pricingQuoteUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the latest Inosio terms and conditions.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalApi
     */
    getInosioPmTermsConditions(options) {
        return exports.LegalApiFp(this.configuration).getInosioPmTermsConditions(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the latest Inosio privacy policy.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalApi
     */
    getInosioPrivacyPolicy(options) {
        return exports.LegalApiFp(this.configuration).getInosioPrivacyPolicy(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets outstanding acknowledgments for user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalApi
     */
    getOutstandingAcknowledgmentsV2(options) {
        return exports.LegalApiFp(this.configuration).getOutstandingAcknowledgmentsV2(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Fetches a pricing quote given a pricing quote uuid
     * @param {string} pricingQuoteUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalApi
     */
    getPricingQuote(pricingQuoteUuid, options) {
        return exports.LegalApiFp(this.configuration).getPricingQuote(pricingQuoteUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Take note of the \'Amount\' field. When FeeType is fixed, amount represents USD in terms of pennies. So you need to divide by 100.    For example, when the FeeType is \'FIXED\', and the amount is \'295\', then you divide by 295 by 100 and the result is \'$2.95\'.    When FeeType is \'PERCENT\', the amount represents 1/10000th of a percent. So \'2.99%\' should be returned as \'299\'. \'3.5%\' would be returned as \'350\' and so forth.
     * @summary Get product packages with their pricing.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalApi
     */
    getProductPackagesV2(options) {
        return exports.LegalApiFp(this.configuration).getProductPackagesV2(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get product listing.
     * @param {string} organizationUuid
     * @param {'PAYMENTS' | 'APPLICATIONS' | 'MAINTENANCE' | 'SCREENING' | 'OWNER_PORTAL' | 'TENANT_PORTAL' | 'PLATFORM'} [productType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalApi
     */
    getProducts(organizationUuid, productType, options) {
        return exports.LegalApiFp(this.configuration).getProducts(organizationUuid, productType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Take note of the \'Amount\' field. When FeeType is fixed, amount represents USD in terms of pennies. So you need to divide by 100.    For example, when the FeeType is \'FIXED\', and the amount is \'295\', then you divide by 295 by 100 and the result is \'$2.95\'.    When FeeType is \'PERCENT\', the amount represents 1/10000th of a percent. So \'2.99%\' should be returned as \'299\'. \'3.5%\' would be returned as \'350\' and so forth.
     * @summary Get product packages with pricing.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalApi
     */
    getProductsPackages(options) {
        return exports.LegalApiFp(this.configuration).getProductsPackages(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Mark acks as viewed/delivered. Should not be used for terms and conditions.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalApi
     */
    markAcknowledgementViewed(uuid, options) {
        return exports.LegalApiFp(this.configuration).markAcknowledgementViewed(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Inserts a pricing quote in the db if the quote uuid is not provided. Updates the quote if it is provided.
     * @summary Upserts a pricing quote into the db and returns it
     * @param {UpsertPricingQuoteDto} upsertPricingQuoteDto
     * @param {string} [pricingQuoteUuid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalApi
     */
    upsertPricingQuote(upsertPricingQuoteDto, pricingQuoteUuid, options) {
        return exports.LegalApiFp(this.configuration).upsertPricingQuote(upsertPricingQuoteDto, pricingQuoteUuid, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.LegalApi = LegalApi;
/**
 * MaintenanceApi - axios parameter creator
 * @export
 */
exports.MaintenanceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a maintenance request
         * @param {CreateMaintenanceRequestDto} createMaintenanceRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMaintenanceRequest: (createMaintenanceRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createMaintenanceRequestDto' is not null or undefined
            common_1.assertParamExists('createMaintenanceRequest', 'createMaintenanceRequestDto', createMaintenanceRequestDto);
            const localVarPath = `/api/v1/maintenance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createMaintenanceRequestDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Searches for maintenance requests by requester uuid
         * @param {string} requesterUuid
         * @param {MaintenanceRequestSearchParamsDTO} maintenanceRequestSearchParamsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllMaintenanceRequests: (requesterUuid, maintenanceRequestSearchParamsDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'requesterUuid' is not null or undefined
            common_1.assertParamExists('fetchAllMaintenanceRequests', 'requesterUuid', requesterUuid);
            // verify required parameter 'maintenanceRequestSearchParamsDTO' is not null or undefined
            common_1.assertParamExists('fetchAllMaintenanceRequests', 'maintenanceRequestSearchParamsDTO', maintenanceRequestSearchParamsDTO);
            const localVarPath = `/api/v1/maintenance/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (requesterUuid !== undefined) {
                localVarQueryParameter['requester_uuid'] = requesterUuid;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(maintenanceRequestSearchParamsDTO, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Fetches a maintenance request by uuid and ensures the resident or the pm owns it
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMaintenanceRequest: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('fetchMaintenanceRequest', 'uuid', uuid);
            const localVarPath = `/api/v1/maintenance/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MaintenanceApi - functional programming interface
 * @export
 */
exports.MaintenanceApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.MaintenanceApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a maintenance request
         * @param {CreateMaintenanceRequestDto} createMaintenanceRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMaintenanceRequest(createMaintenanceRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createMaintenanceRequest(createMaintenanceRequestDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Searches for maintenance requests by requester uuid
         * @param {string} requesterUuid
         * @param {MaintenanceRequestSearchParamsDTO} maintenanceRequestSearchParamsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllMaintenanceRequests(requesterUuid, maintenanceRequestSearchParamsDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchAllMaintenanceRequests(requesterUuid, maintenanceRequestSearchParamsDTO, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Fetches a maintenance request by uuid and ensures the resident or the pm owns it
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMaintenanceRequest(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchMaintenanceRequest(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MaintenanceApi - factory interface
 * @export
 */
exports.MaintenanceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.MaintenanceApiFp(configuration);
    return {
        /**
         *
         * @summary Create a maintenance request
         * @param {CreateMaintenanceRequestDto} createMaintenanceRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMaintenanceRequest(createMaintenanceRequestDto, options) {
            return localVarFp.createMaintenanceRequest(createMaintenanceRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Searches for maintenance requests by requester uuid
         * @param {string} requesterUuid
         * @param {MaintenanceRequestSearchParamsDTO} maintenanceRequestSearchParamsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllMaintenanceRequests(requesterUuid, maintenanceRequestSearchParamsDTO, options) {
            return localVarFp.fetchAllMaintenanceRequests(requesterUuid, maintenanceRequestSearchParamsDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Fetches a maintenance request by uuid and ensures the resident or the pm owns it
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMaintenanceRequest(uuid, options) {
            return localVarFp.fetchMaintenanceRequest(uuid, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MaintenanceApi - object-oriented interface
 * @export
 * @class MaintenanceApi
 * @extends {BaseAPI}
 */
class MaintenanceApi extends base_1.BaseAPI {
    /**
     *
     * @summary Create a maintenance request
     * @param {CreateMaintenanceRequestDto} createMaintenanceRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceApi
     */
    createMaintenanceRequest(createMaintenanceRequestDto, options) {
        return exports.MaintenanceApiFp(this.configuration).createMaintenanceRequest(createMaintenanceRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Searches for maintenance requests by requester uuid
     * @param {string} requesterUuid
     * @param {MaintenanceRequestSearchParamsDTO} maintenanceRequestSearchParamsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceApi
     */
    fetchAllMaintenanceRequests(requesterUuid, maintenanceRequestSearchParamsDTO, options) {
        return exports.MaintenanceApiFp(this.configuration).fetchAllMaintenanceRequests(requesterUuid, maintenanceRequestSearchParamsDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Fetches a maintenance request by uuid and ensures the resident or the pm owns it
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceApi
     */
    fetchMaintenanceRequest(uuid, options) {
        return exports.MaintenanceApiFp(this.configuration).fetchMaintenanceRequest(uuid, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.MaintenanceApi = MaintenanceApi;
/**
 * OwnersApi - axios parameter creator
 * @export
 */
exports.OwnersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Allows the user to add an owner into our system
         * @param {CreateOwnerDto} createOwnerDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOwner: (createOwnerDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createOwnerDto' is not null or undefined
            common_1.assertParamExists('createOwner', 'createOwnerDto', createOwnerDto);
            const localVarPath = `/api/v1/owners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createOwnerDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Fetches details about an owner.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwner: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getOwner', 'uuid', uuid);
            const localVarPath = `/api/v1/owners/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets all properties for this owner
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnerProperties: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getOwnerProperties', 'uuid', uuid);
            const localVarPath = `/api/v1/owners/{uuid}/properties`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Searches for Owner documents
         * @summary Search Owner Documents.
         * @param {string} uuid
         * @param {OwnerDocumentSearchParamsDto} ownerDocumentSearchParamsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOwnerDocuments: (uuid, ownerDocumentSearchParamsDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('searchOwnerDocuments', 'uuid', uuid);
            // verify required parameter 'ownerDocumentSearchParamsDto' is not null or undefined
            common_1.assertParamExists('searchOwnerDocuments', 'ownerDocumentSearchParamsDto', ownerDocumentSearchParamsDto);
            const localVarPath = `/api/v1/owners/{uuid}/documents/search`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(ownerDocumentSearchParamsDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Searches for Owner with pagination
         * @summary Search Owners.
         * @param {OwnerSearchRequestDto} ownerSearchRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOwners: (ownerSearchRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ownerSearchRequestDto' is not null or undefined
            common_1.assertParamExists('searchOwners', 'ownerSearchRequestDto', ownerSearchRequestDto);
            const localVarPath = `/api/v1/owners/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(ownerSearchRequestDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update an owner.
         * @param {string} uuid
         * @param {UpdateOwnerDto} updateOwnerDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOwner: (uuid, updateOwnerDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateOwner', 'uuid', uuid);
            // verify required parameter 'updateOwnerDto' is not null or undefined
            common_1.assertParamExists('updateOwner', 'updateOwnerDto', updateOwnerDto);
            const localVarPath = `/api/v1/owners/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateOwnerDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Sets document metadata
         * @param {string} uuid
         * @param {string} docUuid
         * @param {UpsertOwnerDocumentDto} upsertOwnerDocumentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertOwnerDocumentMetadata: (uuid, docUuid, upsertOwnerDocumentDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('upsertOwnerDocumentMetadata', 'uuid', uuid);
            // verify required parameter 'docUuid' is not null or undefined
            common_1.assertParamExists('upsertOwnerDocumentMetadata', 'docUuid', docUuid);
            // verify required parameter 'upsertOwnerDocumentDto' is not null or undefined
            common_1.assertParamExists('upsertOwnerDocumentMetadata', 'upsertOwnerDocumentDto', upsertOwnerDocumentDto);
            const localVarPath = `/api/v1/owners/{uuid}/documents/{doc_uuid}/metadata`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"doc_uuid"}}`, encodeURIComponent(String(docUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(upsertOwnerDocumentDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OwnersApi - functional programming interface
 * @export
 */
exports.OwnersApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.OwnersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Allows the user to add an owner into our system
         * @param {CreateOwnerDto} createOwnerDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOwner(createOwnerDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createOwner(createOwnerDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Fetches details about an owner.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwner(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOwner(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets all properties for this owner
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnerProperties(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOwnerProperties(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Searches for Owner documents
         * @summary Search Owner Documents.
         * @param {string} uuid
         * @param {OwnerDocumentSearchParamsDto} ownerDocumentSearchParamsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOwnerDocuments(uuid, ownerDocumentSearchParamsDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchOwnerDocuments(uuid, ownerDocumentSearchParamsDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Searches for Owner with pagination
         * @summary Search Owners.
         * @param {OwnerSearchRequestDto} ownerSearchRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOwners(ownerSearchRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchOwners(ownerSearchRequestDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update an owner.
         * @param {string} uuid
         * @param {UpdateOwnerDto} updateOwnerDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOwner(uuid, updateOwnerDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateOwner(uuid, updateOwnerDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Sets document metadata
         * @param {string} uuid
         * @param {string} docUuid
         * @param {UpsertOwnerDocumentDto} upsertOwnerDocumentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertOwnerDocumentMetadata(uuid, docUuid, upsertOwnerDocumentDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.upsertOwnerDocumentMetadata(uuid, docUuid, upsertOwnerDocumentDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * OwnersApi - factory interface
 * @export
 */
exports.OwnersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.OwnersApiFp(configuration);
    return {
        /**
         *
         * @summary Allows the user to add an owner into our system
         * @param {CreateOwnerDto} createOwnerDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOwner(createOwnerDto, options) {
            return localVarFp.createOwner(createOwnerDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Fetches details about an owner.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwner(uuid, options) {
            return localVarFp.getOwner(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets all properties for this owner
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnerProperties(uuid, options) {
            return localVarFp.getOwnerProperties(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Searches for Owner documents
         * @summary Search Owner Documents.
         * @param {string} uuid
         * @param {OwnerDocumentSearchParamsDto} ownerDocumentSearchParamsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOwnerDocuments(uuid, ownerDocumentSearchParamsDto, options) {
            return localVarFp.searchOwnerDocuments(uuid, ownerDocumentSearchParamsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Searches for Owner with pagination
         * @summary Search Owners.
         * @param {OwnerSearchRequestDto} ownerSearchRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOwners(ownerSearchRequestDto, options) {
            return localVarFp.searchOwners(ownerSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an owner.
         * @param {string} uuid
         * @param {UpdateOwnerDto} updateOwnerDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOwner(uuid, updateOwnerDto, options) {
            return localVarFp.updateOwner(uuid, updateOwnerDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Sets document metadata
         * @param {string} uuid
         * @param {string} docUuid
         * @param {UpsertOwnerDocumentDto} upsertOwnerDocumentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertOwnerDocumentMetadata(uuid, docUuid, upsertOwnerDocumentDto, options) {
            return localVarFp.upsertOwnerDocumentMetadata(uuid, docUuid, upsertOwnerDocumentDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OwnersApi - object-oriented interface
 * @export
 * @class OwnersApi
 * @extends {BaseAPI}
 */
class OwnersApi extends base_1.BaseAPI {
    /**
     *
     * @summary Allows the user to add an owner into our system
     * @param {CreateOwnerDto} createOwnerDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OwnersApi
     */
    createOwner(createOwnerDto, options) {
        return exports.OwnersApiFp(this.configuration).createOwner(createOwnerDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Fetches details about an owner.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OwnersApi
     */
    getOwner(uuid, options) {
        return exports.OwnersApiFp(this.configuration).getOwner(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets all properties for this owner
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OwnersApi
     */
    getOwnerProperties(uuid, options) {
        return exports.OwnersApiFp(this.configuration).getOwnerProperties(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Searches for Owner documents
     * @summary Search Owner Documents.
     * @param {string} uuid
     * @param {OwnerDocumentSearchParamsDto} ownerDocumentSearchParamsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OwnersApi
     */
    searchOwnerDocuments(uuid, ownerDocumentSearchParamsDto, options) {
        return exports.OwnersApiFp(this.configuration).searchOwnerDocuments(uuid, ownerDocumentSearchParamsDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Searches for Owner with pagination
     * @summary Search Owners.
     * @param {OwnerSearchRequestDto} ownerSearchRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OwnersApi
     */
    searchOwners(ownerSearchRequestDto, options) {
        return exports.OwnersApiFp(this.configuration).searchOwners(ownerSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an owner.
     * @param {string} uuid
     * @param {UpdateOwnerDto} updateOwnerDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OwnersApi
     */
    updateOwner(uuid, updateOwnerDto, options) {
        return exports.OwnersApiFp(this.configuration).updateOwner(uuid, updateOwnerDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Sets document metadata
     * @param {string} uuid
     * @param {string} docUuid
     * @param {UpsertOwnerDocumentDto} upsertOwnerDocumentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OwnersApi
     */
    upsertOwnerDocumentMetadata(uuid, docUuid, upsertOwnerDocumentDto, options) {
        return exports.OwnersApiFp(this.configuration).upsertOwnerDocumentMetadata(uuid, docUuid, upsertOwnerDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.OwnersApi = OwnersApi;
/**
 * PartnersApi - axios parameter creator
 * @export
 */
exports.PartnersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Note, this is indiscriminate; It will add these records even if there are already existing bankaccount with similar attributes.
         * @summary Adds one or more bank accounts to the sepcified company.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {Array<CreateBankAccountDTO>} createBankAccountDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankAccountsV1: (uuid, companyUuid, createBankAccountDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('createBankAccountsV1', 'uuid', uuid);
            // verify required parameter 'companyUuid' is not null or undefined
            common_1.assertParamExists('createBankAccountsV1', 'companyUuid', companyUuid);
            // verify required parameter 'createBankAccountDTO' is not null or undefined
            common_1.assertParamExists('createBankAccountsV1', 'createBankAccountDTO', createBankAccountDTO);
            const localVarPath = `/api/v1/partners/{uuid}/companies/{company_uuid}/bankaccounts`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"company_uuid"}}`, encodeURIComponent(String(companyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createBankAccountDTO, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Helper method to create sub accounts with our processor for a company\'s destination bank accounts.
         * @summary Create sub accounts for bank accounts.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcessorSubAccounts: (uuid, companyUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('createProcessorSubAccounts', 'uuid', uuid);
            // verify required parameter 'companyUuid' is not null or undefined
            common_1.assertParamExists('createProcessorSubAccounts', 'companyUuid', companyUuid);
            const localVarPath = `/api/v1/partners/{uuid}/companies/{company_uuid}/subaccounts`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"company_uuid"}}`, encodeURIComponent(String(companyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Find applications by company that were decisioned in the specified date range.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {string} [startDateTimeUtc] ISO 8601 datetime string in YYYY-MM-DDTHH:mm:ss.sssZ format. Inclusive start date to filter. Queries the decison date.
         * @param {string} [endDateTimeUtc] ISO 8601 datetime string in YYYY-MM-DDTHH:mm:ss.sssZ format. Inclusive end date to filter. Queries the decision date.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyApplicationsV2s: (uuid, companyUuid, startDateTimeUtc, endDateTimeUtc, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getCompanyApplicationsV2s', 'uuid', uuid);
            // verify required parameter 'companyUuid' is not null or undefined
            common_1.assertParamExists('getCompanyApplicationsV2s', 'companyUuid', companyUuid);
            const localVarPath = `/api/v2/partners/{uuid}/companies/{company_uuid}/applications`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"company_uuid"}}`, encodeURIComponent(String(companyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (startDateTimeUtc !== undefined) {
                localVarQueryParameter['startDateTimeUtc'] = startDateTimeUtc;
            }
            if (endDateTimeUtc !== undefined) {
                localVarQueryParameter['endDateTimeUtc'] = endDateTimeUtc;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets basic configs for this company..
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyConfigsV2s: (uuid, companyUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getCompanyConfigsV2s', 'uuid', uuid);
            // verify required parameter 'companyUuid' is not null or undefined
            common_1.assertParamExists('getCompanyConfigsV2s', 'companyUuid', companyUuid);
            const localVarPath = `/api/v2/partners/{uuid}/companies/{company_uuid}/configs`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"company_uuid"}}`, encodeURIComponent(String(companyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Find company by uuid.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {string} depositId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyDepositDetailsV1: (uuid, companyUuid, depositId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getCompanyDepositDetailsV1', 'uuid', uuid);
            // verify required parameter 'companyUuid' is not null or undefined
            common_1.assertParamExists('getCompanyDepositDetailsV1', 'companyUuid', companyUuid);
            // verify required parameter 'depositId' is not null or undefined
            common_1.assertParamExists('getCompanyDepositDetailsV1', 'depositId', depositId);
            const localVarPath = `/api/v1/partners/{uuid}/companies/{company_uuid}/deposits/{depositId}/details`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"company_uuid"}}`, encodeURIComponent(String(companyUuid)))
                .replace(`{${"depositId"}}`, encodeURIComponent(String(depositId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Find deposits by company.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {Array<'open' | 'closed' | 'paid' | 'returned'>} [status]
         * @param {string} [startDate] Inclusive start date for the range of deposits. Queries batch deposit date.
         * @param {string} [endDate] Inclusive end date for the range of deposits. Queries batch deposit date.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyDepositsV1: (uuid, companyUuid, status, startDate, endDate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getCompanyDepositsV1', 'uuid', uuid);
            // verify required parameter 'companyUuid' is not null or undefined
            common_1.assertParamExists('getCompanyDepositsV1', 'companyUuid', companyUuid);
            const localVarPath = `/api/v1/partners/{uuid}/companies/{company_uuid}/deposits`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"company_uuid"}}`, encodeURIComponent(String(companyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (status) {
                localVarQueryParameter['status'] = status;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString() :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString() :
                    endDate;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets the details of a specific workorder.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyWorkOrderDetailsV2s: (uuid, companyUuid, id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getCompanyWorkOrderDetailsV2s', 'uuid', uuid);
            // verify required parameter 'companyUuid' is not null or undefined
            common_1.assertParamExists('getCompanyWorkOrderDetailsV2s', 'companyUuid', companyUuid);
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('getCompanyWorkOrderDetailsV2s', 'id', id);
            const localVarPath = `/api/v1/partners/{uuid}/companies/{company_uuid}/workorders/{id}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"company_uuid"}}`, encodeURIComponent(String(companyUuid)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Find workorders by company that were modified in the specified date range.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {string} [startDateTimeUtc] ISO 8601 datetime string in YYYY-MM-DDTHH:mm:ss.sssZ format. Inclusive start date to filter. Queries the last modified date.
         * @param {string} [endDateTimeUtc] ISO 8601 datetime string in YYYY-MM-DDTHH:mm:ss.sssZ format. Inclusive end date to filter. Queries the last modified date.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyWorkOrdersV2s: (uuid, companyUuid, startDateTimeUtc, endDateTimeUtc, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getCompanyWorkOrdersV2s', 'uuid', uuid);
            // verify required parameter 'companyUuid' is not null or undefined
            common_1.assertParamExists('getCompanyWorkOrdersV2s', 'companyUuid', companyUuid);
            const localVarPath = `/api/v1/partners/{uuid}/companies/{company_uuid}/workorders`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"company_uuid"}}`, encodeURIComponent(String(companyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (startDateTimeUtc !== undefined) {
                localVarQueryParameter['startDateTimeUtc'] = startDateTimeUtc;
            }
            if (endDateTimeUtc !== undefined) {
                localVarQueryParameter['endDateTimeUtc'] = endDateTimeUtc;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets owners within this company.
         * @param {string} uuid Partner Uuid
         * @param {string} companyUuid Company Uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwners: (uuid, companyUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getOwners', 'uuid', uuid);
            // verify required parameter 'companyUuid' is not null or undefined
            common_1.assertParamExists('getOwners', 'companyUuid', companyUuid);
            const localVarPath = `/api/v2/partners/{uuid}/companies/{company_uuid}/owners`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"company_uuid"}}`, encodeURIComponent(String(companyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets properties to the sepcified company.
         * @param {string} uuid Partner Uuid
         * @param {string} companyUuid Company Uuid
         * @param {number} [softwareIntegrationCredentialId] Additional filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertiesV2: (uuid, companyUuid, softwareIntegrationCredentialId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getPropertiesV2', 'uuid', uuid);
            // verify required parameter 'companyUuid' is not null or undefined
            common_1.assertParamExists('getPropertiesV2', 'companyUuid', companyUuid);
            const localVarPath = `/api/v2/partners/{uuid}/companies/{company_uuid}/properties`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"company_uuid"}}`, encodeURIComponent(String(companyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (softwareIntegrationCredentialId !== undefined) {
                localVarQueryParameter['softwareIntegrationCredentialId'] = softwareIntegrationCredentialId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets resident records for this company.
         * @param {string} uuid Partner Uuid
         * @param {string} companyUuid Company Uuid
         * @param {number} [softwareIntegrationCredentialId] Additional filter.
         * @param {string} [propertyUuid] Additional filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResidentsV2: (uuid, companyUuid, softwareIntegrationCredentialId, propertyUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getResidentsV2', 'uuid', uuid);
            // verify required parameter 'companyUuid' is not null or undefined
            common_1.assertParamExists('getResidentsV2', 'companyUuid', companyUuid);
            const localVarPath = `/api/v2/partners/{uuid}/companies/{company_uuid}/residents`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"company_uuid"}}`, encodeURIComponent(String(companyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (softwareIntegrationCredentialId !== undefined) {
                localVarQueryParameter['softwareIntegrationCredentialId'] = softwareIntegrationCredentialId;
            }
            if (propertyUuid !== undefined) {
                localVarQueryParameter['propertyUuid'] = propertyUuid;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets vendors within this company.
         * @param {string} uuid Partner Uuid
         * @param {string} companyUuid Company Uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendorsV2: (uuid, companyUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getVendorsV2', 'uuid', uuid);
            // verify required parameter 'companyUuid' is not null or undefined
            common_1.assertParamExists('getVendorsV2', 'companyUuid', companyUuid);
            const localVarPath = `/api/v2/partners/{uuid}/companies/{company_uuid}/vendors`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"company_uuid"}}`, encodeURIComponent(String(companyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * The begin and end dates are both inclusive [startdate, enddate]
         * @summary Find transactions by company uuid.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {PartnerTransactionSearchParamsDto} partnerTransactionSearchParamsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTransactionDateV1: (uuid, companyUuid, partnerTransactionSearchParamsDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('searchTransactionDateV1', 'uuid', uuid);
            // verify required parameter 'companyUuid' is not null or undefined
            common_1.assertParamExists('searchTransactionDateV1', 'companyUuid', companyUuid);
            // verify required parameter 'partnerTransactionSearchParamsDto' is not null or undefined
            common_1.assertParamExists('searchTransactionDateV1', 'partnerTransactionSearchParamsDto', partnerTransactionSearchParamsDto);
            const localVarPath = `/api/v1/partners/{uuid}/companies/{company_uuid}/transactions/search`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"company_uuid"}}`, encodeURIComponent(String(companyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(partnerTransactionSearchParamsDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Note, this is indiscriminate; It will add these records even if there are already existing bankaccount with similar attributes.
         * @summary Adds one or more bank accounts to the sepcified company.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {Array<CreateBankAccountV2Dto>} createBankAccountV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertBankAccountsV2: (uuid, companyUuid, createBankAccountV2Dto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('upsertBankAccountsV2', 'uuid', uuid);
            // verify required parameter 'companyUuid' is not null or undefined
            common_1.assertParamExists('upsertBankAccountsV2', 'companyUuid', companyUuid);
            // verify required parameter 'createBankAccountV2Dto' is not null or undefined
            common_1.assertParamExists('upsertBankAccountsV2', 'createBankAccountV2Dto', createBankAccountV2Dto);
            const localVarPath = `/api/v2/partners/{uuid}/companies/{company_uuid}/bankaccounts`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"company_uuid"}}`, encodeURIComponent(String(companyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createBankAccountV2Dto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Adds or updates document meta data to the sepcified company.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {Array<DocumentMetadataDto>} documentMetadataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertDocumentMetadataV2: (uuid, companyUuid, documentMetadataDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('upsertDocumentMetadataV2', 'uuid', uuid);
            // verify required parameter 'companyUuid' is not null or undefined
            common_1.assertParamExists('upsertDocumentMetadataV2', 'companyUuid', companyUuid);
            // verify required parameter 'documentMetadataDto' is not null or undefined
            common_1.assertParamExists('upsertDocumentMetadataV2', 'documentMetadataDto', documentMetadataDto);
            const localVarPath = `/api/v2/partners/{uuid}/companies/{company_uuid}/document-metadata`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"company_uuid"}}`, encodeURIComponent(String(companyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(documentMetadataDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Adds or updates ledger activities.
         * @param {string} uuid Partner Uuid
         * @param {string} companyUuid
         * @param {Array<LedgerActivityDto>} ledgerActivityDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertLedgerActivityV2: (uuid, companyUuid, ledgerActivityDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('upsertLedgerActivityV2', 'uuid', uuid);
            // verify required parameter 'companyUuid' is not null or undefined
            common_1.assertParamExists('upsertLedgerActivityV2', 'companyUuid', companyUuid);
            // verify required parameter 'ledgerActivityDto' is not null or undefined
            common_1.assertParamExists('upsertLedgerActivityV2', 'ledgerActivityDto', ledgerActivityDto);
            const localVarPath = `/api/v2/partners/{uuid}/companies/{company_uuid}/ledger-activity`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"company_uuid"}}`, encodeURIComponent(String(companyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(ledgerActivityDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Adds or updates owners to the sepcified company. ExternalRef1 must be unique for each owner under each company.
         * @param {string} uuid Partner Uuid
         * @param {string} companyUuid
         * @param {Array<CreateOwnerV2Dto>} createOwnerV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertOwnersV2: (uuid, companyUuid, createOwnerV2Dto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('upsertOwnersV2', 'uuid', uuid);
            // verify required parameter 'companyUuid' is not null or undefined
            common_1.assertParamExists('upsertOwnersV2', 'companyUuid', companyUuid);
            // verify required parameter 'createOwnerV2Dto' is not null or undefined
            common_1.assertParamExists('upsertOwnersV2', 'createOwnerV2Dto', createOwnerV2Dto);
            const localVarPath = `/api/v2/partners/{uuid}/companies/{company_uuid}/owners`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"company_uuid"}}`, encodeURIComponent(String(companyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createOwnerV2Dto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Adds or updates properties to the sepcified company.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {Array<CreatePropertyDTO>} createPropertyDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertPropertiesV1: (uuid, companyUuid, createPropertyDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('upsertPropertiesV1', 'uuid', uuid);
            // verify required parameter 'companyUuid' is not null or undefined
            common_1.assertParamExists('upsertPropertiesV1', 'companyUuid', companyUuid);
            // verify required parameter 'createPropertyDTO' is not null or undefined
            common_1.assertParamExists('upsertPropertiesV1', 'createPropertyDTO', createPropertyDTO);
            const localVarPath = `/api/v1/partners/{uuid}/companies/{company_uuid}/properties`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"company_uuid"}}`, encodeURIComponent(String(companyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createPropertyDTO, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Creates or updates properties to the sepcified company.
         * @param {string} uuid Partner Uuid
         * @param {string} companyUuid
         * @param {Array<CreatePropertyV2Dto>} createPropertyV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertPropertiesV2: (uuid, companyUuid, createPropertyV2Dto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('upsertPropertiesV2', 'uuid', uuid);
            // verify required parameter 'companyUuid' is not null or undefined
            common_1.assertParamExists('upsertPropertiesV2', 'companyUuid', companyUuid);
            // verify required parameter 'createPropertyV2Dto' is not null or undefined
            common_1.assertParamExists('upsertPropertiesV2', 'createPropertyV2Dto', createPropertyV2Dto);
            const localVarPath = `/api/v2/partners/{uuid}/companies/{company_uuid}/properties`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"company_uuid"}}`, encodeURIComponent(String(companyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createPropertyV2Dto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Inserts property payment types. Returns count of new records inserted.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {Array<CreatePropertyPaymentTypeDTO>} createPropertyPaymentTypeDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertPropertyPaymentTypesV1: (uuid, companyUuid, createPropertyPaymentTypeDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('upsertPropertyPaymentTypesV1', 'uuid', uuid);
            // verify required parameter 'companyUuid' is not null or undefined
            common_1.assertParamExists('upsertPropertyPaymentTypesV1', 'companyUuid', companyUuid);
            // verify required parameter 'createPropertyPaymentTypeDTO' is not null or undefined
            common_1.assertParamExists('upsertPropertyPaymentTypesV1', 'createPropertyPaymentTypeDTO', createPropertyPaymentTypeDTO);
            const localVarPath = `/api/v1/partners/{uuid}/companies/{company_uuid}/propertypaymenttypes`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"company_uuid"}}`, encodeURIComponent(String(companyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createPropertyPaymentTypeDTO, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Adds or updates new resident record(s) on this property.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {string} propertyUuid
         * @param {Array<CreateResidentDTO>} createResidentDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertResidentsV1: (uuid, companyUuid, propertyUuid, createResidentDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('upsertResidentsV1', 'uuid', uuid);
            // verify required parameter 'companyUuid' is not null or undefined
            common_1.assertParamExists('upsertResidentsV1', 'companyUuid', companyUuid);
            // verify required parameter 'propertyUuid' is not null or undefined
            common_1.assertParamExists('upsertResidentsV1', 'propertyUuid', propertyUuid);
            // verify required parameter 'createResidentDTO' is not null or undefined
            common_1.assertParamExists('upsertResidentsV1', 'createResidentDTO', createResidentDTO);
            const localVarPath = `/api/v1/partners/{uuid}/companies/{company_uuid}/properties/{property_uuid}/residents`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"company_uuid"}}`, encodeURIComponent(String(companyUuid)))
                .replace(`{${"property_uuid"}}`, encodeURIComponent(String(propertyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createResidentDTO, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Adds or updates new resident record(s) on this property.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {Array<CreateResidentV2Dto>} createResidentV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertResidentsV2: (uuid, companyUuid, createResidentV2Dto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('upsertResidentsV2', 'uuid', uuid);
            // verify required parameter 'companyUuid' is not null or undefined
            common_1.assertParamExists('upsertResidentsV2', 'companyUuid', companyUuid);
            // verify required parameter 'createResidentV2Dto' is not null or undefined
            common_1.assertParamExists('upsertResidentsV2', 'createResidentV2Dto', createResidentV2Dto);
            const localVarPath = `/api/v2/partners/{uuid}/companies/{company_uuid}/residents`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"company_uuid"}}`, encodeURIComponent(String(companyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createResidentV2Dto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Adds or updates vendors to the sepcified company. ExternalRef1 must be unique for each vendor under each company.
         * @param {string} uuid Partner Uuid
         * @param {string} companyUuid
         * @param {Array<CreateVendorV2Dto>} createVendorV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertVendorsV2: (uuid, companyUuid, createVendorV2Dto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('upsertVendorsV2', 'uuid', uuid);
            // verify required parameter 'companyUuid' is not null or undefined
            common_1.assertParamExists('upsertVendorsV2', 'companyUuid', companyUuid);
            // verify required parameter 'createVendorV2Dto' is not null or undefined
            common_1.assertParamExists('upsertVendorsV2', 'createVendorV2Dto', createVendorV2Dto);
            const localVarPath = `/api/v2/partners/{uuid}/companies/{company_uuid}/vendors`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"company_uuid"}}`, encodeURIComponent(String(companyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createVendorV2Dto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PartnersApi - functional programming interface
 * @export
 */
exports.PartnersApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PartnersApiAxiosParamCreator(configuration);
    return {
        /**
         * Note, this is indiscriminate; It will add these records even if there are already existing bankaccount with similar attributes.
         * @summary Adds one or more bank accounts to the sepcified company.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {Array<CreateBankAccountDTO>} createBankAccountDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankAccountsV1(uuid, companyUuid, createBankAccountDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createBankAccountsV1(uuid, companyUuid, createBankAccountDTO, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Helper method to create sub accounts with our processor for a company\'s destination bank accounts.
         * @summary Create sub accounts for bank accounts.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcessorSubAccounts(uuid, companyUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createProcessorSubAccounts(uuid, companyUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Find applications by company that were decisioned in the specified date range.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {string} [startDateTimeUtc] ISO 8601 datetime string in YYYY-MM-DDTHH:mm:ss.sssZ format. Inclusive start date to filter. Queries the decison date.
         * @param {string} [endDateTimeUtc] ISO 8601 datetime string in YYYY-MM-DDTHH:mm:ss.sssZ format. Inclusive end date to filter. Queries the decision date.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyApplicationsV2s(uuid, companyUuid, startDateTimeUtc, endDateTimeUtc, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompanyApplicationsV2s(uuid, companyUuid, startDateTimeUtc, endDateTimeUtc, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets basic configs for this company..
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyConfigsV2s(uuid, companyUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompanyConfigsV2s(uuid, companyUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Find company by uuid.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {string} depositId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyDepositDetailsV1(uuid, companyUuid, depositId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompanyDepositDetailsV1(uuid, companyUuid, depositId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Find deposits by company.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {Array<'open' | 'closed' | 'paid' | 'returned'>} [status]
         * @param {string} [startDate] Inclusive start date for the range of deposits. Queries batch deposit date.
         * @param {string} [endDate] Inclusive end date for the range of deposits. Queries batch deposit date.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyDepositsV1(uuid, companyUuid, status, startDate, endDate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompanyDepositsV1(uuid, companyUuid, status, startDate, endDate, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets the details of a specific workorder.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyWorkOrderDetailsV2s(uuid, companyUuid, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompanyWorkOrderDetailsV2s(uuid, companyUuid, id, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Find workorders by company that were modified in the specified date range.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {string} [startDateTimeUtc] ISO 8601 datetime string in YYYY-MM-DDTHH:mm:ss.sssZ format. Inclusive start date to filter. Queries the last modified date.
         * @param {string} [endDateTimeUtc] ISO 8601 datetime string in YYYY-MM-DDTHH:mm:ss.sssZ format. Inclusive end date to filter. Queries the last modified date.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyWorkOrdersV2s(uuid, companyUuid, startDateTimeUtc, endDateTimeUtc, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompanyWorkOrdersV2s(uuid, companyUuid, startDateTimeUtc, endDateTimeUtc, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets owners within this company.
         * @param {string} uuid Partner Uuid
         * @param {string} companyUuid Company Uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwners(uuid, companyUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOwners(uuid, companyUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets properties to the sepcified company.
         * @param {string} uuid Partner Uuid
         * @param {string} companyUuid Company Uuid
         * @param {number} [softwareIntegrationCredentialId] Additional filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertiesV2(uuid, companyUuid, softwareIntegrationCredentialId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPropertiesV2(uuid, companyUuid, softwareIntegrationCredentialId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets resident records for this company.
         * @param {string} uuid Partner Uuid
         * @param {string} companyUuid Company Uuid
         * @param {number} [softwareIntegrationCredentialId] Additional filter.
         * @param {string} [propertyUuid] Additional filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResidentsV2(uuid, companyUuid, softwareIntegrationCredentialId, propertyUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getResidentsV2(uuid, companyUuid, softwareIntegrationCredentialId, propertyUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets vendors within this company.
         * @param {string} uuid Partner Uuid
         * @param {string} companyUuid Company Uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendorsV2(uuid, companyUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getVendorsV2(uuid, companyUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * The begin and end dates are both inclusive [startdate, enddate]
         * @summary Find transactions by company uuid.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {PartnerTransactionSearchParamsDto} partnerTransactionSearchParamsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTransactionDateV1(uuid, companyUuid, partnerTransactionSearchParamsDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchTransactionDateV1(uuid, companyUuid, partnerTransactionSearchParamsDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Note, this is indiscriminate; It will add these records even if there are already existing bankaccount with similar attributes.
         * @summary Adds one or more bank accounts to the sepcified company.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {Array<CreateBankAccountV2Dto>} createBankAccountV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertBankAccountsV2(uuid, companyUuid, createBankAccountV2Dto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.upsertBankAccountsV2(uuid, companyUuid, createBankAccountV2Dto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Adds or updates document meta data to the sepcified company.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {Array<DocumentMetadataDto>} documentMetadataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertDocumentMetadataV2(uuid, companyUuid, documentMetadataDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.upsertDocumentMetadataV2(uuid, companyUuid, documentMetadataDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Adds or updates ledger activities.
         * @param {string} uuid Partner Uuid
         * @param {string} companyUuid
         * @param {Array<LedgerActivityDto>} ledgerActivityDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertLedgerActivityV2(uuid, companyUuid, ledgerActivityDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.upsertLedgerActivityV2(uuid, companyUuid, ledgerActivityDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Adds or updates owners to the sepcified company. ExternalRef1 must be unique for each owner under each company.
         * @param {string} uuid Partner Uuid
         * @param {string} companyUuid
         * @param {Array<CreateOwnerV2Dto>} createOwnerV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertOwnersV2(uuid, companyUuid, createOwnerV2Dto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.upsertOwnersV2(uuid, companyUuid, createOwnerV2Dto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Adds or updates properties to the sepcified company.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {Array<CreatePropertyDTO>} createPropertyDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertPropertiesV1(uuid, companyUuid, createPropertyDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.upsertPropertiesV1(uuid, companyUuid, createPropertyDTO, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Creates or updates properties to the sepcified company.
         * @param {string} uuid Partner Uuid
         * @param {string} companyUuid
         * @param {Array<CreatePropertyV2Dto>} createPropertyV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertPropertiesV2(uuid, companyUuid, createPropertyV2Dto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.upsertPropertiesV2(uuid, companyUuid, createPropertyV2Dto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Inserts property payment types. Returns count of new records inserted.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {Array<CreatePropertyPaymentTypeDTO>} createPropertyPaymentTypeDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertPropertyPaymentTypesV1(uuid, companyUuid, createPropertyPaymentTypeDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.upsertPropertyPaymentTypesV1(uuid, companyUuid, createPropertyPaymentTypeDTO, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Adds or updates new resident record(s) on this property.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {string} propertyUuid
         * @param {Array<CreateResidentDTO>} createResidentDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertResidentsV1(uuid, companyUuid, propertyUuid, createResidentDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.upsertResidentsV1(uuid, companyUuid, propertyUuid, createResidentDTO, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Adds or updates new resident record(s) on this property.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {Array<CreateResidentV2Dto>} createResidentV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertResidentsV2(uuid, companyUuid, createResidentV2Dto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.upsertResidentsV2(uuid, companyUuid, createResidentV2Dto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Adds or updates vendors to the sepcified company. ExternalRef1 must be unique for each vendor under each company.
         * @param {string} uuid Partner Uuid
         * @param {string} companyUuid
         * @param {Array<CreateVendorV2Dto>} createVendorV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertVendorsV2(uuid, companyUuid, createVendorV2Dto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.upsertVendorsV2(uuid, companyUuid, createVendorV2Dto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PartnersApi - factory interface
 * @export
 */
exports.PartnersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PartnersApiFp(configuration);
    return {
        /**
         * Note, this is indiscriminate; It will add these records even if there are already existing bankaccount with similar attributes.
         * @summary Adds one or more bank accounts to the sepcified company.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {Array<CreateBankAccountDTO>} createBankAccountDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankAccountsV1(uuid, companyUuid, createBankAccountDTO, options) {
            return localVarFp.createBankAccountsV1(uuid, companyUuid, createBankAccountDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Helper method to create sub accounts with our processor for a company\'s destination bank accounts.
         * @summary Create sub accounts for bank accounts.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcessorSubAccounts(uuid, companyUuid, options) {
            return localVarFp.createProcessorSubAccounts(uuid, companyUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Find applications by company that were decisioned in the specified date range.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {string} [startDateTimeUtc] ISO 8601 datetime string in YYYY-MM-DDTHH:mm:ss.sssZ format. Inclusive start date to filter. Queries the decison date.
         * @param {string} [endDateTimeUtc] ISO 8601 datetime string in YYYY-MM-DDTHH:mm:ss.sssZ format. Inclusive end date to filter. Queries the decision date.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyApplicationsV2s(uuid, companyUuid, startDateTimeUtc, endDateTimeUtc, options) {
            return localVarFp.getCompanyApplicationsV2s(uuid, companyUuid, startDateTimeUtc, endDateTimeUtc, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets basic configs for this company..
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyConfigsV2s(uuid, companyUuid, options) {
            return localVarFp.getCompanyConfigsV2s(uuid, companyUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Find company by uuid.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {string} depositId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyDepositDetailsV1(uuid, companyUuid, depositId, options) {
            return localVarFp.getCompanyDepositDetailsV1(uuid, companyUuid, depositId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Find deposits by company.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {Array<'open' | 'closed' | 'paid' | 'returned'>} [status]
         * @param {string} [startDate] Inclusive start date for the range of deposits. Queries batch deposit date.
         * @param {string} [endDate] Inclusive end date for the range of deposits. Queries batch deposit date.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyDepositsV1(uuid, companyUuid, status, startDate, endDate, options) {
            return localVarFp.getCompanyDepositsV1(uuid, companyUuid, status, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets the details of a specific workorder.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyWorkOrderDetailsV2s(uuid, companyUuid, id, options) {
            return localVarFp.getCompanyWorkOrderDetailsV2s(uuid, companyUuid, id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Find workorders by company that were modified in the specified date range.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {string} [startDateTimeUtc] ISO 8601 datetime string in YYYY-MM-DDTHH:mm:ss.sssZ format. Inclusive start date to filter. Queries the last modified date.
         * @param {string} [endDateTimeUtc] ISO 8601 datetime string in YYYY-MM-DDTHH:mm:ss.sssZ format. Inclusive end date to filter. Queries the last modified date.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyWorkOrdersV2s(uuid, companyUuid, startDateTimeUtc, endDateTimeUtc, options) {
            return localVarFp.getCompanyWorkOrdersV2s(uuid, companyUuid, startDateTimeUtc, endDateTimeUtc, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets owners within this company.
         * @param {string} uuid Partner Uuid
         * @param {string} companyUuid Company Uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwners(uuid, companyUuid, options) {
            return localVarFp.getOwners(uuid, companyUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets properties to the sepcified company.
         * @param {string} uuid Partner Uuid
         * @param {string} companyUuid Company Uuid
         * @param {number} [softwareIntegrationCredentialId] Additional filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertiesV2(uuid, companyUuid, softwareIntegrationCredentialId, options) {
            return localVarFp.getPropertiesV2(uuid, companyUuid, softwareIntegrationCredentialId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets resident records for this company.
         * @param {string} uuid Partner Uuid
         * @param {string} companyUuid Company Uuid
         * @param {number} [softwareIntegrationCredentialId] Additional filter.
         * @param {string} [propertyUuid] Additional filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResidentsV2(uuid, companyUuid, softwareIntegrationCredentialId, propertyUuid, options) {
            return localVarFp.getResidentsV2(uuid, companyUuid, softwareIntegrationCredentialId, propertyUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets vendors within this company.
         * @param {string} uuid Partner Uuid
         * @param {string} companyUuid Company Uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendorsV2(uuid, companyUuid, options) {
            return localVarFp.getVendorsV2(uuid, companyUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * The begin and end dates are both inclusive [startdate, enddate]
         * @summary Find transactions by company uuid.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {PartnerTransactionSearchParamsDto} partnerTransactionSearchParamsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTransactionDateV1(uuid, companyUuid, partnerTransactionSearchParamsDto, options) {
            return localVarFp.searchTransactionDateV1(uuid, companyUuid, partnerTransactionSearchParamsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Note, this is indiscriminate; It will add these records even if there are already existing bankaccount with similar attributes.
         * @summary Adds one or more bank accounts to the sepcified company.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {Array<CreateBankAccountV2Dto>} createBankAccountV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertBankAccountsV2(uuid, companyUuid, createBankAccountV2Dto, options) {
            return localVarFp.upsertBankAccountsV2(uuid, companyUuid, createBankAccountV2Dto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Adds or updates document meta data to the sepcified company.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {Array<DocumentMetadataDto>} documentMetadataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertDocumentMetadataV2(uuid, companyUuid, documentMetadataDto, options) {
            return localVarFp.upsertDocumentMetadataV2(uuid, companyUuid, documentMetadataDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Adds or updates ledger activities.
         * @param {string} uuid Partner Uuid
         * @param {string} companyUuid
         * @param {Array<LedgerActivityDto>} ledgerActivityDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertLedgerActivityV2(uuid, companyUuid, ledgerActivityDto, options) {
            return localVarFp.upsertLedgerActivityV2(uuid, companyUuid, ledgerActivityDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Adds or updates owners to the sepcified company. ExternalRef1 must be unique for each owner under each company.
         * @param {string} uuid Partner Uuid
         * @param {string} companyUuid
         * @param {Array<CreateOwnerV2Dto>} createOwnerV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertOwnersV2(uuid, companyUuid, createOwnerV2Dto, options) {
            return localVarFp.upsertOwnersV2(uuid, companyUuid, createOwnerV2Dto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Adds or updates properties to the sepcified company.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {Array<CreatePropertyDTO>} createPropertyDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertPropertiesV1(uuid, companyUuid, createPropertyDTO, options) {
            return localVarFp.upsertPropertiesV1(uuid, companyUuid, createPropertyDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Creates or updates properties to the sepcified company.
         * @param {string} uuid Partner Uuid
         * @param {string} companyUuid
         * @param {Array<CreatePropertyV2Dto>} createPropertyV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertPropertiesV2(uuid, companyUuid, createPropertyV2Dto, options) {
            return localVarFp.upsertPropertiesV2(uuid, companyUuid, createPropertyV2Dto, options).then((request) => request(axios, basePath));
        },
        /**
         * Inserts property payment types. Returns count of new records inserted.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {Array<CreatePropertyPaymentTypeDTO>} createPropertyPaymentTypeDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertPropertyPaymentTypesV1(uuid, companyUuid, createPropertyPaymentTypeDTO, options) {
            return localVarFp.upsertPropertyPaymentTypesV1(uuid, companyUuid, createPropertyPaymentTypeDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Adds or updates new resident record(s) on this property.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {string} propertyUuid
         * @param {Array<CreateResidentDTO>} createResidentDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertResidentsV1(uuid, companyUuid, propertyUuid, createResidentDTO, options) {
            return localVarFp.upsertResidentsV1(uuid, companyUuid, propertyUuid, createResidentDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Adds or updates new resident record(s) on this property.
         * @param {string} uuid
         * @param {string} companyUuid
         * @param {Array<CreateResidentV2Dto>} createResidentV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertResidentsV2(uuid, companyUuid, createResidentV2Dto, options) {
            return localVarFp.upsertResidentsV2(uuid, companyUuid, createResidentV2Dto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Adds or updates vendors to the sepcified company. ExternalRef1 must be unique for each vendor under each company.
         * @param {string} uuid Partner Uuid
         * @param {string} companyUuid
         * @param {Array<CreateVendorV2Dto>} createVendorV2Dto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertVendorsV2(uuid, companyUuid, createVendorV2Dto, options) {
            return localVarFp.upsertVendorsV2(uuid, companyUuid, createVendorV2Dto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PartnersApi - object-oriented interface
 * @export
 * @class PartnersApi
 * @extends {BaseAPI}
 */
class PartnersApi extends base_1.BaseAPI {
    /**
     * Note, this is indiscriminate; It will add these records even if there are already existing bankaccount with similar attributes.
     * @summary Adds one or more bank accounts to the sepcified company.
     * @param {string} uuid
     * @param {string} companyUuid
     * @param {Array<CreateBankAccountDTO>} createBankAccountDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    createBankAccountsV1(uuid, companyUuid, createBankAccountDTO, options) {
        return exports.PartnersApiFp(this.configuration).createBankAccountsV1(uuid, companyUuid, createBankAccountDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Helper method to create sub accounts with our processor for a company\'s destination bank accounts.
     * @summary Create sub accounts for bank accounts.
     * @param {string} uuid
     * @param {string} companyUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    createProcessorSubAccounts(uuid, companyUuid, options) {
        return exports.PartnersApiFp(this.configuration).createProcessorSubAccounts(uuid, companyUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Find applications by company that were decisioned in the specified date range.
     * @param {string} uuid
     * @param {string} companyUuid
     * @param {string} [startDateTimeUtc] ISO 8601 datetime string in YYYY-MM-DDTHH:mm:ss.sssZ format. Inclusive start date to filter. Queries the decison date.
     * @param {string} [endDateTimeUtc] ISO 8601 datetime string in YYYY-MM-DDTHH:mm:ss.sssZ format. Inclusive end date to filter. Queries the decision date.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    getCompanyApplicationsV2s(uuid, companyUuid, startDateTimeUtc, endDateTimeUtc, options) {
        return exports.PartnersApiFp(this.configuration).getCompanyApplicationsV2s(uuid, companyUuid, startDateTimeUtc, endDateTimeUtc, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets basic configs for this company..
     * @param {string} uuid
     * @param {string} companyUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    getCompanyConfigsV2s(uuid, companyUuid, options) {
        return exports.PartnersApiFp(this.configuration).getCompanyConfigsV2s(uuid, companyUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Find company by uuid.
     * @param {string} uuid
     * @param {string} companyUuid
     * @param {string} depositId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    getCompanyDepositDetailsV1(uuid, companyUuid, depositId, options) {
        return exports.PartnersApiFp(this.configuration).getCompanyDepositDetailsV1(uuid, companyUuid, depositId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Find deposits by company.
     * @param {string} uuid
     * @param {string} companyUuid
     * @param {Array<'open' | 'closed' | 'paid' | 'returned'>} [status]
     * @param {string} [startDate] Inclusive start date for the range of deposits. Queries batch deposit date.
     * @param {string} [endDate] Inclusive end date for the range of deposits. Queries batch deposit date.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    getCompanyDepositsV1(uuid, companyUuid, status, startDate, endDate, options) {
        return exports.PartnersApiFp(this.configuration).getCompanyDepositsV1(uuid, companyUuid, status, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets the details of a specific workorder.
     * @param {string} uuid
     * @param {string} companyUuid
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    getCompanyWorkOrderDetailsV2s(uuid, companyUuid, id, options) {
        return exports.PartnersApiFp(this.configuration).getCompanyWorkOrderDetailsV2s(uuid, companyUuid, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Find workorders by company that were modified in the specified date range.
     * @param {string} uuid
     * @param {string} companyUuid
     * @param {string} [startDateTimeUtc] ISO 8601 datetime string in YYYY-MM-DDTHH:mm:ss.sssZ format. Inclusive start date to filter. Queries the last modified date.
     * @param {string} [endDateTimeUtc] ISO 8601 datetime string in YYYY-MM-DDTHH:mm:ss.sssZ format. Inclusive end date to filter. Queries the last modified date.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    getCompanyWorkOrdersV2s(uuid, companyUuid, startDateTimeUtc, endDateTimeUtc, options) {
        return exports.PartnersApiFp(this.configuration).getCompanyWorkOrdersV2s(uuid, companyUuid, startDateTimeUtc, endDateTimeUtc, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets owners within this company.
     * @param {string} uuid Partner Uuid
     * @param {string} companyUuid Company Uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    getOwners(uuid, companyUuid, options) {
        return exports.PartnersApiFp(this.configuration).getOwners(uuid, companyUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets properties to the sepcified company.
     * @param {string} uuid Partner Uuid
     * @param {string} companyUuid Company Uuid
     * @param {number} [softwareIntegrationCredentialId] Additional filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    getPropertiesV2(uuid, companyUuid, softwareIntegrationCredentialId, options) {
        return exports.PartnersApiFp(this.configuration).getPropertiesV2(uuid, companyUuid, softwareIntegrationCredentialId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets resident records for this company.
     * @param {string} uuid Partner Uuid
     * @param {string} companyUuid Company Uuid
     * @param {number} [softwareIntegrationCredentialId] Additional filter.
     * @param {string} [propertyUuid] Additional filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    getResidentsV2(uuid, companyUuid, softwareIntegrationCredentialId, propertyUuid, options) {
        return exports.PartnersApiFp(this.configuration).getResidentsV2(uuid, companyUuid, softwareIntegrationCredentialId, propertyUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets vendors within this company.
     * @param {string} uuid Partner Uuid
     * @param {string} companyUuid Company Uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    getVendorsV2(uuid, companyUuid, options) {
        return exports.PartnersApiFp(this.configuration).getVendorsV2(uuid, companyUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * The begin and end dates are both inclusive [startdate, enddate]
     * @summary Find transactions by company uuid.
     * @param {string} uuid
     * @param {string} companyUuid
     * @param {PartnerTransactionSearchParamsDto} partnerTransactionSearchParamsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    searchTransactionDateV1(uuid, companyUuid, partnerTransactionSearchParamsDto, options) {
        return exports.PartnersApiFp(this.configuration).searchTransactionDateV1(uuid, companyUuid, partnerTransactionSearchParamsDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Note, this is indiscriminate; It will add these records even if there are already existing bankaccount with similar attributes.
     * @summary Adds one or more bank accounts to the sepcified company.
     * @param {string} uuid
     * @param {string} companyUuid
     * @param {Array<CreateBankAccountV2Dto>} createBankAccountV2Dto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    upsertBankAccountsV2(uuid, companyUuid, createBankAccountV2Dto, options) {
        return exports.PartnersApiFp(this.configuration).upsertBankAccountsV2(uuid, companyUuid, createBankAccountV2Dto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Adds or updates document meta data to the sepcified company.
     * @param {string} uuid
     * @param {string} companyUuid
     * @param {Array<DocumentMetadataDto>} documentMetadataDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    upsertDocumentMetadataV2(uuid, companyUuid, documentMetadataDto, options) {
        return exports.PartnersApiFp(this.configuration).upsertDocumentMetadataV2(uuid, companyUuid, documentMetadataDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Adds or updates ledger activities.
     * @param {string} uuid Partner Uuid
     * @param {string} companyUuid
     * @param {Array<LedgerActivityDto>} ledgerActivityDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    upsertLedgerActivityV2(uuid, companyUuid, ledgerActivityDto, options) {
        return exports.PartnersApiFp(this.configuration).upsertLedgerActivityV2(uuid, companyUuid, ledgerActivityDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Adds or updates owners to the sepcified company. ExternalRef1 must be unique for each owner under each company.
     * @param {string} uuid Partner Uuid
     * @param {string} companyUuid
     * @param {Array<CreateOwnerV2Dto>} createOwnerV2Dto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    upsertOwnersV2(uuid, companyUuid, createOwnerV2Dto, options) {
        return exports.PartnersApiFp(this.configuration).upsertOwnersV2(uuid, companyUuid, createOwnerV2Dto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Adds or updates properties to the sepcified company.
     * @param {string} uuid
     * @param {string} companyUuid
     * @param {Array<CreatePropertyDTO>} createPropertyDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    upsertPropertiesV1(uuid, companyUuid, createPropertyDTO, options) {
        return exports.PartnersApiFp(this.configuration).upsertPropertiesV1(uuid, companyUuid, createPropertyDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Creates or updates properties to the sepcified company.
     * @param {string} uuid Partner Uuid
     * @param {string} companyUuid
     * @param {Array<CreatePropertyV2Dto>} createPropertyV2Dto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    upsertPropertiesV2(uuid, companyUuid, createPropertyV2Dto, options) {
        return exports.PartnersApiFp(this.configuration).upsertPropertiesV2(uuid, companyUuid, createPropertyV2Dto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Inserts property payment types. Returns count of new records inserted.
     * @param {string} uuid
     * @param {string} companyUuid
     * @param {Array<CreatePropertyPaymentTypeDTO>} createPropertyPaymentTypeDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    upsertPropertyPaymentTypesV1(uuid, companyUuid, createPropertyPaymentTypeDTO, options) {
        return exports.PartnersApiFp(this.configuration).upsertPropertyPaymentTypesV1(uuid, companyUuid, createPropertyPaymentTypeDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Adds or updates new resident record(s) on this property.
     * @param {string} uuid
     * @param {string} companyUuid
     * @param {string} propertyUuid
     * @param {Array<CreateResidentDTO>} createResidentDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    upsertResidentsV1(uuid, companyUuid, propertyUuid, createResidentDTO, options) {
        return exports.PartnersApiFp(this.configuration).upsertResidentsV1(uuid, companyUuid, propertyUuid, createResidentDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Adds or updates new resident record(s) on this property.
     * @param {string} uuid
     * @param {string} companyUuid
     * @param {Array<CreateResidentV2Dto>} createResidentV2Dto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    upsertResidentsV2(uuid, companyUuid, createResidentV2Dto, options) {
        return exports.PartnersApiFp(this.configuration).upsertResidentsV2(uuid, companyUuid, createResidentV2Dto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Adds or updates vendors to the sepcified company. ExternalRef1 must be unique for each vendor under each company.
     * @param {string} uuid Partner Uuid
     * @param {string} companyUuid
     * @param {Array<CreateVendorV2Dto>} createVendorV2Dto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    upsertVendorsV2(uuid, companyUuid, createVendorV2Dto, options) {
        return exports.PartnersApiFp(this.configuration).upsertVendorsV2(uuid, companyUuid, createVendorV2Dto, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PartnersApi = PartnersApi;
/**
 * PaymentsApi - axios parameter creator
 * @export
 */
exports.PaymentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Cancels an autopayment schedule.
         * @param {string} autopayUid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAutoPayment: (autopayUid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'autopayUid' is not null or undefined
            common_1.assertParamExists('cancelAutoPayment', 'autopayUid', autopayUid);
            const localVarPath = `/api/v1/payments/autopay/{autopay_uid}`
                .replace(`{${"autopay_uid"}}`, encodeURIComponent(String(autopayUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary cancel an eligible transaction
         * @param {string} paymentId
         * @param {string} payerUuid
         * @param {PaymentActionDto} paymentActionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrRefundPayment: (paymentId, payerUuid, paymentActionDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'paymentId' is not null or undefined
            common_1.assertParamExists('cancelOrRefundPayment', 'paymentId', paymentId);
            // verify required parameter 'payerUuid' is not null or undefined
            common_1.assertParamExists('cancelOrRefundPayment', 'payerUuid', payerUuid);
            // verify required parameter 'paymentActionDto' is not null or undefined
            common_1.assertParamExists('cancelOrRefundPayment', 'paymentActionDto', paymentActionDto);
            const localVarPath = `/api/v1/payments/{payment_id}`
                .replace(`{${"payment_id"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (payerUuid !== undefined) {
                localVarQueryParameter['payerUuid'] = payerUuid;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(paymentActionDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Cancel a transaction
         * @param {string} uuid
         * @param {string} payeruuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTransactionByPayerUuid: (uuid, payeruuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('cancelTransactionByPayerUuid', 'uuid', uuid);
            // verify required parameter 'payeruuid' is not null or undefined
            common_1.assertParamExists('cancelTransactionByPayerUuid', 'payeruuid', payeruuid);
            const localVarPath = `/api/v1/payments/{uuid}/cancel`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (payeruuid !== undefined) {
                localVarQueryParameter['payeruuid'] = payeruuid;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Change the status of a Payment Request
         * @param {string} requestUuid
         * @param {string} statusDescription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePaymentRequestStatus: (requestUuid, statusDescription, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'requestUuid' is not null or undefined
            common_1.assertParamExists('changePaymentRequestStatus', 'requestUuid', requestUuid);
            // verify required parameter 'statusDescription' is not null or undefined
            common_1.assertParamExists('changePaymentRequestStatus', 'statusDescription', statusDescription);
            const localVarPath = `/api/v1/payments/requests/{request_uuid}/status`
                .replace(`{${"request_uuid"}}`, encodeURIComponent(String(requestUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (statusDescription !== undefined) {
                localVarQueryParameter['statusDescription'] = statusDescription;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Set up an autopayment schedule.
         * @param {CreateScheduledAutoPayDto} createScheduledAutoPayDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAutoPayment: (createScheduledAutoPayDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createScheduledAutoPayDto' is not null or undefined
            common_1.assertParamExists('createAutoPayment', 'createScheduledAutoPayDto', createScheduledAutoPayDto);
            const localVarPath = `/api/v1/payments/autopays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createScheduledAutoPayDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create a generic payer.
         * @param {CreateGenericPayerDto} createGenericPayerDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGenericPayer: (createGenericPayerDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createGenericPayerDto' is not null or undefined
            common_1.assertParamExists('createGenericPayer', 'createGenericPayerDto', createGenericPayerDto);
            const localVarPath = `/api/v1/payments/payers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createGenericPayerDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Payee is any supported payment recipient in our system, payer is any supported payment executor in our system
         * @summary Create one time payment for any two set of payer and payee entities
         * @param {CreateOneTimePaymentDto} createOneTimePaymentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneTimePayment: (createOneTimePaymentDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createOneTimePaymentDto' is not null or undefined
            common_1.assertParamExists('createOneTimePayment', 'createOneTimePaymentDto', createOneTimePaymentDto);
            const localVarPath = `/api/v1/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createOneTimePaymentDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create a Payment Request
         * @param {CreatePaymentRequestDto} createPaymentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaymentRequest: (createPaymentRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createPaymentRequestDto' is not null or undefined
            common_1.assertParamExists('createPaymentRequest', 'createPaymentRequestDto', createPaymentRequestDto);
            const localVarPath = `/api/v1/payments/requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createPaymentRequestDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary export details of specified transaction as pdf
         * @param {string} paymentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTransactionDetails: (paymentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'paymentId' is not null or undefined
            common_1.assertParamExists('exportTransactionDetails', 'paymentId', paymentId);
            const localVarPath = `/api/v1/payments/{payment_id}/export`
                .replace(`{${"payment_id"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Find payments by payer uuid.
         * @param {string} payerUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllPayments: (payerUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'payerUuid' is not null or undefined
            common_1.assertParamExists('findAllPayments', 'payerUuid', payerUuid);
            const localVarPath = `/api/v1/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (payerUuid !== undefined) {
                localVarQueryParameter['payerUuid'] = payerUuid;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} paymentId
         * @param {string} payerUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSpecificPayment: (paymentId, payerUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'paymentId' is not null or undefined
            common_1.assertParamExists('findSpecificPayment', 'paymentId', paymentId);
            // verify required parameter 'payerUuid' is not null or undefined
            common_1.assertParamExists('findSpecificPayment', 'payerUuid', payerUuid);
            const localVarPath = `/api/v1/payments/{payment_id}`
                .replace(`{${"payment_id"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (payerUuid !== undefined) {
                localVarQueryParameter['payerUuid'] = payerUuid;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns a specific autopay owned by this user that have not been cancelled and have not passed the end date.
         * @summary Find specific autopay.
         * @param {string} autopayUid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutopay: (autopayUid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'autopayUid' is not null or undefined
            common_1.assertParamExists('getAutopay', 'autopayUid', autopayUid);
            const localVarPath = `/api/v1/payments/autopay/{autopay_uid}`
                .replace(`{${"autopay_uid"}}`, encodeURIComponent(String(autopayUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns all active autopays on this payer that have not been cancelled and have not passed the end date.
         * @summary Find active autopays for current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutopays: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v1/payments/autopays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Find balance by payer uuid.
         * @param {string} payerUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalanceDetails: (payerUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'payerUuid' is not null or undefined
            common_1.assertParamExists('getBalanceDetails', 'payerUuid', payerUuid);
            const localVarPath = `/api/v1/payments/balance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (payerUuid !== undefined) {
                localVarQueryParameter['payerUuid'] = payerUuid;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Find methods that the payer has saved.
         * @param {string} payerUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayMethods: (payerUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'payerUuid' is not null or undefined
            common_1.assertParamExists('getPayMethods', 'payerUuid', payerUuid);
            const localVarPath = `/api/v1/payments/paymethods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (payerUuid !== undefined) {
                localVarQueryParameter['payerUuid'] = payerUuid;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Find payments configs.
         * @param {string} payerUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentConfigs: (payerUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'payerUuid' is not null or undefined
            common_1.assertParamExists('getPaymentConfigs', 'payerUuid', payerUuid);
            const localVarPath = `/api/v1/payments/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (payerUuid !== undefined) {
                localVarQueryParameter['payerUuid'] = payerUuid;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Calculates fees for the configured payment methods, given the specified amount.
         * @param {string} payerUuid
         * @param {number} paymentAmount
         * @param {number} propertyPayTypeId
         * @param {string} [paymentRequestsId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentFees: (payerUuid, paymentAmount, propertyPayTypeId, paymentRequestsId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'payerUuid' is not null or undefined
            common_1.assertParamExists('getPaymentFees', 'payerUuid', payerUuid);
            // verify required parameter 'paymentAmount' is not null or undefined
            common_1.assertParamExists('getPaymentFees', 'paymentAmount', paymentAmount);
            // verify required parameter 'propertyPayTypeId' is not null or undefined
            common_1.assertParamExists('getPaymentFees', 'propertyPayTypeId', propertyPayTypeId);
            const localVarPath = `/api/v1/payments/fees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (payerUuid !== undefined) {
                localVarQueryParameter['payerUuid'] = payerUuid;
            }
            if (paymentAmount !== undefined) {
                localVarQueryParameter['paymentAmount'] = paymentAmount;
            }
            if (propertyPayTypeId !== undefined) {
                localVarQueryParameter['propertyPayTypeId'] = propertyPayTypeId;
            }
            if (paymentRequestsId !== undefined) {
                localVarQueryParameter['paymentRequestsId'] = paymentRequestsId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Searches for payment request details
         * @summary Find payment request details by transaction uuid.
         * @param {string} paymentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentReqDetailsByTransUuid: (paymentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'paymentId' is not null or undefined
            common_1.assertParamExists('getPaymentReqDetailsByTransUuid', 'paymentId', paymentId);
            const localVarPath = `/api/v1/payments/{payment_id}/paymentrequest`
                .replace(`{${"payment_id"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Searches for payment request details and prop pay types
         * @summary Find payment request balance details by request uuid.
         * @param {string} requestUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestBalanceDetails: (requestUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'requestUuid' is not null or undefined
            common_1.assertParamExists('getPaymentRequestBalanceDetails', 'requestUuid', requestUuid);
            const localVarPath = `/api/v1/payments/requests/{request_uuid}/balance`
                .replace(`{${"request_uuid"}}`, encodeURIComponent(String(requestUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Searches for payment request details
         * @summary Find payment request details by request uuid.
         * @param {string} requestUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestDetails: (requestUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'requestUuid' is not null or undefined
            common_1.assertParamExists('getPaymentRequestDetails', 'requestUuid', requestUuid);
            const localVarPath = `/api/v1/payments/requests/{request_uuid}`
                .replace(`{${"request_uuid"}}`, encodeURIComponent(String(requestUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Replaces an autopayment schedule.
         * @param {string} autopayUid
         * @param {CreateScheduledAutoPayDto} createScheduledAutoPayDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceAutoPayment: (autopayUid, createScheduledAutoPayDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'autopayUid' is not null or undefined
            common_1.assertParamExists('replaceAutoPayment', 'autopayUid', autopayUid);
            // verify required parameter 'createScheduledAutoPayDto' is not null or undefined
            common_1.assertParamExists('replaceAutoPayment', 'createScheduledAutoPayDto', createScheduledAutoPayDto);
            const localVarPath = `/api/v1/payments/autopay/{autopay_uid}`
                .replace(`{${"autopay_uid"}}`, encodeURIComponent(String(autopayUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createScheduledAutoPayDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Resend payment request to a different email
         * @param {string} requestUuid
         * @param {ResendPaymentRequestDto} resendPaymentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendPaymentRequest: (requestUuid, resendPaymentRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'requestUuid' is not null or undefined
            common_1.assertParamExists('resendPaymentRequest', 'requestUuid', requestUuid);
            // verify required parameter 'resendPaymentRequestDto' is not null or undefined
            common_1.assertParamExists('resendPaymentRequest', 'resendPaymentRequestDto', resendPaymentRequestDto);
            const localVarPath = `/api/v1/payments/requests/{request_uuid}`
                .replace(`{${"request_uuid"}}`, encodeURIComponent(String(requestUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(resendPaymentRequestDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Searches for payment requests with pagination
         * @summary Find payment requests by pm uuid.
         * @param {PaymentRequestSearchDTO} paymentRequestSearchDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPaymentRequestsByPM: (paymentRequestSearchDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'paymentRequestSearchDTO' is not null or undefined
            common_1.assertParamExists('searchPaymentRequestsByPM', 'paymentRequestSearchDTO', paymentRequestSearchDTO);
            const localVarPath = `/api/v1/payments/requests/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(paymentRequestSearchDTO, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Sets the skip value of this autopay.
         * @param {string} autopayUid
         * @param {UpdateSkipAPDto} updateSkipAPDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAutopaySkipSetting: (autopayUid, updateSkipAPDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'autopayUid' is not null or undefined
            common_1.assertParamExists('setAutopaySkipSetting', 'autopayUid', autopayUid);
            // verify required parameter 'updateSkipAPDto' is not null or undefined
            common_1.assertParamExists('setAutopaySkipSetting', 'updateSkipAPDto', updateSkipAPDto);
            const localVarPath = `/api/v1/payments/autopay/{autopay_uid}`
                .replace(`{${"autopay_uid"}}`, encodeURIComponent(String(autopayUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateSkipAPDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update a generic payer.
         * @param {string} payerUuid
         * @param {UpdateGenericPayerDto} updateGenericPayerDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGenericPayer: (payerUuid, updateGenericPayerDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'payerUuid' is not null or undefined
            common_1.assertParamExists('updateGenericPayer', 'payerUuid', payerUuid);
            // verify required parameter 'updateGenericPayerDto' is not null or undefined
            common_1.assertParamExists('updateGenericPayer', 'updateGenericPayerDto', updateGenericPayerDto);
            const localVarPath = `/api/v1/payments/payers/{payer_uuid}`
                .replace(`{${"payer_uuid"}}`, encodeURIComponent(String(payerUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateGenericPayerDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PaymentsApi - functional programming interface
 * @export
 */
exports.PaymentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PaymentsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Cancels an autopayment schedule.
         * @param {string} autopayUid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAutoPayment(autopayUid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cancelAutoPayment(autopayUid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary cancel an eligible transaction
         * @param {string} paymentId
         * @param {string} payerUuid
         * @param {PaymentActionDto} paymentActionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrRefundPayment(paymentId, payerUuid, paymentActionDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cancelOrRefundPayment(paymentId, payerUuid, paymentActionDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Cancel a transaction
         * @param {string} uuid
         * @param {string} payeruuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTransactionByPayerUuid(uuid, payeruuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cancelTransactionByPayerUuid(uuid, payeruuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Change the status of a Payment Request
         * @param {string} requestUuid
         * @param {string} statusDescription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePaymentRequestStatus(requestUuid, statusDescription, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.changePaymentRequestStatus(requestUuid, statusDescription, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Set up an autopayment schedule.
         * @param {CreateScheduledAutoPayDto} createScheduledAutoPayDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAutoPayment(createScheduledAutoPayDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAutoPayment(createScheduledAutoPayDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create a generic payer.
         * @param {CreateGenericPayerDto} createGenericPayerDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGenericPayer(createGenericPayerDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createGenericPayer(createGenericPayerDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Payee is any supported payment recipient in our system, payer is any supported payment executor in our system
         * @summary Create one time payment for any two set of payer and payee entities
         * @param {CreateOneTimePaymentDto} createOneTimePaymentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneTimePayment(createOneTimePaymentDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createOneTimePayment(createOneTimePaymentDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create a Payment Request
         * @param {CreatePaymentRequestDto} createPaymentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaymentRequest(createPaymentRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createPaymentRequest(createPaymentRequestDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary export details of specified transaction as pdf
         * @param {string} paymentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTransactionDetails(paymentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.exportTransactionDetails(paymentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Find payments by payer uuid.
         * @param {string} payerUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllPayments(payerUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.findAllPayments(payerUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} paymentId
         * @param {string} payerUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSpecificPayment(paymentId, payerUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.findSpecificPayment(paymentId, payerUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Returns a specific autopay owned by this user that have not been cancelled and have not passed the end date.
         * @summary Find specific autopay.
         * @param {string} autopayUid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutopay(autopayUid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAutopay(autopayUid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Returns all active autopays on this payer that have not been cancelled and have not passed the end date.
         * @summary Find active autopays for current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutopays(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAutopays(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Find balance by payer uuid.
         * @param {string} payerUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalanceDetails(payerUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBalanceDetails(payerUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Find methods that the payer has saved.
         * @param {string} payerUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayMethods(payerUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPayMethods(payerUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Find payments configs.
         * @param {string} payerUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentConfigs(payerUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPaymentConfigs(payerUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Calculates fees for the configured payment methods, given the specified amount.
         * @param {string} payerUuid
         * @param {number} paymentAmount
         * @param {number} propertyPayTypeId
         * @param {string} [paymentRequestsId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentFees(payerUuid, paymentAmount, propertyPayTypeId, paymentRequestsId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPaymentFees(payerUuid, paymentAmount, propertyPayTypeId, paymentRequestsId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Searches for payment request details
         * @summary Find payment request details by transaction uuid.
         * @param {string} paymentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentReqDetailsByTransUuid(paymentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPaymentReqDetailsByTransUuid(paymentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Searches for payment request details and prop pay types
         * @summary Find payment request balance details by request uuid.
         * @param {string} requestUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestBalanceDetails(requestUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPaymentRequestBalanceDetails(requestUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Searches for payment request details
         * @summary Find payment request details by request uuid.
         * @param {string} requestUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestDetails(requestUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPaymentRequestDetails(requestUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Replaces an autopayment schedule.
         * @param {string} autopayUid
         * @param {CreateScheduledAutoPayDto} createScheduledAutoPayDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceAutoPayment(autopayUid, createScheduledAutoPayDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.replaceAutoPayment(autopayUid, createScheduledAutoPayDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Resend payment request to a different email
         * @param {string} requestUuid
         * @param {ResendPaymentRequestDto} resendPaymentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendPaymentRequest(requestUuid, resendPaymentRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resendPaymentRequest(requestUuid, resendPaymentRequestDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Searches for payment requests with pagination
         * @summary Find payment requests by pm uuid.
         * @param {PaymentRequestSearchDTO} paymentRequestSearchDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPaymentRequestsByPM(paymentRequestSearchDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchPaymentRequestsByPM(paymentRequestSearchDTO, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Sets the skip value of this autopay.
         * @param {string} autopayUid
         * @param {UpdateSkipAPDto} updateSkipAPDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAutopaySkipSetting(autopayUid, updateSkipAPDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setAutopaySkipSetting(autopayUid, updateSkipAPDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update a generic payer.
         * @param {string} payerUuid
         * @param {UpdateGenericPayerDto} updateGenericPayerDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGenericPayer(payerUuid, updateGenericPayerDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateGenericPayer(payerUuid, updateGenericPayerDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PaymentsApi - factory interface
 * @export
 */
exports.PaymentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PaymentsApiFp(configuration);
    return {
        /**
         *
         * @summary Cancels an autopayment schedule.
         * @param {string} autopayUid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAutoPayment(autopayUid, options) {
            return localVarFp.cancelAutoPayment(autopayUid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary cancel an eligible transaction
         * @param {string} paymentId
         * @param {string} payerUuid
         * @param {PaymentActionDto} paymentActionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrRefundPayment(paymentId, payerUuid, paymentActionDto, options) {
            return localVarFp.cancelOrRefundPayment(paymentId, payerUuid, paymentActionDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Cancel a transaction
         * @param {string} uuid
         * @param {string} payeruuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTransactionByPayerUuid(uuid, payeruuid, options) {
            return localVarFp.cancelTransactionByPayerUuid(uuid, payeruuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Change the status of a Payment Request
         * @param {string} requestUuid
         * @param {string} statusDescription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePaymentRequestStatus(requestUuid, statusDescription, options) {
            return localVarFp.changePaymentRequestStatus(requestUuid, statusDescription, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set up an autopayment schedule.
         * @param {CreateScheduledAutoPayDto} createScheduledAutoPayDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAutoPayment(createScheduledAutoPayDto, options) {
            return localVarFp.createAutoPayment(createScheduledAutoPayDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a generic payer.
         * @param {CreateGenericPayerDto} createGenericPayerDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGenericPayer(createGenericPayerDto, options) {
            return localVarFp.createGenericPayer(createGenericPayerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Payee is any supported payment recipient in our system, payer is any supported payment executor in our system
         * @summary Create one time payment for any two set of payer and payee entities
         * @param {CreateOneTimePaymentDto} createOneTimePaymentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneTimePayment(createOneTimePaymentDto, options) {
            return localVarFp.createOneTimePayment(createOneTimePaymentDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a Payment Request
         * @param {CreatePaymentRequestDto} createPaymentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaymentRequest(createPaymentRequestDto, options) {
            return localVarFp.createPaymentRequest(createPaymentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary export details of specified transaction as pdf
         * @param {string} paymentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTransactionDetails(paymentId, options) {
            return localVarFp.exportTransactionDetails(paymentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Find payments by payer uuid.
         * @param {string} payerUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllPayments(payerUuid, options) {
            return localVarFp.findAllPayments(payerUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} paymentId
         * @param {string} payerUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSpecificPayment(paymentId, payerUuid, options) {
            return localVarFp.findSpecificPayment(paymentId, payerUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a specific autopay owned by this user that have not been cancelled and have not passed the end date.
         * @summary Find specific autopay.
         * @param {string} autopayUid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutopay(autopayUid, options) {
            return localVarFp.getAutopay(autopayUid, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all active autopays on this payer that have not been cancelled and have not passed the end date.
         * @summary Find active autopays for current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutopays(options) {
            return localVarFp.getAutopays(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Find balance by payer uuid.
         * @param {string} payerUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalanceDetails(payerUuid, options) {
            return localVarFp.getBalanceDetails(payerUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Find methods that the payer has saved.
         * @param {string} payerUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayMethods(payerUuid, options) {
            return localVarFp.getPayMethods(payerUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Find payments configs.
         * @param {string} payerUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentConfigs(payerUuid, options) {
            return localVarFp.getPaymentConfigs(payerUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Calculates fees for the configured payment methods, given the specified amount.
         * @param {string} payerUuid
         * @param {number} paymentAmount
         * @param {number} propertyPayTypeId
         * @param {string} [paymentRequestsId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentFees(payerUuid, paymentAmount, propertyPayTypeId, paymentRequestsId, options) {
            return localVarFp.getPaymentFees(payerUuid, paymentAmount, propertyPayTypeId, paymentRequestsId, options).then((request) => request(axios, basePath));
        },
        /**
         * Searches for payment request details
         * @summary Find payment request details by transaction uuid.
         * @param {string} paymentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentReqDetailsByTransUuid(paymentId, options) {
            return localVarFp.getPaymentReqDetailsByTransUuid(paymentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Searches for payment request details and prop pay types
         * @summary Find payment request balance details by request uuid.
         * @param {string} requestUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestBalanceDetails(requestUuid, options) {
            return localVarFp.getPaymentRequestBalanceDetails(requestUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Searches for payment request details
         * @summary Find payment request details by request uuid.
         * @param {string} requestUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestDetails(requestUuid, options) {
            return localVarFp.getPaymentRequestDetails(requestUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Replaces an autopayment schedule.
         * @param {string} autopayUid
         * @param {CreateScheduledAutoPayDto} createScheduledAutoPayDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceAutoPayment(autopayUid, createScheduledAutoPayDto, options) {
            return localVarFp.replaceAutoPayment(autopayUid, createScheduledAutoPayDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Resend payment request to a different email
         * @param {string} requestUuid
         * @param {ResendPaymentRequestDto} resendPaymentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendPaymentRequest(requestUuid, resendPaymentRequestDto, options) {
            return localVarFp.resendPaymentRequest(requestUuid, resendPaymentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Searches for payment requests with pagination
         * @summary Find payment requests by pm uuid.
         * @param {PaymentRequestSearchDTO} paymentRequestSearchDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPaymentRequestsByPM(paymentRequestSearchDTO, options) {
            return localVarFp.searchPaymentRequestsByPM(paymentRequestSearchDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Sets the skip value of this autopay.
         * @param {string} autopayUid
         * @param {UpdateSkipAPDto} updateSkipAPDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAutopaySkipSetting(autopayUid, updateSkipAPDto, options) {
            return localVarFp.setAutopaySkipSetting(autopayUid, updateSkipAPDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a generic payer.
         * @param {string} payerUuid
         * @param {UpdateGenericPayerDto} updateGenericPayerDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGenericPayer(payerUuid, updateGenericPayerDto, options) {
            return localVarFp.updateGenericPayer(payerUuid, updateGenericPayerDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PaymentsApi - object-oriented interface
 * @export
 * @class PaymentsApi
 * @extends {BaseAPI}
 */
class PaymentsApi extends base_1.BaseAPI {
    /**
     *
     * @summary Cancels an autopayment schedule.
     * @param {string} autopayUid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    cancelAutoPayment(autopayUid, options) {
        return exports.PaymentsApiFp(this.configuration).cancelAutoPayment(autopayUid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary cancel an eligible transaction
     * @param {string} paymentId
     * @param {string} payerUuid
     * @param {PaymentActionDto} paymentActionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    cancelOrRefundPayment(paymentId, payerUuid, paymentActionDto, options) {
        return exports.PaymentsApiFp(this.configuration).cancelOrRefundPayment(paymentId, payerUuid, paymentActionDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Cancel a transaction
     * @param {string} uuid
     * @param {string} payeruuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    cancelTransactionByPayerUuid(uuid, payeruuid, options) {
        return exports.PaymentsApiFp(this.configuration).cancelTransactionByPayerUuid(uuid, payeruuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Change the status of a Payment Request
     * @param {string} requestUuid
     * @param {string} statusDescription
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    changePaymentRequestStatus(requestUuid, statusDescription, options) {
        return exports.PaymentsApiFp(this.configuration).changePaymentRequestStatus(requestUuid, statusDescription, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Set up an autopayment schedule.
     * @param {CreateScheduledAutoPayDto} createScheduledAutoPayDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    createAutoPayment(createScheduledAutoPayDto, options) {
        return exports.PaymentsApiFp(this.configuration).createAutoPayment(createScheduledAutoPayDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a generic payer.
     * @param {CreateGenericPayerDto} createGenericPayerDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    createGenericPayer(createGenericPayerDto, options) {
        return exports.PaymentsApiFp(this.configuration).createGenericPayer(createGenericPayerDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Payee is any supported payment recipient in our system, payer is any supported payment executor in our system
     * @summary Create one time payment for any two set of payer and payee entities
     * @param {CreateOneTimePaymentDto} createOneTimePaymentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    createOneTimePayment(createOneTimePaymentDto, options) {
        return exports.PaymentsApiFp(this.configuration).createOneTimePayment(createOneTimePaymentDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a Payment Request
     * @param {CreatePaymentRequestDto} createPaymentRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    createPaymentRequest(createPaymentRequestDto, options) {
        return exports.PaymentsApiFp(this.configuration).createPaymentRequest(createPaymentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary export details of specified transaction as pdf
     * @param {string} paymentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    exportTransactionDetails(paymentId, options) {
        return exports.PaymentsApiFp(this.configuration).exportTransactionDetails(paymentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Find payments by payer uuid.
     * @param {string} payerUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    findAllPayments(payerUuid, options) {
        return exports.PaymentsApiFp(this.configuration).findAllPayments(payerUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} paymentId
     * @param {string} payerUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    findSpecificPayment(paymentId, payerUuid, options) {
        return exports.PaymentsApiFp(this.configuration).findSpecificPayment(paymentId, payerUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a specific autopay owned by this user that have not been cancelled and have not passed the end date.
     * @summary Find specific autopay.
     * @param {string} autopayUid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    getAutopay(autopayUid, options) {
        return exports.PaymentsApiFp(this.configuration).getAutopay(autopayUid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns all active autopays on this payer that have not been cancelled and have not passed the end date.
     * @summary Find active autopays for current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    getAutopays(options) {
        return exports.PaymentsApiFp(this.configuration).getAutopays(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Find balance by payer uuid.
     * @param {string} payerUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    getBalanceDetails(payerUuid, options) {
        return exports.PaymentsApiFp(this.configuration).getBalanceDetails(payerUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Find methods that the payer has saved.
     * @param {string} payerUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    getPayMethods(payerUuid, options) {
        return exports.PaymentsApiFp(this.configuration).getPayMethods(payerUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Find payments configs.
     * @param {string} payerUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    getPaymentConfigs(payerUuid, options) {
        return exports.PaymentsApiFp(this.configuration).getPaymentConfigs(payerUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Calculates fees for the configured payment methods, given the specified amount.
     * @param {string} payerUuid
     * @param {number} paymentAmount
     * @param {number} propertyPayTypeId
     * @param {string} [paymentRequestsId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    getPaymentFees(payerUuid, paymentAmount, propertyPayTypeId, paymentRequestsId, options) {
        return exports.PaymentsApiFp(this.configuration).getPaymentFees(payerUuid, paymentAmount, propertyPayTypeId, paymentRequestsId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Searches for payment request details
     * @summary Find payment request details by transaction uuid.
     * @param {string} paymentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    getPaymentReqDetailsByTransUuid(paymentId, options) {
        return exports.PaymentsApiFp(this.configuration).getPaymentReqDetailsByTransUuid(paymentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Searches for payment request details and prop pay types
     * @summary Find payment request balance details by request uuid.
     * @param {string} requestUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    getPaymentRequestBalanceDetails(requestUuid, options) {
        return exports.PaymentsApiFp(this.configuration).getPaymentRequestBalanceDetails(requestUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Searches for payment request details
     * @summary Find payment request details by request uuid.
     * @param {string} requestUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    getPaymentRequestDetails(requestUuid, options) {
        return exports.PaymentsApiFp(this.configuration).getPaymentRequestDetails(requestUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Replaces an autopayment schedule.
     * @param {string} autopayUid
     * @param {CreateScheduledAutoPayDto} createScheduledAutoPayDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    replaceAutoPayment(autopayUid, createScheduledAutoPayDto, options) {
        return exports.PaymentsApiFp(this.configuration).replaceAutoPayment(autopayUid, createScheduledAutoPayDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Resend payment request to a different email
     * @param {string} requestUuid
     * @param {ResendPaymentRequestDto} resendPaymentRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    resendPaymentRequest(requestUuid, resendPaymentRequestDto, options) {
        return exports.PaymentsApiFp(this.configuration).resendPaymentRequest(requestUuid, resendPaymentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Searches for payment requests with pagination
     * @summary Find payment requests by pm uuid.
     * @param {PaymentRequestSearchDTO} paymentRequestSearchDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    searchPaymentRequestsByPM(paymentRequestSearchDTO, options) {
        return exports.PaymentsApiFp(this.configuration).searchPaymentRequestsByPM(paymentRequestSearchDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Sets the skip value of this autopay.
     * @param {string} autopayUid
     * @param {UpdateSkipAPDto} updateSkipAPDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    setAutopaySkipSetting(autopayUid, updateSkipAPDto, options) {
        return exports.PaymentsApiFp(this.configuration).setAutopaySkipSetting(autopayUid, updateSkipAPDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a generic payer.
     * @param {string} payerUuid
     * @param {UpdateGenericPayerDto} updateGenericPayerDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    updateGenericPayer(payerUuid, updateGenericPayerDto, options) {
        return exports.PaymentsApiFp(this.configuration).updateGenericPayer(payerUuid, updateGenericPayerDto, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PaymentsApi = PaymentsApi;
/**
 * PmsApi - axios parameter creator
 * @export
 */
exports.PmsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary allows resident to cancel an eligible transaction
         * @param {string} uuid
         * @param {string} paymentUuid
         * @param {PaymentActionDto} paymentActionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPayment: (uuid, paymentUuid, paymentActionDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('cancelPayment', 'uuid', uuid);
            // verify required parameter 'paymentUuid' is not null or undefined
            common_1.assertParamExists('cancelPayment', 'paymentUuid', paymentUuid);
            // verify required parameter 'paymentActionDto' is not null or undefined
            common_1.assertParamExists('cancelPayment', 'paymentActionDto', paymentActionDto);
            const localVarPath = `/api/v1/pms/{uuid}/payments/{paymentUuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"paymentUuid"}}`, encodeURIComponent(String(paymentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(paymentActionDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Cancel a refund that has been previously approved by a pm but is yet to be processed
         * @param {string} uuid
         * @param {string} paymentUuid
         * @param {CancelRefundDto} cancelRefundDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRefund: (uuid, paymentUuid, cancelRefundDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('cancelRefund', 'uuid', uuid);
            // verify required parameter 'paymentUuid' is not null or undefined
            common_1.assertParamExists('cancelRefund', 'paymentUuid', paymentUuid);
            // verify required parameter 'cancelRefundDto' is not null or undefined
            common_1.assertParamExists('cancelRefund', 'cancelRefundDto', cancelRefundDto);
            const localVarPath = `/api/v1/pms/{uuid}/refunds/{paymentUuid}/cancel`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"paymentUuid"}}`, encodeURIComponent(String(paymentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(cancelRefundDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create new PM Staff
         * @param {string} uuid
         * @param {CreateCompleteCompanyStaffDto} createCompleteCompanyStaffDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPmStaff: (uuid, createCompleteCompanyStaffDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('createPmStaff', 'uuid', uuid);
            // verify required parameter 'createCompleteCompanyStaffDto' is not null or undefined
            common_1.assertParamExists('createPmStaff', 'createCompleteCompanyStaffDto', createCompleteCompanyStaffDto);
            const localVarPath = `/api/v1/pms/{uuid}/staff`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createCompleteCompanyStaffDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Creates a new software integration/portfolio
         * @param {string} uuid
         * @param {CreateSoftwareIntegrationDto} createSoftwareIntegrationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSoftwareIntegration: (uuid, createSoftwareIntegrationDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('createSoftwareIntegration', 'uuid', uuid);
            // verify required parameter 'createSoftwareIntegrationDto' is not null or undefined
            common_1.assertParamExists('createSoftwareIntegration', 'createSoftwareIntegrationDto', createSoftwareIntegrationDto);
            const localVarPath = `/api/v1/pms/{uuid}/integrations`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createSoftwareIntegrationDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete existing PM
         * @param {string} uuid
         * @param {string} pmUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableCompanyStaff: (uuid, pmUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('disableCompanyStaff', 'uuid', uuid);
            // verify required parameter 'pmUuid' is not null or undefined
            common_1.assertParamExists('disableCompanyStaff', 'pmUuid', pmUuid);
            const localVarPath = `/api/v1/pms/{uuid}/delete/{pmUuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"pmUuid"}}`, encodeURIComponent(String(pmUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Edit resident information
         * @summary Edit resident information
         * @param {string} uuid
         * @param {ResidentEditParamsDTO} residentEditParamsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAcceptedPaymentMethods: (uuid, residentEditParamsDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('editAcceptedPaymentMethods', 'uuid', uuid);
            // verify required parameter 'residentEditParamsDTO' is not null or undefined
            common_1.assertParamExists('editAcceptedPaymentMethods', 'residentEditParamsDTO', residentEditParamsDTO);
            const localVarPath = `/api/v1/pms/{uuid}/residents/paymentoptions`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(residentEditParamsDTO, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary export invoice Documents based on product type id
         * @param {string} uuid
         * @param {InvoiceFileType} invoiceFileType
         * @param {number} invoiceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportInvoiceDetails: (uuid, invoiceFileType, invoiceId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('exportInvoiceDetails', 'uuid', uuid);
            // verify required parameter 'invoiceFileType' is not null or undefined
            common_1.assertParamExists('exportInvoiceDetails', 'invoiceFileType', invoiceFileType);
            // verify required parameter 'invoiceId' is not null or undefined
            common_1.assertParamExists('exportInvoiceDetails', 'invoiceId', invoiceId);
            const localVarPath = `/api/v1/pms/{uuid}/invoices/{invoiceId}/files`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (invoiceFileType !== undefined) {
                localVarQueryParameter['InvoiceFileType'] = invoiceFileType;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary fetch all available bank accounts for this pm
         * @param {string} uuid
         * @param {boolean} [fundableOnly]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAvailableBankAccounts: (uuid, fundableOnly, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('fetchAvailableBankAccounts', 'uuid', uuid);
            const localVarPath = `/api/v1/pms/{uuid}/bankaccounts`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (fundableOnly !== undefined) {
                localVarQueryParameter['fundableOnly'] = fundableOnly;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchProductsPurchased: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('fetchProductsPurchased', 'uuid', uuid);
            const localVarPath = `/api/v1/pms/{uuid}/pricingplan`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get details of PM user by uuid
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOnePM: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('findOnePM', 'uuid', uuid);
            const localVarPath = `/api/v1/pms/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all associated pm staff for the current user. The association is derived from property groups
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssociatedCompanyStaff: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getAssociatedCompanyStaff', 'uuid', uuid);
            const localVarPath = `/api/v1/pms/{uuid}/staff`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns a boolean field in the response object indicating whether or not the transaction can be cancelled
         * @param {string} uuid
         * @param {string} paymentUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCancelEligibilityStatus: (uuid, paymentUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getCancelEligibilityStatus', 'uuid', uuid);
            // verify required parameter 'paymentUuid' is not null or undefined
            common_1.assertParamExists('getCancelEligibilityStatus', 'paymentUuid', paymentUuid);
            const localVarPath = `/api/v1/pms/{uuid}/payments/{paymentUuid}/status`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"paymentUuid"}}`, encodeURIComponent(String(paymentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get chargeback details including details of the payer
         * @param {string} uuid
         * @param {string} paymentUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChargebackDetails: (uuid, paymentUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getChargebackDetails', 'uuid', uuid);
            // verify required parameter 'paymentUuid' is not null or undefined
            common_1.assertParamExists('getChargebackDetails', 'paymentUuid', paymentUuid);
            const localVarPath = `/api/v1/pms/{uuid}/chargebacks/{paymentUuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"paymentUuid"}}`, encodeURIComponent(String(paymentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Fetch statistics for project manager dashboard
         * @param {string} uuid
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardData: (uuid, startDate, endDate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getDashboardData', 'uuid', uuid);
            const localVarPath = `/api/v1/pms/{uuid}/dashboardstats`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString() :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString() :
                    endDate;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get Existing Portfolios of a company
         * @param {string} uuid
         * @param {'INOSIO' | 'PROMAS' | 'TENANT_REPORTS'} [integrationType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExistingPortfolios: (uuid, integrationType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getExistingPortfolios', 'uuid', uuid);
            const localVarPath = `/api/v1/pms/{uuid}/integrations`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (integrationType !== undefined) {
                localVarQueryParameter['integrationType'] = integrationType;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the latest processor terms and conditions for property managers.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessorTermsConditions: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getProcessorTermsConditions', 'uuid', uuid);
            const localVarPath = `/api/v1/pms/{uuid}/terms/processor`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Find balance by resident uuid.
         * @param {string} uuid
         * @param {string} resUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResidentBalanceDetails: (uuid, resUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getResidentBalanceDetails', 'uuid', uuid);
            // verify required parameter 'resUuid' is not null or undefined
            common_1.assertParamExists('getResidentBalanceDetails', 'resUuid', resUuid);
            const localVarPath = `/api/v1/pms/{uuid}/residents/{resUuid}/balance`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"resUuid"}}`, encodeURIComponent(String(resUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get Payment Configs for resident resident
         * @param {string} uuid
         * @param {string} resUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResidentPaymentConfigs: (uuid, resUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getResidentPaymentConfigs', 'uuid', uuid);
            // verify required parameter 'resUuid' is not null or undefined
            common_1.assertParamExists('getResidentPaymentConfigs', 'resUuid', resUuid);
            const localVarPath = `/api/v1/pms/{uuid}/residents/{resUuid}/paymentconfigs`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"resUuid"}}`, encodeURIComponent(String(resUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Calculates fees for the configured payment methods, given the specified amount.
         * @param {string} uuid
         * @param {string} resUuid
         * @param {number} paymentAmount
         * @param {number} propertyPayTypeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResidentPaymentFees: (uuid, resUuid, paymentAmount, propertyPayTypeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getResidentPaymentFees', 'uuid', uuid);
            // verify required parameter 'resUuid' is not null or undefined
            common_1.assertParamExists('getResidentPaymentFees', 'resUuid', resUuid);
            // verify required parameter 'paymentAmount' is not null or undefined
            common_1.assertParamExists('getResidentPaymentFees', 'paymentAmount', paymentAmount);
            // verify required parameter 'propertyPayTypeId' is not null or undefined
            common_1.assertParamExists('getResidentPaymentFees', 'propertyPayTypeId', propertyPayTypeId);
            const localVarPath = `/api/v1/pms/{uuid}/residents/{resUuid}/fees`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"resUuid"}}`, encodeURIComponent(String(resUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (paymentAmount !== undefined) {
                localVarQueryParameter['paymentAmount'] = paymentAmount;
            }
            if (propertyPayTypeId !== undefined) {
                localVarQueryParameter['propertyPayTypeId'] = propertyPayTypeId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary fetch details of transaction for PM refund action
         * @param {string} uuid
         * @param {string} transactionUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionDetails: (uuid, transactionUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getTransactionDetails', 'uuid', uuid);
            // verify required parameter 'transactionUuid' is not null or undefined
            common_1.assertParamExists('getTransactionDetails', 'transactionUuid', transactionUuid);
            const localVarPath = `/api/v1/pms/{uuid}/transactions/{transactionUuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"transactionUuid"}}`, encodeURIComponent(String(transactionUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns transactions under a deposit Id
         * @param {string} uuid
         * @param {string} depositUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsByDepositId: (uuid, depositUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getTransactionsByDepositId', 'uuid', uuid);
            // verify required parameter 'depositUuid' is not null or undefined
            common_1.assertParamExists('getTransactionsByDepositId', 'depositUuid', depositUuid);
            const localVarPath = `/api/v1/pms/{uuid}/depositsdebits/{deposit_uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"deposit_uuid"}}`, encodeURIComponent(String(depositUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * The begin and end dates are both inclusive [startdate, enddate]
         * @summary Find deposits and debits by pm uuid.
         * @param {string} uuid
         * @param {DepositsSearchParamsDTO} depositsSearchParamsDTO
         * @param {'PDF' | 'CSV'} [exportAs]
         * @param {string} [fileName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDepositsDebitsByPM: (uuid, depositsSearchParamsDTO, exportAs, fileName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('searchDepositsDebitsByPM', 'uuid', uuid);
            // verify required parameter 'depositsSearchParamsDTO' is not null or undefined
            common_1.assertParamExists('searchDepositsDebitsByPM', 'depositsSearchParamsDTO', depositsSearchParamsDTO);
            const localVarPath = `/api/v1/pms/{uuid}/depositsdebits/search`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (exportAs !== undefined) {
                localVarQueryParameter['exportAs'] = exportAs;
            }
            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(depositsSearchParamsDTO, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * The begin and end dates are both inclusive [startdate, enddate]
         * @summary Find disbursements by pm uuid.
         * @param {string} uuid
         * @param {DisbursementSearchParamsDTO} disbursementSearchParamsDTO
         * @param {'PDF' | 'CSV'} [exportAs]
         * @param {string} [fileName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDisbursementsByPM: (uuid, disbursementSearchParamsDTO, exportAs, fileName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('searchDisbursementsByPM', 'uuid', uuid);
            // verify required parameter 'disbursementSearchParamsDTO' is not null or undefined
            common_1.assertParamExists('searchDisbursementsByPM', 'disbursementSearchParamsDTO', disbursementSearchParamsDTO);
            const localVarPath = `/api/v1/pms/{uuid}/disbursements/search`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (exportAs !== undefined) {
                localVarQueryParameter['exportAs'] = exportAs;
            }
            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(disbursementSearchParamsDTO, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary retrieve all invoices that match the specified search criteria
         * @param {string} uuid
         * @param {InvoiceSearchDto} invoiceSearchDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchInvoicesByPM: (uuid, invoiceSearchDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('searchInvoicesByPM', 'uuid', uuid);
            // verify required parameter 'invoiceSearchDto' is not null or undefined
            common_1.assertParamExists('searchInvoicesByPM', 'invoiceSearchDto', invoiceSearchDto);
            const localVarPath = `/api/v1/pms/{uuid}/invoices`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(invoiceSearchDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Find a payer in our db
         * @param {string} uuid
         * @param {PayerTypeSearchParamsDto} payerTypeSearchParamsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPayerByName: (uuid, payerTypeSearchParamsDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('searchPayerByName', 'uuid', uuid);
            // verify required parameter 'payerTypeSearchParamsDto' is not null or undefined
            common_1.assertParamExists('searchPayerByName', 'payerTypeSearchParamsDto', payerTypeSearchParamsDto);
            const localVarPath = `/api/v1/pms/{uuid}/payer/search`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(payerTypeSearchParamsDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Searches for user with pagination
         * @summary Searches for user by pm uuid.
         * @param {string} uuid
         * @param {PmSearchParamsDTO} pmSearchParamsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPms: (uuid, pmSearchParamsDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('searchPms', 'uuid', uuid);
            // verify required parameter 'pmSearchParamsDTO' is not null or undefined
            common_1.assertParamExists('searchPms', 'pmSearchParamsDTO', pmSearchParamsDTO);
            const localVarPath = `/api/v1/pms/{uuid}/staff/search`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(pmSearchParamsDTO, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Searches for property with pagination
         * @summary Find properties by pm uuid.
         * @param {string} uuid
         * @param {PropertySearchDTO} propertySearchDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPropertiesByPM: (uuid, propertySearchDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('searchPropertiesByPM', 'uuid', uuid);
            // verify required parameter 'propertySearchDTO' is not null or undefined
            common_1.assertParamExists('searchPropertiesByPM', 'propertySearchDTO', propertySearchDTO);
            const localVarPath = `/api/v1/pms/{uuid}/properties/search`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(propertySearchDTO, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Searches for residents with pagination
         * @summary Searches for residents by pm uuid.
         * @param {string} uuid
         * @param {ResidentSearchParamsDTO} residentSearchParamsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchResidentsByPM: (uuid, residentSearchParamsDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('searchResidentsByPM', 'uuid', uuid);
            // verify required parameter 'residentSearchParamsDTO' is not null or undefined
            common_1.assertParamExists('searchResidentsByPM', 'residentSearchParamsDTO', residentSearchParamsDTO);
            const localVarPath = `/api/v1/pms/{uuid}/residents/search`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(residentSearchParamsDTO, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * The begin and end dates are both inclusive [startdate, enddate]
         * @summary Find transactions by pm uuid.
         * @param {string} uuid
         * @param {TransactionSearchParamsDTO} transactionSearchParamsDTO
         * @param {'PDF' | 'CSV'} [exportAs]
         * @param {string} [fileName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTransactionsByPM: (uuid, transactionSearchParamsDTO, exportAs, fileName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('searchTransactionsByPM', 'uuid', uuid);
            // verify required parameter 'transactionSearchParamsDTO' is not null or undefined
            common_1.assertParamExists('searchTransactionsByPM', 'transactionSearchParamsDTO', transactionSearchParamsDTO);
            const localVarPath = `/api/v1/pms/{uuid}/transactions/search`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (exportAs !== undefined) {
                localVarQueryParameter['exportAs'] = exportAs;
            }
            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(transactionSearchParamsDTO, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary set the preferred invoicing bank account for pm company
         * @param {string} uuid
         * @param {InvoiceBankAccountConfigDto} invoiceBankAccountConfigDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setInvoiceBankAccount: (uuid, invoiceBankAccountConfigDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('setInvoiceBankAccount', 'uuid', uuid);
            // verify required parameter 'invoiceBankAccountConfigDto' is not null or undefined
            common_1.assertParamExists('setInvoiceBankAccount', 'invoiceBankAccountConfigDto', invoiceBankAccountConfigDto);
            const localVarPath = `/api/v1/pms/{uuid}/bankaccounts`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(invoiceBankAccountConfigDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Allows pm to accept or dispute a chargeback
         * @param {string} uuid
         * @param {string} paymentUuid
         * @param {PaymentActionDto} paymentActionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        takeChargebackAction: (uuid, paymentUuid, paymentActionDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('takeChargebackAction', 'uuid', uuid);
            // verify required parameter 'paymentUuid' is not null or undefined
            common_1.assertParamExists('takeChargebackAction', 'paymentUuid', paymentUuid);
            // verify required parameter 'paymentActionDto' is not null or undefined
            common_1.assertParamExists('takeChargebackAction', 'paymentActionDto', paymentActionDto);
            const localVarPath = `/api/v1/pms/{uuid}/chargebacks/{paymentUuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"paymentUuid"}}`, encodeURIComponent(String(paymentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(paymentActionDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Allows pm to accept or deny a pending refund request Or Adhoc a refund
         * @param {string} uuid
         * @param {string} paymentUuid
         * @param {PaymentActionDto} paymentActionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        takeRefundAction: (uuid, paymentUuid, paymentActionDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('takeRefundAction', 'uuid', uuid);
            // verify required parameter 'paymentUuid' is not null or undefined
            common_1.assertParamExists('takeRefundAction', 'paymentUuid', paymentUuid);
            // verify required parameter 'paymentActionDto' is not null or undefined
            common_1.assertParamExists('takeRefundAction', 'paymentActionDto', paymentActionDto);
            const localVarPath = `/api/v1/pms/{uuid}/refunds/{paymentUuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"paymentUuid"}}`, encodeURIComponent(String(paymentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(paymentActionDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update an Api Key
         * @param {string} uuid
         * @param {UpdateIntegrationApiKeyDto} updateIntegrationApiKeyDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiKey: (uuid, updateIntegrationApiKeyDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateApiKey', 'uuid', uuid);
            // verify required parameter 'updateIntegrationApiKeyDto' is not null or undefined
            common_1.assertParamExists('updateApiKey', 'updateIntegrationApiKeyDto', updateIntegrationApiKeyDto);
            const localVarPath = `/api/v1/pms/{uuid}/integrations`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateIntegrationApiKeyDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update details of existing PM
         * @param {string} uuid
         * @param {string} staffUuid
         * @param {UpdateCompleteCompanyStaffDto} updateCompleteCompanyStaffDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePmStaff: (uuid, staffUuid, updateCompleteCompanyStaffDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updatePmStaff', 'uuid', uuid);
            // verify required parameter 'staffUuid' is not null or undefined
            common_1.assertParamExists('updatePmStaff', 'staffUuid', staffUuid);
            // verify required parameter 'updateCompleteCompanyStaffDto' is not null or undefined
            common_1.assertParamExists('updatePmStaff', 'updateCompleteCompanyStaffDto', updateCompleteCompanyStaffDto);
            const localVarPath = `/api/v1/pms/{uuid}/update/{staff_uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"staff_uuid"}}`, encodeURIComponent(String(staffUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateCompleteCompanyStaffDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PmsApi - functional programming interface
 * @export
 */
exports.PmsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PmsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary allows resident to cancel an eligible transaction
         * @param {string} uuid
         * @param {string} paymentUuid
         * @param {PaymentActionDto} paymentActionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPayment(uuid, paymentUuid, paymentActionDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cancelPayment(uuid, paymentUuid, paymentActionDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Cancel a refund that has been previously approved by a pm but is yet to be processed
         * @param {string} uuid
         * @param {string} paymentUuid
         * @param {CancelRefundDto} cancelRefundDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRefund(uuid, paymentUuid, cancelRefundDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cancelRefund(uuid, paymentUuid, cancelRefundDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create new PM Staff
         * @param {string} uuid
         * @param {CreateCompleteCompanyStaffDto} createCompleteCompanyStaffDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPmStaff(uuid, createCompleteCompanyStaffDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createPmStaff(uuid, createCompleteCompanyStaffDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Creates a new software integration/portfolio
         * @param {string} uuid
         * @param {CreateSoftwareIntegrationDto} createSoftwareIntegrationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSoftwareIntegration(uuid, createSoftwareIntegrationDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createSoftwareIntegration(uuid, createSoftwareIntegrationDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete existing PM
         * @param {string} uuid
         * @param {string} pmUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableCompanyStaff(uuid, pmUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.disableCompanyStaff(uuid, pmUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Edit resident information
         * @summary Edit resident information
         * @param {string} uuid
         * @param {ResidentEditParamsDTO} residentEditParamsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAcceptedPaymentMethods(uuid, residentEditParamsDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.editAcceptedPaymentMethods(uuid, residentEditParamsDTO, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary export invoice Documents based on product type id
         * @param {string} uuid
         * @param {InvoiceFileType} invoiceFileType
         * @param {number} invoiceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportInvoiceDetails(uuid, invoiceFileType, invoiceId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.exportInvoiceDetails(uuid, invoiceFileType, invoiceId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary fetch all available bank accounts for this pm
         * @param {string} uuid
         * @param {boolean} [fundableOnly]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAvailableBankAccounts(uuid, fundableOnly, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchAvailableBankAccounts(uuid, fundableOnly, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchProductsPurchased(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchProductsPurchased(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get details of PM user by uuid
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOnePM(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.findOnePM(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all associated pm staff for the current user. The association is derived from property groups
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssociatedCompanyStaff(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAssociatedCompanyStaff(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns a boolean field in the response object indicating whether or not the transaction can be cancelled
         * @param {string} uuid
         * @param {string} paymentUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCancelEligibilityStatus(uuid, paymentUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCancelEligibilityStatus(uuid, paymentUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get chargeback details including details of the payer
         * @param {string} uuid
         * @param {string} paymentUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChargebackDetails(uuid, paymentUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getChargebackDetails(uuid, paymentUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Fetch statistics for project manager dashboard
         * @param {string} uuid
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardData(uuid, startDate, endDate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDashboardData(uuid, startDate, endDate, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get Existing Portfolios of a company
         * @param {string} uuid
         * @param {'INOSIO' | 'PROMAS' | 'TENANT_REPORTS'} [integrationType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExistingPortfolios(uuid, integrationType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getExistingPortfolios(uuid, integrationType, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get the latest processor terms and conditions for property managers.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessorTermsConditions(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProcessorTermsConditions(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Find balance by resident uuid.
         * @param {string} uuid
         * @param {string} resUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResidentBalanceDetails(uuid, resUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getResidentBalanceDetails(uuid, resUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get Payment Configs for resident resident
         * @param {string} uuid
         * @param {string} resUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResidentPaymentConfigs(uuid, resUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getResidentPaymentConfigs(uuid, resUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Calculates fees for the configured payment methods, given the specified amount.
         * @param {string} uuid
         * @param {string} resUuid
         * @param {number} paymentAmount
         * @param {number} propertyPayTypeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResidentPaymentFees(uuid, resUuid, paymentAmount, propertyPayTypeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getResidentPaymentFees(uuid, resUuid, paymentAmount, propertyPayTypeId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary fetch details of transaction for PM refund action
         * @param {string} uuid
         * @param {string} transactionUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionDetails(uuid, transactionUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTransactionDetails(uuid, transactionUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns transactions under a deposit Id
         * @param {string} uuid
         * @param {string} depositUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsByDepositId(uuid, depositUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTransactionsByDepositId(uuid, depositUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * The begin and end dates are both inclusive [startdate, enddate]
         * @summary Find deposits and debits by pm uuid.
         * @param {string} uuid
         * @param {DepositsSearchParamsDTO} depositsSearchParamsDTO
         * @param {'PDF' | 'CSV'} [exportAs]
         * @param {string} [fileName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDepositsDebitsByPM(uuid, depositsSearchParamsDTO, exportAs, fileName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchDepositsDebitsByPM(uuid, depositsSearchParamsDTO, exportAs, fileName, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * The begin and end dates are both inclusive [startdate, enddate]
         * @summary Find disbursements by pm uuid.
         * @param {string} uuid
         * @param {DisbursementSearchParamsDTO} disbursementSearchParamsDTO
         * @param {'PDF' | 'CSV'} [exportAs]
         * @param {string} [fileName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDisbursementsByPM(uuid, disbursementSearchParamsDTO, exportAs, fileName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchDisbursementsByPM(uuid, disbursementSearchParamsDTO, exportAs, fileName, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary retrieve all invoices that match the specified search criteria
         * @param {string} uuid
         * @param {InvoiceSearchDto} invoiceSearchDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchInvoicesByPM(uuid, invoiceSearchDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchInvoicesByPM(uuid, invoiceSearchDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Find a payer in our db
         * @param {string} uuid
         * @param {PayerTypeSearchParamsDto} payerTypeSearchParamsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPayerByName(uuid, payerTypeSearchParamsDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchPayerByName(uuid, payerTypeSearchParamsDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Searches for user with pagination
         * @summary Searches for user by pm uuid.
         * @param {string} uuid
         * @param {PmSearchParamsDTO} pmSearchParamsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPms(uuid, pmSearchParamsDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchPms(uuid, pmSearchParamsDTO, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Searches for property with pagination
         * @summary Find properties by pm uuid.
         * @param {string} uuid
         * @param {PropertySearchDTO} propertySearchDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPropertiesByPM(uuid, propertySearchDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchPropertiesByPM(uuid, propertySearchDTO, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Searches for residents with pagination
         * @summary Searches for residents by pm uuid.
         * @param {string} uuid
         * @param {ResidentSearchParamsDTO} residentSearchParamsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchResidentsByPM(uuid, residentSearchParamsDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchResidentsByPM(uuid, residentSearchParamsDTO, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * The begin and end dates are both inclusive [startdate, enddate]
         * @summary Find transactions by pm uuid.
         * @param {string} uuid
         * @param {TransactionSearchParamsDTO} transactionSearchParamsDTO
         * @param {'PDF' | 'CSV'} [exportAs]
         * @param {string} [fileName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTransactionsByPM(uuid, transactionSearchParamsDTO, exportAs, fileName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchTransactionsByPM(uuid, transactionSearchParamsDTO, exportAs, fileName, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary set the preferred invoicing bank account for pm company
         * @param {string} uuid
         * @param {InvoiceBankAccountConfigDto} invoiceBankAccountConfigDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setInvoiceBankAccount(uuid, invoiceBankAccountConfigDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setInvoiceBankAccount(uuid, invoiceBankAccountConfigDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Allows pm to accept or dispute a chargeback
         * @param {string} uuid
         * @param {string} paymentUuid
         * @param {PaymentActionDto} paymentActionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        takeChargebackAction(uuid, paymentUuid, paymentActionDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.takeChargebackAction(uuid, paymentUuid, paymentActionDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Allows pm to accept or deny a pending refund request Or Adhoc a refund
         * @param {string} uuid
         * @param {string} paymentUuid
         * @param {PaymentActionDto} paymentActionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        takeRefundAction(uuid, paymentUuid, paymentActionDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.takeRefundAction(uuid, paymentUuid, paymentActionDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update an Api Key
         * @param {string} uuid
         * @param {UpdateIntegrationApiKeyDto} updateIntegrationApiKeyDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiKey(uuid, updateIntegrationApiKeyDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateApiKey(uuid, updateIntegrationApiKeyDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update details of existing PM
         * @param {string} uuid
         * @param {string} staffUuid
         * @param {UpdateCompleteCompanyStaffDto} updateCompleteCompanyStaffDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePmStaff(uuid, staffUuid, updateCompleteCompanyStaffDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePmStaff(uuid, staffUuid, updateCompleteCompanyStaffDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PmsApi - factory interface
 * @export
 */
exports.PmsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PmsApiFp(configuration);
    return {
        /**
         *
         * @summary allows resident to cancel an eligible transaction
         * @param {string} uuid
         * @param {string} paymentUuid
         * @param {PaymentActionDto} paymentActionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPayment(uuid, paymentUuid, paymentActionDto, options) {
            return localVarFp.cancelPayment(uuid, paymentUuid, paymentActionDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Cancel a refund that has been previously approved by a pm but is yet to be processed
         * @param {string} uuid
         * @param {string} paymentUuid
         * @param {CancelRefundDto} cancelRefundDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRefund(uuid, paymentUuid, cancelRefundDto, options) {
            return localVarFp.cancelRefund(uuid, paymentUuid, cancelRefundDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create new PM Staff
         * @param {string} uuid
         * @param {CreateCompleteCompanyStaffDto} createCompleteCompanyStaffDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPmStaff(uuid, createCompleteCompanyStaffDto, options) {
            return localVarFp.createPmStaff(uuid, createCompleteCompanyStaffDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Creates a new software integration/portfolio
         * @param {string} uuid
         * @param {CreateSoftwareIntegrationDto} createSoftwareIntegrationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSoftwareIntegration(uuid, createSoftwareIntegrationDto, options) {
            return localVarFp.createSoftwareIntegration(uuid, createSoftwareIntegrationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete existing PM
         * @param {string} uuid
         * @param {string} pmUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableCompanyStaff(uuid, pmUuid, options) {
            return localVarFp.disableCompanyStaff(uuid, pmUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit resident information
         * @summary Edit resident information
         * @param {string} uuid
         * @param {ResidentEditParamsDTO} residentEditParamsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAcceptedPaymentMethods(uuid, residentEditParamsDTO, options) {
            return localVarFp.editAcceptedPaymentMethods(uuid, residentEditParamsDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary export invoice Documents based on product type id
         * @param {string} uuid
         * @param {InvoiceFileType} invoiceFileType
         * @param {number} invoiceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportInvoiceDetails(uuid, invoiceFileType, invoiceId, options) {
            return localVarFp.exportInvoiceDetails(uuid, invoiceFileType, invoiceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary fetch all available bank accounts for this pm
         * @param {string} uuid
         * @param {boolean} [fundableOnly]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAvailableBankAccounts(uuid, fundableOnly, options) {
            return localVarFp.fetchAvailableBankAccounts(uuid, fundableOnly, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchProductsPurchased(uuid, options) {
            return localVarFp.fetchProductsPurchased(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get details of PM user by uuid
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOnePM(uuid, options) {
            return localVarFp.findOnePM(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all associated pm staff for the current user. The association is derived from property groups
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssociatedCompanyStaff(uuid, options) {
            return localVarFp.getAssociatedCompanyStaff(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns a boolean field in the response object indicating whether or not the transaction can be cancelled
         * @param {string} uuid
         * @param {string} paymentUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCancelEligibilityStatus(uuid, paymentUuid, options) {
            return localVarFp.getCancelEligibilityStatus(uuid, paymentUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get chargeback details including details of the payer
         * @param {string} uuid
         * @param {string} paymentUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChargebackDetails(uuid, paymentUuid, options) {
            return localVarFp.getChargebackDetails(uuid, paymentUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Fetch statistics for project manager dashboard
         * @param {string} uuid
         * @param {string} [startDate]
         * @param {string} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardData(uuid, startDate, endDate, options) {
            return localVarFp.getDashboardData(uuid, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Existing Portfolios of a company
         * @param {string} uuid
         * @param {'INOSIO' | 'PROMAS' | 'TENANT_REPORTS'} [integrationType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExistingPortfolios(uuid, integrationType, options) {
            return localVarFp.getExistingPortfolios(uuid, integrationType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the latest processor terms and conditions for property managers.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessorTermsConditions(uuid, options) {
            return localVarFp.getProcessorTermsConditions(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Find balance by resident uuid.
         * @param {string} uuid
         * @param {string} resUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResidentBalanceDetails(uuid, resUuid, options) {
            return localVarFp.getResidentBalanceDetails(uuid, resUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Payment Configs for resident resident
         * @param {string} uuid
         * @param {string} resUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResidentPaymentConfigs(uuid, resUuid, options) {
            return localVarFp.getResidentPaymentConfigs(uuid, resUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Calculates fees for the configured payment methods, given the specified amount.
         * @param {string} uuid
         * @param {string} resUuid
         * @param {number} paymentAmount
         * @param {number} propertyPayTypeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResidentPaymentFees(uuid, resUuid, paymentAmount, propertyPayTypeId, options) {
            return localVarFp.getResidentPaymentFees(uuid, resUuid, paymentAmount, propertyPayTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary fetch details of transaction for PM refund action
         * @param {string} uuid
         * @param {string} transactionUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionDetails(uuid, transactionUuid, options) {
            return localVarFp.getTransactionDetails(uuid, transactionUuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns transactions under a deposit Id
         * @param {string} uuid
         * @param {string} depositUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsByDepositId(uuid, depositUuid, options) {
            return localVarFp.getTransactionsByDepositId(uuid, depositUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * The begin and end dates are both inclusive [startdate, enddate]
         * @summary Find deposits and debits by pm uuid.
         * @param {string} uuid
         * @param {DepositsSearchParamsDTO} depositsSearchParamsDTO
         * @param {'PDF' | 'CSV'} [exportAs]
         * @param {string} [fileName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDepositsDebitsByPM(uuid, depositsSearchParamsDTO, exportAs, fileName, options) {
            return localVarFp.searchDepositsDebitsByPM(uuid, depositsSearchParamsDTO, exportAs, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * The begin and end dates are both inclusive [startdate, enddate]
         * @summary Find disbursements by pm uuid.
         * @param {string} uuid
         * @param {DisbursementSearchParamsDTO} disbursementSearchParamsDTO
         * @param {'PDF' | 'CSV'} [exportAs]
         * @param {string} [fileName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDisbursementsByPM(uuid, disbursementSearchParamsDTO, exportAs, fileName, options) {
            return localVarFp.searchDisbursementsByPM(uuid, disbursementSearchParamsDTO, exportAs, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary retrieve all invoices that match the specified search criteria
         * @param {string} uuid
         * @param {InvoiceSearchDto} invoiceSearchDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchInvoicesByPM(uuid, invoiceSearchDto, options) {
            return localVarFp.searchInvoicesByPM(uuid, invoiceSearchDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Find a payer in our db
         * @param {string} uuid
         * @param {PayerTypeSearchParamsDto} payerTypeSearchParamsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPayerByName(uuid, payerTypeSearchParamsDto, options) {
            return localVarFp.searchPayerByName(uuid, payerTypeSearchParamsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Searches for user with pagination
         * @summary Searches for user by pm uuid.
         * @param {string} uuid
         * @param {PmSearchParamsDTO} pmSearchParamsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPms(uuid, pmSearchParamsDTO, options) {
            return localVarFp.searchPms(uuid, pmSearchParamsDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Searches for property with pagination
         * @summary Find properties by pm uuid.
         * @param {string} uuid
         * @param {PropertySearchDTO} propertySearchDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPropertiesByPM(uuid, propertySearchDTO, options) {
            return localVarFp.searchPropertiesByPM(uuid, propertySearchDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Searches for residents with pagination
         * @summary Searches for residents by pm uuid.
         * @param {string} uuid
         * @param {ResidentSearchParamsDTO} residentSearchParamsDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchResidentsByPM(uuid, residentSearchParamsDTO, options) {
            return localVarFp.searchResidentsByPM(uuid, residentSearchParamsDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * The begin and end dates are both inclusive [startdate, enddate]
         * @summary Find transactions by pm uuid.
         * @param {string} uuid
         * @param {TransactionSearchParamsDTO} transactionSearchParamsDTO
         * @param {'PDF' | 'CSV'} [exportAs]
         * @param {string} [fileName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTransactionsByPM(uuid, transactionSearchParamsDTO, exportAs, fileName, options) {
            return localVarFp.searchTransactionsByPM(uuid, transactionSearchParamsDTO, exportAs, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary set the preferred invoicing bank account for pm company
         * @param {string} uuid
         * @param {InvoiceBankAccountConfigDto} invoiceBankAccountConfigDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setInvoiceBankAccount(uuid, invoiceBankAccountConfigDto, options) {
            return localVarFp.setInvoiceBankAccount(uuid, invoiceBankAccountConfigDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Allows pm to accept or dispute a chargeback
         * @param {string} uuid
         * @param {string} paymentUuid
         * @param {PaymentActionDto} paymentActionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        takeChargebackAction(uuid, paymentUuid, paymentActionDto, options) {
            return localVarFp.takeChargebackAction(uuid, paymentUuid, paymentActionDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Allows pm to accept or deny a pending refund request Or Adhoc a refund
         * @param {string} uuid
         * @param {string} paymentUuid
         * @param {PaymentActionDto} paymentActionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        takeRefundAction(uuid, paymentUuid, paymentActionDto, options) {
            return localVarFp.takeRefundAction(uuid, paymentUuid, paymentActionDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an Api Key
         * @param {string} uuid
         * @param {UpdateIntegrationApiKeyDto} updateIntegrationApiKeyDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiKey(uuid, updateIntegrationApiKeyDto, options) {
            return localVarFp.updateApiKey(uuid, updateIntegrationApiKeyDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update details of existing PM
         * @param {string} uuid
         * @param {string} staffUuid
         * @param {UpdateCompleteCompanyStaffDto} updateCompleteCompanyStaffDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePmStaff(uuid, staffUuid, updateCompleteCompanyStaffDto, options) {
            return localVarFp.updatePmStaff(uuid, staffUuid, updateCompleteCompanyStaffDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PmsApi - object-oriented interface
 * @export
 * @class PmsApi
 * @extends {BaseAPI}
 */
class PmsApi extends base_1.BaseAPI {
    /**
     *
     * @summary allows resident to cancel an eligible transaction
     * @param {string} uuid
     * @param {string} paymentUuid
     * @param {PaymentActionDto} paymentActionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    cancelPayment(uuid, paymentUuid, paymentActionDto, options) {
        return exports.PmsApiFp(this.configuration).cancelPayment(uuid, paymentUuid, paymentActionDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Cancel a refund that has been previously approved by a pm but is yet to be processed
     * @param {string} uuid
     * @param {string} paymentUuid
     * @param {CancelRefundDto} cancelRefundDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    cancelRefund(uuid, paymentUuid, cancelRefundDto, options) {
        return exports.PmsApiFp(this.configuration).cancelRefund(uuid, paymentUuid, cancelRefundDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create new PM Staff
     * @param {string} uuid
     * @param {CreateCompleteCompanyStaffDto} createCompleteCompanyStaffDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    createPmStaff(uuid, createCompleteCompanyStaffDto, options) {
        return exports.PmsApiFp(this.configuration).createPmStaff(uuid, createCompleteCompanyStaffDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Creates a new software integration/portfolio
     * @param {string} uuid
     * @param {CreateSoftwareIntegrationDto} createSoftwareIntegrationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    createSoftwareIntegration(uuid, createSoftwareIntegrationDto, options) {
        return exports.PmsApiFp(this.configuration).createSoftwareIntegration(uuid, createSoftwareIntegrationDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete existing PM
     * @param {string} uuid
     * @param {string} pmUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    disableCompanyStaff(uuid, pmUuid, options) {
        return exports.PmsApiFp(this.configuration).disableCompanyStaff(uuid, pmUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Edit resident information
     * @summary Edit resident information
     * @param {string} uuid
     * @param {ResidentEditParamsDTO} residentEditParamsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    editAcceptedPaymentMethods(uuid, residentEditParamsDTO, options) {
        return exports.PmsApiFp(this.configuration).editAcceptedPaymentMethods(uuid, residentEditParamsDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary export invoice Documents based on product type id
     * @param {string} uuid
     * @param {InvoiceFileType} invoiceFileType
     * @param {number} invoiceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    exportInvoiceDetails(uuid, invoiceFileType, invoiceId, options) {
        return exports.PmsApiFp(this.configuration).exportInvoiceDetails(uuid, invoiceFileType, invoiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary fetch all available bank accounts for this pm
     * @param {string} uuid
     * @param {boolean} [fundableOnly]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    fetchAvailableBankAccounts(uuid, fundableOnly, options) {
        return exports.PmsApiFp(this.configuration).fetchAvailableBankAccounts(uuid, fundableOnly, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    fetchProductsPurchased(uuid, options) {
        return exports.PmsApiFp(this.configuration).fetchProductsPurchased(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get details of PM user by uuid
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    findOnePM(uuid, options) {
        return exports.PmsApiFp(this.configuration).findOnePM(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all associated pm staff for the current user. The association is derived from property groups
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    getAssociatedCompanyStaff(uuid, options) {
        return exports.PmsApiFp(this.configuration).getAssociatedCompanyStaff(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns a boolean field in the response object indicating whether or not the transaction can be cancelled
     * @param {string} uuid
     * @param {string} paymentUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    getCancelEligibilityStatus(uuid, paymentUuid, options) {
        return exports.PmsApiFp(this.configuration).getCancelEligibilityStatus(uuid, paymentUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get chargeback details including details of the payer
     * @param {string} uuid
     * @param {string} paymentUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    getChargebackDetails(uuid, paymentUuid, options) {
        return exports.PmsApiFp(this.configuration).getChargebackDetails(uuid, paymentUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Fetch statistics for project manager dashboard
     * @param {string} uuid
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    getDashboardData(uuid, startDate, endDate, options) {
        return exports.PmsApiFp(this.configuration).getDashboardData(uuid, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Existing Portfolios of a company
     * @param {string} uuid
     * @param {'INOSIO' | 'PROMAS' | 'TENANT_REPORTS'} [integrationType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    getExistingPortfolios(uuid, integrationType, options) {
        return exports.PmsApiFp(this.configuration).getExistingPortfolios(uuid, integrationType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the latest processor terms and conditions for property managers.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    getProcessorTermsConditions(uuid, options) {
        return exports.PmsApiFp(this.configuration).getProcessorTermsConditions(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Find balance by resident uuid.
     * @param {string} uuid
     * @param {string} resUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    getResidentBalanceDetails(uuid, resUuid, options) {
        return exports.PmsApiFp(this.configuration).getResidentBalanceDetails(uuid, resUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Payment Configs for resident resident
     * @param {string} uuid
     * @param {string} resUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    getResidentPaymentConfigs(uuid, resUuid, options) {
        return exports.PmsApiFp(this.configuration).getResidentPaymentConfigs(uuid, resUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Calculates fees for the configured payment methods, given the specified amount.
     * @param {string} uuid
     * @param {string} resUuid
     * @param {number} paymentAmount
     * @param {number} propertyPayTypeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    getResidentPaymentFees(uuid, resUuid, paymentAmount, propertyPayTypeId, options) {
        return exports.PmsApiFp(this.configuration).getResidentPaymentFees(uuid, resUuid, paymentAmount, propertyPayTypeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary fetch details of transaction for PM refund action
     * @param {string} uuid
     * @param {string} transactionUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    getTransactionDetails(uuid, transactionUuid, options) {
        return exports.PmsApiFp(this.configuration).getTransactionDetails(uuid, transactionUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns transactions under a deposit Id
     * @param {string} uuid
     * @param {string} depositUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    getTransactionsByDepositId(uuid, depositUuid, options) {
        return exports.PmsApiFp(this.configuration).getTransactionsByDepositId(uuid, depositUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * The begin and end dates are both inclusive [startdate, enddate]
     * @summary Find deposits and debits by pm uuid.
     * @param {string} uuid
     * @param {DepositsSearchParamsDTO} depositsSearchParamsDTO
     * @param {'PDF' | 'CSV'} [exportAs]
     * @param {string} [fileName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    searchDepositsDebitsByPM(uuid, depositsSearchParamsDTO, exportAs, fileName, options) {
        return exports.PmsApiFp(this.configuration).searchDepositsDebitsByPM(uuid, depositsSearchParamsDTO, exportAs, fileName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * The begin and end dates are both inclusive [startdate, enddate]
     * @summary Find disbursements by pm uuid.
     * @param {string} uuid
     * @param {DisbursementSearchParamsDTO} disbursementSearchParamsDTO
     * @param {'PDF' | 'CSV'} [exportAs]
     * @param {string} [fileName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    searchDisbursementsByPM(uuid, disbursementSearchParamsDTO, exportAs, fileName, options) {
        return exports.PmsApiFp(this.configuration).searchDisbursementsByPM(uuid, disbursementSearchParamsDTO, exportAs, fileName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary retrieve all invoices that match the specified search criteria
     * @param {string} uuid
     * @param {InvoiceSearchDto} invoiceSearchDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    searchInvoicesByPM(uuid, invoiceSearchDto, options) {
        return exports.PmsApiFp(this.configuration).searchInvoicesByPM(uuid, invoiceSearchDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Find a payer in our db
     * @param {string} uuid
     * @param {PayerTypeSearchParamsDto} payerTypeSearchParamsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    searchPayerByName(uuid, payerTypeSearchParamsDto, options) {
        return exports.PmsApiFp(this.configuration).searchPayerByName(uuid, payerTypeSearchParamsDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Searches for user with pagination
     * @summary Searches for user by pm uuid.
     * @param {string} uuid
     * @param {PmSearchParamsDTO} pmSearchParamsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    searchPms(uuid, pmSearchParamsDTO, options) {
        return exports.PmsApiFp(this.configuration).searchPms(uuid, pmSearchParamsDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Searches for property with pagination
     * @summary Find properties by pm uuid.
     * @param {string} uuid
     * @param {PropertySearchDTO} propertySearchDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    searchPropertiesByPM(uuid, propertySearchDTO, options) {
        return exports.PmsApiFp(this.configuration).searchPropertiesByPM(uuid, propertySearchDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Searches for residents with pagination
     * @summary Searches for residents by pm uuid.
     * @param {string} uuid
     * @param {ResidentSearchParamsDTO} residentSearchParamsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    searchResidentsByPM(uuid, residentSearchParamsDTO, options) {
        return exports.PmsApiFp(this.configuration).searchResidentsByPM(uuid, residentSearchParamsDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * The begin and end dates are both inclusive [startdate, enddate]
     * @summary Find transactions by pm uuid.
     * @param {string} uuid
     * @param {TransactionSearchParamsDTO} transactionSearchParamsDTO
     * @param {'PDF' | 'CSV'} [exportAs]
     * @param {string} [fileName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    searchTransactionsByPM(uuid, transactionSearchParamsDTO, exportAs, fileName, options) {
        return exports.PmsApiFp(this.configuration).searchTransactionsByPM(uuid, transactionSearchParamsDTO, exportAs, fileName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary set the preferred invoicing bank account for pm company
     * @param {string} uuid
     * @param {InvoiceBankAccountConfigDto} invoiceBankAccountConfigDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    setInvoiceBankAccount(uuid, invoiceBankAccountConfigDto, options) {
        return exports.PmsApiFp(this.configuration).setInvoiceBankAccount(uuid, invoiceBankAccountConfigDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Allows pm to accept or dispute a chargeback
     * @param {string} uuid
     * @param {string} paymentUuid
     * @param {PaymentActionDto} paymentActionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    takeChargebackAction(uuid, paymentUuid, paymentActionDto, options) {
        return exports.PmsApiFp(this.configuration).takeChargebackAction(uuid, paymentUuid, paymentActionDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Allows pm to accept or deny a pending refund request Or Adhoc a refund
     * @param {string} uuid
     * @param {string} paymentUuid
     * @param {PaymentActionDto} paymentActionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    takeRefundAction(uuid, paymentUuid, paymentActionDto, options) {
        return exports.PmsApiFp(this.configuration).takeRefundAction(uuid, paymentUuid, paymentActionDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an Api Key
     * @param {string} uuid
     * @param {UpdateIntegrationApiKeyDto} updateIntegrationApiKeyDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    updateApiKey(uuid, updateIntegrationApiKeyDto, options) {
        return exports.PmsApiFp(this.configuration).updateApiKey(uuid, updateIntegrationApiKeyDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update details of existing PM
     * @param {string} uuid
     * @param {string} staffUuid
     * @param {UpdateCompleteCompanyStaffDto} updateCompleteCompanyStaffDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PmsApi
     */
    updatePmStaff(uuid, staffUuid, updateCompleteCompanyStaffDto, options) {
        return exports.PmsApiFp(this.configuration).updatePmStaff(uuid, staffUuid, updateCompleteCompanyStaffDto, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PmsApi = PmsApi;
/**
 * PropertiesApi - axios parameter creator
 * @export
 */
exports.PropertiesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Searches for properties by address.
         * @param {SearchPropertiesByAddressDto} searchPropertiesByAddressDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProperties: (searchPropertiesByAddressDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchPropertiesByAddressDto' is not null or undefined
            common_1.assertParamExists('searchProperties', 'searchPropertiesByAddressDto', searchPropertiesByAddressDto);
            const localVarPath = `/api/v1/properties/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(searchPropertiesByAddressDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PropertiesApi - functional programming interface
 * @export
 */
exports.PropertiesApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PropertiesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Searches for properties by address.
         * @param {SearchPropertiesByAddressDto} searchPropertiesByAddressDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProperties(searchPropertiesByAddressDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchProperties(searchPropertiesByAddressDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PropertiesApi - factory interface
 * @export
 */
exports.PropertiesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PropertiesApiFp(configuration);
    return {
        /**
         *
         * @summary Searches for properties by address.
         * @param {SearchPropertiesByAddressDto} searchPropertiesByAddressDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProperties(searchPropertiesByAddressDto, options) {
            return localVarFp.searchProperties(searchPropertiesByAddressDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PropertiesApi - object-oriented interface
 * @export
 * @class PropertiesApi
 * @extends {BaseAPI}
 */
class PropertiesApi extends base_1.BaseAPI {
    /**
     *
     * @summary Searches for properties by address.
     * @param {SearchPropertiesByAddressDto} searchPropertiesByAddressDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApi
     */
    searchProperties(searchPropertiesByAddressDto, options) {
        return exports.PropertiesApiFp(this.configuration).searchProperties(searchPropertiesByAddressDto, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PropertiesApi = PropertiesApi;
/**
 * PropertyGroupsApi - axios parameter creator
 * @export
 */
exports.PropertyGroupsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Creates a new property group
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyGroup: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('createPropertyGroup', 'uuid', uuid);
            const localVarPath = `/api/v1/propertygroups`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Creates a new sender identity for a property group
         * @param {string} uuid
         * @param {CreateSenderIdentityDto} createSenderIdentityDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyGroupSenderIdentity: (uuid, createSenderIdentityDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('createPropertyGroupSenderIdentity', 'uuid', uuid);
            // verify required parameter 'createSenderIdentityDto' is not null or undefined
            common_1.assertParamExists('createPropertyGroupSenderIdentity', 'createSenderIdentityDto', createSenderIdentityDto);
            const localVarPath = `/api/v1/propertygroups/{uuid}/sender_identities`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createSenderIdentityDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * delete sender identity
         * @summary delete a sender identity
         * @param {string} uuid
         * @param {string} senderIdentityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyGroupSenderIdentity: (uuid, senderIdentityId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('deletePropertyGroupSenderIdentity', 'uuid', uuid);
            // verify required parameter 'senderIdentityId' is not null or undefined
            common_1.assertParamExists('deletePropertyGroupSenderIdentity', 'senderIdentityId', senderIdentityId);
            const localVarPath = `/api/v1/propertygroups/{uuid}/sender_identities/{senderIdentityId}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"senderIdentityId"}}`, encodeURIComponent(String(senderIdentityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets all property groups the token has access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPropertyGroups: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v1/propertygroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Useful so PMs can see what their current configs are and change them on the UI.
         * @summary Gets the property group configs at the most granular level for all property groups this token has access to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPropertyGroupsConfigs: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v1/propertygroups/configs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets property group details. If valid token is provided, additional details and returned.
         * @param {string} uuid
         * @param {Array<string>} [productTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertyGroup: (uuid, productTypeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getPropertyGroup', 'uuid', uuid);
            const localVarPath = `/api/v1/propertygroups/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (productTypeId) {
                localVarQueryParameter['productTypeId'] = productTypeId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets sender identities for a property group
         * @param {string} uuid
         * @param {SearchSenderIdentityDto} searchSenderIdentityDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertyGroupSenderIdentities: (uuid, searchSenderIdentityDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getPropertyGroupSenderIdentities', 'uuid', uuid);
            // verify required parameter 'searchSenderIdentityDto' is not null or undefined
            common_1.assertParamExists('getPropertyGroupSenderIdentities', 'searchSenderIdentityDto', searchSenderIdentityDto);
            const localVarPath = `/api/v1/propertygroups/{uuid}/sender_identities/search`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(searchSenderIdentityDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets staff members of a property group
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertyGroupStaff: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getPropertyGroupStaff', 'uuid', uuid);
            const localVarPath = `/api/v1/propertygroups/{uuid}/staff`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Updates a property group configs
         * @param {string} uuid
         * @param {number} productTypeId
         * @param {boolean} setToDefault
         * @param {AssignedConfigsDto} assignedConfigsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePropertyGroupConfigs: (uuid, productTypeId, setToDefault, assignedConfigsDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updatePropertyGroupConfigs', 'uuid', uuid);
            // verify required parameter 'productTypeId' is not null or undefined
            common_1.assertParamExists('updatePropertyGroupConfigs', 'productTypeId', productTypeId);
            // verify required parameter 'setToDefault' is not null or undefined
            common_1.assertParamExists('updatePropertyGroupConfigs', 'setToDefault', setToDefault);
            // verify required parameter 'assignedConfigsDto' is not null or undefined
            common_1.assertParamExists('updatePropertyGroupConfigs', 'assignedConfigsDto', assignedConfigsDto);
            const localVarPath = `/api/v1/propertygroups/{uuid}/configs`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (productTypeId !== undefined) {
                localVarQueryParameter['productTypeId'] = productTypeId;
            }
            if (setToDefault !== undefined) {
                localVarQueryParameter['setToDefault'] = setToDefault;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(assignedConfigsDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PropertyGroupsApi - functional programming interface
 * @export
 */
exports.PropertyGroupsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PropertyGroupsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Creates a new property group
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyGroup(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createPropertyGroup(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Creates a new sender identity for a property group
         * @param {string} uuid
         * @param {CreateSenderIdentityDto} createSenderIdentityDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyGroupSenderIdentity(uuid, createSenderIdentityDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createPropertyGroupSenderIdentity(uuid, createSenderIdentityDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * delete sender identity
         * @summary delete a sender identity
         * @param {string} uuid
         * @param {string} senderIdentityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyGroupSenderIdentity(uuid, senderIdentityId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deletePropertyGroupSenderIdentity(uuid, senderIdentityId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets all property groups the token has access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPropertyGroups(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllPropertyGroups(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Useful so PMs can see what their current configs are and change them on the UI.
         * @summary Gets the property group configs at the most granular level for all property groups this token has access to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPropertyGroupsConfigs(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllPropertyGroupsConfigs(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets property group details. If valid token is provided, additional details and returned.
         * @param {string} uuid
         * @param {Array<string>} [productTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertyGroup(uuid, productTypeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPropertyGroup(uuid, productTypeId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets sender identities for a property group
         * @param {string} uuid
         * @param {SearchSenderIdentityDto} searchSenderIdentityDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertyGroupSenderIdentities(uuid, searchSenderIdentityDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPropertyGroupSenderIdentities(uuid, searchSenderIdentityDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets staff members of a property group
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertyGroupStaff(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPropertyGroupStaff(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Updates a property group configs
         * @param {string} uuid
         * @param {number} productTypeId
         * @param {boolean} setToDefault
         * @param {AssignedConfigsDto} assignedConfigsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePropertyGroupConfigs(uuid, productTypeId, setToDefault, assignedConfigsDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePropertyGroupConfigs(uuid, productTypeId, setToDefault, assignedConfigsDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PropertyGroupsApi - factory interface
 * @export
 */
exports.PropertyGroupsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PropertyGroupsApiFp(configuration);
    return {
        /**
         *
         * @summary Creates a new property group
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyGroup(uuid, options) {
            return localVarFp.createPropertyGroup(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Creates a new sender identity for a property group
         * @param {string} uuid
         * @param {CreateSenderIdentityDto} createSenderIdentityDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyGroupSenderIdentity(uuid, createSenderIdentityDto, options) {
            return localVarFp.createPropertyGroupSenderIdentity(uuid, createSenderIdentityDto, options).then((request) => request(axios, basePath));
        },
        /**
         * delete sender identity
         * @summary delete a sender identity
         * @param {string} uuid
         * @param {string} senderIdentityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyGroupSenderIdentity(uuid, senderIdentityId, options) {
            return localVarFp.deletePropertyGroupSenderIdentity(uuid, senderIdentityId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets all property groups the token has access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPropertyGroups(options) {
            return localVarFp.getAllPropertyGroups(options).then((request) => request(axios, basePath));
        },
        /**
         * Useful so PMs can see what their current configs are and change them on the UI.
         * @summary Gets the property group configs at the most granular level for all property groups this token has access to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPropertyGroupsConfigs(options) {
            return localVarFp.getAllPropertyGroupsConfigs(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets property group details. If valid token is provided, additional details and returned.
         * @param {string} uuid
         * @param {Array<string>} [productTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertyGroup(uuid, productTypeId, options) {
            return localVarFp.getPropertyGroup(uuid, productTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets sender identities for a property group
         * @param {string} uuid
         * @param {SearchSenderIdentityDto} searchSenderIdentityDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertyGroupSenderIdentities(uuid, searchSenderIdentityDto, options) {
            return localVarFp.getPropertyGroupSenderIdentities(uuid, searchSenderIdentityDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets staff members of a property group
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertyGroupStaff(uuid, options) {
            return localVarFp.getPropertyGroupStaff(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Updates a property group configs
         * @param {string} uuid
         * @param {number} productTypeId
         * @param {boolean} setToDefault
         * @param {AssignedConfigsDto} assignedConfigsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePropertyGroupConfigs(uuid, productTypeId, setToDefault, assignedConfigsDto, options) {
            return localVarFp.updatePropertyGroupConfigs(uuid, productTypeId, setToDefault, assignedConfigsDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PropertyGroupsApi - object-oriented interface
 * @export
 * @class PropertyGroupsApi
 * @extends {BaseAPI}
 */
class PropertyGroupsApi extends base_1.BaseAPI {
    /**
     *
     * @summary Creates a new property group
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyGroupsApi
     */
    createPropertyGroup(uuid, options) {
        return exports.PropertyGroupsApiFp(this.configuration).createPropertyGroup(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Creates a new sender identity for a property group
     * @param {string} uuid
     * @param {CreateSenderIdentityDto} createSenderIdentityDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyGroupsApi
     */
    createPropertyGroupSenderIdentity(uuid, createSenderIdentityDto, options) {
        return exports.PropertyGroupsApiFp(this.configuration).createPropertyGroupSenderIdentity(uuid, createSenderIdentityDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * delete sender identity
     * @summary delete a sender identity
     * @param {string} uuid
     * @param {string} senderIdentityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyGroupsApi
     */
    deletePropertyGroupSenderIdentity(uuid, senderIdentityId, options) {
        return exports.PropertyGroupsApiFp(this.configuration).deletePropertyGroupSenderIdentity(uuid, senderIdentityId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets all property groups the token has access to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyGroupsApi
     */
    getAllPropertyGroups(options) {
        return exports.PropertyGroupsApiFp(this.configuration).getAllPropertyGroups(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Useful so PMs can see what their current configs are and change them on the UI.
     * @summary Gets the property group configs at the most granular level for all property groups this token has access to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyGroupsApi
     */
    getAllPropertyGroupsConfigs(options) {
        return exports.PropertyGroupsApiFp(this.configuration).getAllPropertyGroupsConfigs(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets property group details. If valid token is provided, additional details and returned.
     * @param {string} uuid
     * @param {Array<string>} [productTypeId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyGroupsApi
     */
    getPropertyGroup(uuid, productTypeId, options) {
        return exports.PropertyGroupsApiFp(this.configuration).getPropertyGroup(uuid, productTypeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets sender identities for a property group
     * @param {string} uuid
     * @param {SearchSenderIdentityDto} searchSenderIdentityDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyGroupsApi
     */
    getPropertyGroupSenderIdentities(uuid, searchSenderIdentityDto, options) {
        return exports.PropertyGroupsApiFp(this.configuration).getPropertyGroupSenderIdentities(uuid, searchSenderIdentityDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets staff members of a property group
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyGroupsApi
     */
    getPropertyGroupStaff(uuid, options) {
        return exports.PropertyGroupsApiFp(this.configuration).getPropertyGroupStaff(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Updates a property group configs
     * @param {string} uuid
     * @param {number} productTypeId
     * @param {boolean} setToDefault
     * @param {AssignedConfigsDto} assignedConfigsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyGroupsApi
     */
    updatePropertyGroupConfigs(uuid, productTypeId, setToDefault, assignedConfigsDto, options) {
        return exports.PropertyGroupsApiFp(this.configuration).updatePropertyGroupConfigs(uuid, productTypeId, setToDefault, assignedConfigsDto, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PropertyGroupsApi = PropertyGroupsApi;
/**
 * ResidentsApi - axios parameter creator
 * @export
 */
exports.ResidentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Find resident by uuid.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneResident: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('findOneResident', 'uuid', uuid);
            const localVarPath = `/api/v1/residents/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Enable residents to register themselves
         * @summary Searches for resident by email or name.
         * @param {SearchResidentLookupDto} searchResidentLookupDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchResidents: (searchResidentLookupDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchResidentLookupDto' is not null or undefined
            common_1.assertParamExists('searchResidents', 'searchResidentLookupDto', searchResidentLookupDto);
            const localVarPath = `/api/v1/residents/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(searchResidentLookupDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ResidentsApi - functional programming interface
 * @export
 */
exports.ResidentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.ResidentsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Find resident by uuid.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneResident(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.findOneResident(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Enable residents to register themselves
         * @summary Searches for resident by email or name.
         * @param {SearchResidentLookupDto} searchResidentLookupDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchResidents(searchResidentLookupDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchResidents(searchResidentLookupDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ResidentsApi - factory interface
 * @export
 */
exports.ResidentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.ResidentsApiFp(configuration);
    return {
        /**
         *
         * @summary Find resident by uuid.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneResident(uuid, options) {
            return localVarFp.findOneResident(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Enable residents to register themselves
         * @summary Searches for resident by email or name.
         * @param {SearchResidentLookupDto} searchResidentLookupDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchResidents(searchResidentLookupDto, options) {
            return localVarFp.searchResidents(searchResidentLookupDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ResidentsApi - object-oriented interface
 * @export
 * @class ResidentsApi
 * @extends {BaseAPI}
 */
class ResidentsApi extends base_1.BaseAPI {
    /**
     *
     * @summary Find resident by uuid.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResidentsApi
     */
    findOneResident(uuid, options) {
        return exports.ResidentsApiFp(this.configuration).findOneResident(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Enable residents to register themselves
     * @summary Searches for resident by email or name.
     * @param {SearchResidentLookupDto} searchResidentLookupDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResidentsApi
     */
    searchResidents(searchResidentLookupDto, options) {
        return exports.ResidentsApiFp(this.configuration).searchResidents(searchResidentLookupDto, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ResidentsApi = ResidentsApi;
/**
 * VendorsApi - axios parameter creator
 * @export
 */
exports.VendorsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Allows the user to add a vendor into our system
         * @param {CreateVendorDto} createVendorDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVendor: (createVendorDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createVendorDto' is not null or undefined
            common_1.assertParamExists('createVendor', 'createVendorDto', createVendorDto);
            const localVarPath = `/api/v1/vendors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createVendorDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a vendor user.
         * @param {string} uuid
         * @param {string} userUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVendorUser: (uuid, userUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('deleteVendorUser', 'uuid', uuid);
            // verify required parameter 'userUuid' is not null or undefined
            common_1.assertParamExists('deleteVendorUser', 'userUuid', userUuid);
            const localVarPath = `/api/v1/vendors/{uuid}/users/{userUuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"userUuid"}}`, encodeURIComponent(String(userUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Searches for Vendor with pagination
         * @summary Search Vendors.
         * @param {VendorSearchDTO} vendorSearchDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchVendors: (vendorSearchDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'vendorSearchDTO' is not null or undefined
            common_1.assertParamExists('searchVendors', 'vendorSearchDTO', vendorSearchDTO);
            const localVarPath = `/api/v1/vendors/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(vendorSearchDTO, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update a vendor.
         * @param {string} uuid
         * @param {UpdateVendorDto} updateVendorDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVendor: (uuid, updateVendorDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateVendor', 'uuid', uuid);
            // verify required parameter 'updateVendorDto' is not null or undefined
            common_1.assertParamExists('updateVendor', 'updateVendorDto', updateVendorDto);
            const localVarPath = `/api/v1/vendors/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateVendorDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * VendorsApi - functional programming interface
 * @export
 */
exports.VendorsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.VendorsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Allows the user to add a vendor into our system
         * @param {CreateVendorDto} createVendorDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVendor(createVendorDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createVendor(createVendorDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete a vendor user.
         * @param {string} uuid
         * @param {string} userUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVendorUser(uuid, userUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteVendorUser(uuid, userUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Searches for Vendor with pagination
         * @summary Search Vendors.
         * @param {VendorSearchDTO} vendorSearchDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchVendors(vendorSearchDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchVendors(vendorSearchDTO, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update a vendor.
         * @param {string} uuid
         * @param {UpdateVendorDto} updateVendorDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVendor(uuid, updateVendorDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateVendor(uuid, updateVendorDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * VendorsApi - factory interface
 * @export
 */
exports.VendorsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.VendorsApiFp(configuration);
    return {
        /**
         *
         * @summary Allows the user to add a vendor into our system
         * @param {CreateVendorDto} createVendorDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVendor(createVendorDto, options) {
            return localVarFp.createVendor(createVendorDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a vendor user.
         * @param {string} uuid
         * @param {string} userUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVendorUser(uuid, userUuid, options) {
            return localVarFp.deleteVendorUser(uuid, userUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Searches for Vendor with pagination
         * @summary Search Vendors.
         * @param {VendorSearchDTO} vendorSearchDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchVendors(vendorSearchDTO, options) {
            return localVarFp.searchVendors(vendorSearchDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a vendor.
         * @param {string} uuid
         * @param {UpdateVendorDto} updateVendorDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVendor(uuid, updateVendorDto, options) {
            return localVarFp.updateVendor(uuid, updateVendorDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * VendorsApi - object-oriented interface
 * @export
 * @class VendorsApi
 * @extends {BaseAPI}
 */
class VendorsApi extends base_1.BaseAPI {
    /**
     *
     * @summary Allows the user to add a vendor into our system
     * @param {CreateVendorDto} createVendorDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    createVendor(createVendorDto, options) {
        return exports.VendorsApiFp(this.configuration).createVendor(createVendorDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a vendor user.
     * @param {string} uuid
     * @param {string} userUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    deleteVendorUser(uuid, userUuid, options) {
        return exports.VendorsApiFp(this.configuration).deleteVendorUser(uuid, userUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Searches for Vendor with pagination
     * @summary Search Vendors.
     * @param {VendorSearchDTO} vendorSearchDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    searchVendors(vendorSearchDTO, options) {
        return exports.VendorsApiFp(this.configuration).searchVendors(vendorSearchDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a vendor.
     * @param {string} uuid
     * @param {UpdateVendorDto} updateVendorDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    updateVendor(uuid, updateVendorDto, options) {
        return exports.VendorsApiFp(this.configuration).updateVendor(uuid, updateVendorDto, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.VendorsApi = VendorsApi;
/**
 * WebhookApi - axios parameter creator
 * @export
 */
exports.WebhookApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {object} body
         * @param {string} [authorization]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleGenericWebhook: (id, body, authorization, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('handleGenericWebhook', 'id', id);
            // verify required parameter 'body' is not null or undefined
            common_1.assertParamExists('handleGenericWebhook', 'body', body);
            const localVarPath = `/api/v1/webhook/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * WebhookApi - functional programming interface
 * @export
 */
exports.WebhookApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.WebhookApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {object} body
         * @param {string} [authorization]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleGenericWebhook(id, body, authorization, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.handleGenericWebhook(id, body, authorization, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * WebhookApi - factory interface
 * @export
 */
exports.WebhookApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.WebhookApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {object} body
         * @param {string} [authorization]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleGenericWebhook(id, body, authorization, options) {
            return localVarFp.handleGenericWebhook(id, body, authorization, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WebhookApi - object-oriented interface
 * @export
 * @class WebhookApi
 * @extends {BaseAPI}
 */
class WebhookApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} id
     * @param {object} body
     * @param {string} [authorization]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookApi
     */
    handleGenericWebhook(id, body, authorization, options) {
        return exports.WebhookApiFp(this.configuration).handleGenericWebhook(id, body, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.WebhookApi = WebhookApi;
/**
 * WorkOrdersApi - axios parameter creator
 * @export
 */
exports.WorkOrdersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Adds an event to a work order.
         * @param {string} uuid
         * @param {CreateWorkOrderEventDto} createWorkOrderEventDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWorkOrderEvent: (uuid, createWorkOrderEventDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('addWorkOrderEvent', 'uuid', uuid);
            // verify required parameter 'createWorkOrderEventDto' is not null or undefined
            common_1.assertParamExists('addWorkOrderEvent', 'createWorkOrderEventDto', createWorkOrderEventDto);
            const localVarPath = `/api/v1/workorder/{uuid}/event`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createWorkOrderEventDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Adds a note to a work order.
         * @param {string} uuid
         * @param {CreateWorkOrderNoteDto} createWorkOrderNoteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWorkOrderNote: (uuid, createWorkOrderNoteDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('addWorkOrderNote', 'uuid', uuid);
            // verify required parameter 'createWorkOrderNoteDto' is not null or undefined
            common_1.assertParamExists('addWorkOrderNote', 'createWorkOrderNoteDto', createWorkOrderNoteDto);
            const localVarPath = `/api/v1/workorder/{uuid}/note`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createWorkOrderNoteDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create a new Work Order
         * @param {CreateWorkOrderDto | CloneWorkOrderDto} createWorkOrderDtoCloneWorkOrderDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkOrder: (createWorkOrderDtoCloneWorkOrderDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createWorkOrderDtoCloneWorkOrderDto' is not null or undefined
            common_1.assertParamExists('createWorkOrder', 'createWorkOrderDtoCloneWorkOrderDto', createWorkOrderDtoCloneWorkOrderDto);
            const localVarPath = `/api/v1/workorder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createWorkOrderDtoCloneWorkOrderDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Deletes a note for a workorder
         * @param {string} uuid
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkOrderNote: (uuid, id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('deleteWorkOrderNote', 'uuid', uuid);
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('deleteWorkOrderNote', 'id', id);
            const localVarPath = `/api/v1/workorder/{uuid}/note/{id}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Export a workorder by uuid
         * @param {string} uuid
         * @param {WorkOrderExportOptionsDto} workOrderExportOptionsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportWorkOrder: (uuid, workOrderExportOptionsDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('exportWorkOrder', 'uuid', uuid);
            // verify required parameter 'workOrderExportOptionsDto' is not null or undefined
            common_1.assertParamExists('exportWorkOrder', 'workOrderExportOptionsDto', workOrderExportOptionsDto);
            const localVarPath = `/api/v1/workorder/{uuid}/export`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(workOrderExportOptionsDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Fetch a workorder by uuid
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findWorkOrderByUuid: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('findWorkOrderByUuid', 'uuid', uuid);
            const localVarPath = `/api/v1/workorder/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Fetch a workorder by id
         * @param {string} workOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkOrderById: (workOrderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'workOrderId' is not null or undefined
            common_1.assertParamExists('getWorkOrderById', 'workOrderId', workOrderId);
            const localVarPath = `/api/v1/workorder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (workOrderId !== undefined) {
                localVarQueryParameter['workOrderId'] = workOrderId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Searches for work orders. Returns results which are in the user\'s property group scope.
         * @param {WorkOrderSearchParamsDto} workOrderSearchParamsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWorkOrders: (workOrderSearchParamsDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'workOrderSearchParamsDto' is not null or undefined
            common_1.assertParamExists('searchWorkOrders', 'workOrderSearchParamsDto', workOrderSearchParamsDto);
            const localVarPath = `/api/v1/workorder/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(workOrderSearchParamsDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update a workorder
         * @param {string} uuid
         * @param {UpdateWorkOrderDto} updateWorkOrderDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkOrder: (uuid, updateWorkOrderDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateWorkOrder', 'uuid', uuid);
            // verify required parameter 'updateWorkOrderDto' is not null or undefined
            common_1.assertParamExists('updateWorkOrder', 'updateWorkOrderDto', updateWorkOrderDto);
            const localVarPath = `/api/v1/workorder/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication access-token required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateWorkOrderDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * WorkOrdersApi - functional programming interface
 * @export
 */
exports.WorkOrdersApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.WorkOrdersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Adds an event to a work order.
         * @param {string} uuid
         * @param {CreateWorkOrderEventDto} createWorkOrderEventDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWorkOrderEvent(uuid, createWorkOrderEventDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addWorkOrderEvent(uuid, createWorkOrderEventDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Adds a note to a work order.
         * @param {string} uuid
         * @param {CreateWorkOrderNoteDto} createWorkOrderNoteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWorkOrderNote(uuid, createWorkOrderNoteDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addWorkOrderNote(uuid, createWorkOrderNoteDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create a new Work Order
         * @param {CreateWorkOrderDto | CloneWorkOrderDto} createWorkOrderDtoCloneWorkOrderDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkOrder(createWorkOrderDtoCloneWorkOrderDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createWorkOrder(createWorkOrderDtoCloneWorkOrderDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Deletes a note for a workorder
         * @param {string} uuid
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkOrderNote(uuid, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteWorkOrderNote(uuid, id, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Export a workorder by uuid
         * @param {string} uuid
         * @param {WorkOrderExportOptionsDto} workOrderExportOptionsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportWorkOrder(uuid, workOrderExportOptionsDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.exportWorkOrder(uuid, workOrderExportOptionsDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Fetch a workorder by uuid
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findWorkOrderByUuid(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.findWorkOrderByUuid(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Fetch a workorder by id
         * @param {string} workOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkOrderById(workOrderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWorkOrderById(workOrderId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Searches for work orders. Returns results which are in the user\'s property group scope.
         * @param {WorkOrderSearchParamsDto} workOrderSearchParamsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWorkOrders(workOrderSearchParamsDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchWorkOrders(workOrderSearchParamsDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update a workorder
         * @param {string} uuid
         * @param {UpdateWorkOrderDto} updateWorkOrderDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkOrder(uuid, updateWorkOrderDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateWorkOrder(uuid, updateWorkOrderDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * WorkOrdersApi - factory interface
 * @export
 */
exports.WorkOrdersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.WorkOrdersApiFp(configuration);
    return {
        /**
         *
         * @summary Adds an event to a work order.
         * @param {string} uuid
         * @param {CreateWorkOrderEventDto} createWorkOrderEventDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWorkOrderEvent(uuid, createWorkOrderEventDto, options) {
            return localVarFp.addWorkOrderEvent(uuid, createWorkOrderEventDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Adds a note to a work order.
         * @param {string} uuid
         * @param {CreateWorkOrderNoteDto} createWorkOrderNoteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWorkOrderNote(uuid, createWorkOrderNoteDto, options) {
            return localVarFp.addWorkOrderNote(uuid, createWorkOrderNoteDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a new Work Order
         * @param {CreateWorkOrderDto | CloneWorkOrderDto} createWorkOrderDtoCloneWorkOrderDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkOrder(createWorkOrderDtoCloneWorkOrderDto, options) {
            return localVarFp.createWorkOrder(createWorkOrderDtoCloneWorkOrderDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Deletes a note for a workorder
         * @param {string} uuid
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkOrderNote(uuid, id, options) {
            return localVarFp.deleteWorkOrderNote(uuid, id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Export a workorder by uuid
         * @param {string} uuid
         * @param {WorkOrderExportOptionsDto} workOrderExportOptionsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportWorkOrder(uuid, workOrderExportOptionsDto, options) {
            return localVarFp.exportWorkOrder(uuid, workOrderExportOptionsDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Fetch a workorder by uuid
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findWorkOrderByUuid(uuid, options) {
            return localVarFp.findWorkOrderByUuid(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Fetch a workorder by id
         * @param {string} workOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkOrderById(workOrderId, options) {
            return localVarFp.getWorkOrderById(workOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Searches for work orders. Returns results which are in the user\'s property group scope.
         * @param {WorkOrderSearchParamsDto} workOrderSearchParamsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWorkOrders(workOrderSearchParamsDto, options) {
            return localVarFp.searchWorkOrders(workOrderSearchParamsDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a workorder
         * @param {string} uuid
         * @param {UpdateWorkOrderDto} updateWorkOrderDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkOrder(uuid, updateWorkOrderDto, options) {
            return localVarFp.updateWorkOrder(uuid, updateWorkOrderDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WorkOrdersApi - object-oriented interface
 * @export
 * @class WorkOrdersApi
 * @extends {BaseAPI}
 */
class WorkOrdersApi extends base_1.BaseAPI {
    /**
     *
     * @summary Adds an event to a work order.
     * @param {string} uuid
     * @param {CreateWorkOrderEventDto} createWorkOrderEventDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    addWorkOrderEvent(uuid, createWorkOrderEventDto, options) {
        return exports.WorkOrdersApiFp(this.configuration).addWorkOrderEvent(uuid, createWorkOrderEventDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Adds a note to a work order.
     * @param {string} uuid
     * @param {CreateWorkOrderNoteDto} createWorkOrderNoteDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    addWorkOrderNote(uuid, createWorkOrderNoteDto, options) {
        return exports.WorkOrdersApiFp(this.configuration).addWorkOrderNote(uuid, createWorkOrderNoteDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a new Work Order
     * @param {CreateWorkOrderDto | CloneWorkOrderDto} createWorkOrderDtoCloneWorkOrderDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    createWorkOrder(createWorkOrderDtoCloneWorkOrderDto, options) {
        return exports.WorkOrdersApiFp(this.configuration).createWorkOrder(createWorkOrderDtoCloneWorkOrderDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Deletes a note for a workorder
     * @param {string} uuid
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    deleteWorkOrderNote(uuid, id, options) {
        return exports.WorkOrdersApiFp(this.configuration).deleteWorkOrderNote(uuid, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Export a workorder by uuid
     * @param {string} uuid
     * @param {WorkOrderExportOptionsDto} workOrderExportOptionsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    exportWorkOrder(uuid, workOrderExportOptionsDto, options) {
        return exports.WorkOrdersApiFp(this.configuration).exportWorkOrder(uuid, workOrderExportOptionsDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Fetch a workorder by uuid
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    findWorkOrderByUuid(uuid, options) {
        return exports.WorkOrdersApiFp(this.configuration).findWorkOrderByUuid(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Fetch a workorder by id
     * @param {string} workOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    getWorkOrderById(workOrderId, options) {
        return exports.WorkOrdersApiFp(this.configuration).getWorkOrderById(workOrderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Searches for work orders. Returns results which are in the user\'s property group scope.
     * @param {WorkOrderSearchParamsDto} workOrderSearchParamsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    searchWorkOrders(workOrderSearchParamsDto, options) {
        return exports.WorkOrdersApiFp(this.configuration).searchWorkOrders(workOrderSearchParamsDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a workorder
     * @param {string} uuid
     * @param {UpdateWorkOrderDto} updateWorkOrderDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    updateWorkOrder(uuid, updateWorkOrderDto, options) {
        return exports.WorkOrdersApiFp(this.configuration).updateWorkOrder(uuid, updateWorkOrderDto, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.WorkOrdersApi = WorkOrdersApi;
